import React, { useState, useEffect, useRef, useContext, createContext } from 'react';
import {
  Layout, Users, BookOpen, Sparkles, BrainCircuit, Target, Smile, MessageSquare, MessageCircle, CreditCard, LogOut, Plus, Trash2, Archive,
  ChevronRight, ChevronLeft, User, Lock, Check, Edit2, Save, X, Calendar, ChevronDown, BarChart2, ArrowUp, ArrowDown,
  Activity, Award, Clock, List, Book, RefreshCw, Zap,
  Library, CheckCircle, Flag, Phone, GraduationCap,
  Play, Pause, RotateCcw, Timer, Menu, CloudOff, Cloud, Shield, Eye, EyeOff, Sun, Moon, Settings, TrendingDown, Minus,
  Lightbulb, MapPin, Store, Search, Star, Info, AlertCircle, AlertTriangle,
  Camera, Maximize2, Upload, Image as ImageIcon, ZoomIn, ZoomOut, RotateCw, Download, CheckCheck, Megaphone, DownloadCloud,
  Printer
} from 'lucide-react';
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, updateDoc, doc, deleteDoc, onSnapshot, query, setDoc, getDoc, arrayUnion, where, serverTimestamp, orderBy, Timestamp, getDocs } from "firebase/firestore";
import { getStorage, ref as storageRef, deleteObject, uploadString, getDownloadURL } from "firebase/storage";
import KocumAiChat from './KocumAiChat';
import TeacherAiFloatingChat from './TeacherAiFloatingChat';
import AiUsageSuperadminModule from './AiUsageSuperadminModule';
import PopupManagementSuperadminModule from './PopupManagementSuperadminModule';
import ActivePopupModal from './ActivePopupModal';
import { subscribePopups } from './popupService';
import { registerServiceWorker, handleIncomingPushItem } from './pushNotificationService';
import VersionManagementSuperadminModule from './VersionManagementSuperadminModule';
import ForceUpdateLockModal from './ForceUpdateLockModal';
import { subscribeVersionConfig } from './versionConfig';


// --- FIREBASE ENTEGRASYONU ---
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBcgbe_NhAfzwUHpuAS0TniHv-FifmxOA8",
  authDomain: "kocluk-6868.firebaseapp.com",
  projectId: "kocluk-6868",
  storageBucket: "kocluk-6868.firebasestorage.app",
  messagingSenderId: "172948773174",
  appId: "1:172948773174:web:4a58aadf83c48d2e187b97"
};

const MyNotesModule = ({ user, student, onUpdateStudent }) => {
  const colors = useThemeColors();
  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(isFirebaseActive);
  const [storageMode, setStorageMode] = useState(isFirebaseActive ? 'collection' : 'embedded');
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ title: '', content: '' });

  useEffect(() => {
    if (!student?.id) return;
    if (!isFirebaseActive || storageMode === 'embedded') {
      const localNotes = Array.isArray(student.myNotes) ? student.myNotes : [];
      const sorted = [...localNotes].sort((a, b) => {
        const da = new Date(a.createdAt || a.date || 0).getTime();
        const dbb = new Date(b.createdAt || b.date || 0).getTime();
        return dbb - da;
      });
      setNotes(sorted);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const q = query(collection(db, 'notes'), where('userId', '==', student.id));
    const unsub = onSnapshot(q, (snap) => {
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      data.sort((a, b) => {
        const da = new Date(a.createdAt || a.date || 0).getTime();
        const dbb = new Date(b.createdAt || b.date || 0).getTime();
        return dbb - da;
      });
      setNotes(data);
      setIsLoading(false);
    }, (err) => {
      console.error(err);
      if (err?.code === 'permission-denied') {
        setStorageMode('embedded');
        const localNotes = Array.isArray(student.myNotes) ? student.myNotes : [];
        const sorted = [...localNotes].sort((a, b) => {
          const da = new Date(a.createdAt || a.date || 0).getTime();
          const dbb = new Date(b.createdAt || b.date || 0).getTime();
          return dbb - da;
        });
        setNotes(sorted);
      }
      setIsLoading(false);
    });

    return () => unsub();
  }, [student?.id, student?.myNotes, storageMode]);

  if (user?.role !== 'student') return <div className={`${colors.text} text-center mt-20`}>Bu alana erişim yetkiniz yok.</div>;
  if (!student) return <div className={`${colors.textSec} text-center mt-20`}>Yükleniyor...</div>;

  const openNew = () => {
    setEditingId(null);
    setForm({ title: '', content: '' });
    setShowModal(true);
  };

  const openEdit = (note) => {
    setEditingId(note.id);
    setForm({ title: note.title || '', content: note.content || '' });
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!form.title.trim() || !form.content.trim()) return alert("Başlık ve not içeriği zorunludur.");
    const now = new Date();
    const dateStr = now.toLocaleDateString('tr-TR');
    const createdAt = now.toISOString();

    if (isFirebaseActive && storageMode === 'collection') {
      try {
        if (editingId) {
          await updateDoc(doc(db, 'notes', editingId), { title: form.title.trim(), content: form.content.trim() });
        } else {
          await addDoc(collection(db, 'notes'), {
            userId: student.id,
            title: form.title.trim(),
            content: form.content.trim(),
            date: dateStr,
            createdAt,
          });
        }
      } catch (e) {
        console.error(e);
        if (e?.code === 'permission-denied') {
          setStorageMode('embedded');
        } else {
          alert("Not kaydedilemedi.");
          return;
        }
      }
    }

    if (!isFirebaseActive || storageMode === 'embedded') {
      const existing = Array.isArray(student.myNotes) ? student.myNotes : [];
      let updated;
      if (editingId) {
        updated = existing.map(n => n.id === editingId ? { ...n, title: form.title.trim(), content: form.content.trim() } : n);
      } else {
        updated = [{ id: Date.now(), userId: student.id, title: form.title.trim(), content: form.content.trim(), date: dateStr, createdAt }, ...existing];
      }
      onUpdateStudent({ ...student, myNotes: updated });
    }

    setShowModal(false);
    setEditingId(null);
    setForm({ title: '', content: '' });
    logActivity(student.id, editingId ? 'note_edit' : 'note_add', { title: form.title.trim() });
  };

  const handleDelete = async (noteId) => {
    if (!window.confirm("Not silinsin mi?")) return;

    if (isFirebaseActive && storageMode === 'collection') {
      try {
        await deleteDoc(doc(db, 'notes', noteId));
      } catch (e) {
        console.error(e);
        if (e?.code === 'permission-denied') {
          setStorageMode('embedded');
        } else {
          alert("Not silinemedi.");
        }
      }
      if (storageMode === 'collection') return;
    }

    const existing = Array.isArray(student.myNotes) ? student.myNotes : [];
    const updated = existing.filter(n => n.id !== noteId);
    onUpdateStudent({ ...student, myNotes: updated });
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex justify-between items-center">
        <h2 className={`text-2xl font-bold ${colors.text}`}>Notlarım</h2>
        <Button icon={Plus} onClick={openNew}>Yeni Not Ekle</Button>
      </div>

      {isLoading ? (
        <div className={`${colors.textSec} text-center py-10`}>Yükleniyor...</div>
      ) : notes.length === 0 ? (
        <div className={`${colors.textSec} text-center py-10`}>Henüz not eklenmedi.</div>
      ) : (
        <div className="space-y-4">
          {notes.map(note => (
            <div key={note.id} className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 ${colors.shadow}`}>
              <div className="flex justify-between items-start gap-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <div className={`text-lg font-bold ${colors.text} truncate`}>{note.title || '(Başlıksız)'}</div>
                  </div>
                  <div className={`text-xs ${colors.textSec} mt-1`}>{note.date || ''}</div>
                </div>

                <div className="flex gap-2 shrink-0">
                  <button onClick={() => openEdit(note)} className={`p-2 rounded-lg ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} ${colors.textSec} hover:text-blue-500 transition-colors`} title="Düzenle">
                    <Edit2 size={16} />
                  </button>
                  <button onClick={() => handleDelete(note.id)} className={`p-2 rounded-lg ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} ${colors.textSec} hover:text-red-500 transition-colors`} title="Sil">
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>

              <div className={`mt-3 text-sm ${colors.text} whitespace-pre-wrap break-words`}>{note.content || ''}</div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <Modal title={editingId ? 'Notu Düzenle' : 'Yeni Not Ekle'} onClose={() => { setShowModal(false); setEditingId(null); }}>
          <div className="space-y-4">
            <Input label="Başlık" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} />
            <div>
              <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase`}>Not İçeriği</label>
              <textarea
                className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg p-3 ${colors.text} h-40`}
                value={form.content}
                onChange={e => setForm({ ...form, content: e.target.value })}
              />
            </div>
            <Button className="w-full" icon={Save} onClick={handleSave}>{editingId ? 'Güncelle' : 'Kaydet'}</Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

let db = null;
let storage = null;
let isFirebaseActive = false;

if (FIREBASE_CONFIG.apiKey) {
  try {
    const app = initializeApp(FIREBASE_CONFIG);
    db = getFirestore(app);
    try {
      storage = getStorage(app);
    } catch (sErr) {
      console.warn("Firebase Storage başlatma uyarısı:", sErr);
    }
    isFirebaseActive = true;
    console.log("Firebase bağlantısı başarılı.");
  } catch (error) {
    console.error("Firebase başlatma hatası:", error);
  }
}

// Firestore'a gönderilen verilerdeki undefined alanları temizleyen güvenli fonksiyon
const sanitizeForFirestore = (obj) => {
  if (obj === null || obj === undefined) return null;
  if (Array.isArray(obj)) {
    return obj.filter(item => item !== undefined).map(sanitizeForFirestore);
  }
  if (typeof obj === 'object') {
    const res = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== undefined) {
        res[key] = sanitizeForFirestore(value);
      }
    }
    return res;
  }
  return obj;
};

// --- TEMA YÖNETİMİ ---
const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => { } });

const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useTheme must be used within a ThemeProvider");
  return context;
};

// Renk paleti yardımcı fonksiyonu
const useThemeColors = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  return {
    isDark,
    bgMain: isDark ? 'bg-slate-950' : 'bg-slate-100',
    bgCard: isDark ? 'bg-slate-900' : 'bg-white',
    bgCardTransparent: isDark ? 'bg-slate-900/50' : 'bg-white/80',
    text: isDark ? 'text-white' : 'text-slate-900',
    textSec: isDark ? 'text-slate-400' : 'text-slate-500',
    border: isDark ? 'border-slate-800' : 'border-slate-300',
    inputBg: isDark ? 'bg-slate-900' : 'bg-slate-50',
    inputBorder: isDark ? 'border-slate-700' : 'border-slate-300',
    hoverBg: isDark ? 'hover:bg-slate-800' : 'hover:bg-slate-200',
    tableHeader: isDark ? 'bg-slate-800 text-slate-300' : 'bg-slate-200 text-slate-700',
    divider: isDark ? 'divide-slate-800' : 'divide-slate-200',
    shadow: isDark ? 'shadow-none' : 'shadow-sm',
    chartGrid: isDark ? '#334155' : '#e2e8f0',
    chartTooltip: isDark ? '#1e293b' : '#ffffff',
  };
};

// --- CHART HELPER (SMOOTH CURVES) ---
const svgPath = (points, command) => {
  const d = points.reduce((acc, point, i, a) => i === 0
    ? `M ${point[0]},${point[1]}`
    : `${acc} ${command(point, i, a)}`
    , '')
  return d
}
const line = (pointA, pointB) => {
  const lengthX = pointB[0] - pointA[0]
  const lengthY = pointB[1] - pointA[1]
  return { length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)), angle: Math.atan2(lengthY, lengthX) }
}
const controlPoint = (current, previous, next, reverse) => {
  const p = previous || current
  const n = next || current
  const smoothing = 0.2
  const o = line(p, n)
  const angle = o.angle + (reverse ? Math.PI : 0)
  const length = o.length * smoothing
  const x = current[0] + Math.cos(angle) * length
  const y = current[1] + Math.sin(angle) * length
  return [x, y]
}
const bezierCommand = (point, i, a) => {
  const [cpsX, cpsY] = controlPoint(a[i - 1], a[i - 2], point)
  const [cpeX, cpeY] = controlPoint(point, a[i - 1], a[i + 1], true)
  return `C ${cpsX},${cpsY} ${cpeX},${cpeY} ${point[0]},${point[1]}`
}

// --- VERİ MODELİ VE SABİTLER ---

const SUPER_ADMIN_ID = "super_admin_hmk";

const EXAM_TYPES = {
  TYT: { label: 'YKS - TYT', groups: [{ title: 'Türkçe', sections: [{ key: 'turk', label: 'Türkçe', q: 40 }] }, { title: 'Sosyal Bilimler', sections: [{ key: 'tarih', label: 'Tarih', q: 5 }, { key: 'cog', label: 'Coğrafya', q: 5 }, { key: 'fel', label: 'Felsefe', q: 5 }, { key: 'din', label: 'Din K.', q: 5 }] }, { title: 'Temel Matematik', sections: [{ key: 'mat', label: 'Matematik', q: 30 }, { key: 'geo', label: 'Geometri', q: 10 }] }, { title: 'Fen Bilimleri', sections: [{ key: 'fiz', label: 'Fizik', q: 7 }, { key: 'kim', label: 'Kimya', q: 7 }, { key: 'biyo', label: 'Biyoloji', q: 6 }] }] },
  AYT: { label: 'YKS - AYT', groups: [{ title: 'Matematik & Geometri', sections: [{ key: 'mat', label: 'Matematik', q: 30 }, { key: 'geo', label: 'Geometri', q: 10 }] }, { title: 'Fen Bilimleri', sections: [{ key: 'fiz', label: 'Fizik', q: 14 }, { key: 'kim', label: 'Kimya', q: 13 }, { key: 'biyo', label: 'Biyoloji', q: 13 }] }, { title: 'Edebiyat & Sosyal-1', sections: [{ key: 'edb', label: 'Edebiyat', q: 24 }, { key: 'tar1', label: 'Tarih-1', q: 10 }, { key: 'cog1', label: 'Coğ-1', q: 6 }] }, { title: 'Sosyal-2', sections: [{ key: 'tar2', label: 'Tarih-2', q: 11 }, { key: 'cog2', label: 'Coğrafya-2', q: 11 }, { key: 'felg', label: 'Felsefe Grb.', q: 12 }, { key: 'din', label: 'Din K.', q: 6 }] }] },
  LGS: { label: 'LGS', groups: [{ title: 'Sözel Bölüm', sections: [{ key: 'turk', label: 'Türkçe', q: 20 }, { key: 'ink', label: 'İnkılap', q: 10 }, { key: 'din', label: 'Din K.', q: 10 }, { key: 'ing', label: 'İngilizce', q: 10 }] }, { title: 'Sayısal Bölüm', sections: [{ key: 'mat', label: 'Matematik', q: 20 }, { key: 'fen', label: 'Fen Bilimleri', q: 20 }] }] },
  KPSS: {
    label: 'KPSS',
    groups: [
      {
        title: 'Genel Yetenek',
        sections: [
          { key: 'kpss_gy_turk', label: 'Türkçe', q: 30 },
          { key: 'kpss_gy_mat', label: 'Matematik', q: 30 }
        ]
      },
      {
        title: 'Genel Kültür',
        sections: [
          { key: 'kpss_gk_tar', label: 'Tarih', q: 27 },
          { key: 'kpss_gk_cog', label: 'Coğrafya', q: 18 },
          { key: 'kpss_gk_vat', label: 'Vatandaşlık', q: 9 },
          { key: 'kpss_gk_guncel', label: 'Güncel Bilgiler', q: 6 }
        ]
      }
    ]
  }
};

const BRANCH_SUBJECTS = [
  { id: 'turk', label: 'Türkçe' }, { id: 'mat', label: 'Matematik' }, { id: 'geo', label: 'Geometri' },
  { id: 'fiz', label: 'Fizik' }, { id: 'kim', label: 'Kimya' }, { id: 'biyo', label: 'Biyoloji' },
  { id: 'tarih', label: 'Tarih' }, { id: 'cog', label: 'Coğrafya' }, { id: 'fel', label: 'Felsefe' },
  { id: 'din', label: 'Din Kültürü' }, { id: 'sos', label: 'Sosyal (Genel)' }, { id: 'fen', label: 'Fen (Genel)' }
];

const DAYS = [
  { id: 'Mon', label: 'Pazartesi', short: 'Pzt' },
  { id: 'Tue', label: 'Salı', short: 'Sal' },
  { id: 'Wed', label: 'Çarşamba', short: 'Çar' },
  { id: 'Thu', label: 'Perşembe', short: 'Per' },
  { id: 'Fri', label: 'Cuma', short: 'Cum' },
  { id: 'Sat', label: 'Cumartesi', short: 'Cmt' },
  { id: 'Sun', label: 'Pazar', short: 'Paz' }
];

const TASK_TYPES = [
  { id: 'konu', label: 'Konu Çalışması' }, { id: 'soru', label: 'Soru Çözümü' },
  { id: 'tekrar', label: 'Konu Tekrarı' }, { id: 'deneme', label: 'Branş Denemesi' }, { id: 'ozel', label: 'Özel Görev' },
  { id: 'extra', label: 'Ekstra Çalışma' }
];

const INITIAL_CURRICULUM = [
  { id: 'mat-tyt', name: 'TYT Matematik', units: [{ id: 'u1', name: 'Temel Kavramlar', topics: ['Sayı Kümeleri', 'Tek-Çift Sayılar'] }] },
  { id: 'geo-tyt', name: 'Geometri', units: [{ id: 'g1', name: 'Üçgenler', topics: ['Doğruda Açı', 'Üçgende Açı'] }] }
];

const INITIAL_ADMINS = [
  { id: SUPER_ADMIN_ID, name: "Hamza Metehan Kılıç", username: "admin", password: "123", role: "superadmin" }
];

const INITIAL_STUDENTS = [
  {
    id: "demo_student_1", teacherId: SUPER_ADMIN_ID, name: "Ahmet Yılmaz (Demo)", username: "ahmet", password: "123", phone: "0555 111 22 33", school: "Fen Lisesi", grade: "12. Sınıf (YKS)", target: "Hukuk Fakültesi",
    exams: [{ id: 1, name: "Özdebir TYT-1", type: "TYT", date: "2024-10-15", totalNet: 68.75, difficulty: "Orta", stats: { turkey: { rank: 15400, total: 120000 }, city: { rank: 450, total: 5000 }, school: { rank: 45, total: 120 } }, details: { turk: { d: 30, y: 5, n: 28.75 }, tarih: { d: 4, y: 1, n: 3.75 }, cog: { d: 3, y: 2, n: 2.5 }, fel: { d: 4, y: 1, n: 3.75 }, din: { d: 4, y: 1, n: 3.75 }, mat: { d: 15, y: 3, n: 14.25 }, geo: { d: 5, y: 2, n: 4.5 }, fiz: { d: 3, y: 2, n: 2.5 }, kim: { d: 3, y: 0, n: 3 }, biyo: { d: 2, y: 0, n: 2 } } }],
    moods: [{ id: 101, date: "2024-12-01", metrics: { motivation: 80, happiness: 70, social: 60, examAnxiety: 40, lessonAnxiety: 30, performance: 75, homeworkRate: 90 } }],
    lessons: {}, interviews: [], payments: [], teacherNotes: [],
    assignments: [{ id: 201, day: 'Mon', subject: 'TYT Matematik', topic: 'Sayı Kümeleri', type: 'soru', count: 50, source: '3D Yayınları', status: 'pending', note: 'İlk 2 test' }],
    pastWeeks: [], goals: [], resources: [], diary: [],
    stats: { totalSolved: 12500, monthlySolved: 1200, xp: 1250, level: 5, pomodoroCount: 12, sprintCount: 5 }
  }
];

// --- YARDIMCI FONKSİYONLAR ---
const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

const compressImageFile = async (file, maxWidth = 850, quality = 0.55) => {
  if (!file || !file.type || !file.type.startsWith('image/')) {
    throw new Error("Lütfen geçerli bir görsel dosyası seçin.");
  }

  // 1. Donanım hızlandırmalı hızlı görsel çözme (createImageBitmap)
  let imgWidth = 0;
  let imgHeight = 0;
  let sourceElement = null;

  if (typeof window !== 'undefined' && window.createImageBitmap) {
    try {
      const bitmap = await window.createImageBitmap(file);
      imgWidth = bitmap.width;
      imgHeight = bitmap.height;
      sourceElement = bitmap;
    } catch (e) {
      sourceElement = null;
    }
  }

  // Tarayıcı desteği yoksa FileReader + Image yedeği
  if (!sourceElement) {
    sourceElement = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error("Dosya okunamadı."));
      reader.onload = (e) => {
        const img = new window.Image();
        img.onerror = () => reject(new Error("Görsel yüklenemedi."));
        img.onload = () => resolve(img);
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
    imgWidth = sourceElement.width;
    imgHeight = sourceElement.height;
  }

  // Boyutlandırma hesabı (Maksimum 850px)
  let width = imgWidth;
  let height = imgHeight;
  if (width > maxWidth || height > maxWidth) {
    if (width > height) {
      height = Math.round((height * maxWidth) / width);
      width = maxWidth;
    } else {
      width = Math.round((width * maxWidth) / height);
      height = maxWidth;
    }
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(sourceElement, 0, 0, width, height);

  if (sourceElement.close) {
    try { sourceElement.close(); } catch (e) { }
  }

  let dataUrl = canvas.toDataURL('image/jpeg', quality);

  // Güvenlik & Firestore Koruması: Eğer base64 verisi 70KB'tan (~95.000 karakter) büyükse otomatik ikinci aşama sıkıştırma
  if (dataUrl.length > 95000) {
    dataUrl = canvas.toDataURL('image/jpeg', 0.42);
  }
  if (dataUrl.length > 95000) {
    const scale = 0.75;
    const c2 = document.createElement('canvas');
    c2.width = Math.round(width * scale);
    c2.height = Math.round(height * scale);
    const ctx2 = c2.getContext('2d');
    ctx2.fillStyle = '#ffffff';
    ctx2.fillRect(0, 0, c2.width, c2.height);
    ctx2.drawImage(canvas, 0, 0, c2.width, c2.height);
    dataUrl = c2.toDataURL('image/jpeg', 0.40);
  }

  const approxSize = Math.round((dataUrl.length - 23) * 0.75);

  return {
    dataUrl,
    name: (file.name || 'foto').replace(/\.[^/.]+$/, "") + ".jpg",
    size: approxSize,
    originalSize: file.size,
    width,
    height
  };
};

// Eski dokümanlarda kalmış aşırı büyük base64 fotoğraflar varsa küçülten yardımcı
const recompressLegacyDataUrl = async (dataUrl) => {
  if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:image/') || dataUrl.length < 120000) {
    return dataUrl;
  }
  return new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => {
      let width = img.width;
      let height = img.height;
      const maxWidth = 800;
      if (width > maxWidth || height > maxWidth) {
        if (width > height) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        } else {
          width = Math.round((width * maxWidth) / height);
          height = maxWidth;
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.50));
    };
    img.onerror = () => resolve(dataUrl);
    img.src = dataUrl;
  });
};

// Hem Firebase Storage'a yükleyen hem de başarısızlıkta optimize inline base64'e düşen güvenli yükleyici
const uploadPhotoFile = async (file, studentId, folder = 'assignments') => {
  const compressed = await compressImageFile(file, 850, 0.55);
  const imageId = 'img_' + Date.now() + '_' + Math.random().toString(36).substring(2, 7);
  let finalUrl = compressed.dataUrl;
  let finalStoragePath = '';

  if (storage && studentId) {
    try {
      const sPath = `${folder}/${studentId}/${imageId}.jpg`;
      const sRef = storageRef(storage, sPath);
      await uploadString(sRef, compressed.dataUrl, 'data_url');
      const downloadUrl = await getDownloadURL(sRef);
      if (downloadUrl) {
        finalUrl = downloadUrl;
        finalStoragePath = sPath;
      }
    } catch (storageErr) {
      console.warn("Firebase Storage yükleme hatası (optimize inline fallback devrede):", storageErr?.message || storageErr);
    }
  }

  return {
    id: imageId,
    url: finalUrl,
    storagePath: finalStoragePath,
    name: compressed.name,
    size: compressed.size,
    uploadedAt: new Date().toISOString()
  };
};

const StudyTimerModule = ({ user, student, onUpdateStudent }) => {
  const [timerMode, setTimerMode] = useState('pomodoro');
  const [timeLeft, setTimeLeft] = useState(25 * 60);
  const [isActive, setIsActive] = useState(false);
  const timerRef = useRef(null);
  const colors = useThemeColors();

  useEffect(() => {
    if (isActive && timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      clearInterval(timerRef.current);
      setIsActive(false);
      handleTimerComplete();
    }

    return () => clearInterval(timerRef.current);
  }, [isActive, timeLeft]);

  const resetTimer = (mode) => {
    setIsActive(false);
    clearInterval(timerRef.current);
    if (mode === 'pomodoro') setTimeLeft(25 * 60);
    else setTimeLeft(50 * 60);
  };

  const changeMode = (mode) => {
    setTimerMode(mode);
    resetTimer(mode);
  };

  const toggleTimer = () => setIsActive(!isActive);

  const handleTimerComplete = () => {
    if (user.role === 'student' && student) {
      onUpdateStudent({
        ...student,
        stats: {
          ...(student.stats || {}),
          pomodoroCount: timerMode === 'pomodoro' ? ((student.stats?.pomodoroCount || 0) + 1) : (student.stats?.pomodoroCount || 0),
          sprintCount: timerMode === 'sprint' ? ((student.stats?.sprintCount || 0) + 1) : (student.stats?.sprintCount || 0),
        }
      });
    }
    resetTimer(timerMode);
  };

  if (!student) return <div className={`text-center mt-20 ${colors.textSec}`}>Öğrenci verisi bulunamadı.</div>;

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-orange-500/30">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-lg font-bold text-white flex items-center gap-2"><Timer className="text-orange-500" /> Çalışma Sayacı</h3>
            <div className="flex bg-slate-800 rounded p-1">
              <button onClick={() => changeMode('pomodoro')} className={`px-3 py-1 text-xs font-bold rounded transition-colors ${timerMode === 'pomodoro' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:text-white'}`}>Pomodoro</button>
              <button onClick={() => changeMode('sprint')} className={`px-3 py-1 text-xs font-bold rounded transition-colors ${timerMode === 'sprint' ? 'bg-orange-500 text-white' : 'text-slate-400 hover:text-white'}`}>Sprint</button>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center py-4">
            <div className="text-5xl md:text-6xl font-mono font-bold text-white mb-6 tracking-wider">{formatTime(timeLeft)}</div>
            <div className="flex gap-4">
              <Button onClick={toggleTimer} size="large" className={isActive ? "bg-amber-600 hover:bg-amber-700" : "bg-emerald-600 hover:bg-emerald-700"}>
                {isActive ? (<><Pause size={20} /> Duraklat</>) : (<><Play size={20} /> Başlat</>)}
              </Button>
              <Button variant="secondary" onClick={() => resetTimer(timerMode)}><RotateCcw size={20} /> Sıfırla</Button>
            </div>
          </div>
        </Card>

        <div className="grid grid-cols-2 gap-4">
          <Card className={`${colors.bgCard} flex flex-col items-center justify-center text-center`}>
            <div className="w-12 h-12 rounded-full bg-orange-500/20 flex items-center justify-center mb-2 text-orange-500"><Clock size={24} /></div>
            <div className={`text-3xl font-bold ${colors.text}`}>{student.stats?.pomodoroCount || 0}</div>
            <div className={`text-xs ${colors.textSec} uppercase font-bold mt-1`}>Pomodoro</div>
          </Card>
          <Card className={`${colors.bgCard} flex flex-col items-center justify-center text-center`}>
            <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-2 text-blue-500"><Zap size={24} /></div>
            <div className={`text-3xl font-bold ${colors.text}`}>{student.stats?.sprintCount || 0}</div>
            <div className={`text-xs ${colors.textSec} uppercase font-bold mt-1`}>Sprint</div>
          </Card>
        </div>
      </div>
    </div>
  );
};

// TARİH FORMATLAYICI (GÜNCELLENDİ: Saat desteği eklendi)
const formatDate = (dateString, includeTime = false) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString; // Geçersiz tarihse olduğu gibi döndür

  const d = date.getDate().toString().padStart(2, '0');
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const y = date.getFullYear();

  if (includeTime) {
    const hours = date.getHours().toString().padStart(2, '0');
    const mins = date.getMinutes().toString().padStart(2, '0');
    return `${d}.${m}.${y} ${hours}:${mins}`;
  }
  return `${d}.${m}.${y}`;
};

//// --- GELİŞMİŞ GRAFİK BİLEŞENİ (DÜZELTİLDİ: X Ekseni Yazıları Kaldırıldı) ---
const LineChart = ({ data, dataKey, labelKey, subLabelKey = null, color = "#f97316", height = 250, showDots = true, strokeWidth = 3, maxValue = null, fixedRange = false }) => {
  const colors = useThemeColors();
  const containerRef = useRef(null);
  const [width, setWidth] = useState(600);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => { if (entries[0]) setWidth(entries[0].contentRect.width); });
    if (containerRef.current) resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  if (!data || data.length < 2) return <div className={`flex items-center justify-center ${colors.textSec} text-sm h-full`}>Veri yetersiz</div>;

  const calculatedMax = Math.max(...data.map(d => Number(d[dataKey]) || 0));
  const maxVal = fixedRange ? 100 : (maxValue || (calculatedMax * 1.15) || 10);
  const padding = 20; // Padding azaltıldı çünkü alt yazılar kalktı
  const effectiveHeight = height;

  const points = data.map((d, i) => {
    const x = (i / (data.length - 1)) * (width - 2 * padding) + padding;
    const y = effectiveHeight - padding - ((Number(d[dataKey]) / maxVal) * (effectiveHeight - 2 * padding));
    return [x, y];
  });

  const pathD = svgPath(points, bezierCommand);
  const fillPathD = `${pathD} L ${width - padding},${effectiveHeight - padding} L ${padding},${effectiveHeight - padding} Z`;

  return (
    <div ref={containerRef} className="w-full relative select-none" style={{ height: effectiveHeight }}>
      <svg viewBox={`0 0 ${width} ${effectiveHeight}`} className="w-full h-full overflow-visible">
        <defs>
          <linearGradient id={`gradient-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.3" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Y EKSENİ ÇİZGİLERİ */}
        {[0, 0.25, 0.5, 0.75, 1].map(p => {
          const y = effectiveHeight - padding - (p * (effectiveHeight - 2 * padding));
          return <line key={p} x1={padding} y1={y} x2={width - padding} y2={y} stroke={colors.chartGrid} strokeWidth="1" strokeDasharray="4" opacity="0.3" />;
        })}

        <path d={fillPathD} fill={`url(#gradient-${color.replace('#', '')})`} stroke="none" />
        <path d={pathD} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />

        {showDots && data.map((d, i) => {
          const [x, y] = points[i];
          return (
            <g key={i} className="group">
              {/* Nokta */}
              <circle cx={x} cy={y} r="4" fill={colors.bgCard} stroke={color} strokeWidth="2" className="transition-all duration-300 group-hover:r-6 cursor-pointer" />

              {/* Net Değeri (Noktanın üzerinde) */}
              <text x={x} y={y - 10} textAnchor="middle" stroke={colors.bgCard} strokeWidth="3" fontSize="11" fontWeight="bold" paintOrder="stroke">{Number(d[dataKey]).toFixed(1)}</text>
              <text x={x} y={y - 10} textAnchor="middle" fill={color} fontSize="11" fontWeight="bold">{Number(d[dataKey]).toFixed(1)}</text>

              {/* X EKSENİ YAZILARI VE DENEME İSİMLERİ KALDIRILDI */}
            </g>
          );
        })}
      </svg>
    </div>
  );
};

// --- EKSİLEN UI BİLEŞENLERİ (GÜNCELLENDİ: onKeyDown Eklendi) ---

const Input = ({ label, type = "text", value, onChange, placeholder, className = "", min, max, onKeyDown }) => {
  const colors = useThemeColors();
  return (
    <div className={`mb-4 ${className}`}>
      {label && <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase tracking-wider`}>{label}</label>}
      <input
        type={type}
        value={value === undefined || value === null ? '' : value}
        onChange={onChange}
        onKeyDown={onKeyDown} // YENİ EKLENDİ
        placeholder={placeholder}
        min={min}
        max={max}
        className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg px-4 py-3 ${colors.text} text-sm placeholder-slate-500 focus:outline-none focus:border-orange-500 transition-colors shadow-sm`}
      />
    </div>
  );
};

const Button = ({ children, onClick, variant = "primary", className = "", size = "normal", icon: Icon }) => {
  const colors = useThemeColors();
  const variants = {
    primary: "bg-orange-600 hover:bg-orange-700 text-white shadow-lg shadow-orange-500/30",
    secondary: `${colors.isDark ? 'bg-slate-800 text-slate-200' : 'bg-white text-slate-700'} hover:opacity-80 border ${colors.border} shadow-sm`,
    danger: "bg-red-500/10 text-red-500 hover:bg-red-500/20 border border-red-500/20",
    ghost: `bg-transparent ${colors.hoverBg} ${colors.textSec} hover:${colors.text}`
  };
  const sizes = { small: "px-3 py-1.5 text-xs", normal: "px-5 py-2.5 text-sm", large: "px-6 py-3 text-base" };
  return (
    <button onClick={onClick} className={`${variants[variant]} ${sizes[size]} rounded-lg font-medium transition-all flex items-center justify-center gap-2 ${className}`}>
      {Icon && <Icon size="16" />} {children}
    </button>
  );
};

const Card = ({ children, title, action, className = "" }) => {
  const colors = useThemeColors();
  return (
    <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 md:p-6 ${colors.shadow} transition-colors ${className}`}>
      {(title || action) && <div className={`flex flex-col md:flex-row justify-between items-start md:items-center mb-6 pb-4 border-b ${colors.border} gap-4`}>{title && <h3 className="text-lg font-bold text-orange-500 flex items-center gap-2">{title}</h3>}{action}</div>}
      {children}
    </div>
  );
};

const Modal = ({ title, children, onClose, maxWidth = "max-w-lg", footer, zIndex = "z-[60]" }) => {
  const colors = useThemeColors();
  return (
    <div className={`fixed inset-0 bg-black/80 backdrop-blur-sm ${zIndex} flex items-center justify-center p-3 sm:p-4 animate-fade-in`}>
      <div className={`${colors.bgCard} border ${colors.border} rounded-2xl w-full ${maxWidth} shadow-2xl flex flex-col max-h-[92vh] overflow-hidden`}>
        <div className={`flex justify-between items-center px-6 py-4 border-b ${colors.border} shrink-0`}>
          <h3 className={`text-lg sm:text-xl font-bold ${colors.text}`}>{title}</h3>
          <button
            onClick={onClose}
            className={`p-1.5 rounded-lg ${colors.textSec} hover:${colors.text} hover:${colors.hoverBg} transition-colors`}
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-6 overflow-y-auto custom-scrollbar flex-1">{children}</div>
        {footer && (
          <div className={`px-6 py-4 border-t ${colors.border} ${colors.isDark ? 'bg-slate-900/90' : 'bg-slate-50/90'} backdrop-blur shrink-0`}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

const ProfileSettingsModal = ({ user, onClose, onUpdate }) => {
  const [form, setForm] = useState({ name: user.name, username: user.username || '', password: user.password || '' });
  const colors = useThemeColors();

  const handleSave = () => {
    if (!form.username || !form.password) return alert("Kullanıcı adı ve şifre boş bırakılamaz.");
    onUpdate({ ...user, ...form });
    onClose();
  };

  return (
    <Modal title="Profil Ayarları" onClose={onClose}>
      <div className="space-y-4">
        <Input label="Ad Soyad" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
        <div className={`p-4 rounded-lg border ${colors.border} ${colors.isDark ? 'bg-slate-800/50' : 'bg-slate-50'}`}>
          <h4 className="text-orange-500 font-bold text-xs uppercase mb-3 flex items-center gap-2"><Lock size={12} /> Güvenlik Bilgileri</h4>
          <div className="space-y-4">
            <Input label="Kullanıcı Adı" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
            <Input label="Yeni Şifre" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Yeni şifrenizi giriniz" />
          </div>
        </div>
        <Button className="w-full" onClick={handleSave}>Değişiklikleri Kaydet</Button>
      </div>
    </Modal>
  );
};

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "İşlem Onayı",
  message = "Bu işlemi yapmak istediğinize emin misiniz?",
  confirmText = "Evet, Onayla",
  cancelText = "Vazgeç",
  variant = "danger",
  icon: Icon = null,
  zIndex = "z-[110]"
}) => {
  const colors = useThemeColors();
  if (!isOpen) return null;
  return (
    <Modal title={title} onClose={onClose} maxWidth="max-w-md" zIndex={zIndex}>
      <div className="space-y-5">
        <p className={`${colors.text} text-sm leading-relaxed whitespace-pre-line`}>
          {message}
        </p>
        <div className="flex items-center justify-end gap-3 pt-3 border-t border-slate-700/30">
          <Button variant="secondary" onClick={onClose} size="small">
            {cancelText}
          </Button>
          <Button
            variant={variant === 'success' ? 'primary' : variant}
            className={variant === 'success' ? '!bg-emerald-600 hover:!bg-emerald-500 !text-white shadow-lg shadow-emerald-900/30' : ''}
            onClick={onConfirm}
            size="small"
            icon={Icon}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title = "Silme Onayı", message = "Bu öğeyi silmek istediğinize emin misiniz? Bu işlem geri alınamaz.", zIndex = "z-[110]" }) => {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      confirmText="Evet, Sil"
      cancelText="İptal"
      variant="danger"
      icon={Trash2}
      zIndex={zIndex}
    />
  );
};

// --- YÖNETİCİ YÖNETİMİ (GÜNCELLENMİŞ: Sınav Tarihleri Ayarı Eklendi) ---
const AdminManagementModule = ({ admins, setAdmins, user, allStudents, onInspectStudent, notifications, setNotifications, systemSettings, setSystemSettings }) => {
  const [showModal, setShowModal] = useState(false);
  const [editingAdmin, setEditingAdmin] = useState(null);
  const [form, setForm] = useState({ name: '', username: '', password: '', startDate: '', endDate: '', studentLimit: 20 });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
    const [expandedAdminId, setExpandedAdminId] = useState(null);
    
  // Sınav Tarihleri Formu
  const [datesForm, setDatesForm] = useState(systemSettings || { tytDate: '', aytDate: '', lgsDate: '' });

  useEffect(() => {
    if (systemSettings) {
      setDatesForm(systemSettings);
    }
  }, [systemSettings]);

  const colors = useThemeColors();

  if (user.role !== 'superadmin') return <div className={`${colors.text} text-center`}>Bu sayfaya erişim yetkiniz yok.</div>;

  const handleEdit = (admin) => {
    setEditingAdmin(admin);
    setForm({
      name: admin.name,
      username: admin.username,
      password: admin.password,
      startDate: admin.startDate || new Date().toISOString().split('T')[0],
      endDate: admin.endDate || new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      studentLimit: admin.studentLimit || 20
    });
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!form.name || !form.username || !form.password) {
      if (window.toast?.warning) return window.toast.warning("Tüm alanları doldurunuz.");
      return alert("Tüm alanları doldurunuz.");
    }
    const adminExists = admins.some(a => a.username === form.username && a.id !== editingAdmin?.id);
    const studentExists = allStudents.some(s => s.username === form.username);
    if (adminExists || studentExists) {
      if (window.toast?.warning) return window.toast.warning("Bu kullanıcı adı sistemde kayıtlı.");
      return alert("Bu kullanıcı adı sistemde kayıtlı.");
    }

    const limit = parseInt(form.studentLimit);
    const safeLimit = isNaN(limit) ? 20 : limit;
    const adminData = { ...form, studentLimit: safeLimit };

    if (editingAdmin) {
      if (isFirebaseActive) {
        try {
          const { id, ...dataToUpdate } = adminData;
          await setDoc(doc(db, "admins", editingAdmin.id), dataToUpdate, { merge: true });
          if (window.toast?.success) window.toast.success("Öğretmen lisansı güncellendi.");
        } catch (e) {
          console.error(e);
          if (window.toast?.error) window.toast.error("Hata oluştu: " + e.message);
          else alert("Hata oluştu: " + e.message);
        }
      } else {
        setAdmins(admins.map(a => a.id === editingAdmin.id ? { ...editingAdmin, ...adminData } : a));
        if (window.toast?.success) window.toast.success("Öğretmen lisansı güncellendi.");
      }
    } else {
      const newAdmin = { ...adminData, role: 'admin' };
      if (isFirebaseActive) {
        try {
          await addDoc(collection(db, "admins"), newAdmin);
          if (window.toast?.success) window.toast.success("Yeni öğretmen eklendi.");
        } catch (e) {
          console.error(e);
          if (window.toast?.error) window.toast.error("Hata oluştu: " + e.message);
          else alert("Hata oluştu.");
        }
      } else {
        setAdmins([...admins, { id: Date.now().toString(), ...newAdmin }]);
        if (window.toast?.success) window.toast.success("Yeni öğretmen eklendi.");
      }
    }
    setShowModal(false);
    setForm({ name: '', username: '', password: '', startDate: '', endDate: '', studentLimit: 20 });
    setEditingAdmin(null);
  };

  

  // SINAV TARİHLERİNİ KAYDETME (Firebase Yetki Korumalı & Çift Katmanlı Eşitleme)
  const handleSaveDates = async () => {
    const cleanDates = sanitizeForFirestore(datesForm);
    setSystemSettings(cleanDates);
    try {
      localStorage.setItem('exam_dates', JSON.stringify(cleanDates));
    } catch (e) {
      console.warn("LocalStorage kaydetme uyarısı:", e);
    }

    if (isFirebaseActive) {
      // 1. Birincil & Garantili Depolama: Admin Dokümanına Kaydet (Firestore kuralları admin koleksiyonuna her zaman izin verir)
      if (user?.id) {
        try {
          await setDoc(doc(db, "admins", String(user.id)), { examDates: cleanDates }, { merge: true });
        } catch (e1) {
          console.warn("Admin dokümanına sınav tarihleri kaydedilemedi:", e1);
        }
      }

      // 2. Standart Koleksiyon: settings/exam_dates (Firebase kurallarında /settings açıksa oraya da yazar)
      try {
        await setDoc(doc(db, "settings", "exam_dates"), cleanDates);
      } catch (e2) {
        // İzin hatası varsa konsola bilgi yaz, kullanıcıya hata pop-up'ı çıkarma çünkü admin dokümanından senkronize oldu
        console.warn("settings/exam_dates Firestore izni kısıtlı (admin dokümanı üzerinden senkronize edildi):", e2.message);
      }

      if (window.toast?.success) {
        window.toast.success("Sınav tarihleri başarıyla güncellendi ve tüm öğrencilerde aktif oldu.");
      } else {
        alert("Sınav tarihleri güncellendi ve tüm öğrencilerde aktif oldu.");
      }
    } else {
      if (window.toast?.success) {
        window.toast.success("Sınav tarihleri yerel olarak kaydedildi.");
      } else {
        alert("Sınav tarihleri güncellendi ve tüm öğrencilerde aktif oldu.");
      }
    }
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="flex justify-between items-center"><h2 className={`text-2xl font-bold ${colors.text}`}>Yönetici & Lisans Paneli</h2><Button icon={Plus} onClick={() => { setEditingAdmin(null); setForm({ name: '', username: '', password: '', startDate: new Date().toISOString().split('T')[0], endDate: '', studentLimit: 20 }); setShowModal(true); }}>Yeni Öğretmen Ekle</Button></div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {admins.map(admin => {
          const adminStudents = allStudents.filter(s => s.teacherId === admin.id);
          const isExpanded = expandedAdminId === admin.id;
          const daysLeft = admin.endDate ? Math.ceil((new Date(admin.endDate) - new Date()) / (1000 * 60 * 60 * 24)) : 0;
          const isExpired = daysLeft < 0;
          return (
            <div key={admin.id} className={`${colors.bgCard} border ${colors.border} rounded-xl p-6 relative group transition-all ${isExpanded ? 'row-span-2 shadow-xl border-orange-500/30' : ''}`}>
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 ${isExpired ? 'bg-red-500/20 text-red-500' : 'bg-emerald-500/20 text-emerald-500'} rounded-full flex items-center justify-center shrink-0`}><User size={24} /></div>
                <div className="overflow-hidden flex-1"><h3 className={`font-bold ${colors.text} truncate`}>{admin.name}</h3><div className={`text-xs ${colors.textSec}`}>Kullanılan: {adminStudents.length} / {admin.studentLimit || '∞'}</div><div className={`text-[10px] font-bold mt-1 ${isExpired ? 'text-red-500' : 'text-emerald-500'}`}>{isExpired ? 'SÜRESİ BİTTİ' : `${daysLeft} Gün Kaldı`}</div></div>
              </div>
              <div className="mt-4 flex gap-2"><button onClick={() => setExpandedAdminId(isExpanded ? null : admin.id)} className={`flex-1 py-2 rounded text-xs font-bold flex items-center justify-center gap-1 transition-colors ${isExpanded ? 'bg-orange-500 text-white' : `${colors.isDark ? 'bg-slate-800 text-slate-400 hover:text-white' : 'bg-slate-100 text-slate-600 hover:text-slate-900'}`}`}><Users size={14} /> {isExpanded ? 'Gizle' : 'Öğrenciler'}</button><button onClick={() => handleEdit(admin)} className={`p-2 ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} rounded text-slate-600 hover:text-blue-500 hover:bg-blue-500/10 transition-colors`}><Edit2 size={16} /></button><button onClick={() => { if (admin.id === user.id) { if (window.toast?.warning) return window.toast.warning("Kendinizi silemezsiniz."); return alert("Kendinizi silemezsiniz."); } setDeleteConfirm(admin.id); }} className={`p-2 ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} rounded text-slate-600 hover:text-red-500 hover:bg-red-500/10 transition-colors`}><Trash2 size={16} /></button></div>
              {isExpanded && (<div className={`mt-4 pt-4 border-t ${colors.border} animate-fade-in`}><h4 className={`text-xs uppercase font-bold ${colors.textSec} mb-2`}>Öğrenci Listesi</h4><div className="space-y-2 max-h-60 overflow-y-auto custom-scrollbar">{adminStudents.map(st => (<div key={st.id} onClick={() => onInspectStudent(st.id)} className={`flex justify-between items-center p-2 rounded ${colors.isDark ? 'bg-slate-800/50 hover:bg-slate-800' : 'bg-slate-100 hover:bg-slate-200'} cursor-pointer transition-colors border border-transparent hover:border-slate-400`}><div><div className={`text-sm font-medium ${colors.text}`}>{st.name}</div><div className={`text-[10px] ${colors.textSec}`}>{st.grade}</div></div><Eye size={14} className={`${colors.textSec} hover:text-orange-500`} /></div>))}{adminStudents.length === 0 && <div className={`text-center text-xs ${colors.textSec} py-2`}>Öğrenci bulunamadı.</div>}</div></div>)}
            </div>
          );
        })}
      </div>

      {/* SİSTEM AYARLARI & BİLDİRİM */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* SINAV TARİHLERİ AYARI */}
        <div className={`p-6 ${colors.bgCardTransparent} border ${colors.border} rounded-xl`}>
          <h3 className={`text-lg font-bold ${colors.text} mb-4 flex items-center gap-2`}><Calendar className="text-orange-500" /> Sınav Takvimi</h3>
          <div className="space-y-4">
            <div>
              <label className={`text-xs font-bold ${colors.textSec}`}>YKS - TYT Tarihi</label>
              <input type="date" value={datesForm.tytDate || ''} onChange={e => setDatesForm({ ...datesForm, tytDate: e.target.value })} className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 text-sm ${colors.text}`} />
            </div>
            <div>
              <label className={`text-xs font-bold ${colors.textSec}`}>YKS - AYT Tarihi</label>
              <input type="date" value={datesForm.aytDate || ''} onChange={e => setDatesForm({ ...datesForm, aytDate: e.target.value })} className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 text-sm ${colors.text}`} />
            </div>
            <div>
              <label className={`text-xs font-bold ${colors.textSec}`}>LGS Tarihi</label>
              <input type="date" value={datesForm.lgsDate || ''} onChange={e => setDatesForm({ ...datesForm, lgsDate: e.target.value })} className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 text-sm ${colors.text}`} />
            </div>
            <Button onClick={handleSaveDates} className="w-full">Tarihleri Güncelle</Button>
          </div>
        </div>

        {/* POP-UP & PUSH BİLDİRİM KARTI */}
        <div className={`lg:col-span-2 p-6 ${colors.bgCardTransparent} border ${colors.border} rounded-xl flex flex-col justify-between`}>
          <div>
            <div className="flex items-center gap-2 mb-2 text-orange-500 font-bold text-lg">
              <Megaphone size={22} />
              <span>Pop-up & Push Bildirim Merkezi</span>
            </div>
            <p className={`text-sm ${colors.textSec} leading-relaxed mb-4`}>
              Tüm öğrencilere ve öğretmenlere mobil uygulama kapalıyken üstten düşen anlık Push Bildirimleri veya uygulama içi Pop-up pencereleri göndermek için sol menüdeki <b>Pop-up & Push Bildirim</b> sekmesini kullanabilirsiniz.
            </p>
          </div>
          <div>
            <span className="text-xs px-3 py-1.5 rounded-lg bg-orange-500/10 text-orange-400 border border-orange-500/30 font-semibold inline-flex items-center gap-1.5">
              <Zap size={14} /> Yeni Nesil Bildirim Sistemi Aktif
            </span>
          </div>
        </div>
      </div>

      {showModal && (<Modal title={editingAdmin ? "Öğretmen Lisans Düzenle" : "Yeni Öğretmen Ekle"} onClose={() => setShowModal(false)}><div className="space-y-4"><Input label="Ad Soyad" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /><Input label="Kullanıcı Adı" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} /><Input label="Şifre" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} /><div className="grid grid-cols-2 gap-4 bg-orange-500/10 p-3 rounded-lg border border-orange-500/20"><div><label className={`block text-xs font-bold ${colors.textSec} mb-1`}>Başlangıç Tarihi</label><input type="date" className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 ${colors.text} text-sm`} value={form.startDate} onChange={e => setForm({ ...form, startDate: e.target.value })} /></div><div><label className={`block text-xs font-bold ${colors.textSec} mb-1`}>Bitiş Tarihi</label><input type="date" className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 ${colors.text} text-sm`} value={form.endDate} onChange={e => setForm({ ...form, endDate: e.target.value })} /></div><div className="col-span-2"><Input label="Öğrenci Kayıt Limiti" type="number" value={form.studentLimit} onChange={e => setForm({ ...form, studentLimit: e.target.value })} /></div></div><Button className="w-full" onClick={handleSave}>{editingAdmin ? "Güncelle" : "Kaydet"}</Button></div></Modal>)}
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={async () => {
        const adminIdToDelete = deleteConfirm;
        if (isFirebaseActive) {
          await deleteDoc(doc(db, "admins", adminIdToDelete));
          const coachStudents = (allStudents || []).filter(s => String(s.teacherId) === String(adminIdToDelete));
          for (const st of coachStudents) {
            try { await deleteDoc(doc(db, "students", String(st.id))); } catch (e) { console.warn("Öğrenci silme hatası:", e); }
          }
        } else {
          setAdmins(admins.filter(a => a.id !== adminIdToDelete));
        }
        setDeleteConfirm(null);
      }} />
    </div>
  );
};

// 0. DASHBOARD (GÜNCELLENMİŞ: SINAV GERİ SAYIM SAYACI + WhatsApp + Mobil Menü)
const DashboardModule = ({ user, students, setStudents, setSelectedStudentId, onUpdateStudent, classes, setClasses, licenseInfo, admins, setIsMobileMenuOpen, selectedStudentId, systemSettings, archivedStudents }) => {
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ name: '', grade: '', target: '', phone: '', school: '', username: '', password: '', classId: '', allowedExams: ['LGS', 'YKS', 'KPSS'] });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const colors = useThemeColors();

  // --- SINAV GERİ SAYIM HESAPLAYICI ---
  const calculateTimeLeft = (targetDate) => {
    if (!targetDate) return null;
    const difference = +new Date(targetDate) - +new Date();
    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, expired: true };

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      expired: false
    };
  };

  const handleWhatsApp = (e, phone) => {
    e.stopPropagation();
    if (!phone) return alert("Bu öğrencinin telefon numarası kayıtlı değil.");
    const cleanPhone = phone.replace(/[^0-9]/g, '');
    window.open(`https://wa.me/90${cleanPhone.replace(/^0/, '').replace(/^90/, '')}`, '_blank');
  };

  const handleSave = async () => {
    if (!form.name || !form.username) return alert("Zorunlu alanları doldurun.");
    const studentExists = students.some(s => s.username === form.username && s.id !== editingId);
    const adminExists = admins.some(a => a.username === form.username);
    if (studentExists || adminExists) return alert("Bu kullanıcı adı zaten kullanımda.");

    if (!editingId && user.role === 'admin' && licenseInfo && licenseInfo.used >= licenseInfo.limit) return alert(`Kota doldu!`);
    const data = { ...form, teacherId: user.id, ...(!editingId && { createdAt: new Date().toISOString(), exams: [], moods: [], lessons: {}, payments: [], teacherNotes: [], assignments: [], pastWeeks: [], diary: [], stats: { totalSolved: 0, monthlySolved: 0 } }) };
    if (editingId) { const s = students.find(x => x.id === editingId); onUpdateStudent({ ...s, ...data }); setEditingId(null); }
    else {
      if (isFirebaseActive) await addDoc(collection(db, "students"), data);
      else setStudents([...students, { id: Date.now(), ...data }]);
    }

    setShowModal(false);
    setForm({ name: '', grade: '', target: '', phone: '', school: '', username: '', password: '', classId: '', allowedExams: ['LGS', 'YKS', 'KPSS'] });
  };

  const handleEdit = (student) => {
    setForm({ name: student.name, grade: student.grade, target: student.target, phone: student.phone, school: student.school, username: student.username, password: student.password, classId: student.classId || '', allowedExams: student.allowedExams || ['LGS', 'YKS', 'KPSS'] });
    setEditingId(student.id); setShowModal(true);
  };
  const confirmDelete = async () => {
    if (deleteConfirm) {
      if (isFirebaseActive) await deleteDoc(doc(db, "students", deleteConfirm));
      else setStudents(students.filter(s => s.id !== deleteConfirm)); setSelectedStudentId(null); setDeleteConfirm(null);
    }
  };
  const filteredStudents = students.filter(student => {
    return student.name.toLowerCase().includes(searchQuery.toLowerCase());
  });
  const handleSelectStudent = (id) => {
    setSelectedStudentId(id);
    if (window.innerWidth < 768) {
      setIsMobileMenuOpen(true);
    }
  };

  // ÖĞRENCİ PANELİ
  if (user.role === 'student') {
    const s = students.find(s => s.id === user.id);
    if (!s) return <div>Yükleniyor...</div>;

    // SINAV TÜRÜ ALGILAMA (OTOMATİK)
    const gradeLower = s.grade?.toLowerCase() || '';
    const isLGS = gradeLower.includes('8') || gradeLower.includes('lgs') || gradeLower.includes('ortaokul') || gradeLower.includes('7');
    const isYKS = gradeLower.includes('11') || gradeLower.includes('12') || gradeLower.includes('mezun') || gradeLower.includes('yks') || gradeLower.includes('tyt') || gradeLower.includes('9') || gradeLower.includes('10');

    const tytTime = systemSettings?.tytDate ? calculateTimeLeft(systemSettings.tytDate) : null;
    const lgsTime = systemSettings?.lgsDate ? calculateTimeLeft(systemSettings.lgsDate) : null;

    const parseTrDate = (dateStr) => {
      if (!dateStr || typeof dateStr !== 'string') return null;
      const parts = dateStr.split('.').map(p => p.trim()).filter(Boolean);
      if (parts.length !== 3) return null;
      const [dd, mm, yyyy] = parts;
      const d = new Date(parseInt(yyyy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
      return Number.isNaN(d.getTime()) ? null : d;
    };

    const assignments = Array.isArray(s.assignments) ? s.assignments : [];
    const thisWeekCompletedCount = assignments.filter(a => a.status === 'completed').length;
    const thisWeekRemainingCount = assignments.filter(a => a.status !== 'completed').length;

    const thisWeekSolvedQuestions = assignments.reduce((acc, curr) => {
      const target = parseInt(curr.count) || 0;
      const solved = (curr.solvedCount !== undefined && curr.solvedCount !== '') ? (parseInt(curr.solvedCount) || 0) : (curr.status === 'completed' ? target : 0);
      return acc + solved;
    }, 0);

    const topicCompletedCount = Object.values(s.lessons || {}).filter(l => l && l.konu).length;

    const now = new Date();
    const last7 = new Date(now); last7.setDate(now.getDate() - 7);
    const last30 = new Date(now); last30.setDate(now.getDate() - 30);

    const solvedEntries = [
      ...((Array.isArray(s.pastWeeks) ? s.pastWeeks : []).map(w => ({
        date: parseTrDate(w.date),
        solved: parseInt(w.solvedCount, 10) || 0,
      })).filter(e => e.date)),
      { date: now, solved: thisWeekSolvedQuestions },
    ];

    const solvedLast7Days = solvedEntries.filter(e => e.date >= last7).reduce((acc, e) => acc + e.solved, 0);
    const solvedLast30Days = solvedEntries.filter(e => e.date >= last30).reduce((acc, e) => acc + e.solved, 0);
    const solvedAllTime = s.stats?.totalSolved || 0;

    const exams = Array.isArray(s.exams) ? s.exams : [];
    const totalExamCount = exams.length;
    const lastTYT = exams.find(e => (e.type || '').toUpperCase() === 'TYT') || null;
    const lastAYT = exams.find(e => (e.type || '').toUpperCase() === 'AYT') || null;
    const lastLGS = exams.find(e => (e.type || '').toUpperCase() === 'LGS') || null;
    const lastKPSS = exams.find(e => (e.type || '').toUpperCase() === 'KPSS') || null;
    const lastTYTNet = lastTYT?.totalNet;
    const lastAYTNet = lastAYT?.totalNet;
    const lastLGSNet = lastLGS?.totalNet;
    const lastKPSSNet = lastKPSS?.totalNet;

    const allowed = s.allowedExams || ['LGS', 'YKS', 'KPSS'];
    const showYKS = allowed.includes('YKS');
    const showLGS = allowed.includes('LGS');
    const showKPSS = allowed.includes('KPSS');

    return (
      <div className="space-y-6 animate-fade-in">
        {/* GERİ SAYIM KARTI */}
        {((isYKS && tytTime) || (isLGS && lgsTime)) && (
          <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-xl p-6 text-white shadow-lg relative overflow-hidden">
            <div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-center md:text-left">
                <h2 className="text-2xl font-bold tracking-tight">{isLGS ? 'LGS Sınavı' : 'YKS (TYT) Sınavı'}</h2>
                <p className="text-white/80 text-sm">Hedefine ulaşmak için kalan süren:</p>
              </div>
              <div className="flex gap-4">
                {isLGS && lgsTime && (
                  <>
                    <div className="text-center"><div className="text-3xl font-bold font-mono">{lgsTime.days}</div><div className="text-xs uppercase opacity-75">Gün</div></div>
                    <div className="text-center"><div className="text-3xl font-bold font-mono">{lgsTime.hours}</div><div className="text-xs uppercase opacity-75">Saat</div></div>
                  </>
                )}
                {isYKS && tytTime && (
                  <>
                    <div className="text-center"><div className="text-3xl font-bold font-mono">{tytTime.days}</div><div className="text-xs uppercase opacity-75">Gün</div></div>
                    <div className="text-center"><div className="text-3xl font-bold font-mono">{tytTime.hours}</div><div className="text-xs uppercase opacity-75">Saat</div></div>
                  </>
                )}
              </div>
            </div>
            {/* Arkaplan Süsü */}
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full blur-xl"></div>
          </div>
        )}

        {s.teacherNotes && s.teacherNotes.length > 0 && (
          <div className="mt-4">
            <Card title="Öğretmenden Notlar" className={`border-l-4 border-l-orange-500 ${colors.bgCard}`}>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {s.teacherNotes.map((note, idx) => (
                  <div key={idx} className={`${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} p-4 rounded-lg border ${colors.border}`}>
                    <div className="flex items-center gap-2 mb-2">
                      <MessageSquare size={14} className="text-orange-500" />
                      <span className={`text-xs font-bold ${colors.textSec}`}>{note.date}</span>
                    </div>
                    <p className={`${colors.text} text-sm italic whitespace-pre-wrap`}>"{note.text}"</p>
                  </div>
                ))}
              </div>
            </Card>
          </div>
        )}

        <div className="mt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            <Card className={`border-l-4 border-l-blue-500 ${colors.bgCard}`}>
              <div className={`${colors.textSec} text-xs uppercase font-bold mb-2`}>Toplam Deneme</div>
              <div className={`text-4xl font-bold ${colors.text}`}>{totalExamCount || 0}</div>
              <div className="mt-2 space-y-1">
                {showYKS && (
                  <>
                    <div className={`text-xs ${colors.textSec} flex justify-between`}>
                      <span>TYT:</span>
                      <span className={`${colors.text} font-bold`}>{typeof lastTYTNet === 'number' ? lastTYTNet.toFixed(1) : '-'}</span>
                    </div>
                    <div className={`text-xs ${colors.textSec} flex justify-between`}>
                      <span>AYT:</span>
                      <span className={`${colors.text} font-bold`}>{typeof lastAYTNet === 'number' ? lastAYTNet.toFixed(1) : '-'}</span>
                    </div>
                  </>
                )}
                {showLGS && (
                  <div className={`text-xs ${colors.textSec} flex justify-between`}>
                    <span>LGS:</span>
                    <span className={`${colors.text} font-bold`}>{typeof lastLGSNet === 'number' ? lastLGSNet.toFixed(1) : '-'}</span>
                  </div>
                )}
                {showKPSS && (
                  <div className={`text-xs ${colors.textSec} flex justify-between`}>
                    <span>KPSS:</span>
                    <span className={`${colors.text} font-bold`}>{typeof lastKPSSNet === 'number' ? lastKPSSNet.toFixed(1) : '-'}</span>
                  </div>
                )}
              </div>
            </Card>

            <Card className={`border-l-4 border-l-green-500 ${colors.bgCard}`}>
              <div className={`${colors.textSec} text-xs uppercase font-bold mb-2`}>Bitirilen Konu</div>
              <div className={`text-4xl font-bold ${colors.text}`}>{topicCompletedCount || 0}</div>
            </Card>

            <Card className={`border-l-4 border-l-emerald-500 ${colors.bgCard}`}>
              <div className={`${colors.textSec} text-xs uppercase font-bold mb-2`}>Bu Hafta Ödev</div>
              <div className="grid grid-cols-2 gap-3 mt-1">
                <div className={`${colors.isDark ? 'bg-slate-800/60' : 'bg-slate-100'} rounded-lg p-3 border ${colors.border} text-center`}>
                  <div className="text-[10px] uppercase font-bold text-emerald-500">Tamamlanan</div>
                  <div className={`text-2xl font-bold ${colors.text}`}>{thisWeekCompletedCount || 0}</div>
                </div>
                <div className={`${colors.isDark ? 'bg-slate-800/60' : 'bg-slate-100'} rounded-lg p-3 border ${colors.border} text-center`}>
                  <div className="text-[10px] uppercase font-bold text-orange-500">Kalan</div>
                  <div className={`text-2xl font-bold ${colors.text}`}>{thisWeekRemainingCount || 0}</div>
                </div>
              </div>
            </Card>

            <Card className={`border-l-4 border-l-orange-500 ${colors.bgCard}`}>
              <div className={`${colors.textSec} text-xs uppercase font-bold mb-2`}>Haftalık Soru (7 Gün)</div>
              <div className={`text-4xl font-bold ${colors.text}`}>{solvedLast7Days || 0}</div>
            </Card>

            <Card className={`border-l-4 border-l-purple-500 ${colors.bgCard}`}>
              <div className={`${colors.textSec} text-xs uppercase font-bold mb-2`}>Aylık Soru (30 Gün)</div>
              <div className={`text-4xl font-bold ${colors.text}`}>{solvedLast30Days || 0}</div>
            </Card>

            <Card className={`border-l-4 border-l-slate-500 ${colors.bgCard}`}>
              <div className={`${colors.textSec} text-xs uppercase font-bold mb-2`}>Toplam Soru</div>
              <div className={`text-4xl font-bold ${colors.text}`}>{solvedAllTime || 0}</div>
            </Card>
          </div>
        </div>

      </div>
    );
  }

  // ÖĞRETMEN PANELİ
  return (
    <div className="space-y-8 animate-fade-in">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <h2 className={`text-2xl font-bold ${colors.text}`}>Öğrenci Portföyü</h2>
        <div className="grid grid-cols-2 gap-2 w-full md:flex md:flex-row md:w-auto">
          <Button variant="secondary" icon={Archive} onClick={() => setShowArchiveModal(true)} className="w-full justify-center text-xs sm:text-sm">Arşiv</Button>
          <Button icon={Plus} onClick={() => setShowModal(true)} className="w-full justify-center text-xs sm:text-sm">Yeni Öğrenci Ekle</Button>
        </div>
      </div>
      <div className={`p-4 ${colors.bgCardTransparent} border ${colors.border} rounded-xl`}>
        <Input placeholder="Öğrenci adı ile ara..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="mb-0" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredStudents.map(student => {
          const isSelected = selectedStudentId === student.id;
          return (
            <div key={student.id} className={`${colors.bgCard} border ${isSelected ? 'border-emerald-500' : colors.border} rounded-xl p-6 hover:border-orange-500/50 transition-all group relative ${colors.shadow}`}>
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-4 cursor-pointer" onClick={() => handleSelectStudent(student.id)}>
                  <div className={`w-16 h-16 bg-gradient-to-br ${colors.isDark ? 'from-slate-800 to-slate-700' : 'from-slate-200 to-slate-100'} rounded-full flex items-center justify-center text-2xl font-bold ${colors.text} border ${colors.border}`}>{student.name.charAt(0)}</div>
                  <div><h3 className={`text-lg font-bold ${colors.text} group-hover:text-orange-400 transition-colors`}>{student.name}</h3><div className={`text-sm ${colors.textSec}`}>{student.grade}</div></div>
                </div>
                <div className="flex gap-2"><button onClick={(e) => {
                  e.stopPropagation();
                  handleEdit(student)
                }} className={`p-2 ${colors.textSec} hover:text-blue-400 ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} rounded-lg`} title="Düzenle"><Edit2 size={16} /></button><button onClick={async (e) => {
                  e.stopPropagation(); e.preventDefault();
                  if (window.confirm(`${student.name} isimli öğrenci arşive eklensin mi?`)) {
                    await onUpdateStudent({ ...student, isArchived: true });
                    alert("Öğrenci arşive eklendi.");
                  }
                }} className={`p-2 ${colors.textSec} hover:text-amber-500 ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} rounded-lg`} title="Arşive Ekle"><Archive size={16} /></button><button onClick={(e) => {
                  e.stopPropagation(); e.preventDefault();
                  setDeleteConfirm(student.id);
                }} className={`p-2 ${colors.textSec} hover:text-red-500 ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} rounded-lg`} title="Sil"><Trash2 size={16} /></button></div>
              </div>

              <div className="flex gap-2">
                <button onClick={(e) => handleWhatsApp(e, student.phone)} className={`px-3 py-2.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white transition-colors flex items-center justify-center`} title="WhatsApp">
                  <MessageCircle size={18} />
                </button>

                <Button className={`flex-1 ${isSelected ? '!bg-emerald-600 !text-white' : ''}`} variant={isSelected ? "primary" : "secondary"} onClick={() => handleSelectStudent(student.id)}>
                  {isSelected ? (<><Check size={16} /> Seçildi</>) : (<>Profile Git <ChevronRight size={16} /></>)}
                </Button>
              </div>
            </div>
          );
        })}
        {filteredStudents.length === 0 && <div className={`col-span-full text-center py-12 ${colors.textSec}`}>Aradığınız kriterlere uygun öğrenci bulunamadı.</div>}
      </div>

      
      {showModal && (<Modal title={editingId ? "Öğrenci Düzenle" : "Yeni Öğrenci Ekle"} onClose={() => {
        setShowModal(false); setEditingId(null);
        setForm({ name: '', grade: '', target: '', phone: '', school: '', username: '', password: '', classId: '', allowedExams: ['LGS', 'YKS', 'KPSS'] });
      }}><div className="grid grid-cols-1 md:grid-cols-2 gap-4"><Input label="Ad Soyad" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /><Input label="Sınıf Düzeyi" value={form.grade} onChange={e => setForm({ ...form, grade: e.target.value })} /><Input label="Hedef" value={form.target} onChange={e => setForm({ ...form, target: e.target.value })} /><Input label="Okul" value={form.school} onChange={e => setForm({ ...form, school: e.target.value })} /><Input label="Telefon" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} /><div className="col-span-1 md:col-span-2"><label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase tracking-wider`}>Aktif Sınav Türleri</label><div className="flex gap-4">{['LGS', 'YKS', 'KPSS'].map(exam => { const isChecked = (form.allowedExams || []).includes(exam); return (<label key={exam} className={`flex items-center gap-2 cursor-pointer ${colors.text} text-sm`}><input type="checkbox" checked={isChecked} onChange={() => { const currentExams = form.allowedExams || []; const nextExams = currentExams.includes(exam) ? currentExams.filter(e => e !== exam) : [...currentExams, exam]; setForm({ ...form, allowedExams: nextExams }); }} className="rounded border-slate-600 text-orange-600 focus:ring-orange-500" />{exam}</label>); })}</div></div><div className={`col-span-1 md:col-span-2 p-4 ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} rounded-lg border ${colors.border} mt-2`}><h4 className="text-orange-500 font-bold text-xs uppercase mb-3">Giriş Bilgileri</h4><div className="grid grid-cols-2 gap-4"><Input label="Kullanıcı Adı" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} /><Input label="Şifre" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} /></div></div><div className="col-span-1 md:col-span-2 pt-4"><Button size="large" className="w-full" onClick={handleSave}>Kaydet</Button></div></div></Modal>)}


      {showArchiveModal && (
        <Modal title="Arşivlenmiş Öğrenciler" onClose={() => setShowArchiveModal(false)}>
          <div className="space-y-4">
            <div className="bg-orange-500/10 p-3 rounded text-orange-500 text-xs font-semibold">
              Burada arşivlenen öğrenciler yer alır. İstediğiniz öğrenciyi tekrar aktif listeye alabilirsiniz.
            </div>
            <div className="space-y-2 max-h-60 overflow-y-auto custom-scrollbar">
              {archivedStudents && archivedStudents.map(student => (
                <div key={student.id} className={`flex justify-between items-center p-3 rounded border ${colors.border} ${colors.bgCard}`}>
                  <div>
                    <span className={`font-bold ${colors.text}`}>{student.name}</span>
                    <div className={`text-xs ${colors.textSec}`}>{student.grade}</div>
                  </div>
                  <button onClick={async () => {
                    if (window.confirm(`${student.name} isimli öğrenci arşivden çıkarılsın mı?`)) {
                      await onUpdateStudent({ ...student, isArchived: false });
                      alert("Öğrenci aktif listeye taşındı.");
                    }
                  }} className="px-3 py-1.5 rounded-lg bg-orange-600 hover:bg-orange-700 text-white text-xs font-bold transition-all flex items-center gap-1">
                    <RotateCcw size={14} /> Aktife Al
                  </button>
                </div>
              ))}
              {(!archivedStudents || archivedStudents.length === 0) && (
                <div className={`text-center py-4 ${colors.textSec} text-xs italic`}>
                  Arşivlenmiş öğrenci bulunamadı.
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};

// --- BİREBİR ORİJİNAL MÜFREDAT VERİ HAVUZU ---
const STATIC_POOL = {
    KPSS_TURKCE: {
      name: "KPSS Türkçe", units: [
        { name: "Anlam Bilgisi", topics: ["Sözcükte Anlam", "Cümlede Anlam", "Paragrafta Anlam (Ana Düşünce, Yardımcı Düşünce)", "Paragrafta Yapı ve Anlatım Biçimleri"] },
        { name: "Dil Bilgisi", topics: ["Ses Bilgisi", "Yazım Kuralları", "Noktalama İşaretleri", "Sözcükte Yapı", "Sözcük Türleri (İsim, Sıfat, Zamir, Zarf, Edat-Bağlaç-Ünlem)", "Fiiller (Fiilimsi, Fiilde Çatı, Eylem)", "Cümlenin Ögeleri", "Cümle Türleri"] },
        { name: "Anlatım Bozuklukları", topics: ["Anlamsal Anlatım Bozuklukları", "Yapısal Anlatım Bozuklukları"] },
        { name: "Sözel Mantık", topics: ["Sözel Mantık ve Akıl Yürütme"] }
      ]
    },
    KPSS_MATEMATIK: {
      name: "KPSS Matematik", units: [
        { name: "Temel Matematik", topics: ["Sayı Kümeleri ve Çözümleme", "Bölme ve Bölünebilme Kuralları", "Asal Sayılar, OBEB-OKEK", "Rasyonel ve Ondalık Sayılar", "Birinci Dereceden Denklemler ve Eşitsizlikler", "Mutlak Değer", "Üslü Sayılar", "Köklü Sayılar", "Çarpanlara Ayırma", "Oran-Orantı"] },
        { name: "Problemler", topics: ["Sayı ve Kesir Problemleri", "Yaş Problemleri", "İşçi Problemleri", "Hareket Problemleri", "Yüzde, Kar-Zarar ve Faiz Problemleri", "Karışım Problemleri", "Grafik Problemleri"] },
        { name: "Yüksek Matematik & Mantık", topics: ["Kümeler ve Kartezyen Çarpım", "Fonksiyonlar", "Permütasyon, Kombinasyon ve Olasılık", "Sayısal Mantık ve Şekil Yeteneği"] },
        { name: "Geometri", topics: ["Geometrik Kavramlar ve Açılar", "Üçgenler", "Çokgenler ve Dörtgenler", "Çember ve Daire", "Analitik Geometri ve Katı Cisimler"] }
      ]
    },
    KPSS_COGRAFYA: {
      name: "KPSS Coğrafya", units: [
        { name: "Türkiye'nin Fiziki Coğrafyası", topics: ["Türkiye'nin Coğrafi Konumu ve Etkileri", "Türkiye'nin Yer şekilleri ve Özellikleri (Dağlar, Ovalar, Platolar vb.)", "Türkiye'nin İklimi ve Bitki Örtüsü", "Türkiye'nin Akarsuları, Gölleri ve Toprak Yapısı"] },
        { name: "Türkiye'nin Beşeri Coğrafyası", topics: ["Türkiye'de Nüfus ve Göç", "Türkiye'de Yerleşmeler ve Kentleşme"] },
        { name: "Türkiye'nin Ekonomik Coğrafyası", topics: ["Türkiye'de Tarım ve Hayvancılık", "Türkiye'de Madenler ve Enerji Kaynakları", "Türkiye'de Sanayi, Ulaşım ve Ticaret", "Türkiye'de Turizm ve Bölgesel Kalkınma Projeleri"] }
      ]
    },
    KPSS_TARIH: {
      name: "KPSS Tarih", units: [
        { name: "İslamiyet Öncesi ve İlk Türk-İslam Devletleri", topics: ["İslamiyet Öncesi Türk Tarihi (Siyasi Tarih, Kültür ve Medeniyet)", "İlk Türk-İslam Devletleri ve Beylikleri (Siyasi Tarih, Kültür ve Medeniyet)"] },
        { name: "Osmanlı Tarihi", topics: ["Osmanlı Devleti Kuruluş ve Yükselme Dönemleri", "Osmanlı Devleti Kültür ve Medeniyeti", "Osmanlı Devleti Arayış ve Değişim YüYYılları (Duraklama ve Gerileme)", "En Uzun YüYYıl (Osmanlı Dağılma Dönemi ve Islahatlar)", "20. YüYYılda Osmanlı Devleti (Trablusgarp, Balkan Savaşları, I. Dünya Savaşı)"] },
        { name: "Milli Mücadele Dönemi", topics: ["Kurtuluş Savaşı Hazırlık Dönemi (Genelgeler ve Kongreler)", "Milli Mücadele Cepheleri", "I. TBMM Dönemi ve Antlaşmalar"] },
        { name: "Atatürk Dönemi ve İnkılaplar", topics: ["Atatürk İlke ve İnkılapları", "Atatürk Dönemi Türk Dış Politikası", "Atatürk'ün Hayatı ve Eserleri"] },
        { name: "Çağdaş Türk ve Dünya Tarihi", topics: ["İki Savaş Arasındaki Dönem ve II. Dünya Savaşı", "Soğuk Savaş, Yumuşama Dönemi ve Küreselleşen Dünya"] }
      ]
    },
    KPSS_VATANDASLIK: {
      name: "KPSS Vatandaşlık", units: [
        { name: "Temel Hukuk Kavramları", topics: ["Hukukun Tanımı ve Sosyal Hayatı Düzenleyen Kurallar", "Hukukun Kaynakları ve Dalları", "Hak Kavramı, Ehliyetler ve Borçlar Hukuku"] },
        { name: "Devlet ve Anayasa Tarihi", topics: ["Devlet Biçimleri ve Hükümet Sistemleri", "Türk Anayasa Tarihi Gelişmeleri"] },
        { name: "1982 Anayasası ve Temel Esaslar", topics: ["1982 Anayasası Genel Esasları", "Temel Hak ve Ödevler", "Yasama Organı (TBMM Yapısı ve Görevleri)", "Yürütme Organı (Cumhurbaşkanı ve Kararnameler)", "Yargı Organı (Mahkemeler ve Yüksek Mahkemeler)"] },
        { name: "İdare Hukuku", topics: ["İdare Hukukuna Giriş ve Teşkilat Yapısı (Merkezden ve Yerinden Yönetim)", "Memurlar ve Kamu Görevlileri Hakları"] }
      ]
    },
    KPSS_GUNCEL: {
      name: "KPSS Güncel Bilgiler", units: [
        { name: "Güncel ve Kültürel Gelişmeler", topics: ["Türkiye ve Dünyadaki Güncel Gelişmeler", "Önemli Uluslararası Kuruluşlar (BM, NATO, AB vb.)", "Kültürel ve Sanatsal Gelişmeler, Önemli Tarihi Şahsiyetler"] }
      ]
    },
    // YKS DERSLERİ (Senin Dosyandan Birebir)
    TYT_TURKCE: {
      name: "TYT Türkçe", units: [
        { name: "Anlam Bilgisi", topics: ["Sözcükte Anlam", "Cümlede Anlam", "Paragrafta Anlam"] },
        { name: "Dil Bilgisi", topics: ["Ses Bilgisi", "Yazım Kuralları", "Noktalama İşaretleri", "Sözcük Türleri (İsim, Zamir, Sıfat, Zarf vb.)", "Fiiller (Filimsi, Çekim Ekleri vb.)", "Sözcükte Yapı (Basit, Türemiş, Birleşik)", "Cümlenin Ögeleri (Özne, Yüklem vb.)", "Cümle Türleri (Yapısına Göre, Türüne Göre vb.)", "Anlatım Bozuklukları (Anlam, Yapı)"] }
      ]
    },
    TYT_MAT: {
      name: "TYT Matematik", units: [
        { name: "Sayılar (1. Bölüm)", topics: ["Temel Kavramlar (Sayı kümeleri, tek-çift vb.)", "Sayı Basamakları", "Bölme ve Bölünebilme Kuralları", "EBOB - EKOK", "Rasyonel Sayılar"] },
        { name: "Denklem ve Eşitsizlikler (2. Bölüm)", topics: ["Basit Eşitsizlikler", "Mutlak Değer", "Üslü Sayılar", "Köklü Sayılar", "Çarpanlara Ayırma", "Oran - Orantı", "Denklem Çözme (Birinci Dereceden)"] },
        { name: "Kümeler ve Fonksiyonlar (3. Bölüm)", topics: ["Kümeler", "Fonksiyonlar"] },
        { name: "Permütasyon, Kombinasyon, Olasılık, Veri (4. Bölüm)", topics: ["Permütasyon (Sıralama)", "Kombinasyon (Seçme)", "Olasılık", "Veri - İstatistik (Grafik Yorumlama)"] }
      ]
    },
    TYT_FIZIK: {
      name: "TYT Fizik", units: [
        { name: "Fizik Bilimine Giriş (1. Bölüm)", topics: ["Fizik Bilimine Giriş", "Özkütle", "Dayanıklılık, Adezyon, Kohezyon", "Katı Basıncı", "Sıvı Basıncı", "Gaz ve Akışkan Basıncı", "Sıvıların Kaldırma Kuvveti", "Isı ve Sıcaklık", "Genleşme, Isı İletimi"] },
        { name: "Hareket ve Kuvvet (2. Bölüm)", topics: ["Hareket", "Kuvvet ve Özellikleri", "Dinamik", "İş Güç Enerji"] },
        { name: "Elektrik ve Manyetizma (3. Bölüm)", topics: ["Elektrik Yükleri", "Elektrostatik", "Coulomb Kuvveti ve Elektrik Alan", "Ohm Yasası", "Piller", "Elektriksel Güç ve Enerji", "Lamba Parlaklığı", "Manyetizma", "Elektrik ve Manyetizma"] },
        { name: "Optik (4. Bölüm)", topics: ["Aydınlanma", "Gölge", "Yansıma ve Düzlem Ayna", "Küresel Ayna", "Kırılma", "Mercekler", "Prizma", "Renk", "Optik"] },
        { name: "Dalgalar (5. Bölüm)", topics: ["Dalgalar ve Genel Özellikleri", "Yay Dalgaları", "Su Dalgaları", "Deprem ve Ses Dalgaları", "Dalgalar Karma"] }
      ]
    },
    TYT_KIMYA: {
      name: "TYT Kimya", units: [
        { name: "Kimya Bilimi (1. Bölüm)", topics: ["Kimyanın Alt Disiplinleri", "Kimyanın Sembolik Dili", "Kimya Uygulamalarında İş Sağlığı ve Güvenliği"] },
        { name: "Atom ve Periyodik Sistem (2. Bölüm)", topics: ["Atom Modelleri", "Atomu Oluşturan Temel Tanecikler", "Atom Türleri", "Atomun Yapısı", "Periyodik Sistemin Genel Özellikleri ve Yer Bulma", "Periyodik Sistemde Değişen Özellikler"] },
        { name: "Kimyasal Türler Arası Etkileşimler (3. Bölüm)", topics: ["Kim. Tür. Ar. Et. Sınıflandırılması", "Dublet - Oktet Kuralı ve Lewis Yapısı", "İyonik Bağın Oluşumu ve Lewis Yapısı", "İyonik Bağlı Bileşiklerin Adlandırılması", "Kovalent Bağın Oluşumu ve Lewis Yapısı", "Kovalent Bağlı Bileşiklerin Adlandırılması", "Metalik Bağ", "Zayıf Etkileşimler", "Fiziksel ve Kimyasal Değişimler"] },
        { name: "Maddenin Halleri (4. Bölüm)", topics: ["Fiziksel Halleri", "Katılar ve Özellikleri", "Sıvılar ve Özellikleri", "Gazlar ve Özellikleri - Plazma Hali", "Hâl Değişim Grafikleri", "Maddenin Halleri"] },
        { name: "Doğa ve Kimya (Su ve Hayat, Çevre Kimyası) (5. Bölüm)", topics: ["Su ve Hayat", "Çevre Kimyası"] },
        { name: "Kimyanın Temel Kanunları ve Kimyasal Hesaplamalar (6. Bölüm)", topics: ["Kimyanın Temel Kanunları", "Mol Kavramı", "Tepkime Denklemleri", "Tepkime Türleri", "Kimyasal Hesaplamalar", "Homojen ve Heterojen Karışımlar"] },
        { name: "Karışımlar (7. Bölüm)", topics: ["Çözünme Olayı", "Kütlece/Hacimce Yüzde Derişimler", "Günlük Hay. Çöz. Kaynama ve Donma Noktalarındaki Değişimler", "Karışımları Ayırma Yöntemleri", "Karışımlar Karma"] },
        { name: "Asitler, Bazlar ve Tuzlar (8. Bölüm)", topics: ["Genel Özellikleri", "Asitler ve Bazların Tepkimeleri", "Asitler ve Bazların Metallerle Tepkimeleri", "Yaygın Asitler ve Kullanım Alanları", "Yaygın Bazlar ve Kullanım Alanları", "Asitler ve Bazların Fayda ve Zararları", "Tuzlar"] },
        { name: "Kimya Her Yerde (9. Bölüm)", topics: ["Temizlik Maddeleri", "Yaygın Polimerler", "Kozmetik ve İlaçlar", "Hazır Gıda ve Yağlar", "Kimya Her Yerde"] }
      ]
    },
    TYT_BIYOLOJI: {
      name: "TYT Biyoloji", units: [
        { name: "Yaşam Bilimi Biyoloji (1. Bölüm)", topics: ["Canlıların Ortak Özellikleri", "Canlıların Yapısında Bulunan Temel Bileşenler (İnorganik)", "Canlıların Yapısında Bulunan Temel Bileşenler (Organik)"] },
        { name: "Hücre (2. Bölüm)", topics: ["Hücrenin Keşfi, Teorisi, Kısımları", "Hücre Organelleri", "Hücre İskeleti, Hücre Zarının Yapısı", "Hücre Zarından Madde Geçişleri"] },
        { name: "Canlılar Dünyası (Sınıflandırma) (3. Bölüm)", topics: ["Çeşitliliği ve Sınıflandırması", "Bakteriler, Arkeler, Protista", "Bitki, Mantar", "Hayvanlar, Virüsler"] },
        { name: "Hücre Bölünmeleri ve Üreme (4. Bölüm)", topics: ["Mitoz Bölünme", "Eşeysiz Üreme", "Mayoz Bölünme", "Eşeyli Üreme"] },
        { name: "Kalıtım (5. Bölüm)", topics: ["Genetik Kavramlar", "Gamet Oluşumları", "Mendel Genetiği", "Soyağaçları", "Eş Baskınlık ve Çok Alellilik", "Kan Grupları", "Eşeye Bağlı Kalıtım", "Genetik Varyasyonlar ve Biyolojik Çeşitlilik"] },
        { name: "Ekosistem Ekolojisi ve Güncel Çevre Sorunları (6. Bölüm)", topics: ["Etkileyen Faktörler", "Madde ve Enerji Akışı", "Madde Döngüleri", "Güncel Çevre Sorunları ve İnsan"] }
      ]
    },
    GEOMETRI: {
      name: "TYT - AYT Geometri", units: [
        { name: "TYT ve AYT", topics: ["Doğruda Açılar", "Üçgende Açılar", "Dik Üçgen", "İkizkenar ve Eşkenar Üçgen", "Üçgende Yardımcı Doğrular", "Üçgende Eşlik ve Benzerlik", "Üçgende Alan", "Açı - Kenar Bağıntıları", "Çokgenler ve Dörtgenler", "Paralelkenar", "Eşkenar Dörtgen ve Deltoid", "Dikdörtgen ve Kare", "Yamuk", "Çemberde Açılar", "Çemberde Uzunluk", "Dairede Alan", "Katı Cisimler", "Noktanın ve Doğrunun Analitik İncelenmesi", "Dönüşümler", "Çemberin Analitik İncelenmesi"] }
      ]
    },
    AYT_MAT: {
      name: "AYT Matematik", units: [
        { name: "1. Bölüm", topics: ["Polinom", "2. Dereceden Denklemler", "Karmaşık Sayılar", "Eşitsizlikler", "Parabol"] },
        { name: "2. Bölüm", topics: ["Trigonometri", "Fonksiyonlar", "Logaritma", "Diziler"] },
        { name: "3. Bölüm", topics: ["Limit", "Türev", "İntegral"] },
        { name: "4. Bölüm", topics: ["Permütasyon (Sıralama)", "Kombinasyon (Seçme)", "Binom", "Olasılık"] }
      ]
    },
    AYT_FIZIK: {
      name: "AYT Fizik", units: [
        { name: "AYT Fizik Konuları", topics: ["Vektörler", "Bağıl Hareket", "Newton'ın Hareket Yasaları", "Bir Boyutta Sabit İvmeli Hareket", "İki Boyutta Hareket", "Enerji", "İtme ve Çizgisel Momentum", "Tork", "Denge", "Kütle ve Ağırlık Merkezi", "Basit Makineler", "Elektrik", "Manyetizma", "Alternatif Akım ve Transformatörler", "Çembersel Hareket", "Basit Harmonik Hareket", "Dalga Mekaniği", "Atom Fiziğine Giriş ve Radyoaktivite", "Modern Fizik", "Modern Fiziğin Teknolojideki Uygulamaları"] }
      ]
    },
    AYT_KIMYA: {
      name: "AYT Kimya", units: [
        { name: "AYT Kimya", topics: ["Modern Atom Teorisi", "Periyodik Sistem", "Gazlar", "Sıvı Çözeltiler", "Kimyasal Tepkimelerde Enerji", "Kimyasal Tepkimelerde Hız", "Kimyasal Tepkimelerde Denge", "Asit ve Bazlar", "Çözünürlük Dengesi", "Elektrokimya", "Organik Kimya", "Enerji Kaynakları ve Bilimsel Gelişmeler"] }
      ]
    },
    AYT_BIYOLOJI: {
      name: "AYT Biyoloji", units: [
        { name: "İnsan Fizyolojisi (1. Bölüm)", topics: ["Denetleyici ve Düzenleyici Sistem (Sinir Sistemi, Endokrin Sistem, Duyu Organları)", "Destek ve Hareket Sistemi", "Sindirim Sistemi", "Dolaşım Sistemleri", "Solunum Sistemi", "Üriner Sistem", "Üreme Sistemi ve Ebriyonik Gelişim"] },
        { name: "Komünite ve Popülasyon Ekolojisi (2. Bölüm)", topics: ["Komünite ve Popülasyon Ekolojisi"] },
        { name: "Genlerden Proteinlere (3. Bölüm)", topics: ["Genlerden Proteinlere"] },
        { name: "Canlılarda Enerji Dönüşümleri (4. Bölüm)", topics: ["Canlılarda Enerji Dönüşümleri"] },
        { name: "Bitki Fizyolojisi (5. Bölüm)", topics: ["Bitki Fizyolojisi"] },
        { name: "Canlılık ve Çevre (6. Bölüm)", topics: ["Canlılık ve Çevre"] }
      ]
    },
    PARAGRAF: { name: "Paragraf", units: [{ name: "Paragraf", topics: ["Paragraf"] }] },
    PROBLEMLER: { name: "Problemler", units: [{ name: "Problemler", topics: ["Sayı Problemleri (Denklem Kurma)", "Kesir Problemleri", "Yaş Problemleri", "İşçi Havuz Problemleri", "Hareket (Hız) Problemleri", "Yüzde Problemleri", "Kâr - Zarar Problemleri", "Karışım Problemleri", "Grafik ve Tablo Yorumlama Problemleri", "Rutin Olmayan / Mantıksal Akıl Yürütme Problemleri"] }] },

    // YKS SÖZEL & EŞİT AĞIRLIK İÇİN EK DERSLER (Standart Müfredata Göre Dolduruldu)
    AYT_ED: { name: "AYT Edebiyat", units: [{ name: "Giriş", topics: ["Edebiyat Nedir?", "Edebi Akımlar"] }, { name: "Şiir", topics: ["Şiir Bilgisi", "Halk Şiiri", "Divan Şiiri"] }, { name: "Dönemler", topics: ["Tanzimat Edebiyatı", "Servet-i Fünun Edebiyatı", "Milli Edebiyat", "Cumhuriyet Dönemi Edebiyatı"] }] },
    AYT_TAR1: { name: "AYT Tarih-1", units: [{ name: "Tarih Bilimi", topics: ["Tarih ve Zaman"] }, { name: "İlk Çağ", topics: ["İlk Çağ Medeniyetleri"] }, { name: "Orta Çağ", topics: ["Orta Çağda Dünya"] }, { name: "Türk Dünyası", topics: ["İlk Türk Devletleri", "İslamiyet'in Kabulü"] }, { name: "Osmanlı", topics: ["Osmanlı Kuruluş-Yükselme", "Kültür Medeniyet"] }, { name: "İnkılap", topics: ["Milli Mücadele"] }] },
    AYT_COG1: { name: "AYT Coğrafya-1", units: [{ name: "Doğal Sistemler", topics: ["Ekosistem", "Madde Döngüleri"] }, { name: "Beşeri Sistemler", topics: ["Nüfus Politikaları", "Şehirler"] }, { name: "Küresel Ortam", topics: ["Ülkeler", "Jeopolitik Konum"] }, { name: "Çevre", topics: ["Çevre Sorunları"] }] },
    AYT_TAR2: { name: "AYT Tarih-2", units: [{ name: "Çağdaş Türk ve Dünya Tarihi", topics: ["II. Dünya Savaşı", "Soğuk Savaş", "Küreselleşen Dünya"] }] },
    AYT_COG2: { name: "AYT Coğrafya-2", units: [{ name: "Türkiye Coğrafyası", topics: ["Türkiye'de Tarım/Hayvancılık", "Türkiye'de Sanayi/Turizm"] }, { name: "Doğal Kaynaklar", topics: ["Enerji Kaynakları"] }] },
    AYT_FEL: { name: "AYT Felsefe Grubu", units: [{ name: "Psikoloji", topics: ["Psikoloji Bilimi", "Öğrenme", "Bellek"] }, { name: "Sosyoloji", topics: ["Toplum", "Kültür", "Toplumsal Değişme"] }, { name: "Mantık", topics: ["Klasik Mantık", "Sembolik Mantık"] }] },
    AYT_DIN: { name: "AYT Din Kültürü", units: [{ name: "İslam Düşüncesi", topics: ["İnanç Problemleri", "İslam ve Bilim"] }] },

    // LGS DERSLERİ (Senin Dosyandan Birebir)
    LGS_TURKCE: {
      name: "LGS Türkçe", units: [
        { name: "Fiilimsi (Eylemsi) (1. Bölüm)", topics: ["İsim-Fiil (Ad-Eylem)", "Sıfat-Fiil (Ortaç)", "Zarf-Fiil (Ulaç/Bağ-Fiil)", "Fiilimsi (Eylemsi)"] },
        { name: "Sözcükte Anlam (2. Bölüm)", topics: ["Çok Anlamlılık, Gerçek, Mecaz ve Terim Anlam", "Sözcükler Arası Anlam İlişkileri", "İkilemeler ve Kalıplaşmış Söz Grupları", "Atasözü, Deyim ve Özdeyiş", "Söz Sanatları", "Sözcükte Anlam"] },
        { name: "Cümlede Anlam (3. Bölüm)", topics: ["Cümle Yorumlama", "Öznel ve Nesnel Cümleler", "Amaç-Sonuç, Neden-Sonuç, Koşul-Sonuç Cümleleri", "Karşılaştırma, Benzetme, Örnekleme, Tanım ve Varsayım Cümleleri", "Cümlede Kavramlar ve Duygular", "Cümlede Anlam"] },
        { name: "Parçada Anlam (4. Bölüm)", topics: ["Ana Fikir, Ana Duygu", "Konu, Başlık, Soru", "Yardımcı Düşünce", "Paragrafta Yapı", "Metin Karşılaştırma", "Anlatım Biçimleri, Metnin Anlatıcısı", "Düşünceyi Geliştirme Yolları", "Hikaye Unsurları, Metnin Dili ve Anlatımı", "Parçada Anlam"] },
        { name: "Cümlenin Öğeleri (5. Bölüm)", topics: ["Cümlenin Temel Öğeleri", "Cümlenin Yardımcı Öğeleri", "Cümlede Vurgu ve Ara Söz", "Cümlenin Öğeleri"] },
        { name: "Sözel Mantık ve Muhakeme (6. Bölüm)", topics: ["Sözel Mantık ve Muhakeme"] },
        { name: "Görsel Tablo ve Grafik Okuma (7. Bölüm)", topics: ["Görsel Tablo ve Grafik Okuma"] },
        { name: "Fiilde (Eylemde) Çatı (8. Bölüm)", topics: ["Özne-Yüklem İlişkisi", "Nesne-Yüklem İlişkisi", "Fiilde (Eylemde) Çatı"] },
        { name: "Cümle Türleri (9. Bölüm)", topics: ["Yüklemin Türüne Göre Cümleler", "Yüklemin Yerine Göre Cümleler", "Anlamına Göre Cümleler", "Yapısına Göre Cümleler", "Cümle Türleri"] },
        { name: "Anlatım Bozuklukları (10. Bölüm)", topics: ["Anlatım Bozuklukları"] },
        { name: "Yazım Kuralları (11. Bölüm)", topics: ["Büyük Harflerin Yazımı", "Sayıların ve Kısaltmaların Yazımı", "De, Mi, Ki'nin Yazımı", "İkilemelerin, Pekiştirmelerin ve Birleşik Sözcüklerin Yazımı", "Yazım Kuralları"] },
        { name: "Noktalama İşaretleri (12. Bölüm)", topics: ["Noktalama İşaretleri"] },
        { name: "Metin Türleri (13. Bölüm)", topics: ["Hikaye Edici Metin Türleri", "Bilgilendirici Metinler", "Metin Türleri"] }
      ]
    },
    LGS_MAT: {
      name: "LGS Matematik", units: [
        { name: "Çarpanlar ve Katlar (1. Bölüm)", topics: ["Pozitif Tam Sayıların Çarpanları", "En Büyük Ortak Bölen (EBOB)", "En Küçük Ortak Kat (EKOK)", "Aralarında Asal Sayılar", "Çarpanlar ve Katlar"] },
        { name: "Üslü İfadeler (2. Bölüm)", topics: ["Tam Sayıların Tam Sayı Kuvvetleri", "Üslü İfadelerde Çarpma İşlemi", "Üslü İfadelerde Bölme İşlemi", "Ondalık Gösterimleri Çözümleme", "10'un Tam Sayı Kuvvetleri", "Bilimsel Gösterim", "Üslü İfadeler"] },
        { name: "Kareköklü İfadeler (3. Bölüm)", topics: ["Tamkare Doğal Sayılar", "Tamkare Olmayan Doğal Sayıların Karekök Değerlerinin Aralıkları", "Tamkare Olmayan Kareköklü İfadelerin Farklı Biçimlerde Gösterimi", "Kareköklü İfadelerde Çarpma İşlemi", "Kareköklü İfadelerde Bölme İşlemi", "Kareköklü İfadelerle Toplama ve Çıkarma İşlemi", "Ondalık Gösterimleri Kareköklü Olarak Gösterimi", "Gerçek Sayılar", "Kareköklü İfadeler"] },
        { name: "Veri Analizi (4. Bölüm)", topics: ["Grafik Yorumlama", "Grafikler Arası Dönüşümler", "Veri Analizi"] },
        { name: "Basit Olayların Olma Olasılığı (5. Bölüm)", topics: ["Olasılık Kavramları", "Olasılık Değeri", "Olasılık Hesabı", "Basit Olayların Olma Olasılığı"] },
        { name: "Cebirsel İfadeler ve Özdeşlikler (6. Bölüm)", topics: ["Basit Cebirsel İfadeler ve Cebirsel İfadelerle Çarpma İşlemi", "Özdeşlikler", "Cebirsel İfadeleri Çarpanlara Ayırma", "Cebirsel İfadeler ve Özdeşlikler"] },
        { name: "Doğrusal Denklemler (7. Bölüm)", topics: ["Birinci Dereceden Bir Bilinmeyenli Denklemler", "Koordinat Sistemi", "Doğrusal Denklemlerin Grafiği", "Doğrusal İlişki", "Doğrunun Eğimi", "Doğrusal Denklemler"] },
        { name: "Eşitsizlikler (8. Bölüm)", topics: ["Eşitsizliği Yazma ve Sayı Doğrusunda Gösterme", "Eşitsizlik Çözme", "Eşitsizlikler"] },
        { name: "Üçgenler (9. Bölüm)", topics: ["Üçgenin Yardımcı Elemanları", "Üçgenin Kenar Bağıntıları", "Üçgenin Yardımcı Elemanları ve Kenar Bağıntıları", "Üçgenlerde Açı Kenar Bağıntıları", "Üçgen Çizimi", "Üçgenlerde Açı Kenar Bağıntıları ve Üçgen Çizimi", "Dik Üçgen ve Pisagor Bağıntısı", "Üçgenler"] },
        { name: "Eşlik ve Benzerlik (10. Bölüm)", topics: ["Eşlik ve Benzerlik Kavramı", "Eşlik ve Benzerlik İşlemi", "Eşlik ve Benzerlik"] },
        { name: "Dönüşüm Geometrisi (11. Bölüm)", topics: ["Öteleme", "Yansıma", "Dönüşüm Geometrisi"] },
        { name: "Geometrik Cisimler (12. Bölüm)", topics: ["Dik Prizmalar", "Dik Dairesel Silindir ve Alanı", "Dik Dairesel Silindirin Hacmi", "Dik Piramit", "Dik Koni", "Geometrik Cisimler"] }
      ]
    },
    LGS_FEN: {
      name: "LGS Fen Bilgisi", units: [
        { name: "Mevsimler ve İklim (1. Bölüm)", topics: ["Mevsimlerin Oluşumu", "İklim ve Hava Hareketleri"] },
        { name: "DNA ve Genetik Kod (2. Bölüm)", topics: ["DNA ve Genetik Kod", "Kalıtım", "Mutasyon ve Modifikasyon", "Adaptasyon", "Biyoteknoloji"] },
        { name: "Basınç (3. Bölüm)", topics: ["Katılarda Basınç", "Sıvı ve Gazlarda Basınç"] },
        { name: "Madde ve Endüstri (4. Bölüm)", topics: ["Periyodik Sistem", "Fiziksel ve Kimyasal Değişimler", "Kimyasal Tepkimeler", "Asitler ve Bazlar", "Maddenin Isı ile Etkileşimi", "Maddenin Isı ile Etkileşimi - Türkiye'de Kimya Endüstrisi", "Madde ve Endüstri"] },
        { name: "Basit Makineler (5. Bölüm)", topics: ["Makaralar - Kaldıraçlar", "Eğik Düzlem - Çıkrık - Diğer Basit Makineler", "Basit Makineler"] },
        { name: "Enerji Dönüşümleri ve Çevre Bilimi (6. Bölüm)", topics: ["Besin Zinciri ve Enerji Akışı", "Enerji Dönüşümleri", "Madde Döngüleri ve Çevre Sorunları - Sürdürülebilir Kalkınma", "Enerji Dönüşümleri ve Çevre Bilimi"] },
        { name: "Elektrik Yükleri ve Elektrik Enerjisi (7. Bölüm)", topics: ["Elektrik Yükleri ve Elektriklenme", "Elektrik Yüklü Cisimler", "Elektrik Enerjisinin Dönüşümü"] }
      ]
    },
    LGS_ING: {
      name: "LGS İngilizce", units: [
        { name: "LGS İngilizce", topics: ["Friendship", "Teen Life", "In The Kitchen", "On The Phone", "The Internet", "Adventures", "Tourism", "Chores", "Science"] }
      ]
    },
    LGS_DIN: {
      name: "LGS Din Kültürü", units: [
        { name: "Kader İnancı (1. Bölüm)", topics: ["Kader ve Kaza İnancı", "İnsanın İradesi ve Kader", "İnsanın İradesi ve Kader İle İlgili Kavramlar", "Kader ve Kaza İle İlgili Kavramlar", "Hz. Musa ve Ayet el-Kürsi", "Kader İnancı"] },
        { name: "Zekât ve Sadaka (2. Bölüm)", topics: ["İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem", "Zekât ve Sadaka İbadeti", "Hz. Şuayb ve Maûn Suresi", "Zekât ve Sadaka"] },
        { name: "Din ve Hayat (3. Bölüm)", topics: ["Din, Birey ve Toplum", "Dinin Temel Gayesi", "Hz. Yusuf ve Asr Suresi", "Din ve Hayat"] },
        { name: "Hz. Muhammed'in Örnekliği (4. Bölüm)", topics: ["Hz. Muhammed'in Doğruluğu, Güvenilir Kişiliği", "Merhametli ve Affedici Oluşu", "Davasındaki İsrarı ve Verdiği Önem", "Hz. Muhammed'in İnsanlara Değer Vermesi, Hakkı Gözetmedeki Hassasiyeti ve Kureyş Suresi", "Hz. Muhammed'in Örnekliği"] },
        { name: "Kur'an-ı Kerim ve Özellikleri (5. Bölüm)", topics: ["İslam Dininin Temel Kaynakları", "Kur'an-ı Kerim'in Ana Konuları", "Kur'an-ı Kerim'in Temel Özellikleri", "Kur'an-ı Kerim ve Özellikleri"] }
      ]
    },
    LGS_INK: {
      name: "LGS İnkılap", units: [
        { name: "Bir Kahraman Doğuyor (1. Bölüm)", topics: ["Uyanan Avrupa ve Sarsılan Osmanlı", "Mavi Gözlü Çocuk Mustafa Kemal", "Buhranlar Büyük Kahramanlar Doğurur", "Adım Adım Liderliğe"] },
        { name: "Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar (2. Bölüm)", topics: ["I. Dünya Savaşı'na Yol Açan Gelişmeler", "Osmanlı Devleti'nin Son Savaştığı: I. Dünya Savaşı", "İşgal Yıllarında Anadolu", "Cemiyetler ve Kuva-yı Millîye", "İstiklal Yolculuğu", "Bir Milletin Yüreklenişi: Misak-ı Millî", "Büyük Millet Meclisi'ne Karşı Çıkan Ayaklanmalar", "Sevr Antlaşması"] },
        { name: "Milli Bir Destan: Ya İstiklal Ya Ölüm! (3. Bölüm)", topics: ["Doğu ve Güney Cepheleri", "Batı Cephesi", "Maarif Kongresi / Millî Mücadele, Millî Seferberlik: Tekâlif-i Millîye", "Sakarya'dan Büyük Taarruz'a", "Lozan Anlaşması / Sanat ve Edebiyat Eserlerinde Millî Mücadele"] },
        { name: "Atatürkçülük ve Çağdaşlaşan Türkiye (4. Bölüm)", topics: ["Atatürk İlkeleri", "Siyasal ve Hukuki Alandaki Gelişmeler", "Eğitim ve Kültür Alanındaki Gelişmeler", "Toplumsal Alandaki Gelişmeler", "Ekonomi ve Sağlık Alanındaki Gelişmeler", "İlelebet Cumhuriyet / Atatürk İlke ve İnkılaplarının Temel Esasları"] },
        { name: "Demokratikleşme Çabaları (5. Bölüm)", topics: ["Demokrasi Yolunda Atılan Adımlar", "Mustafa Kemal'e Suikast Girişimi / Türkiye Cumhuriyeti'ne Yönelik Tehditler"] },
        { name: "Atatürk Dönemi Türk Dış Politikası (6. Bölüm)", topics: ["Türk Dış Politikasının Temel İlkeleri / Dış Politikada Yaşanan Gelişmeler", "Misak-ı Milli'nin Son Zaferi: Hatay"] },
        { name: "Atatürk'ün Ölümü ve Sonrası (7. Bölüm)", topics: ["Atatürk'ün Vefatı ve Yankıları / İnsan Eserleriyle Yaşar", "Yeniden Sarsılan Dünya", "II. Dünya Savaşı'nın Türkiye'ye Etkileri / Demokrasi Yolunda Güçlü Adımlar"] }
      ]
    }
  };

// 1. DERS YÖNETİMİ (FİNAL: Birebir Orijinal İçerik + YKS/LGS Tam Liste)
const LessonModule = ({ student, curriculum, setCurriculum, onUpdateStudent, user, allStudents, templatesPool, setTemplatesPool }) => {
  const activeCurriculum = student.curriculum || curriculum;
  const [selectedCourseId, setSelectedCourseId] = useState(activeCurriculum[0]?.id || null);
  const [showAddModal, setShowAddModal] = useState(null);
  const [newItem, setNewItem] = useState({ name: "", parentId: "" });
  const [bulkText, setBulkText] = useState("");
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [showTemplateEditor, setShowTemplateEditor] = useState(false);
  const [selectedTemplateKey, setSelectedTemplateKey] = useState('TYT_TURKCE');
  const [editingTemplate, setEditingTemplate] = useState(null);

  const colors = useThemeColors();

  useEffect(() => {
    if (showTemplateEditor && selectedTemplateKey) {
      const activePool = templatesPool || STATIC_POOL;
      if (activePool[selectedTemplateKey]) {
        setEditingTemplate(JSON.parse(JSON.stringify(activePool[selectedTemplateKey])));
      }
    }
  }, [showTemplateEditor, selectedTemplateKey, templatesPool]);

  if (user.role === 'student') return <div className={`${colors.text} text-center mt-20`}>Bu alana erişim yetkiniz yok.</div>;

  const selectedCourse = activeCurriculum.find(c => c.id === selectedCourseId);
  const courseResources = student.resources ? student.resources.filter(r => r.courseId === selectedCourseId && !r.isHidden && !r.isCompleted) : [];

  const activeTemplatesPool = templatesPool || STATIC_POOL;

  const loadTemplate = (type) => {
    if (!window.confirm(`DİKKAT: Bu işlem mevcut ders listesini SİLECEK ve yerine ${type} paketini yükleyecektir. Onaylıyor musunuz?`)) return;

    let courses = [];
    const addCourse = (courseData) => {
      if (!courseData) return;
      courses.push({
        id: `tpl-${type}-${Date.now()}-${courses.length}`,
        name: courseData.name,
        units: courseData.units.map((unit, uIdx) => ({
          id: `tpl-u-${Date.now()}-${courses.length}-${uIdx}`,
          name: unit.name,
          topics: [...unit.topics]
        }))
      });
    };

    // YKS ORTAK DERSLER (TYT) - Sayısal/EA/Sözel fark etmeksizin eklenir
    if (type.startsWith('YKS')) {
      addCourse(activeTemplatesPool.TYT_TURKCE);
      addCourse(activeTemplatesPool.TYT_MAT);
      // TYT Sosyal ve Fen dersleri ayrı objelerde değil, bütünleşik bir TYT yapısında olmadığı için manuel ekleyelim
      // Ancak senin listende TYT Sosyal yok, sadece TYT Türkçe, Mat, Fen var.
      // Dosyada Sosyal olmadığı için eklemiyorum (Sadece YKS.docx içeriği).
      // Eğer istersen Sosyal'i de ekleyebilirim. Şimdilik dosyaya sadık kalıyorum.

      addCourse(activeTemplatesPool.TYT_FIZIK);
      addCourse(activeTemplatesPool.TYT_KIMYA);
      addCourse(activeTemplatesPool.TYT_BIYOLOJI);
      addCourse(activeTemplatesPool.GEOMETRI);
      addCourse(activeTemplatesPool.PROBLEMLER);
      addCourse(activeTemplatesPool.PARAGRAF);
    }

    // ALAN DERSLERİ
    if (type === 'YKS_SAY') {
      addCourse(activeTemplatesPool.AYT_MAT);
      addCourse(activeTemplatesPool.AYT_FIZIK);
      addCourse(activeTemplatesPool.AYT_KIMYA);
      addCourse(activeTemplatesPool.AYT_BIYOLOJI);
    } else if (type === 'YKS_EA') {
      addCourse(activeTemplatesPool.AYT_MAT);
      addCourse(activeTemplatesPool.AYT_ED);
      addCourse(activeTemplatesPool.AYT_TAR1);
      addCourse(activeTemplatesPool.AYT_COG1);
    } else if (type === 'YKS_SOZ') {
      addCourse(activeTemplatesPool.AYT_ED);
      addCourse(activeTemplatesPool.AYT_TAR1);
      addCourse(activeTemplatesPool.AYT_COG1);
      addCourse(activeTemplatesPool.AYT_TAR2);
      addCourse(activeTemplatesPool.AYT_COG2);
      addCourse(activeTemplatesPool.AYT_FEL);
      addCourse(activeTemplatesPool.AYT_DIN);
    } else if (type === 'LGS') {
      addCourse(activeTemplatesPool.LGS_TURKCE);
      addCourse(activeTemplatesPool.LGS_MAT);
      addCourse(activeTemplatesPool.LGS_FEN);
      addCourse(activeTemplatesPool.LGS_INK);
      addCourse(activeTemplatesPool.LGS_ING);
      addCourse(activeTemplatesPool.LGS_DIN);
    } else if (type === 'KPSS') {
      addCourse(activeTemplatesPool.KPSS_TURKCE);
      addCourse(activeTemplatesPool.KPSS_MATEMATIK);
      addCourse(activeTemplatesPool.KPSS_TARIH);
      addCourse(activeTemplatesPool.KPSS_COGRAFYA);
      addCourse(activeTemplatesPool.KPSS_VATANDASLIK);
      addCourse(activeTemplatesPool.KPSS_GUNCEL);
    }

    onUpdateStudent({ ...student, curriculum: courses });
    if (courses.length > 0) setSelectedCourseId(courses[0].id);
    setShowAddModal(null);
    alert("Müfredat başarıyla yüklendi.");
  };

  const toggleStatus = (topicId, type, extra = null) => {
    const currentStatus = student.lessons[topicId] || {};
    const newStatus = { ...currentStatus, [type]: !currentStatus[type] };
    onUpdateStudent({ ...student, lessons: { ...student.lessons, [topicId]: newStatus } });
    if (!currentStatus[type]) {
      const fMap = { konu: 'Konu', soru: 'Soru', t1: '1. Tekrar', t2: '2. Tekrar', t3: '3. Tekrar' };
      const fieldLabel = extra?.fieldLabel || fMap[type] || type;
      logActivity(student.id, 'topic_completion', {
        topic: extra?.topic || topicId,
        topicId: topicId,
        subject: extra?.subject,
        unit: extra?.unit,
        field: type,
        fieldLabel: fieldLabel
      });
    }
  };

  const toggleResourceTopic = (resourceId, uniqueTopicKey, extra = null) => {
    const resource = student.resources.find(r => r.id === resourceId);
    if (!resource) return;

    const isCompleted = resource.completedTopics?.includes(uniqueTopicKey);
    let newCompleted = resource.completedTopics || [];

    if (isCompleted) {
      newCompleted = newCompleted.filter(t => t !== uniqueTopicKey);
    } else {
      newCompleted = [...newCompleted, uniqueTopicKey];
    }

    const resCourse = activeCurriculum.find(c => c.id === resource.courseId);
    let totalTopics = 0;
    if (resCourse) {
      resCourse.units.forEach(u => totalTopics += u.topics.length);
    }
    const progress = totalTopics > 0 ? Math.round((newCompleted.length / totalTopics) * 100) : 0;

    const updatedResource = { ...resource, completedTopics: newCompleted, progress };
    const updatedResourcesList = student.resources.map(r => r.id === resourceId ? updatedResource : r);

    onUpdateStudent({ ...student, resources: updatedResourcesList });
    if (!isCompleted) {
      logActivity(student.id, 'topic_completion', {
        resourceName: resource.name,
        subject: extra?.subject || resCourse?.name,
        unit: extra?.unit,
        topic: extra?.topic || uniqueTopicKey,
        topicKey: uniqueTopicKey
      });
    }
  };

  const handleAddItem = () => {
    let updatedCurriculum = [...activeCurriculum];
    if (showAddModal === 'course') {
      if (!newItem.name) return;
      const newCourse = { id: Date.now().toString(), name: newItem.name, units: [] };
      updatedCurriculum = [...updatedCurriculum, newCourse];
      setSelectedCourseId(newCourse.id);
    } else if (showAddModal === 'unit' || showAddModal === 'topic') {
      const names = bulkText ? bulkText.split('\n').filter(n => n.trim()) : (newItem.name ? [newItem.name] : []);
      if (names.length === 0) return;
      updatedCurriculum = updatedCurriculum.map(c => {
        if (c.id === selectedCourseId) {
          if (showAddModal === 'unit') {
            const newUnits = names.map(name => ({ id: Math.random().toString(36).substr(2, 9), name, topics: [] }));
            return { ...c, units: [...c.units, ...newUnits] };
          } else {
            return { ...c, units: c.units.map(u => u.id === newItem.parentId ? { ...u, topics: [...u.topics, ...names] } : u) };
          }
        }
        return c;
      });
    }
    onUpdateStudent({ ...student, curriculum: updatedCurriculum });
    setShowAddModal(null); setNewItem({ name: "", parentId: "" }); setBulkText("");
  };

  const handleMove = (e, type, index, direction, parentId = null, subParentId = null) => {
    e.stopPropagation(); let updated = [...activeCurriculum];
    const swap = (arr, i, dir) => { if (dir === 'up' && i > 0) { [arr[i], arr[i - 1]] = [arr[i - 1], arr[i]]; } else if (dir === 'down' && i < arr.length - 1) { [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]; } return arr; };
    if (type === 'course') { updated = swap(updated, index, direction); }
    else if (type === 'unit') { const courseIndex = updated.findIndex(c => c.id === selectedCourseId); if (courseIndex > -1) { let units = [...updated[courseIndex].units]; units = swap(units, index, direction); updated[courseIndex] = { ...updated[courseIndex], units }; } }
    else if (type === 'topic') { const courseIndex = updated.findIndex(c => c.id === selectedCourseId); if (courseIndex > -1) { const unitIndex = updated[courseIndex].units.findIndex(u => u.id === parentId); if (unitIndex > -1) { let topics = [...updated[courseIndex].units[unitIndex].topics]; topics = swap(topics, index, direction); const newUnits = [...updated[courseIndex].units]; newUnits[unitIndex] = { ...newUnits[unitIndex], topics }; updated[courseIndex] = { ...updated[courseIndex], units: newUnits }; } } }
    onUpdateStudent({ ...student, curriculum: updated });
  };

  const requestDelete = (e, type, id, parentId = null) => { e.stopPropagation(); e.preventDefault(); setDeleteConfirm({ type, id, parentId }); };
  const confirmDelete = () => { if (!deleteConfirm) return; const { type, id, parentId } = deleteConfirm; let updatedCurriculum = [...activeCurriculum]; if (type === 'course') { updatedCurriculum = updatedCurriculum.filter(c => c.id !== id); if (selectedCourseId === id) setSelectedCourseId(updatedCurriculum[0]?.id || null); } else if (type === 'unit') { updatedCurriculum = updatedCurriculum.map(c => c.id === selectedCourseId ? { ...c, units: c.units.filter(u => u.id !== id) } : c); } else if (type === 'topic') { updatedCurriculum = updatedCurriculum.map(c => c.id === selectedCourseId ? { ...c, units: c.units.map(u => u.id === parentId ? { ...u, topics: u.topics.filter(t => t !== id) } : u) } : c); } onUpdateStudent({ ...student, curriculum: updatedCurriculum }); setDeleteConfirm(null); };

  const LABELS = [
    { id: 'konu', label: 'Konu', color: 'bg-emerald-500' },
    { id: 'soru', label: 'Soru', color: 'bg-blue-500' },
    { id: 't1', label: '1. Tekrar', color: 'bg-purple-500' },
    { id: 't2', label: '2. Tekrar', color: 'bg-pink-500' },
    { id: 't3', label: '3. Tekrar', color: 'bg-orange-500' }
  ];

  const handleCopyFromStudent = (targetStudentId) => {
    if (!window.confirm("Bu işlem mevcut öğrencinin ders programını silecek ve seçilen öğrencininkiyle değiştirecektir. Emin misiniz?")) return;
    const targetStudent = allStudents.find(s => s.id === targetStudentId);
    if (targetStudent && targetStudent.curriculum) {
      onUpdateStudent({ ...student, curriculum: targetStudent.curriculum });
      setShowCopyModal(false);
      alert("Ders programı başarıyla kopyalandı.");
    } else { alert("Seçilen öğrencinin özel bir ders programı yok."); }
  };

  const COL_WIDTHS = {
    TOPIC: 'min-w-[200px] w-[200px] md:min-w-[300px] md:w-[300px]',
    STATUS: 'min-w-[250px] w-[250px] md:min-w-[320px] md:w-[320px]',
    RESOURCE: 'min-w-[100px] w-[100px]'
  };

  const stickyBg = colors.isDark ? 'bg-slate-900' : 'bg-white';

  return (
    <div className="flex flex-col lg:flex-row gap-6 items-start animate-fade-in relative">

      {/* --- SOL PANEL: DERS LİSTESİ --- */}
      <div className="w-full lg:w-1/4 flex flex-col gap-2 lg:sticky lg:top-0 lg:h-[calc(100vh-2rem)] lg:overflow-y-auto pr-1 custom-scrollbar">
        <div className={`flex justify-between items-center mb-2 sticky top-0 z-10 py-2 ${colors.bgMain}`}><h3 className="text-orange-500 font-bold">Dersler</h3><div className="flex gap-1"><Button size="small" variant="secondary" icon={RefreshCw} onClick={() => setShowCopyModal(true)} title="Kopyala" /><Button size="small" icon={Plus} onClick={() => setShowAddModal('course')} /></div></div>
        {activeCurriculum.map((c, idx) => (<div key={c.id} className="flex gap-1 items-center"><button onClick={() => setSelectedCourseId(c.id)} className={`flex-1 p-3 rounded-lg text-left transition-all truncate ${selectedCourseId === c.id ? `bg-slate-800 border-orange-500 text-white border` : `${colors.bgCard} ${colors.border} ${colors.textSec}`}`}>{c.name}</button><div className="flex flex-col gap-1"><button onClick={(e) => handleMove(e, 'course', idx, 'up')} disabled={idx === 0} className={`p-1 ${colors.bgCard} border ${colors.border} rounded text-slate-500 hover:text-orange-500 disabled:opacity-30`}><ArrowUp size={10} /></button><button onClick={(e) => handleMove(e, 'course', idx, 'down')} disabled={idx === activeCurriculum.length - 1} className={`p-1 ${colors.bgCard} border ${colors.border} rounded text-slate-500 hover:text-orange-500 disabled:opacity-30`}><ArrowDown size={10} /></button></div><button onClick={(e) => requestDelete(e, 'course', c.id)} className={`p-3 ${colors.bgCard} ${colors.border} border rounded-lg text-slate-500 hover:text-red-500 hover:border-red-500/50 group h-full flex items-center`}><Trash2 size={16} className="group-hover:text-red-500" /></button></div>))}
        <div className="h-10 shrink-0"></div>
      </div>

      {/* --- SAĞ PANEL: İÇERİK --- */}
      <div className={`flex-1 w-full lg:w-3/4 ${colors.bgCardTransparent} border ${colors.border} rounded-xl flex flex-col shadow-sm relative overflow-visible`}>
        {selectedCourse ? (
          <>
            <div className={`p-4 md:p-6 pb-2 border-b ${colors.border} flex flex-col md:flex-row justify-between items-start md:items-center bg-opacity-50 gap-4`}>
              <h2 className={`text-xl font-bold ${colors.text}`}>{selectedCourse.name}</h2>
              <div className="flex gap-3 w-full md:w-auto">
                <Button size="small" variant="secondary" icon={Plus} className="flex-1 md:flex-none" onClick={() => setShowAddModal('unit')}>Ünite Ekle</Button>
                <Button size="small" variant="secondary" icon={Plus} className="flex-1 md:flex-none" onClick={() => { setNewItem({ ...newItem, parentId: selectedCourse.units[0]?.id }); setShowAddModal('topic'); }}>Konu Ekle</Button>
              </div>
            </div>

            {/* --- TEK PARÇA TABLO YAPISI (Double Sticky) --- */}
            <div className="w-full relative overflow-x-auto custom-scrollbar rounded-b-xl">
              <div className="min-w-max">

                {/* 1. BAŞLIK SATIRI (STICKY TOP) */}
                <div className={`flex items-stretch border-b border-slate-700/50 sticky top-0 z-40 shadow-md backdrop-blur bg-opacity-95 ${stickyBg}`}>
                  {/* SOL ÜST KÖŞE (STICKY LEFT + TOP) */}
                  <div className={`sticky left-0 z-50 ${COL_WIDTHS.TOPIC} p-3 text-orange-500 font-bold text-sm flex items-center border-r border-slate-800/50 backdrop-blur bg-opacity-95 ${stickyBg}`}>
                    Konu Başlıkları
                  </div>
                  {/* ORTA BAŞLIKLAR */}
                  <div className={`${COL_WIDTHS.STATUS} p-3 flex items-center justify-center text-center text-emerald-500 font-bold text-sm border-r border-slate-800/50 shrink-0`}>
                    Çalışma Durumu
                  </div>
                  {/* KAYNAK BAŞLIKLARI */}
                  <div className="flex items-center px-2">
                    {courseResources.length > 0 ? courseResources.map(r => (
                      <div key={r.id} className={`${COL_WIDTHS.RESOURCE} flex justify-center py-2 relative group shrink-0`}>
                        <div className="absolute top-full mt-1 hidden group-hover:block bg-slate-800 border border-slate-700 text-white text-[10px] p-2 rounded z-50 whitespace-nowrap shadow-xl">
                          {r.name}
                        </div>
                        <span className={`text-[9px] font-bold text-slate-400 cursor-help uppercase line-clamp-2 leading-tight px-1 w-full text-center break-words select-none`} title={r.name}>
                          {r.name}
                        </span>
                      </div>
                    )) : (
                      <div className="text-xs italic text-slate-500 p-3 shrink-0">Kaynak Yok</div>
                    )}
                  </div>
                </div>

                {/* 2. İÇERİK SATIRLARI */}
                {selectedCourse.units.map((unit, uIdx) => (
                  <div key={unit.id} className="contents">
                    {/* ÜNİTE AYIRACI (KİTAP İSİMLERİ SÜTUNLARLA BİREBİR HİZALI) */}
                    <div className={`flex items-stretch ${colors.isDark ? 'bg-slate-800/90' : 'bg-slate-200'} border-b border-slate-700/40 min-h-[42px]`}>
                      {/* SOL: ÜNİTE BAŞLIĞI VE İŞLEMLER */}
                      <div className={`sticky left-0 z-20 ${COL_WIDTHS.TOPIC} p-2 px-3 flex items-center justify-between border-r border-slate-700/30 shrink-0 ${colors.isDark ? 'bg-slate-800/95' : 'bg-slate-200'} backdrop-blur shadow-sm`}>
                        <h4 className="text-orange-500 font-bold text-sm truncate" title={unit.name}>{unit.name}</h4>
                        <div className="flex items-center gap-1 opacity-70 hover:opacity-100 transition-opacity shrink-0 ml-1">
                          <button onClick={(e) => handleMove(e, 'unit', uIdx, 'up')} disabled={uIdx === 0} className="text-slate-400 hover:text-white disabled:hidden p-0.5" title="Yukarı Taşı"><ArrowUp size={12} /></button>
                          <button onClick={(e) => handleMove(e, 'unit', uIdx, 'down')} disabled={uIdx === selectedCourse.units.length - 1} className="text-slate-400 hover:text-white disabled:hidden p-0.5" title="Aşağı Taşı"><ArrowDown size={12} /></button>
                          <button onClick={(e) => requestDelete(e, 'unit', unit.id)} className="text-slate-400 hover:text-red-500 disabled:hidden p-0.5 ml-1" title="Üniteyi Sil"><Trash2 size={12} /></button>
                        </div>
                      </div>

                      {/* ORTA: ÇALIŞMA DURUMU HİZASINDA BİLGİ */}
                      <div className={`${COL_WIDTHS.STATUS} px-3 flex items-center justify-center shrink-0 border-r border-slate-700/30 text-[11px] font-semibold ${colors.textSec}`}>
                        <span className="opacity-75">{unit.topics.length} Konu</span>
                      </div>

                      {/* SAĞ: KİTAP / KAYNAK İSİMLERİ (SÜTUNLARLA TAM BİREBİR HİZALI) */}
                      <div className="flex items-center px-2">
                        {courseResources.length > 0 ? courseResources.map(r => (
                          <div key={r.id} className={`${COL_WIDTHS.RESOURCE} flex justify-center py-1.5 relative group shrink-0`}>
                            <div className="absolute top-full mt-1 hidden group-hover:block bg-slate-800 border border-slate-700 text-white text-[10px] p-2 rounded z-50 whitespace-nowrap shadow-xl">
                              {r.name}
                            </div>
                            <span className="text-[9px] font-bold text-orange-400/95 uppercase line-clamp-2 leading-tight px-1 w-full text-center break-words select-none" title={r.name}>
                              {r.name}
                            </span>
                          </div>
                        )) : (
                          <div className="text-[10px] italic text-slate-500 px-3 shrink-0">Kaynak Yok</div>
                        )}
                      </div>
                    </div>

                    {/* KONU SATIRLARI */}
                    {unit.topics.map((topic, tIdx) => {
                      const key = `${selectedCourse.id}-${unit.id}-${tIdx}`;
                      const status = student.lessons[key] || {};
                      return (
                        <div key={tIdx} className={`flex items-stretch border-b border-slate-800/30 hover:bg-slate-800/20 transition-colors group min-h-[50px]`}>

                          {/* SOL SÜTUN */}
                          <div className={`sticky left-0 z-20 ${COL_WIDTHS.TOPIC} p-3 flex items-center gap-2 border-r border-slate-800/30 shrink-0 ${stickyBg}`}>
                            <div className="flex flex-col gap-1 opacity-0 group-hover:opacity-100 transition-opacity w-3 shrink-0">
                              <button onClick={(e) => handleMove(e, 'topic', tIdx, 'up', unit.id)} disabled={tIdx === 0} className="text-slate-500 hover:text-orange-500 disabled:hidden"><ArrowUp size={10} /></button>
                              <button onClick={(e) => handleMove(e, 'topic', tIdx, 'down', unit.id)} disabled={tIdx === unit.topics.length - 1} className="text-slate-500 hover:text-orange-500 disabled:hidden"><ArrowDown size={10} /></button>
                            </div>
                            <span className={`${colors.text} text-sm font-medium whitespace-normal leading-snug`}>{topic}</span>
                          </div>

                          {/* ORTA SÜTUN */}
                          <div className={`${COL_WIDTHS.STATUS} p-2 flex items-center justify-center gap-2 md:gap-4 shrink-0 border-r border-slate-800/30`}>
                            {LABELS.map(lbl => (
                              <div key={lbl.id} className="flex flex-col items-center gap-1 cursor-pointer group/lbl shrink-0 w-8 md:w-auto" onClick={() => toggleStatus(key, lbl.id, { subject: selectedCourse?.name, unit: unit.name, topic: topic, fieldLabel: lbl.label })}>
                                <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border border-slate-600 flex items-center justify-center transition-all ${status[lbl.id] ? `${lbl.color} border-transparent shadow` : `hover:border-slate-500 ${colors.isDark ? 'bg-slate-800' : 'bg-white'}`}`}>
                                  {status[lbl.id] && <Check size={12} className="text-white" />}
                                </div>
                                <span className={`text-[8px] md:text-[9px] ${colors.textSec} font-medium group-hover/lbl:${colors.text} transition-colors text-center leading-tight`}>{lbl.label}</span>
                              </div>
                            ))}
                            <button onClick={(e) => requestDelete(e, 'topic', topic, unit.id)} className="text-slate-600 hover:text-red-500 ml-2 opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 size={14} /></button>
                          </div>

                          {/* SAĞ SÜTUN */}
                          <div className="flex items-center px-2">
                            {courseResources.length > 0 ? courseResources.map(r => {
                              const uniqueKey = `${unit.id || unit.name}-${tIdx}`;
                              const isChecked = r.completedTopics?.includes(uniqueKey);
                              return (
                                <div key={r.id} className={`${COL_WIDTHS.RESOURCE} flex justify-center shrink-0`}>
                                  <div
                                    onClick={() => toggleResourceTopic(r.id, uniqueKey, { subject: selectedCourse?.name, unit: unit.name, topic: topic })}
                                    className={`w-5 h-5 rounded border cursor-pointer transition-all duration-200 flex items-center justify-center ${isChecked ? 'bg-orange-600 border-orange-600 shadow' : 'border-slate-600 hover:border-orange-400 bg-slate-800/50'}`}
                                  >
                                    {isChecked && <Check size={12} className="text-white" />}
                                  </div>
                                </div>
                              )
                            }) : (
                              <div className="w-full"></div>
                            )}
                          </div>

                        </div>
                      )
                    })}
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : <div className={`${colors.textSec} text-center py-20`}>Ders seçiniz veya ekleyiniz.</div>}
      </div>

      {showAddModal && (
        <Modal title={showAddModal === 'course' ? 'Yeni Ders' : showAddModal === 'unit' ? 'Yeni Ünite' : 'Yeni Konu'} onClose={() => setShowAddModal(null)}>
          <div className="space-y-4">
            {showAddModal === 'topic' && (
              <div>
                <label className={`block text-sm ${colors.textSec} mb-1`}>Hangi Üniteye?</label>
                <select className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg p-3 ${colors.text}`} value={newItem.parentId} onChange={e => setNewItem({ ...newItem, parentId: e.target.value })}>
                  <option value="">Seçiniz</option>
                  {selectedCourse?.units.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>
            )}

            {showAddModal === 'course' ? (
              <>
                <Input label="Ders Adı" value={newItem.name} onChange={e => setNewItem({ ...newItem, name: e.target.value })} />

                {/* ALAN SEÇİM BUTONLARI */}
                <div className="pt-4 border-t border-slate-700">
                  <label className={`block text-xs font-bold ${colors.textSec} mb-3 uppercase`}>Hızlı Müfredat Yükle (Listeyi Sıfırlar)</label>
                  <div className="grid grid-cols-2 gap-3">
                    <button onClick={() => loadTemplate('YKS_SAY')} className="p-3 rounded-lg bg-blue-600 text-white font-bold text-xs hover:shadow-lg transition-all flex flex-col items-center gap-1">
                      <GraduationCap size={18} /> YKS - SAYISAL
                    </button>
                    <button onClick={() => loadTemplate('YKS_EA')} className="p-3 rounded-lg bg-indigo-600 text-white font-bold text-xs hover:shadow-lg transition-all flex flex-col items-center gap-1">
                      <BookOpen size={18} /> YKS - EŞİT AĞIRLIK
                    </button>
                    <button onClick={() => loadTemplate('YKS_SOZ')} className="p-3 rounded-lg bg-purple-600 text-white font-bold text-xs hover:shadow-lg transition-all flex flex-col items-center gap-1">
                      <Library size={18} /> YKS - SÖZEL
                    </button>
                    <button onClick={() => loadTemplate('LGS')} className="p-3 rounded-lg bg-emerald-600 text-white font-bold text-xs hover:shadow-lg transition-all flex flex-col items-center gap-1">
                      <CheckCircle size={18} /> LGS (TÜMÜ)
                    </button>
                    <button onClick={() => loadTemplate('KPSS')} className="p-3 rounded-lg bg-amber-600 text-white font-bold text-xs hover:shadow-lg transition-all flex flex-col items-center gap-1 col-span-2">
                      <Zap size={18} /> KPSS (TÜMÜ)
                    </button>
                  </div>
                  {user.role === 'superadmin' && (
                    <button
                      onClick={() => setShowTemplateEditor(true)}
                      className="w-full mt-4 py-2.5 px-3 rounded-lg border border-dashed border-orange-500 text-orange-500 font-bold text-xs hover:bg-orange-500/10 transition-all flex items-center justify-center gap-1"
                    >
                      <Edit2 size={12} /> Şablon Müfredatları Düzenle
                    </button>
                  )}
                </div>
              </>
            ) : (
              <div>
                <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase`}>{showAddModal === 'unit' ? 'Ünite İsimleri' : 'Konu İsimleri'} (Her satıra bir tane)</label>
                <textarea className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg p-3 ${colors.text} h-32 focus:border-orange-500 outline-none`} value={bulkText} onChange={e => setBulkText(e.target.value)}></textarea>
              </div>
            )}

            <Button onClick={handleAddItem} className="w-full mt-4">Kaydet</Button>
          </div>
        </Modal>
      )}

      {showCopyModal && (<Modal title="Müfredat Kopyala" onClose={() => setShowCopyModal(false)}> <div className="space-y-4"> <div className="bg-red-500/10 p-4 rounded text-red-500 text-sm"> Dikkat: Bu işlem, şu anki öğrencinin tüm ders yapısını silecek ve seçtiğiniz öğrencinin ders yapısını (dersler, üniteler, konular) buraya aktaracaktır. </div> <div className="max-h-60 overflow-y-auto space-y-2"> {allStudents.filter(s => s.id !== student.id).map(s => (<button key={s.id} onClick={() => handleCopyFromStudent(s.id)} className={`w-full text-left p-3 rounded border ${colors.border} ${colors.hoverBg} flex justify-between items-center`}> <span className={colors.text}>{s.name}</span> <span className={`text-xs ${colors.textSec}`}>{s.grade}</span> </button>))} {allStudents.filter(s => s.id !== student.id).length === 0 && <div className={`text-center ${colors.textSec} py-2`}>Kopyalanacak başka öğrenciniz yok.</div>} </div> </div> </Modal>)}
      {showTemplateEditor && editingTemplate && (
        <Modal title="Şablon Müfredatları Düzenle" onClose={() => { setShowTemplateEditor(false); setEditingTemplate(null); }}>
          <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
            <div>
              <label className={`block text-xs font-bold ${colors.textSec} mb-1 uppercase`}>Şablon Seçin</label>
              <select
                className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg p-2.5 ${colors.text} text-sm`}
                value={selectedTemplateKey}
                onChange={e => setSelectedTemplateKey(e.target.value)}
              >
                {Object.keys(templatesPool || STATIC_POOL).map(key => (
                  <option key={key} value={key}>
                    {STATIC_POOL[key]?.name || key} ({key})
                  </option>
                ))}
              </select>
            </div>

            <div>
              <Input
                label="Ders Şablon Adı"
                value={editingTemplate.name}
                onChange={e => setEditingTemplate({ ...editingTemplate, name: e.target.value })}
              />
            </div>

            <div className="pt-4 border-t border-slate-700/50 space-y-4">
              <div className="flex justify-between items-center">
                <span className={`text-sm font-bold ${colors.text}`}>Üniteler & Konular</span>
                <Button
                  size="small"
                  variant="secondary"
                  icon={Plus}
                  onClick={() => {
                    const newUnit = { name: "Yeni Ünite", topics: [] };
                    setEditingTemplate({ ...editingTemplate, units: [...editingTemplate.units, newUnit] });
                  }}
                >
                  Ünite Ekle
                </Button>
              </div>

              {editingTemplate.units.map((unit, uIdx) => (
                <div key={uIdx} className={`p-4 rounded-xl border ${colors.border} ${colors.bgCard} space-y-3 relative`}>
                  <button
                    onClick={() => {
                      const updatedUnits = editingTemplate.units.filter((_, idx) => idx !== uIdx);
                      setEditingTemplate({ ...editingTemplate, units: updatedUnits });
                    }}
                    className="absolute right-3 top-3 text-red-500 hover:bg-red-500/10 p-1.5 rounded transition-colors"
                    title="Üniteyi Sil"
                  >
                    <Trash2 size={14} />
                  </button>

                  <div className="pr-8">
                    <Input
                      label={`Ünite ${uIdx + 1} Adı`}
                      value={unit.name}
                      onChange={e => {
                        const updatedUnits = editingTemplate.units.map((u, idx) => idx === uIdx ? { ...u, name: e.target.value } : u);
                        setEditingTemplate({ ...editingTemplate, units: updatedUnits });
                      }}
                    />
                  </div>

                  <div>
                    <label className={`block text-xs font-medium ${colors.textSec} mb-1 uppercase`}>
                      Konular (Her satıra bir tane)
                    </label>
                    <textarea
                      className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg p-3 ${colors.text} h-24 text-sm focus:border-orange-500 outline-none`}
                      value={unit.topics.join('\n')}
                      onChange={e => {
                        const topics = e.target.value.split('\n').map(t => t.trim()).filter(Boolean);
                        const updatedUnits = editingTemplate.units.map((u, idx) => idx === uIdx ? { ...u, topics } : u);
                        setEditingTemplate({ ...editingTemplate, units: updatedUnits });
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <Button
              className="w-full mt-4"
              onClick={async () => {
                const updatedPool = { ...(templatesPool || STATIC_POOL), [selectedTemplateKey]: editingTemplate };
                setTemplatesPool(updatedPool);
                if (isFirebaseActive) {
                  try {
                    await setDoc(doc(db, "settings", "curriculum_templates"), { pool: updatedPool });
                    alert("Şablon başarıyla kaydedildi.");
                  } catch (err) {
                    console.error(err);
                    alert("Şablon kaydedilirken Firestore hatası oluştu.");
                  }
                } else {
                  localStorage.setItem('curriculum_templates', JSON.stringify(updatedPool));
                  alert("Şablon yerel tarayıcı hafızasına kaydedildi.");
                }
                setShowTemplateEditor(false);
                setEditingTemplate(null);
              }}
            >
              Şablonu Kaydet
            </Button>
          </div>
        </Modal>
      )}
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};

// --- HAFTALIK PROGRAM YAZDIRMA (A4 YATAY PREMİUM AÇIK TEMA) GÖRÜNÜMÜ ---
const WeeklySchedulePrintView = ({
  student,
  assignments,
  DAYS,
  TASK_TYPES,
  user,
  weeklyTotalQuestions,
  weeklySolvedQuestions,
  weeklyTaskCount,
  completionRate
}) => {
  const printDate = new Date().toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const coachName = (user?.role === 'admin' || user?.role === 'superadmin')
    ? user?.name
    : (student?.coachName || student?.adminName || 'Hamza Metehan Kılıç');

  const getSubjectAccent = (subjectName) => {
    const name = (subjectName || '').toLowerCase();
    if (name.includes('paragraf') || name.includes('türkçe') || name.includes('edebiyat')) {
      return { border: 'border-l-amber-500', text: 'text-amber-800', bg: 'bg-amber-50/40', badge: 'bg-amber-100 text-amber-800 border-amber-200' };
    }
    if (name.includes('problem')) {
      return { border: 'border-l-purple-600', text: 'text-purple-800', bg: 'bg-purple-50/40', badge: 'bg-purple-100 text-purple-800 border-purple-200' };
    }
    if (name.includes('matematik') || name.includes('geo') || name.includes('ayt') || name.includes('tyt')) {
      return { border: 'border-l-blue-600', text: 'text-blue-800', bg: 'bg-blue-50/40', badge: 'bg-blue-100 text-blue-800 border-blue-200' };
    }
    if (name.includes('fizik') || name.includes('kimya') || name.includes('biyo') || name.includes('fen')) {
      return { border: 'border-l-emerald-600', text: 'text-emerald-800', bg: 'bg-emerald-50/40', badge: 'bg-emerald-100 text-emerald-800 border-emerald-200' };
    }
    if (name.includes('tarih') || name.includes('coğ') || name.includes('felsefe') || name.includes('sosyal')) {
      return { border: 'border-l-rose-500', text: 'text-rose-800', bg: 'bg-rose-50/40', badge: 'bg-rose-100 text-rose-800 border-rose-200' };
    }
    return { border: 'border-l-slate-500', text: 'text-slate-800', bg: 'bg-slate-50/40', badge: 'bg-slate-100 text-slate-700 border-slate-200' };
  };

  return (
    <div className="w-full bg-white text-slate-900 p-2 font-sans select-none box-border text-[9px]" style={{ minWidth: '100%', WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
      
      {/* 1. PREMİUM ÜST BAŞLIK KARTI */}
      <div className="border border-slate-200 rounded-xl p-2.5 mb-2 bg-gradient-to-r from-slate-50 via-white to-amber-50/30 shadow-xs border-t-[3.5px] border-t-amber-500 flex flex-wrap items-center justify-between gap-2.5">
        
        {/* Sol: Logo ve İsim */}
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-slate-900 text-amber-400 flex items-center justify-center font-black text-base shadow-sm shrink-0 border border-slate-800">
            K
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="text-xs font-black tracking-wider text-slate-900 uppercase">KOÇUM ONLINE</span>
              <span className="text-[8.5px] font-bold px-1.5 py-0.2 rounded bg-amber-100 text-amber-800 border border-amber-200 uppercase">Haftalık Plan</span>
            </div>
            <div className="text-[9px] text-slate-500 font-medium">Bireysel Öğrenci Koçluğu & Ödev Çizelgesi</div>
          </div>
        </div>

        {/* Orta: Öğrenci ve Danışman Bilgileri */}
        <div className="flex items-center gap-3 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-xs text-[10px]">
          <div>
            <span className="text-slate-400 block text-[7.5px] uppercase font-bold tracking-wider">Öğrenci Adı</span>
            <div className="flex items-center gap-1.5">
              <span className="font-extrabold text-slate-900 text-[11px]">{student?.name || 'Öğrenci'}</span>
              {student?.grade && <span className="bg-slate-100 text-slate-700 font-bold px-1.5 py-0.2 rounded text-[8.5px] border border-slate-200">{student.grade}</span>}
            </div>
          </div>

          <div className="h-6 w-px bg-slate-200 mx-1"></div>

          <div>
            <span className="text-slate-400 block text-[7.5px] uppercase font-bold tracking-wider">Danışman / Koç</span>
            <span className="font-bold text-slate-800 text-[10.5px]">{coachName}</span>
          </div>

          <div className="h-6 w-px bg-slate-200 mx-1"></div>

          <div>
            <span className="text-slate-400 block text-[7.5px] uppercase font-bold tracking-wider">Tarih</span>
            <span className="font-bold text-slate-800 text-[10.5px]">{printDate}</span>
          </div>
        </div>

        {/* Sağ: 4'lü Haftalık İstatistik Rozetleri */}
        <div className="flex items-center gap-1.5">
          <div className="bg-amber-50/80 border border-amber-200/80 rounded-lg px-2 py-1 text-center min-w-[52px]">
            <span className="text-amber-700/80 block text-[7.5px] font-bold uppercase tracking-wider">Hedef Soru</span>
            <span className="font-black text-amber-600 text-[11.5px] leading-tight">{weeklyTotalQuestions}</span>
          </div>
          <div className="bg-emerald-50/80 border border-emerald-200/80 rounded-lg px-2 py-1 text-center min-w-[48px]">
            <span className="text-emerald-700/80 block text-[7.5px] font-bold uppercase tracking-wider">Çözülen</span>
            <span className="font-black text-emerald-600 text-[11.5px] leading-tight">{weeklySolvedQuestions}</span>
          </div>
          <div className="bg-slate-100/90 border border-slate-200 rounded-lg px-2 py-1 text-center min-w-[46px]">
            <span className="text-slate-500 block text-[7.5px] font-bold uppercase tracking-wider">Görev</span>
            <span className="font-black text-slate-800 text-[11.5px] leading-tight">{weeklyTaskCount}</span>
          </div>
          <div className="bg-blue-50/80 border border-blue-200/80 rounded-lg px-2 py-1 text-center min-w-[46px]">
            <span className="text-blue-700/80 block text-[7.5px] font-bold uppercase tracking-wider">Uyum</span>
            <span className="font-black text-blue-600 text-[11.5px] leading-tight">%{completionRate}</span>
          </div>
        </div>
      </div>

      {/* 2. 7 GÜNLÜK PREMİUM PROGRAM TABLOSU */}
      <div className="grid grid-cols-7 gap-1.5 w-full items-stretch">
        {DAYS.map(day => {
          const dayTasks = (assignments || []).filter(a => a.day === day.id);
          const dayTargetQuestions = dayTasks.reduce((sum, t) => sum + (parseInt(t.count) || 0), 0);

          return (
            <div
              key={day.id}
              className="border border-slate-200 rounded-xl overflow-hidden bg-white flex flex-col justify-between print-avoid-break shadow-xs hover:border-slate-300 transition-colors"
            >
              {/* Gün Başlığı */}
              <div>
                <div className="bg-slate-900 px-1.5 py-1.5 text-center text-white">
                  <div className="text-[10px] font-black tracking-wider uppercase text-amber-400">
                    {day.label}
                  </div>
                  <div className="text-[8px] text-slate-300 font-semibold flex items-center justify-center gap-1 mt-0.5">
                    <span>{dayTasks.length} Görev</span>
                    {dayTargetQuestions > 0 && (
                      <>
                        <span>•</span>
                        <span className="text-white font-bold">{dayTargetQuestions} Soru</span>
                      </>
                    )}
                  </div>
                </div>

                {/* Günün Görevleri */}
                <div className="p-1 space-y-1 bg-slate-50/40 min-h-[170px]">
                  {dayTasks.length === 0 ? (
                    <div className="py-5 px-1 border border-dashed border-slate-200 rounded-lg text-center my-2 bg-white">
                      <div className="text-[8.5px] font-bold text-slate-500">Serbest Çalışma Günü</div>
                      <div className="text-[7px] text-slate-400 mt-1 space-y-0.5 text-left pl-2">
                        <div>☐ Eksik Konu Tekrarı</div>
                        <div>☐ Kitap / Paragraf</div>
                        <div>☐ Branş Denemesi</div>
                      </div>
                    </div>
                  ) : (
                    dayTasks.map((task, idx) => {
                      const isCompleted = task.status === 'completed';
                      const target = parseInt(task.count) || 0;
                      const solved = (task.solvedCount !== undefined && task.solvedCount !== '') ? (parseInt(task.solvedCount) || 0) : (isCompleted ? target : 0);
                      const taskTypeLabel = TASK_TYPES.find(t => t.id === task.type)?.label || 'Görev';
                      const accent = getSubjectAccent(task.subject);

                      const topicsList = Array.isArray(task.topics) && task.topics.length > 0
                        ? task.topics
                        : (task.topic ? String(task.topic).split('\n').map(t => t.trim()).filter(Boolean) : []);

                      return (
                        <div
                          key={task.id || idx}
                          className={`rounded-lg p-1.5 text-[8px] print-avoid-break bg-white shadow-xs border border-slate-200 border-l-[3.5px] ${accent.border} ${
                            isCompleted ? 'bg-emerald-50/20' : ''
                          }`}
                        >
                          {/* Ders Adı & Yuvarlak Onay Kutucuğu */}
                          <div className="flex items-start justify-between gap-1 mb-1">
                            <span className="font-extrabold text-[9.5px] text-slate-900 leading-tight break-words">
                              {task.subject}
                            </span>
                            <div
                              className={`w-3.5 h-3.5 shrink-0 rounded-full border flex items-center justify-center font-bold text-[7.5px] ${
                                isCompleted
                                  ? 'bg-emerald-600 border-emerald-600 text-white'
                                  : 'border-slate-300 bg-white text-transparent hover:border-slate-400'
                              }`}
                              title={isCompleted ? 'Tamamlandı' : 'Onay'}
                            >
                              ✓
                            </div>
                          </div>

                          {/* Konu(lar) */}
                          {topicsList.length > 0 && (
                            <div className="space-y-0.5 my-1 text-slate-700">
                              {topicsList.map((tp, tIdx) => (
                                <div key={tIdx} className="flex items-start gap-1 leading-tight">
                                  <span className="text-amber-500 font-black text-[7px] leading-none mt-0.5">•</span>
                                  <span className="text-[8px] font-medium break-words text-slate-700">{tp}</span>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Tip & Soru Hedefi Rozeti */}
                          <div className="flex flex-wrap items-center justify-between gap-1 mt-1 pt-1 border-t border-slate-100 text-[7.5px]">
                            <span className="font-semibold text-slate-600 bg-slate-100 px-1 py-0.2 rounded border border-slate-200/60">
                              {taskTypeLabel}
                            </span>
                            {target > 0 && (
                              <span className="font-black text-amber-700 bg-amber-50 px-1 py-0.2 rounded border border-amber-200/60">
                                {solved > 0 && solved !== target ? `${solved}/` : ''}{target} Soru
                              </span>
                            )}
                          </div>

                          {/* Kaynak Kitap */}
                          {task.source && (
                            <div className="text-[7.5px] text-blue-700 font-semibold truncate mt-1 flex items-center gap-0.5">
                              <span>📖</span>
                              <span className="truncate">{task.source}</span>
                            </div>
                          )}

                          {/* Not */}
                          {task.note && (
                            <div className="text-[7px] text-slate-500 italic mt-0.5 leading-tight bg-slate-50 p-0.5 rounded">
                              Not: {task.note}
                            </div>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* Günün Sonu Günlük Takip Kutusu (Kalemle Doldurulabilir) */}
              <div className="bg-slate-100/90 border-t border-slate-200 p-1 text-[7.5px] space-y-0.5">
                <div className="flex justify-between items-center text-slate-600 font-bold border-b border-slate-200 pb-0.5">
                  <span>Günlük Hedef:</span>
                  <span className="text-slate-900">{dayTargetQuestions} Soru</span>
                </div>
                <div className="flex justify-between items-center text-slate-500 text-[7px] pt-0.5">
                  <span>Çözülen:</span>
                  <span className="border-b border-slate-400 w-12 inline-block text-right">___ Soru</span>
                </div>
                <div className="flex justify-between items-center text-slate-500 text-[7px]">
                  <span>Süre:</span>
                  <span className="border-b border-slate-400 w-12 inline-block text-right">___ dk</span>
                </div>
              </div>

            </div>
          );
        })}
      </div>

      {/* 3. ALT KOÇLUK DEĞERLENDİRME & ÖĞRENCİ HEDEF PANELİ */}
      <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-1.5 border border-slate-200 rounded-xl p-2 bg-slate-50/80">
        
        {/* Sol (2 Kolon): Haftalık Koç Strateji Notu */}
        <div className="md:col-span-2 border-r-0 md:border-r border-slate-200 pr-0 md:pr-2">
          <div className="flex items-center gap-1.5 mb-1">
            <span className="w-2 h-2 rounded-full bg-amber-500"></span>
            <span className="font-black text-[9px] uppercase tracking-wider text-slate-900">Haftalık Koç Tavsiyesi & Odak Noktası</span>
          </div>
          <div className="text-[8px] text-slate-600 leading-snug bg-white p-1.5 rounded-lg border border-slate-200/80">
            "Günlük paragraf ve problem rutinlerini kesinlikle aksatma. Yapamadığın veya boş bıraktığın soruların çözüm videolarını aynı gün içinde izleyerek not al. Düzenli çalışma disiplini seni hedeflediğin bölüme taşıyacaktır."
          </div>
        </div>

        {/* Sağ (1 Kolon): Haftalık Değerlendirme & İmzalar */}
        <div className="pl-0 md:pl-1 flex flex-col justify-between text-[7.5px] space-y-1">
          <div className="flex justify-between items-center">
            <span className="font-bold text-slate-700">Haftalık Toplam Çözülen:</span>
            <span className="border-b border-slate-400 w-16 text-center font-bold text-slate-900">_____ Soru</span>
          </div>
          <div className="flex items-center justify-between text-[7px] text-slate-500">
            <span>Ulaşma Durumu:</span>
            <div className="flex gap-1.5 font-medium text-slate-700">
              <span>☐ Başarılı</span>
              <span>☐ Kısmen</span>
              <span>☐ Geliştirilmeli</span>
            </div>
          </div>
          <div className="flex justify-between items-center pt-0.5 text-[7px] text-slate-400 border-t border-slate-200">
            <span>Öğrenci İmzası: _________</span>
            <span>Koç İmzası: _________</span>
          </div>
        </div>

      </div>

      {/* 4. EN ALT BİLGİ (FOOTER) */}
      <div className="mt-1.5 pt-1 border-t border-slate-200 flex items-center justify-between text-[7.5px] text-slate-400">
        <span className="font-semibold text-slate-500">Koçum Online • Profesyonel Bireysel Öğrenci Koçluğu & Sınav Hazırlık Platformu</span>
        <span className="italic text-slate-400">"Hedefe giden yol düzenli plandan geçer. Başarılar dileriz!"</span>
        <span>Sayfa: 1/1</span>
      </div>

    </div>
  );
};

// 2. HAFTALIK PROGRAM (NİHAİ FİNAL SÜRÜM: Tema Uyumlu + Veri Korumalı)
const ScheduleModule = ({ student, curriculum, onUpdateStudent, user, students, classes }) => {
  const activeCurriculum = student.curriculum || curriculum;
  const [form, setForm] = useState({ days: [], courseId: '', unitId: '', topic: '', topics: [], type: 'soru', count: '', source: '', note: '' });
  const [showTopicDropdown, setShowTopicDropdown] = useState(false);
  const topicDropdownRef = useRef(null);
  const [scheduleZoom, setScheduleZoom] = useState(() => {
    try {
      const saved = localStorage.getItem('schedule_zoom');
      return saved ? parseInt(saved, 10) : 100;
    } catch {
      return 100;
    }
  });

  const handleZoomChange = (newZoom) => {
    setScheduleZoom(newZoom);
    try {
      localStorage.setItem('schedule_zoom', String(newZoom));
    } catch {}
  };
  const [editingId, setEditingId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [showQuickModal, setShowQuickModal] = useState(false);
  const [quickForm, setQuickForm] = useState({ title: '', text: '', days: [], count: '', source: '' });
  const [quickEditingId, setQuickEditingId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [expandedArchive, setExpandedArchive] = useState(null);
  const [toastMessage, setToastMessage] = useState('');
  const toastTimerRef = useRef(null);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [analysisExpandedCourse, setAnalysisExpandedCourse] = useState(null);
  const [analysisExpandedUnitKey, setAnalysisExpandedUnitKey] = useState(null);
  const [showArchiveEditModal, setShowArchiveEditModal] = useState(false);
  const [archiveEditContext, setArchiveEditContext] = useState({ weekId: null, taskId: null });
  const [archiveEditForm, setArchiveEditForm] = useState({ subject: '', topic: '', count: '', solvedCount: '', source: '', note: '', type: 'soru', status: 'pending' });
  const [showExtraModal, setShowExtraModal] = useState(false);
  const [extraForm, setExtraForm] = useState({ title: '', text: '', day: '', count: '', source: '' });
  const [extraEditingId, setExtraEditingId] = useState(null);
  const [editingSolvedId, setEditingSolvedId] = useState(null);
  const [solvedValue, setSolvedValue] = useState('');
  const [photoModalTask, setPhotoModalTask] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxZoom, setLightboxZoom] = useState(1);
  const [lightboxRotation, setLightboxRotation] = useState(0);
  const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const photoFileInputRef = useRef(null);
  const cameraInputRef = useRef(null);
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const colors = useThemeColors();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (topicDropdownRef.current && !topicDropdownRef.current.contains(event.target)) {
        setShowTopicDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    };
  }, []);

  // --- AKILLI RENK SEÇİCİ (Hash Algoritması) ---
  const getSubjectColorInfo = (subjectName) => {
    const name = subjectName || "";

    // Canlı, ayırt edici renkler (Border ve Nokta için)
    const palettes = [
      { border: "border-l-blue-500", dot: "bg-blue-500" },
      { border: "border-l-red-500", dot: "bg-red-500" },
      { border: "border-l-emerald-500", dot: "bg-emerald-500" },
      { border: "border-l-purple-500", dot: "bg-purple-500" },
      { border: "border-l-orange-500", dot: "bg-orange-500" },
      { border: "border-l-pink-500", dot: "bg-pink-500" },
      { border: "border-l-cyan-500", dot: "bg-cyan-500" },
      { border: "border-l-yellow-500", dot: "bg-yellow-500" },
      { border: "border-l-indigo-500", dot: "bg-indigo-500" },
      { border: "border-l-lime-500", dot: "bg-lime-500" },
      { border: "border-l-rose-500", dot: "bg-rose-500" },
      { border: "border-l-teal-500", dot: "bg-teal-500" }
    ];

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % palettes.length;
    return palettes[index];
  };

  const selectedCourse = activeCurriculum.find(c => c.id === form.courseId);
  const selectedUnit = selectedCourse?.units.find(u => u.id === form.unitId);
  const availableResources = student.resources ? student.resources.filter(r => r.courseId === form.courseId && !r.isHidden && !r.isCompleted) : [];
  const assignments = student.assignments || [];
  const weeklySolvedQuestions = assignments.reduce((acc, curr) => {
    const target = parseInt(curr.count) || 0;
    const solved = (curr.solvedCount !== undefined && curr.solvedCount !== '') ? (parseInt(curr.solvedCount) || 0) : (curr.status === 'completed' ? target : 0);
    return acc + solved;
  }, 0);
  const weeklyTotalQuestions = assignments.reduce((acc, curr) => acc + (parseInt(curr.count) || 0), 0);
  const weeklyTaskCount = assignments.length;
  const weeklyCompletedCount = assignments.filter(a => a.status === 'completed').length;
  const completionRate = weeklyTaskCount > 0 ? Math.round((weeklyCompletedCount / weeklyTaskCount) * 100) : 0;


  // --- ANA ATAMA FONKSİYONU (GÜVENLİ) ---
  const handleAssign = async () => {
    const selectedTopics = (form.topics && form.topics.length > 0)
      ? form.topics
      : (form.topic ? form.topic.split('\n').map(t => t.trim()).filter(Boolean) : []);
    if (!form.courseId || selectedTopics.length === 0) return alert("Lütfen ders ve en az bir konu seçiniz.");
    if (form.days.length === 0) return alert("En az bir gün seçiniz.");

    const topicString = selectedTopics.join('\n');

    // Eklenecek ödev listesini hazırla
    const assignmentsToAdd = [];
    form.days.forEach((day, index) => {
      assignmentsToAdd.push({
        id: Date.now() + Math.random() + index,
        status: 'pending',
        subject: selectedCourse.name,
        ...form,
        topic: topicString,
        topics: selectedTopics,
        day
      });
    });

      // TEKİL ÖĞRENCİ (EKLEME / DÜZENLEME)
      if (editingId) {
        // DÜZENLEME: Yerini korumak için map kullanıyoruz
        const finalAssignments = assignments.map(a => {
          if (a.id === editingId) {
            const updatedTask = assignmentsToAdd[0];
            return {
              ...a, // Mevcut status ve solvedCount'u koru
              ...updatedTask,
              id: editingId // ID değişmesin
            };
          }
          return a;
        });

        if (isFirebaseActive) {
          try {
            await updateDoc(doc(db, "students", student.id), { assignments: finalAssignments });
          } catch (e) { console.error(e); alert("Güncelleme hatası."); }
        } else {
          onUpdateStudent({ ...student, assignments: finalAssignments });
        }
      }
      else {
        // YENİ EKLEME
        if (isFirebaseActive) {
          try {
            await updateDoc(doc(db, "students", student.id), { assignments: arrayUnion(...assignmentsToAdd) });
          } catch (e) { console.error(e); alert("Hata oluştu."); }
        } else {
          onUpdateStudent({ ...student, assignments: [...assignments, ...assignmentsToAdd] });
        }
      }
    setEditingId(null);
    setToastMessage('Ödev başarıyla atandı');

    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
  };

  const handleQuickAssign = async () => {
    if (!quickForm.title || !quickForm.title.trim()) return alert("Ödev başlığı giriniz.");
    if (!quickForm.text) return alert("Görev giriniz.");
    if (quickForm.days.length === 0) return alert("Gün seçiniz.");
    if (quickEditingId && quickForm.days.length !== 1) return alert("Düzenleme modunda tek bir gün seçiniz.");

    if (quickEditingId) {
      const day = quickForm.days[0];
      const updated = assignments.map(a => {
        if (a.id !== quickEditingId) return a;
        return {
          ...a,
          subject: quickForm.title.trim(),
          topic: quickForm.text,
          day,
          type: 'ozel',
          count: quickForm.count,
          source: quickForm.source
        };
      });

      if (isFirebaseActive) {
        try { await updateDoc(doc(db, "students", student.id), { assignments: updated }); } catch (e) { }
      } else {
        onUpdateStudent({ ...student, assignments: updated });
      }

      setShowQuickModal(false);
      setQuickEditingId(null);
      setQuickForm({ title: '', text: '', days: [], count: '', source: '' });

      setToastMessage('Ödev başarıyla atandı');
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
      toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
      return;
    }

    const assignmentsToAdd = [];
    quickForm.days.forEach((day, index) => {
      assignmentsToAdd.push({
        id: Date.now() + Math.random() + index,
        status: 'pending',
        subject: quickForm.title.trim(),
        topic: quickForm.text,
        day,
        type: 'ozel',
        count: quickForm.count,
        source: quickForm.source
      });
    });

    if (isFirebaseActive) {
      try { await updateDoc(doc(db, "students", student.id), { assignments: arrayUnion(...assignmentsToAdd) }); } catch (e) { }
    } else {
      onUpdateStudent({ ...student, assignments: [...assignments, ...assignmentsToAdd] });
    }

    setShowQuickModal(false);
    setQuickForm({ title: '', text: '', days: [], count: '', source: '' });

    setToastMessage('Ödev başarıyla atandı');
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
  };

  const handleExtraAssign = async () => {
    if (!extraForm.title || !extraForm.title.trim()) return alert("Başlık giriniz.");
    if (!extraForm.text) return alert("İçerik giriniz.");
    if (!extraForm.day) return alert("Gün seçiniz.");

    if (extraEditingId) {
      const updated = assignments.map(a => {
        if (a.id !== extraEditingId) return a;
        return {
          ...a,
          subject: extraForm.title.trim(),
          topic: extraForm.text,
          day: extraForm.day,
          count: extraForm.count,
          source: extraForm.source
        };
      });

      if (isFirebaseActive) {
        try { await updateDoc(doc(db, "students", student.id), { assignments: updated }); } catch (e) { }
      } else {
        onUpdateStudent({ ...student, assignments: updated });
      }
    } else {
      const newExtraTask = {
        id: Date.now() + Math.random(),
        status: 'pending',
        subject: extraForm.title.trim(),
        topic: extraForm.text,
        day: extraForm.day,
        type: 'extra',
        count: extraForm.count,
        source: extraForm.source
      };

      if (isFirebaseActive) {
        try { await updateDoc(doc(db, "students", student.id), { assignments: arrayUnion(newExtraTask) }); } catch (e) { console.error(e); }
      } else {
        onUpdateStudent({ ...student, assignments: [...assignments, newExtraTask] });
      }
    }

    setShowExtraModal(false);
    setExtraForm({ title: '', text: '', day: '', count: '', source: '' });
    setExtraEditingId(null);
    setToastMessage(extraEditingId ? 'Ekstra ödev güncellendi' : 'Ekstra ödev başarıyla eklendi');
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
  };

  const handleEdit = (task) => {
    if (task.type === 'ozel') {
      setQuickEditingId(task.id);
      setQuickForm({
        title: task.subject || '',
        text: task.topic || '',
        days: task.day ? [task.day] : [],
        count: task.count || '',
        source: task.source || ''
      });
      setShowQuickModal(true);
      return;
    }
    if (task.type === 'extra') {
      setExtraEditingId(task.id);
      setExtraForm({
        title: task.subject || '',
        text: task.topic || '',
        day: task.day || '',
        count: task.count || '',
        source: task.source || ''
      });
      setShowExtraModal(true);
      return;
    }
    const course = activeCurriculum.find(c => c.name === task.subject);
    const taskTopics = Array.isArray(task.topics) && task.topics.length > 0
      ? task.topics
      : (task.topic ? task.topic.split('\n').map(t => t.trim()).filter(Boolean) : []);
    setForm({
      days: [task.day],
      courseId: course ? course.id : '',
      unitId: task.unitId || '',
      topic: task.topic || '',
      topics: taskTopics,
      type: task.type,
      count: task.count,
      source: task.source || '',
      note: task.note || ''
    });
    setEditingId(task.id); window.scrollTo(0, 0);
  };
  const handleCancelEdit = () => { setEditingId(null); setForm(prev => ({ ...prev, count: '', source: '', unitId: '', topic: '', topics: [], note: '', days: [] })); };

  const toggleTaskStatus = (id) => {
    const task = assignments.find(a => a.id === id);
    if (!task) return;
    const isNowCompleted = task.status !== 'completed';
    const updated = assignments.map(a => a.id === id ? {
      ...a,
      status: isNowCompleted ? 'completed' : 'pending',
      solvedCount: isNowCompleted ? (a.solvedCount || a.count) : ''
    } : a);

    let newStats = { ...student.stats };
    if (isNowCompleted) {
      newStats.xp = (newStats.xp || 0) + 50;
    } else {
      newStats.xp = Math.max(0, (newStats.xp || 0) - 50);
    }
    newStats.level = Math.floor(newStats.xp / 1000) + 1;
    onUpdateStudent({ ...student, assignments: updated, stats: newStats });
    if (isNowCompleted) logActivity(student.id, 'assignment_mark', { subject: task.subject, topic: task.topic, status: 'completed' });
  };

  const handleUpdateSolvedCount = (id, value) => {
    const numValue = value === '' ? '' : parseInt(value);
    const updated = assignments.map(a => {
      if (a.id !== id) return a;
      const target = parseInt(a.count) || 0;
      const solved = numValue === '' ? 0 : numValue;
      return {
        ...a,
        solvedCount: numValue,
        status: (target > 0 && solved >= target) ? 'completed' : (target > 0 && solved < target ? 'pending' : a.status)
      };
    });
    onUpdateStudent({ ...student, assignments: updated });
  };

  const requestDelete = (e, id) => { e.stopPropagation(); e.preventDefault(); setDeleteConfirm(id); };
  const confirmDelete = () => { if (deleteConfirm) { const filtered = assignments.filter(a => String(a.id) !== String(deleteConfirm)); onUpdateStudent({ ...student, assignments: filtered }); setDeleteConfirm(null); } };
  const handleDeleteArchive = async (weekId) => {
    if (!window.confirm("Arşiv silinsin mi?")) return;
    const targetWeek = (student.pastWeeks || []).find(w => String(w.id) === String(weekId));
    if (storage && targetWeek && Array.isArray(targetWeek.assignments)) {
      for (const task of targetWeek.assignments) {
        if (Array.isArray(task?.images)) {
          for (const img of task.images) {
            if (img?.storagePath) {
              try {
                const fRef = storageRef(storage, img.storagePath);
                await deleteObject(fRef);
              } catch (err) {
                console.warn("Storage archive delete error:", err);
              }
            }
          }
        }
      }
    }
    const updatedArchives = (student.pastWeeks || []).filter(w => String(w.id) !== String(weekId));
    if (isFirebaseActive && student?.id) {
      try { await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ pastWeeks: updatedArchives })); } catch (e) { console.error("handleDeleteArchive hatası:", e); }
    }
    onUpdateStudent({ ...student, pastWeeks: updatedArchives });
  };

  const handleEditWeekName = async (weekId, currentName) => {
    const newName = prompt("Hafta adı için yeni bir değer girin:", currentName);
    if (newName === null) return;
    const trimmedName = newName.trim();
    if (!trimmedName) return alert("Hafta adı boş olamaz!");

    const updatedPastWeeks = (student.pastWeeks || []).map(w => {
      if (w.id === weekId) {
        return { ...w, name: trimmedName };
      }
      return w;
    });

    if (isFirebaseActive && student?.id) {
      try {
        await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ pastWeeks: updatedPastWeeks }));
      } catch (e) {
        console.error("handleEditWeekName hatası:", e);
        alert("Güncelleme hatası.");
        return;
      }
    } else {
      onUpdateStudent({ ...student, pastWeeks: updatedPastWeeks });
    }
  };

  useEffect(() => {
    if (!lightboxImage) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setLightboxImage(null);
      } else if (e.key === 'ArrowRight') {
        const images = photoModalTask?.images || [];
        if (images.length > 1) {
          const nextIdx = (lightboxIndex + 1) % images.length;
          setLightboxIndex(nextIdx);
          setLightboxImage(images[nextIdx]);
          setLightboxZoom(1);
          setLightboxRotation(0);
        }
      } else if (e.key === 'ArrowLeft') {
        const images = photoModalTask?.images || [];
        if (images.length > 1) {
          const prevIdx = (lightboxIndex - 1 + images.length) % images.length;
          setLightboxIndex(prevIdx);
          setLightboxImage(images[prevIdx]);
          setLightboxZoom(1);
          setLightboxRotation(0);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxImage, lightboxIndex, photoModalTask]);

  const handleUploadPhotos = async (files) => {
    if (!files || files.length === 0 || !photoModalTask) return;
    setIsUploadingPhoto(true);
    setUploadError('');

    try {
      const uploadedList = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!file.type || !file.type.startsWith('image/')) continue;

        const uploadedItem = await uploadPhotoFile(file, student?.id, 'assignments');
        uploadedList.push(uploadedItem);
      }

      if (uploadedList.length === 0) {
        setIsUploadingPhoto(false);
        return;
      }

      const currentImages = Array.isArray(photoModalTask.images) ? photoModalTask.images : [];
      const newImages = [...currentImages, ...uploadedList];

      // Arayüzü derhal güncelle (gecikme hissi sıfırlanır)
      setPhotoModalTask(prev => prev ? { ...prev, images: newImages } : null);

      if (photoModalTask.isArchived && photoModalTask.weekId) {
        const updatedPastWeeks = (student.pastWeeks || []).map(w => {
          if (String(w.id) !== String(photoModalTask.weekId)) return w;
          return {
            ...w,
            assignments: (w.assignments || []).map(a => String(a.id) === String(photoModalTask.id) ? { ...a, images: newImages } : a)
          };
        });
        if (isFirebaseActive && student?.id) {
          try {
            await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ pastWeeks: updatedPastWeeks }));
          } catch (e) {
            console.error("handleUploadPhotos pastWeeks hatası:", e);
            throw new Error("Görsel arşive kaydedilirken veritabanı hatası: " + (e.message || "Bilinmeyen hata"));
          }
        }
        onUpdateStudent({ ...student, pastWeeks: updatedPastWeeks }, { skipFirestore: true });
      } else {
        const updatedAssignments = assignments.map(a => {
          if (String(a.id) === String(photoModalTask.id)) {
            return { ...a, images: newImages };
          }
          return a;
        });
        if (isFirebaseActive && student?.id) {
          try {
            await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ assignments: updatedAssignments }));
          } catch (e) {
            console.error("handleUploadPhotos assignments hatası:", e);
            throw new Error("Görsel ödeve kaydedilirken veritabanı hatası: " + (e.message || "Bilinmeyen hata"));
          }
        }
        onUpdateStudent({ ...student, assignments: updatedAssignments }, { skipFirestore: true });
      }

      setToastMessage(`${uploadedList.length} fotoğraf başarıyla yüklendi`);
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
      toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
    } catch (err) {
      console.error("Fotoğraf yükleme hatası:", err);
      setUploadError(err.message || "Fotoğraf yüklenirken bir hata oluştu.");
    } finally {
      setIsUploadingPhoto(false);
      if (photoFileInputRef.current) photoFileInputRef.current.value = '';
      if (cameraInputRef.current) cameraInputRef.current.value = '';
    }
  };

  const executeDeleteSinglePhoto = async (imageToDelete) => {
    if (storage && imageToDelete?.storagePath) {
      try {
        const fRef = storageRef(storage, imageToDelete.storagePath);
        await deleteObject(fRef);
      } catch (err) {
        console.warn("Storage deleteObject error:", err);
      }
    }

    const remainingImages = (photoModalTask?.images || []).filter(img => String(img.id) !== String(imageToDelete.id));

    if (photoModalTask.isArchived && photoModalTask.weekId) {
      const updatedPastWeeks = (student.pastWeeks || []).map(w => {
        if (String(w.id) !== String(photoModalTask.weekId)) return w;
        return {
          ...w,
          assignments: (w.assignments || []).map(a => String(a.id) === String(photoModalTask.id) ? { ...a, images: remainingImages } : a)
        };
      });
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ pastWeeks: updatedPastWeeks }));
        } catch (e) {
          console.error("handleDeleteSinglePhoto pastWeeks hatası:", e);
        }
      }
      onUpdateStudent({ ...student, pastWeeks: updatedPastWeeks }, { skipFirestore: true });
    } else {
      const updatedAssignments = assignments.map(a => {
        if (String(a.id) === String(photoModalTask.id)) {
          return { ...a, images: remainingImages };
        }
        return a;
      });
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ assignments: updatedAssignments }));
        } catch (e) {
          console.error("handleDeleteSinglePhoto assignments hatası:", e);
        }
      }
      onUpdateStudent({ ...student, assignments: updatedAssignments }, { skipFirestore: true });
    }

    setPhotoModalTask(prev => prev ? { ...prev, images: remainingImages } : null);
    if (String(lightboxImage?.id) === String(imageToDelete.id)) {
      setLightboxImage(null);
    }
    setToastMessage("Fotoğraf silindi.");
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
  };

  const handleDeleteSinglePhoto = (imageToDelete) => {
    setConfirmDialog({
      title: "Fotoğrafı Sil",
      message: "Bu fotoğrafı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
      confirmText: "Evet, Sil",
      cancelText: "Vazgeç",
      variant: "danger",
      icon: Trash2,
      onConfirm: () => executeDeleteSinglePhoto(imageToDelete)
    });
  };

  const executeClearAllPhotos = async (alsoCompleteTask = false) => {
    if (storage && Array.isArray(photoModalTask?.images)) {
      for (const img of photoModalTask.images) {
        if (img?.storagePath) {
          try {
            const fRef = storageRef(storage, img.storagePath);
            await deleteObject(fRef);
          } catch (err) {
            console.warn("Storage clear error:", err);
          }
        }
      }
    }

    if (photoModalTask.isArchived && photoModalTask.weekId) {
      const updatedPastWeeks = (student.pastWeeks || []).map(w => {
        if (String(w.id) !== String(photoModalTask.weekId)) return w;
        return {
          ...w,
          assignments: (w.assignments || []).map(a => {
            if (String(a.id) === String(photoModalTask.id)) {
              return {
                ...a,
                images: [],
                status: alsoCompleteTask ? 'completed' : a.status,
                solvedCount: alsoCompleteTask ? (a.solvedCount || a.count) : a.solvedCount
              };
            }
            return a;
          })
        };
      });
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ pastWeeks: updatedPastWeeks }));
        } catch (e) {
          console.error("handleClearAllPhotos pastWeeks hatası:", e);
        }
      }
      onUpdateStudent({ ...student, pastWeeks: updatedPastWeeks }, { skipFirestore: true });
    } else {
      let newStats = { ...student.stats };
      const updatedAssignments = assignments.map(a => {
        if (String(a.id) === String(photoModalTask.id)) {
          const isNowCompleted = alsoCompleteTask || a.status === 'completed';
          if (alsoCompleteTask && a.status !== 'completed') {
            newStats.xp = (newStats.xp || 0) + 50;
            newStats.level = Math.floor(newStats.xp / 1000) + 1;
          }
          return {
            ...a,
            images: [],
            status: isNowCompleted ? 'completed' : a.status,
            solvedCount: isNowCompleted ? (a.solvedCount || a.count) : a.solvedCount
          };
        }
        return a;
      });
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ assignments: updatedAssignments, stats: newStats }));
        } catch (e) {
          console.error("handleClearAllPhotos assignments hatası:", e);
        }
      }
      onUpdateStudent({ ...student, assignments: updatedAssignments, stats: newStats }, { skipFirestore: true });
      if (alsoCompleteTask && photoModalTask.status !== 'completed') {
        logActivity(student.id, 'assignment_mark', { subject: photoModalTask.subject, topic: photoModalTask.topic, status: 'completed' });
      }
    }

    setPhotoModalTask(prev => prev ? { ...prev, images: [], status: alsoCompleteTask ? 'completed' : prev.status } : null);
    setLightboxImage(null);
    setToastMessage(alsoCompleteTask ? "Ödev tamamlandı ve tüm fotoğraflar temizlendi!" : "Fotoğraflar temizlendi, alan boşaltıldı.");
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2500);
  };

  const handleClearAllPhotos = (alsoCompleteTask = false) => {
    const count = photoModalTask?.images?.length || 0;
    if (count === 0 && !alsoCompleteTask) return;

    const confirmMsg = alsoCompleteTask
      ? `Ödev 'Tamamlandı' olarak işaretlenecek ve bu ödeve ait ${count} adet fotoğraf kalıcı olarak silinerek depolama alanı tamamen boşaltılacaktır.\n\nOnaylıyor musunuz?`
      : `Bu ödeve ait ${count} adet fotoğraf kalıcı olarak silinecek ve depolama alanı boşaltılacaktır.\n\nOnaylıyor musunuz?`;

    setConfirmDialog({
      title: "Ödevi Kontrol Et & Temizle",
      message: confirmMsg,
      confirmText: "✓ Kontrol Edildi & Temizle",
      cancelText: "Vazgeç",
      variant: "success",
      icon: CheckCheck,
      onConfirm: () => executeClearAllPhotos(alsoCompleteTask)
    });
  };

  const openLightbox = (img, index) => {
    setLightboxImage(img);
    setLightboxIndex(index);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const nextLightboxImage = () => {
    const images = photoModalTask?.images || [];
    if (images.length <= 1) return;
    const nextIdx = (lightboxIndex + 1) % images.length;
    setLightboxIndex(nextIdx);
    setLightboxImage(images[nextIdx]);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const prevLightboxImage = () => {
    const images = photoModalTask?.images || [];
    if (images.length <= 1) return;
    const prevIdx = (lightboxIndex - 1 + images.length) % images.length;
    setLightboxIndex(prevIdx);
    setLightboxImage(images[prevIdx]);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const openArchiveTaskEdit = (weekId, task) => {
    setArchiveEditContext({ weekId, taskId: task.id });
    setArchiveEditForm({
      subject: task.subject || '',
      topic: task.topic || '',
      count: task.count || '',
      solvedCount: task.solvedCount !== undefined ? task.solvedCount : '',
      source: task.source || '',
      note: task.note || '',
      type: task.type || 'soru',
      status: task.status === 'completed' ? 'completed' : 'pending'
    });
    setShowArchiveEditModal(true);
  };

  const handleSaveArchiveTask = async () => {
    const { weekId, taskId } = archiveEditContext;
    if (!weekId || !taskId) return;

    const updatedPastWeeks = (student.pastWeeks || []).map(w => {
      if (w.id !== weekId) return w;
      const updatedAssignments = (w.assignments || []).map(a => {
        if (a.id !== taskId) return a;
        const countVal = parseInt(archiveEditForm.count) || 0;
        const solvedVal = archiveEditForm.solvedCount === '' ? '' : (parseInt(archiveEditForm.solvedCount) || 0);
        let newStatus = archiveEditForm.status;
        if (countVal > 0 && solvedVal !== '') {
          newStatus = solvedVal >= countVal ? 'completed' : 'pending';
        }
        return {
          ...a,
          subject: archiveEditForm.subject,
          topic: archiveEditForm.topic,
          count: archiveEditForm.count,
          solvedCount: solvedVal,
          source: archiveEditForm.source,
          note: archiveEditForm.note,
          status: newStatus
        };
      });
      const totalSolved = updatedAssignments.reduce((acc, curr) => {
        const target = parseInt(curr.count) || 0;
        const solved = curr.solvedCount !== undefined && curr.solvedCount !== '' ? (parseInt(curr.solvedCount) || 0) : (curr.status === 'completed' ? target : 0);
        return acc + solved;
      }, 0);
      const totalCount = updatedAssignments.length;
      const completedCount = updatedAssignments.filter(a => a.status === 'completed').length;
      const completionRate = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;
      return { ...w, assignments: updatedAssignments, solvedCount: totalSolved, completionRate: completionRate };
    });

    if (isFirebaseActive) {
      try { await updateDoc(doc(db, "students", student.id), { pastWeeks: updatedPastWeeks }); } catch (e) { console.error(e); alert("Güncelleme hatası."); return; }
    } else {
      onUpdateStudent({ ...student, pastWeeks: updatedPastWeeks });
    }

    setShowArchiveEditModal(false);
    setArchiveEditContext({ weekId: null, taskId: null });
  };

  const handleResetSchedule = async () => {
    const weekName = prompt("Arşivlenecek hafta için bir isim giriniz:", `${new Date().toLocaleDateString('tr-TR')} Haftası`);
    if (!weekName) return;
    if (window.confirm("Program arşive alınıp sıfırlansın mı?\n(Bu haftaya ait ödev fotoğrafları kalıcı olarak temizlenecek ve depolama alanı boşaltılacaktır.)")) {
      // 1. Bu haftadaki tüm ödev fotoğraflarını Storage'dan temizle
      if (storage) {
        for (const task of assignments) {
          if (Array.isArray(task?.images)) {
            for (const img of task.images) {
              if (img?.storagePath) {
                try {
                  const fRef = storageRef(storage, img.storagePath);
                  await deleteObject(fRef);
                } catch (err) {
                  console.warn("Storage archive cleanup error:", err);
                }
              }
            }
          }
        }
      }

      // 2. Arşivlenen ödevlerin fotoğraflarını temizle
      const cleanedAssignments = assignments.map(a => ({
        ...a,
        images: []
      }));

      const newTotalSolved = (student.stats?.totalSolved || 0) + weeklySolvedQuestions;
      const newMonthlySolved = (student.stats?.monthlySolved || 0) + weeklySolvedQuestions;
      const archivedWeek = {
        id: Date.now(),
        name: weekName,
        date: new Date().toLocaleDateString('tr-TR'),
        assignments: cleanedAssignments,
        solvedCount: weeklySolvedQuestions,
        completionRate: completionRate
      };
      const updatedStudent = {
        ...student,
        assignments: [],
        pastWeeks: [archivedWeek, ...(student.pastWeeks || [])],
        stats: { ...student.stats, totalSolved: newTotalSolved, monthlySolved: newMonthlySolved }
      };

      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({
            assignments: [],
            pastWeeks: updatedStudent.pastWeeks,
            stats: updatedStudent.stats
          }));
        } catch (e) {
          console.error("Archive updateDoc error:", e);
        }
      }
      onUpdateStudent(updatedStudent);
    }
  };

  const getDailyStats = (dayId) => {
    const dayTasks = assignments.filter(a => a.day === dayId);
    const totalQuestions = dayTasks.reduce((acc, curr) => acc + (parseInt(curr.count) || 0), 0);
    return {
      topic: dayTasks.filter(t => t.type === 'konu').length,
      question: totalQuestions,
      repeat: dayTasks.filter(t => t.type === 'tekrar').length,
      exam: dayTasks.filter(t => t.type === 'deneme').length
    };
  };
  const isAdmin = user.role === 'admin' || user.role === 'superadmin';
  const isStudent = user.role === 'student';

  const analysisData = React.useMemo(() => {
    if (!showAnalysisModal) return null;

    const allAssignments = [
      ...((student.assignments || []).map(a => ({ ...a }))),
      ...((student.pastWeeks || []).flatMap(w => (w.assignments || []).map(a => ({ ...a }))))
    ];

    const completed = allAssignments.filter(a => (a.status === 'completed' || (a.solvedCount !== undefined && parseInt(a.solvedCount) > 0)));

    const unitNameById = new Map();
    const courseNameById = new Map();
    const courseByName = new Map();
    (activeCurriculum || []).forEach(c => {
      courseNameById.set(c.id, c.name);
      courseByName.set(c.name, c);
      (c.units || []).forEach(u => unitNameById.set(u.id, u.name));
    });

    const resolveUnitName = (courseName, topic) => {
      const course = courseByName.get(courseName);
      if (!course || !topic) return 'Ünite Belirtilmemiş';
      for (const u of (course.units || [])) {
        if ((u.topics || []).includes(topic)) return u.name;
      }
      return 'Ünite Belirtilmemiş';
    };

    const courseMap = new Map();

    completed.forEach(a => {
      const target = parseInt(a.count) || 0;
      const count = (a.solvedCount !== undefined && a.solvedCount !== '') ? (parseInt(a.solvedCount) || 0) : (a.status === 'completed' ? target : 0);
      if (!count) return;

      const courseName = a.subject || courseNameById.get(a.courseId) || 'Diğer';
      const topicName = a.topic || 'Konu Belirtilmemiş';
      const unitName = a.unitId ? (unitNameById.get(a.unitId) || 'Ünite Belirtilmemiş') : resolveUnitName(courseName, a.topic);

      if (!courseMap.has(courseName)) courseMap.set(courseName, { name: courseName, total: 0, unitMap: new Map() });
      const courseNode = courseMap.get(courseName);
      courseNode.total += count;

      if (!courseNode.unitMap.has(unitName)) courseNode.unitMap.set(unitName, { name: unitName, total: 0, topicMap: new Map() });
      const unitNode = courseNode.unitMap.get(unitName);
      unitNode.total += count;

      unitNode.topicMap.set(topicName, (unitNode.topicMap.get(topicName) || 0) + count);
    });

    const courses = Array.from(courseMap.values())
      .map(c => ({
        name: c.name,
        total: c.total,
        units: Array.from(c.unitMap.values())
          .map(u => ({
            name: u.name,
            total: u.total,
            topics: Array.from(u.topicMap.entries())
              .map(([name, total]) => ({ name, total }))
              .sort((a, b) => b.total - a.total)
          }))
          .sort((a, b) => b.total - a.total)
      }))
      .sort((a, b) => b.total - a.total);

    return { courses };
  }, [showAnalysisModal, student.assignments, activeCurriculum]);
  const DaySelector = ({ selectedDays, onChange }) => (
    <div className="flex flex-wrap gap-1">
      {DAYS.map(d => (
        <button
          key={d.id}
          type="button"
          onClick={() => {
            const newDays = selectedDays.includes(d.id)
              ? selectedDays.filter(id => id !== d.id)
              : [...selectedDays, d.id];
            onChange(newDays);
          }}
          className={`px-2.5 py-1.5 text-xs font-bold rounded-lg border transition-all ${
            selectedDays.includes(d.id)
              ? 'bg-orange-600 text-white border-orange-600'
              : `${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} ${colors.textSec} border-transparent hover:border-slate-500`
          }`}
        >
          {d.short || (d.id === 'Sat' ? 'Cmt' : (d.id === 'Mon' ? 'Pzt' : d.label.substring(0, 3)))}
        </button>
      ))}
    </div>
  );

  return (
    <div className="space-y-8 animate-fade-in">
      {/* SADECE YAZDIRMA (A4 YATAY) ÇIKTISINDA GÖRÜNECEK ALAN */}
      <div id="schedule-print-container" className="print-only-container">
        <WeeklySchedulePrintView
          student={student}
          assignments={assignments}
          DAYS={DAYS}
          TASK_TYPES={TASK_TYPES}
          user={user}
          weeklyTotalQuestions={weeklyTotalQuestions}
          weeklySolvedQuestions={weeklySolvedQuestions}
          weeklyTaskCount={weeklyTaskCount}
          completionRate={completionRate}
        />
      </div>

      <div className="no-print space-y-8">
        {toastMessage && (
          <div className="fixed top-5 right-5 z-[9999]">
            <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-emerald-600 text-white shadow-lg">
              <CheckCircle size={18} />
              <span className="text-sm font-bold">{toastMessage}</span>
            </div>
          </div>
        )}
      <div className="flex justify-between items-center flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <h2 className={`text-2xl font-bold ${colors.text}`}>Haftalık Planlama</h2>
          {/* Ölçeklendirme / Zoom Butonları */}
          <div className={`flex items-center gap-1 px-1.5 py-1 rounded-xl border ${colors.border} ${colors.isDark ? 'bg-slate-900/60' : 'bg-slate-100'} shadow-sm`}>
            <button
              type="button"
              onClick={() => handleZoomChange(Math.max(70, scheduleZoom - 10))}
              className={`p-1 rounded-lg ${colors.hoverBg} text-slate-400 hover:text-white transition-colors`}
              title="Küçült (-%10)"
            >
              <ZoomOut size={13} />
            </button>
            <div className="flex items-center gap-0.5">
              {[100, 90, 80, 70].map(z => (
                <button
                  key={z}
                  type="button"
                  onClick={() => handleZoomChange(z)}
                  className={`px-2 py-0.5 text-[11px] font-bold rounded-md transition-all ${
                    scheduleZoom === z
                      ? 'bg-orange-600 text-white shadow-sm'
                      : `${colors.textSec} hover:${colors.text} hover:bg-slate-700/30`
                  }`}
                  title={`%${z} Görünüm`}
                >
                  %{z}
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={() => handleZoomChange(Math.min(120, scheduleZoom + 10))}
              className={`p-1 rounded-lg ${colors.hoverBg} text-slate-400 hover:text-white transition-colors`}
              title="Büyüt (+%10)"
            >
              <ZoomIn size={13} />
            </button>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 justify-end items-center">
          <Button
            size="small"
            variant="secondary"
            icon={Printer}
            onClick={() => setShowPrintModal(true)}
            title="Haftalık Programı Yazdır / PDF Olarak Kaydet (Yatay A4)"
          >
            Yazdır
          </Button>
          {isAdmin && <Button variant="ghost" onClick={() => setIsEditMode(!isEditMode)} icon={Settings} className={isEditMode ? 'text-orange-500 bg-orange-500/10' : ''} />}
          {isAdmin && <Button variant="secondary" icon={BarChart2} onClick={() => { setShowAnalysisModal(true); setAnalysisExpandedCourse(null); setAnalysisExpandedUnitKey(null); }}>Analiz</Button>}
          {isAdmin && <Button size="small" icon={Zap} onClick={() => setShowQuickModal(true)}>Hızlı Görev</Button>}
          {isAdmin && <Button variant="danger" size="small" icon={RefreshCw} onClick={handleResetSchedule}>Arşivle & Sıfırla</Button>}
          {isStudent && <Button size="small" variant="secondary" icon={Plus} onClick={() => { setExtraEditingId(null); setExtraForm({ title: '', text: '', day: '', count: '', source: '' }); setShowExtraModal(true); }}>Ekstra</Button>}
        </div>
      </div>

      {showAnalysisModal && (
        <Modal title="Performans Analizi" onClose={() => { setShowAnalysisModal(false); setAnalysisExpandedCourse(null); setAnalysisExpandedUnitKey(null); }}>
          <div className="space-y-4">
            {!analysisData || analysisData.courses.length === 0 ? (
              <div className={`p-4 rounded-lg border ${colors.border} ${colors.bgCard}`}>
                <div className={`text-sm font-bold ${colors.text}`}>Henüz analiz edilecek veri yok</div>
                <div className={`text-xs ${colors.textSec} mt-1`}>Tamamlanan (completed) soru ödevleri üzerinden analiz yapılır.</div>
              </div>
            ) : (
              <div className="space-y-3">
                <div className={`text-xs font-bold ${colors.textSec} uppercase`}>Tüm Geçmiş (Ders / Ünite / Konu)</div>

                {analysisData.courses.map(course => {
                  const isOpen = analysisExpandedCourse === course.name;
                  return (
                    <div key={course.name} className={`${colors.bgCard} border ${colors.border} rounded-xl overflow-hidden`}>
                      <button
                        onClick={() => { setAnalysisExpandedCourse(isOpen ? null : course.name); setAnalysisExpandedUnitKey(null); }}
                        className={`w-full p-4 flex items-center justify-between ${colors.hoverBg}`}
                      >
                        <div className="flex items-center gap-2 overflow-hidden">
                          {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                          <div className="overflow-hidden">
                            <div className={`font-bold ${colors.text} truncate`}>{course.name}</div>
                            <div className={`text-[10px] ${colors.textSec}`}>Toplam çözülen soru</div>
                          </div>
                        </div>
                        <div className="text-orange-400 font-bold">{course.total}</div>
                      </button>

                      {isOpen && (
                        <div className={`border-t ${colors.border} ${colors.isDark ? 'bg-slate-900/30' : 'bg-slate-50/50'} p-3 space-y-2`}>
                          {course.units.map(unit => {
                            const unitKey = `${course.name}__${unit.name}`;
                            const unitOpen = analysisExpandedUnitKey === unitKey;
                            return (
                              <div key={unitKey} className={`border ${colors.border} rounded-lg overflow-hidden ${colors.isDark ? 'bg-slate-900/20' : 'bg-white/60'}`}>
                                <button
                                  onClick={() => setAnalysisExpandedUnitKey(unitOpen ? null : unitKey)}
                                  className={`w-full px-4 py-3 flex items-center justify-between ${colors.hoverBg}`}
                                >
                                  <div className="flex items-center gap-2 overflow-hidden">
                                    {unitOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                                    <span className={`text-sm font-bold ${colors.text} truncate`}>{unit.name}</span>
                                  </div>
                                  <span className="text-orange-400 font-bold text-sm">{unit.total}</span>
                                </button>

                                {unitOpen && (
                                  <div className={`border-t ${colors.border} p-3 space-y-1 ${colors.isDark ? 'bg-slate-950/30' : 'bg-slate-50/60'}`}>
                                    {unit.topics.map(topic => (
                                      <div key={topic.name} className={`px-3 py-2 rounded flex justify-between items-center ${colors.isDark ? 'bg-slate-900/30' : 'bg-white'} border ${colors.border}`}>
                                        <span className={`text-xs font-medium ${colors.text} truncate pr-4`}>{topic.name}</span>
                                        <span className="text-orange-400 font-bold text-xs">{topic.total}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })}

                          {course.units.length === 0 && (
                            <div className={`p-3 rounded border ${colors.border} ${colors.bgCard}`}>
                              <div className={`text-xs ${colors.textSec}`}>Bu derste ünite bilgisi bulunamadı.</div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Modal>
      )}

      {showArchiveEditModal && (
        <Modal title="Arşiv Ödevini Düzenle" onClose={() => { setShowArchiveEditModal(false); setArchiveEditContext({ weekId: null, taskId: null }); }}>
          <div className="space-y-4">
            <Input label="Başlık" value={archiveEditForm.subject} onChange={e => setArchiveEditForm({ ...archiveEditForm, subject: e.target.value })} />
            <Input label="Konu / İçerik" value={archiveEditForm.topic} onChange={e => setArchiveEditForm({ ...archiveEditForm, topic: e.target.value })} />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Input label="Hedef Soru" type="number" value={archiveEditForm.count} onChange={e => setArchiveEditForm({ ...archiveEditForm, count: e.target.value })} />
              <Input label="Çözülen Soru" type="number" value={archiveEditForm.solvedCount} onChange={e => setArchiveEditForm({ ...archiveEditForm, solvedCount: e.target.value })} />
              <Input label="Kaynak" value={archiveEditForm.source} onChange={e => setArchiveEditForm({ ...archiveEditForm, source: e.target.value })} />
            </div>
            <Input label="Not" value={archiveEditForm.note} onChange={e => setArchiveEditForm({ ...archiveEditForm, note: e.target.value })} />
            <div className="flex items-center justify-between gap-4">
              <div className={`text-sm font-bold ${colors.text}`}>Durum</div>
              <button
                onClick={() => setArchiveEditForm({ ...archiveEditForm, status: archiveEditForm.status === 'completed' ? 'pending' : 'completed' })}
                className={`px-3 py-2 rounded-lg text-sm font-bold border ${archiveEditForm.status === 'completed' ? 'bg-emerald-600 text-white border-emerald-600' : `${colors.bgCard} ${colors.border} ${colors.textSec}`}`}
              >
                {archiveEditForm.status === 'completed' ? 'Tamamlandı' : 'Bekliyor'}
              </button>
            </div>
            <Button className="w-full" icon={Save} onClick={handleSaveArchiveTask}>Kaydet</Button>
          </div>
        </Modal>
      )}

      {isAdmin && (
        <Card title={editingId ? "Ödevi Düzenle" : "Detaylı Ödev Atama"} className={`${colors.isDark ? 'bg-slate-800/50' : 'bg-white'}`}>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
            <div>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>Ders</label>
              <select
                className={`w-full ${colors.inputBg} ${colors.inputBorder} border rounded p-2 ${colors.text} text-sm`}
                value={form.courseId}
                onChange={e => {
                  setForm({ ...form, courseId: e.target.value, unitId: '', topic: '', topics: [], source: '' });
                  setShowTopicDropdown(false);
                }}
              >
                <option value="">Seçiniz</option>
                {activeCurriculum.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>Ünite</label>
              <select
                className={`w-full ${colors.inputBg} ${colors.inputBorder} border rounded p-2 ${colors.text} text-sm`}
                value={form.unitId}
                onChange={e => {
                  setForm({ ...form, unitId: e.target.value, topic: '', topics: [] });
                  setShowTopicDropdown(false);
                }}
                disabled={!selectedCourse}
              >
                <option value="">Seçiniz</option>
                {selectedCourse?.units.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </div>
            <div className="relative" ref={topicDropdownRef}>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>
                Konu {(form.topics || []).length > 1 && <span className="text-orange-500 font-bold">({(form.topics || []).length})</span>}
              </label>
              <button
                type="button"
                disabled={!selectedUnit}
                onClick={() => setShowTopicDropdown(!showTopicDropdown)}
                className={`w-full h-[38px] ${colors.inputBg} ${colors.inputBorder} border rounded px-3 py-2 ${colors.text} text-sm flex items-center justify-between text-left disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                <span className="truncate">
                  {!selectedUnit
                    ? 'Önce Ünite Seçiniz'
                    : (form.topics || []).length === 0
                      ? 'Konu Seçiniz'
                      : (form.topics || []).length === 1
                        ? form.topics[0]
                        : `${(form.topics || []).length} Konu Seçildi`}
                </span>
                <ChevronDown size={14} className={`shrink-0 ml-1 transition-transform ${showTopicDropdown ? 'rotate-180' : ''}`} />
              </button>

              {showTopicDropdown && selectedUnit && (
                <div className={`absolute left-0 right-0 top-full mt-1 z-50 ${colors.bgCard} ${colors.border} border rounded-lg shadow-xl p-2 max-h-56 overflow-y-auto custom-scrollbar`}>
                  <div className="flex items-center justify-between pb-1.5 mb-1.5 border-b border-slate-700/50">
                    <span className={`text-[11px] font-bold ${colors.textSec}`}>
                      {(form.topics || []).length} / {selectedUnit.topics?.length || 0} Seçildi
                    </span>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          const all = [...(selectedUnit.topics || [])];
                          setForm({ ...form, topics: all, topic: all.join('\n') });
                        }}
                        className="text-[11px] text-orange-400 hover:underline cursor-pointer"
                      >
                        Tümünü Seç
                      </button>
                      <button
                        type="button"
                        onClick={() => setForm({ ...form, topics: [], topic: '' })}
                        className="text-[11px] text-slate-400 hover:underline cursor-pointer"
                      >
                        Temizle
                      </button>
                    </div>
                  </div>
                  {(!selectedUnit.topics || selectedUnit.topics.length === 0) ? (
                    <div className={`text-xs ${colors.textSec} py-2 text-center`}>Konu bulunamadı</div>
                  ) : (
                    <div className="space-y-0.5">
                      {selectedUnit.topics.map(t => {
                        const isChecked = (form.topics || []).includes(t);
                        return (
                          <label
                            key={t}
                            className={`flex items-center gap-2 p-1.5 rounded cursor-pointer transition-colors text-xs ${
                              isChecked
                                ? (colors.isDark ? 'bg-orange-500/20 text-orange-300 font-medium' : 'bg-orange-50 text-orange-600 font-medium')
                                : `${colors.hoverBg} ${colors.text}`
                            }`}
                          >
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={(e) => {
                                const next = e.target.checked
                                  ? [...(form.topics || []), t]
                                  : (form.topics || []).filter(item => item !== t);
                                setForm({ ...form, topics: next, topic: next.join('\n') });
                              }}
                              className="w-3.5 h-3.5 rounded accent-orange-500 shrink-0"
                            />
                            <span className="truncate">{t}</span>
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>Günler</label>
              <DaySelector selectedDays={form.days} onChange={days => setForm({ ...form, days })} />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end mb-4">
            <div>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>Tip</label>
              <select
                className={`w-full ${colors.inputBg} ${colors.inputBorder} border rounded p-2 ${colors.text} text-sm`}
                value={form.type}
                onChange={e => setForm({ ...form, type: e.target.value })}
              >
                {TASK_TYPES.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
              </select>
            </div>
            <div>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>Soru</label>
              <input
                type="number"
                className={`w-full ${colors.inputBg} ${colors.inputBorder} border rounded p-2 ${colors.text} text-sm`}
                value={form.count}
                onChange={e => setForm({ ...form, count: e.target.value })}
              />
            </div>
            <div>
              <label className={`text-xs ${colors.textSec} uppercase font-bold block mb-1`}>Kaynak</label>
              <select
                className={`w-full ${colors.inputBg} ${colors.inputBorder} border rounded p-2 ${colors.text} text-sm`}
                value={form.source}
                onChange={e => setForm({ ...form, source: e.target.value })}
              >
                <option value="">Seçiniz</option>
                {availableResources.map(r => <option key={r.id} value={r.name}>{r.name}</option>)}
              </select>
            </div>

          </div>

          <div className="mb-4">
            <Input label="Not" value={form.note} onChange={e => setForm({ ...form, note: e.target.value })} />
          </div>
          <div className="flex gap-2"><Button onClick={handleAssign} icon={editingId ? Save : Plus} className="flex-1">{editingId ? 'Güncelle' : 'Ekle'}</Button>{editingId && <Button onClick={handleCancelEdit} variant="secondary">İptal</Button>}</div>
        </Card>
      )}

      <div
        style={{ zoom: scheduleZoom !== 100 ? `${scheduleZoom}%` : undefined }}
        className={`flex overflow-x-auto pb-4 gap-3 snap-x snap-mandatory ${
          scheduleZoom <= 75
            ? 'grid grid-cols-7 overflow-visible'
            : scheduleZoom <= 85
              ? 'lg:grid lg:grid-cols-7 lg:overflow-visible'
              : scheduleZoom <= 90
                ? 'xl:grid xl:grid-cols-7 xl:overflow-visible'
                : '2xl:grid 2xl:grid-cols-7 2xl:overflow-visible'
        } custom-scrollbar transition-all`}
      >
        {DAYS.map(day => {
          const dayTasks = assignments.filter(a => a.day === day.id);
          const stats = getDailyStats(day.id);
          return (
            <div key={day.id} className={`${scheduleZoom <= 80 ? 'min-w-0 w-full' : 'min-w-[85vw] sm:min-w-[45vw] md:min-w-[30vw] lg:min-w-[22vw] 2xl:min-w-0'} snap-center ${colors.bgCardTransparent} border ${colors.border} rounded-xl flex flex-col h-full min-h-[300px]`}>
              <div className={`p-3 border-b ${colors.border} ${colors.bgCard} rounded-t-xl text-center`}><span className={`font-bold ${colors.text} text-sm`}>{day.label}</span><span className={`block text-xs ${colors.textSec}`}>{dayTasks.length} Görev</span></div>

              <div className="p-2 space-y-2 flex-1">
                {dayTasks.sort((a, b) => a.id - b.id).map(task => {
                  const colorInfo = getSubjectColorInfo(task.subject);
                  const isCompleted = task.status === 'completed';
                  const target = parseInt(task.count) || 0;
                  const solved = (task.solvedCount !== undefined && task.solvedCount !== '') ? (parseInt(task.solvedCount) || 0) : (isCompleted ? target : 0);
                  const percent = target > 0 ? Math.min(100, Math.round((solved / target) * 100)) : (isCompleted ? 100 : 0);
                  const isPartiallyDone = solved > 0 && solved < target;

                  return (
                    <div key={task.id} className={`p-3 rounded-lg border text-xs group relative ${colors.shadow} transition-all hover:brightness-110 ${colors.border} border-l-4 ${colorInfo.border} ${isCompleted ? 'bg-emerald-900/20' : isPartiallyDone ? 'bg-orange-500/10' : colors.bgCard}`} style={isPartiallyDone && !isCompleted ? { background: `linear-gradient(to right, rgba(16, 185, 129, 0.15) ${percent}%, transparent ${percent}%)` } : {}}>
                      <div className="flex justify-between items-start mb-1">
                        <div className={`flex items-start gap-1.5 w-full ${(isAdmin && isEditMode) || (isStudent && task.type === 'extra') ? 'pr-12' : ''}`}>
                          <div className={`w-2 h-2 rounded-full shrink-0 mt-1 ${colorInfo.dot} ${isCompleted ? 'opacity-50' : ''}`}></div>
                          <span className={`font-bold text-xs md:text-sm leading-tight break-words ${isCompleted ? 'text-emerald-500' : colors.text}`}>
                            {task.subject}
                          </span>
                        </div>

                        {((isAdmin && isEditMode) || (isStudent && task.type === 'extra')) && (
                          <div className={`flex gap-1 absolute right-2 top-2 z-10 ${colors.isDark ? 'bg-slate-800/80' : 'bg-white/80'} p-1 rounded backdrop-blur-sm shadow-sm border ${colors.border}`}>
                            <button onClick={(e) => { e.stopPropagation(); handleEdit(task) }} className={`text-slate-400 hover:text-blue-400 p-2`}><Edit2 size={12} /></button>
                            <button onClick={(e) => requestDelete(e, task.id)} className="text-slate-400 hover:text-red-500 p-2"><Trash2 size={12} /></button>
                          </div>
                        )}
                      </div>

                      {Array.isArray(task.topics) && task.topics.length > 0 ? (
                        <div className={`mt-1.5 space-y-1 ${isCompleted ? 'text-emerald-500/70' : colors.textSec}`}>
                          {task.topics.map((t, idx) => (
                            <div key={idx} className="flex items-start gap-1.5 text-xs font-medium leading-snug">
                              <span className="w-1.5 h-1.5 rounded-full bg-orange-400 shrink-0 mt-1" />
                              <span className="break-words">{t}</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className={`mt-1.5 space-y-1 ${isCompleted ? 'text-emerald-500/70' : colors.textSec}`}>
                          {String(task.topic || '').split('\n').map((line, idx) => (
                            <div key={idx} className="flex items-start gap-1.5 text-xs font-medium leading-snug">
                              {task.topic && task.topic.includes('\n') && (
                                <span className="w-1.5 h-1.5 rounded-full bg-orange-400 shrink-0 mt-1" />
                              )}
                              <span className="break-words">{line}</span>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="mt-3 flex flex-col gap-2">
                        <div className="flex justify-between items-start flex-wrap gap-2 text-xs">
                          <span className={`inline-block whitespace-nowrap ${colors.isDark ? 'bg-slate-700/50 text-slate-400' : 'bg-slate-200 text-slate-600'} px-2 py-0.5 rounded`}>
                            {TASK_TYPES.find(t => t.id === task.type)?.label}
                          </span>
                          {target > 0 && (
                            <div className="flex items-center gap-1 group/solve shrink-0">
                              {editingSolvedId === task.id ? (
                                <div className="flex items-center gap-1" onClick={e => e.stopPropagation()}>
                                  <input
                                    autoFocus
                                    type="number"
                                    className={`w-14 h-6 ${colors.inputBg} border border-orange-500 rounded text-center text-orange-400 font-bold outline-none`}
                                    value={solvedValue}
                                    onChange={(e) => setSolvedValue(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && (handleUpdateSolvedCount(task.id, solvedValue), setEditingSolvedId(null))}
                                  />
                                  <button onClick={() => { handleUpdateSolvedCount(task.id, solvedValue); setEditingSolvedId(null); }} className="text-emerald-500"><Check size={14} /></button>
                                  <button onClick={() => setEditingSolvedId(null)} className="text-red-500"><X size={14} /></button>
                                </div>
                              ) : (
                                <div className="flex items-center gap-1">
                                  <span className={`font-bold ${isCompleted ? 'text-emerald-600' : 'text-orange-400'}`}>
                                    {solved > 0 && solved !== target ? `${solved} / ` : ''}{target} Soru
                                  </span>
                                  {isStudent && (
                                    <button
                                      onClick={(e) => { e.stopPropagation(); setEditingSolvedId(task.id); setSolvedValue(solved || ''); }}
                                      className="p-1 text-slate-500 hover:text-orange-500 transition-all"
                                    >
                                      <Edit2 size={12} />
                                    </button>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        {task.source && (<div className="flex items-center gap-1 text-xs text-blue-400"><Book size={10} /><span className="truncate">{task.source}</span></div>)}
                      </div>

                      {task.note && (<div className={`mt-2 pt-2 border-t ${colors.border} text-[10px] ${colors.textSec} italic`}>Not: <span className={colors.textSec}>{task.note}</span></div>)}

                      <div className="mt-3 flex items-center gap-1.5 w-full">
                        <button
                          type="button"
                          onClick={() => toggleTaskStatus(task.id)}
                          className={`flex-1 min-w-0 h-8 px-2 rounded flex items-center justify-center gap-1 text-xs font-medium transition-all ${isCompleted ?
                            'bg-emerald-600 text-white shadow-md shadow-emerald-900/20 hover:bg-emerald-500' :
                            `${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} ${colors.textSec} hover:text-white border ${colors.border}`}`}
                          title={isCompleted ? 'Ödev Tamamlandı' : 'Ödevi Tamamla'}
                        >
                          {isCompleted ? (
                            <>
                              <Check size={13} className="shrink-0" />
                              <span className="truncate">Tamam</span>
                            </>
                          ) : (
                            <span className="truncate">Tamamla</span>
                          )}
                        </button>
                        {/* Fotoğraf yükleme ikonu şimdilik gizlendi */}
                        {false && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setPhotoModalTask(task);
                          }}
                          className={`relative w-8 h-8 shrink-0 rounded flex items-center justify-center transition-all ${task.images?.length > 0 ?
                            'bg-orange-500/20 text-orange-400 border border-orange-500/50 hover:bg-orange-500/30 shadow-sm' :
                            `${colors.isDark ? 'bg-slate-800 hover:bg-slate-700 text-slate-400' : 'bg-slate-100 hover:bg-slate-200 text-slate-600'} hover:text-orange-400 border ${colors.border}`}`}
                          title={task.images?.length > 0 ? `${task.images.length} Ödev Fotoğrafı Yüklendi (İncele / Sil)` : 'Ödev Fotoğrafı Çek / Yükle'}
                        >
                          <Camera size={14} className="shrink-0" />
                          {task.images?.length > 0 && (
                            <span className="absolute -top-1.5 -right-1.5 bg-orange-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center shadow-md">
                              {task.images.length}
                            </span>
                          )}
                        </button>
                        )}
                      </div>
                    </div>
                  );
                })}
                {dayTasks.length === 0 && <div className={`text-center py-8 ${colors.textSec} text-xs`}>Boş Gün</div>}
              </div>

              <div className={`p-3 ${colors.isDark ? 'bg-slate-900/80' : 'bg-white/80'} border-t ${colors.border} rounded-b-xl text-[10px] space-y-1`}>
                <div className={`flex justify-between ${colors.textSec}`}><span>Konu:</span> <span className={`${colors.text} font-bold`}>{stats.topic}</span></div>
                <div className={`flex justify-between ${colors.textSec}`}><span>Soru:</span> <span className="text-orange-400 font-bold">{stats.question}</span></div>
                <div className={`flex justify-between ${colors.textSec}`}><span>Tekrar:</span> <span className={`${colors.text} font-bold`}>{stats.repeat}</span></div>
                <div className={`flex justify-between ${colors.textSec}`}><span>Deneme:</span> <span className={`${colors.text} font-bold`}>{stats.exam}</span></div>
              </div>
            </div>
          )
        })}
      </div>

      {showQuickModal && (
        <Modal
          title={quickEditingId ? "Hızlı Görevi Düzenle" : "Hızlı Görev"}
          onClose={() => { setShowQuickModal(false); setQuickEditingId(null); setQuickForm({ title: '', text: '', days: [], count: '', source: '' }); }}
        >
          <div className="space-y-4">
            <Input label="Ödev Başlığı" value={quickForm.title} onChange={e => setQuickForm({ ...quickForm, title: e.target.value })} />
            <Input label="Görev" value={quickForm.text} onChange={e => setQuickForm({ ...quickForm, text: e.target.value })} />
            <div className="grid grid-cols-2 gap-4">
              <Input label="Soru" type="number" value={quickForm.count} onChange={e => setQuickForm({ ...quickForm, count: e.target.value })} />
              <Input label="Kaynak" value={quickForm.source} onChange={e => setQuickForm({ ...quickForm, source: e.target.value })} />
            </div>
            <div>
              <label className="text-xs font-bold text-slate-500 mb-1 block">Günler</label>
              <DaySelector selectedDays={quickForm.days} onChange={days => setQuickForm({ ...quickForm, days })} />
            </div>

            <Button className="w-full mt-2" onClick={handleQuickAssign}>{quickEditingId ? 'Güncelle' : 'Ata'}</Button>
          </div>
        </Modal>
      )}

      {showExtraModal && (
        <Modal
          title={extraEditingId ? "Ekstra Ödevi Düzenle" : "Ekstra Ödev Ekle"}
          onClose={() => { setShowExtraModal(false); setExtraForm({ title: '', text: '', day: '', count: '', source: '' }); setExtraEditingId(null); }}
        >
          <div className="space-y-4">
            <Input label="Ödev Başlığı" placeholder="Örn: Paragraf Çözümü" value={extraForm.title} onChange={e => setExtraForm({ ...extraForm, title: e.target.value })} />
            <Input label="İçerik" placeholder="Örn: 20 Soru Paragraf" value={extraForm.text} onChange={e => setExtraForm({ ...extraForm, text: e.target.value })} />
            <div className="grid grid-cols-2 gap-4">
              <Input label="Soru Sayısı" type="number" value={extraForm.count} onChange={e => setExtraForm({ ...extraForm, count: e.target.value })} />
              <Input label="Kaynak" value={extraForm.source} onChange={e => setExtraForm({ ...extraForm, source: e.target.value })} />
            </div>
            <div>
              <label className={`text-xs font-bold ${colors.textSec} mb-1 block`}>Gün Seçin</label>
              <select
                className={`w-full ${colors.inputBg} ${colors.inputBorder} border rounded p-2 ${colors.text} text-sm`}
                value={extraForm.day}
                onChange={e => setExtraForm({ ...extraForm, day: e.target.value })}
              >
                <option value="">Seçiniz</option>
                {DAYS.map(d => <option key={d.id} value={d.id}>{d.label}</option>)}
              </select>
            </div>
            <Button className="w-full mt-2" onClick={handleExtraAssign}>{extraEditingId ? 'Güncelle' : 'Ekle'}</Button>
          </div>
        </Modal>
      )}

      {/* 4'LÜ PERFORMANS VE İSTATİSTİK KARTLARI */}
      {(() => {
        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();
        const monthNames = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
        const currentMonthName = monthNames[currentMonth];

        // Tarih çözümleyici
        const parseWeekDate = (w) => {
          if (typeof w?.date === 'string' && w.date.includes('.')) {
            const parts = w.date.split('.');
            if (parts.length === 3) {
              const d = parseInt(parts[0], 10);
              const m = parseInt(parts[1], 10) - 1;
              const y = parseInt(parts[2], 10);
              if (!isNaN(m) && !isNaN(y)) return new Date(y, m, d);
            }
          }
          if (typeof w?.id === 'number' && w.id > 1000000000000) {
            return new Date(w.id);
          }
          if (w?.date) {
            const d = new Date(w.date);
            if (!isNaN(d.getTime())) return d;
          }
          return null;
        };

        // Bu aya (Ekim 2026 vb.) ait arşivlenmiş haftalar
        const currentMonthWeeks = (student.pastWeeks || []).filter(w => {
          const wDate = parseWeekDate(w);
          if (!wDate) return false;
          return wDate.getMonth() === currentMonth && wDate.getFullYear() === currentYear;
        });

        // 1. AYLIK ÇÖZÜLEN SORU SAYISI: Bu ayki arşivlenmiş haftaların soruları + aktif hafta
        const monthlyArchivedSolved = currentMonthWeeks.reduce((acc, w) => {
          const computed = (w.assignments || []).reduce((a, curr) => {
            const target = parseInt(curr.count) || 0;
            const s = (curr.solvedCount !== undefined && curr.solvedCount !== '') ? (parseInt(curr.solvedCount) || 0) : (curr.status === 'completed' ? target : 0);
            return a + s;
          }, 0);
          const solved = (w.solvedCount !== undefined && w.solvedCount !== null && w.solvedCount > 0) ? w.solvedCount : computed;
          return acc + solved;
        }, 0);
        const monthlySolvedDisplay = monthlyArchivedSolved + weeklySolvedQuestions;

        // 2. AYLIK TAMAMLAMA ORANI ORTALAMASI: Bu ayın haftalarının tamamlama oranlarının aritmetik ortalaması
        const monthRates = currentMonthWeeks.map(w => {
          if (w.completionRate !== undefined && w.completionRate !== null) {
            return Number(w.completionRate);
          }
          const total = (w.assignments || []).length;
          const done = (w.assignments || []).filter(a => a.status === 'completed').length;
          return total > 0 ? Math.round((done / total) * 100) : 0;
        });
        if (weeklyTaskCount > 0) {
          monthRates.push(completionRate);
        }
        const monthlyCompletionAvg = monthRates.length > 0
          ? Math.round(monthRates.reduce((a, b) => a + b, 0) / monthRates.length)
          : (weeklyTaskCount > 0 ? completionRate : 0);

        const totalWeeksInMonth = currentMonthWeeks.length + (weeklyTaskCount > 0 ? 1 : 0);

        // 3. TÜM ZAMANLAR TOPLAM ÇÖZÜLEN SORU SAYISI
        const allTimeArchivedSolved = (student.pastWeeks || []).reduce((acc, w) => {
          const computed = (w.assignments || []).reduce((a, curr) => {
            const target = parseInt(curr.count) || 0;
            const s = (curr.solvedCount !== undefined && curr.solvedCount !== '') ? (parseInt(curr.solvedCount) || 0) : (curr.status === 'completed' ? target : 0);
            return a + s;
          }, 0);
          const solved = (w.solvedCount !== undefined && w.solvedCount !== null && w.solvedCount > 0) ? w.solvedCount : computed;
          return acc + solved;
        }, 0);
        const totalSolvedDisplay = allTimeArchivedSolved + weeklySolvedQuestions;

        // 4. GENEL BİTEN VE TOPLAM GÖREV SAYISI (Arşivlenen haftalardan doğru hesaplama)
        const archivedDoneTasks = (student.pastWeeks || []).reduce((acc, w) => {
          return acc + (w.assignments || []).filter(a => a.status === 'completed').length;
        }, 0);
        const allTimeDoneTasks = archivedDoneTasks + weeklyCompletedCount;

        const archivedTotalTasks = (student.pastWeeks || []).reduce((acc, w) => {
          return acc + (w.assignments || []).length;
        }, 0);
        const allTimeTotalTasks = archivedTotalTasks + weeklyTaskCount;
        const allTimeTaskSuccessRate = allTimeTotalTasks > 0 ? Math.round((allTimeDoneTasks / allTimeTotalTasks) * 100) : 0;

        return (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-8">
            {/* 1. Haftalık Performans */}
            <Card className={`border-l-4 border-l-blue-500 ${colors.bgCard} shadow-md`}>
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-blue-500/20 rounded-lg text-blue-500"><Zap size={20} /></div>
                <span className={`text-xs uppercase font-bold ${colors.textSec}`}>Haftalık Performans</span>
              </div>
              <div className="flex justify-between items-end">
                <div>
                  <div className={`text-2xl font-bold ${colors.text}`}>{weeklySolvedQuestions} <span className={`text-sm font-normal ${colors.textSec}`}>Soru</span></div>
                  <div className={`text-[10px] ${colors.textSec}`}>Hedef: {weeklyTotalQuestions} Soru</div>
                </div>
                <div className="text-right">
                  <div className="text-xl font-bold text-blue-400">%{completionRate}</div>
                  <div className={`text-[10px] ${colors.textSec}`}>Tamamlanma</div>
                </div>
              </div>
            </Card>

            {/* 2. Aylık Performans */}
            <Card className={`border-l-4 border-l-emerald-500 ${colors.bgCard} shadow-md`}>
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-emerald-500/20 rounded-lg text-emerald-500"><Calendar size={20} /></div>
                <span className={`text-xs uppercase font-bold ${colors.textSec}`}>Aylık Performans</span>
              </div>
              <div className="flex justify-between items-end">
                <div>
                  <div className={`text-2xl font-bold text-emerald-400`}>{monthlySolvedDisplay} <span className={`text-sm font-normal ${colors.textSec}`}>Soru</span></div>
                  <div className={`text-[10px] ${colors.textSec}`}>{currentMonthName} Ayı ({totalWeeksInMonth} Hafta)</div>
                </div>
                <div className="text-right">
                  <div className="text-xl font-bold text-emerald-400">%{monthlyCompletionAvg}</div>
                  <div className={`text-[10px] ${colors.textSec}`}>Aylık Ortalama</div>
                </div>
              </div>
            </Card>

            {/* 3. Toplam Çözülen Soru Sayısı (Level/XP kaldırıldı) */}
            <Card className={`border-l-4 border-l-orange-500 ${colors.bgCard} shadow-md`}>
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-orange-500/20 rounded-lg text-orange-500"><Target size={20} /></div>
                <span className={`text-xs uppercase font-bold ${colors.textSec}`}>Toplam Çözülen Soru</span>
              </div>
              <div className="flex justify-between items-end">
                <div>
                  <div className={`text-2xl font-bold text-orange-400`}>{totalSolvedDisplay.toLocaleString('tr-TR')} <span className={`text-sm font-normal ${colors.textSec}`}>Soru</span></div>
                  <div className={`text-[10px] ${colors.textSec}`}>Tüm Zamanlar</div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-bold text-orange-400">{(student.pastWeeks || []).length + (weeklyTaskCount > 0 ? 1 : 0)} Hafta</div>
                  <div className={`text-[10px] ${colors.textSec}`}>Kayıtlı Hafta</div>
                </div>
              </div>
            </Card>

            {/* 4. Ödev & Görev Durumu (Arşivden doğru çekilen toplamlar) */}
            <Card className={`border-l-4 border-l-purple-500 ${colors.bgCard} shadow-md`}>
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 bg-purple-500/20 rounded-lg text-purple-500"><CheckCircle size={20} /></div>
                <span className={`text-xs uppercase font-bold ${colors.textSec}`}>Ödev & Görev Durumu</span>
              </div>
              <div className="flex justify-between items-end">
                <div>
                  <div className={`text-2xl font-bold text-purple-400`}>{weeklyCompletedCount} / {weeklyTaskCount} <span className={`text-sm font-normal ${colors.textSec}`}>Ödev</span></div>
                  <div className={`text-[10px] ${colors.textSec}`}>Bu Hafta Biten</div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-bold text-purple-400">{allTimeDoneTasks} / {allTimeTotalTasks} Görev</div>
                  <div className={`text-[10px] ${colors.textSec}`}>Genel Biten (%{allTimeTaskSuccessRate})</div>
                </div>
              </div>
            </Card>
          </div>
        );
      })()}

      {student.pastWeeks?.length > 0 && (
        <Card title="Geçmiş Haftalar Arşivi" className="mt-8">
          <div className="space-y-4">
            {student.pastWeeks.map(week => {
              const computedWeekSolved = (week.assignments || []).reduce((acc, curr) => {
                const target = parseInt(curr.count) || 0;
                const solved = (curr.solvedCount !== undefined && curr.solvedCount !== '') ? (parseInt(curr.solvedCount) || 0) : (curr.status === 'completed' ? target : 0);
                return acc + solved;
              }, 0);
              const displaySolvedCount = (week.solvedCount !== undefined && week.solvedCount !== null && week.solvedCount > 0) ? week.solvedCount : computedWeekSolved;

              return (
              <div key={week.id} className={`${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} rounded-lg overflow-hidden`}>
                <div className="p-4 flex justify-between items-center cursor-pointer" onClick={() => setExpandedArchive(expandedArchive === week.id ? null : week.id)}>
                  <div className="flex items-center gap-3">
                    {expandedArchive === week.id ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                    <div>
                      <div className="flex items-center gap-2">
                        <span className={`font-bold ${colors.text} text-sm`}>{week.name || `Hafta: ${week.date}`}</span>
                        {isAdmin && isEditMode && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditWeekName(week.id, week.name || `Hafta: ${week.date}`);
                            }}
                            className="p-1 text-slate-400 hover:text-orange-500 rounded transition-colors"
                            title="Hafta Adını Düzenle"
                          >
                            <Edit2 size={12} />
                          </button>
                        )}
                      </div>
                      <div className={`text-xs ${colors.textSec}`}>{week.assignments?.length || 0} Görev | {week.date}</div>
                    </div>
                  </div>
                  <div className="text-right flex items-center gap-4">
                    <div className="text-orange-400 font-bold">
                      {displaySolvedCount} Soru Çözüldü
                      {week.assignments?.length > 0 && (
                        <span className="ml-2 text-blue-400">
                          | %{week.completionRate ?? Math.round((week.assignments.filter(a => a.status === 'completed').length / week.assignments.length) * 100)} Tamamlama
                        </span>
                      )}
                    </div>
                    {isAdmin && (<button onClick={(e) => { e.stopPropagation(); handleDeleteArchive(week.id); }} className="text-red-500 hover:bg-red-500/10 p-2 rounded transition-colors"><Trash2 size={16} /></button>)}
                  </div>
                </div>
                {expandedArchive === week.id && week.assignments && (
                  <div className={`p-4 border-t ${colors.border} ${colors.isDark ? 'bg-slate-900/50' : 'bg-white/50'}`}>
                    <div className="flex overflow-x-auto gap-4 pb-4 xl:grid xl:grid-cols-7 xl:overflow-visible">
                      {DAYS.map(day => {
                        const dayTasks = week.assignments.filter(a => a.day === day.id);
                        return (
                          <div key={day.id} className={`min-w-[150px] md:min-w-0 ${colors.bgCardTransparent} border ${colors.border} rounded-xl flex flex-col h-full opacity-90`}>
                            <div className={`p-2 border-b ${colors.border} ${colors.bgCard} rounded-t-xl text-center`}>
                              <span className={`font-bold ${colors.text} text-xs`}>{day.label}</span>
                            </div>
                            <div className="p-2 space-y-2 flex-1 min-h-[80px]">
                              {dayTasks.map(task => {
                                const sourceList = Array.isArray(task.sources) ? task.sources : (Array.isArray(task.resources) ? task.resources : null);
                                const colorInfo = getSubjectColorInfo(task.subject);
                                const isCompleted = task.status === 'completed';
                                const target = parseInt(task.count) || 0;
                                const solved = task.solvedCount !== undefined && task.solvedCount !== '' ? (parseInt(task.solvedCount) || 0) : (isCompleted ? target : 0);
                                const percent = target > 0 ? Math.min(100, Math.round((solved / target) * 100)) : (isCompleted ? 100 : 0);
                                const isPartiallyDone = solved > 0 && solved < target;
                                return (
                                  <div key={task.id} className={`relative p-2 rounded-lg border text-[10px] ${colors.shadow} border-l-4 ${colorInfo.border} ${isCompleted ? 'bg-emerald-900/20' : isPartiallyDone ? 'bg-orange-500/10' : colors.bgCard} ${colors.border}`} style={isPartiallyDone && !isCompleted ? { background: `linear-gradient(to right, rgba(16, 185, 129, 0.15) ${percent}%, transparent ${percent}%)` } : {}}>
                                    <button
                                      onClick={() => openArchiveTaskEdit(week.id, task)}
                                      className={`absolute right-2 top-2 p-1 transition-opacity duration-200 ${isAdmin && isEditMode ? 'opacity-100 text-slate-400 hover:text-blue-400' : 'opacity-0 pointer-events-none'}`}
                                      title="Düzenle"
                                    >
                                      <Edit2 size={12} />
                                    </button>
                                    <div className="font-bold text-xs text-orange-400 break-words leading-tight">{task.subject}</div>
                                    {Array.isArray(task.topics) && task.topics.length > 0 ? (
                                      <div className={`space-y-1 my-1.5 text-[10px] ${colors.text}`}>
                                        {task.topics.map((t, idx) => (
                                          <div key={idx} className="flex items-start gap-1 leading-snug">
                                            <span className="w-1 h-1 rounded-full bg-orange-400 shrink-0 mt-1" />
                                            <span className="break-words">{t}</span>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div className={`space-y-1 my-1.5 text-[10px] ${colors.text}`}>
                                        {String(task.topic || '').split('\n').map((line, idx) => (
                                          <div key={idx} className="flex items-start gap-1 leading-snug">
                                            {task.topic && task.topic.includes('\n') && (
                                              <span className="w-1 h-1 rounded-full bg-orange-400 shrink-0 mt-1" />
                                            )}
                                            <span className="break-words">{line}</span>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                    <div className={`flex justify-between items-center ${colors.textSec}`}>
                                      <span>{TASK_TYPES.find(t => t.id === task.type)?.label}</span>
                                      {isCompleted ? <Check size={12} className="text-emerald-500" /> : isPartiallyDone ? <span className="text-orange-400 font-semibold">% {percent}</span> : <span className="text-red-400 text-[9px] font-bold">X</span>}
                                    </div>
                                    {(target > 0 || solved > 0) && (
                                      <div className="text-orange-500 font-bold mt-1">
                                        {target > 0 ? (
                                          <>
                                            {solved > 0 && solved !== target ? `${solved} / ` : ''}{target} Soru
                                          </>
                                        ) : (
                                          <>{solved} Soru</>
                                        )}
                                      </div>
                                    )}
                                    {typeof task.source === 'string' && task.source.trim() && (
                                      <div className="flex items-center gap-1 text-[10px] text-blue-400 mt-1">
                                        <Book size={10} />
                                        <span className="truncate">{task.source}</span>
                                      </div>
                                    )}
                                    {sourceList && sourceList.length > 0 && (
                                      <div className="mt-1 space-y-0.5">
                                        {sourceList.map((s, idx) => (
                                          <div key={idx} className="flex items-center gap-1 text-[10px] text-blue-400">
                                            <Book size={10} />
                                            <span className="truncate">{typeof s === 'string' ? s : (s?.name || s?.title || '')}</span>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                    {task.note && (
                                      <div className={`mt-1.5 pt-1.5 border-t ${colors.border} text-[10px] ${colors.textSec} italic`}>
                                        Not: <span className={colors.textSec}>{task.note}</span>
                                      </div>
                                    )}
                                    {/* Fotoğraf yükleme ikonu şimdilik gizlendi */}
                                    {false && task.images && task.images.length > 0 && (
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setPhotoModalTask({ ...task, isArchived: true, weekId: week.id });
                                        }}
                                        className="mt-1.5 w-full flex items-center justify-center gap-1 py-1 px-1.5 rounded bg-orange-500/10 text-orange-400 border border-orange-500/30 hover:bg-orange-500/20 text-[10px] font-medium transition-colors"
                                      >
                                        <Camera size={11} />
                                        <span>{task.images.length} Fotoğraf</span>
                                      </button>
                                    )}
                                  </div>
                                );
                              })}
                              {dayTasks.length === 0 && <div className={`text-center py-4 ${colors.textSec} text-[10px]`}>-</div>}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            ); })}
          </div>
        </Card>
      )}
      {photoModalTask && (
        <Modal
          title={`📸 Ödev Fotoğrafları: ${photoModalTask.subject || 'Ödev'}`}
          maxWidth="max-w-4xl"
          onClose={() => setPhotoModalTask(null)}
          footer={
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 w-full">
              <div className={`text-xs ${colors.textSec} flex items-center gap-2`}>
                <span className="font-semibold text-orange-400">{(photoModalTask.images || []).length} Fotoğraf</span>
                {(photoModalTask.images || []).length > 0 && (
                  <>
                    <span>•</span>
                    <span>
                      Toplam {formatFileSize((photoModalTask.images || []).reduce((acc, img) => acc + (img.size || 0), 0))}
                    </span>
                  </>
                )}
              </div>
              <div className="flex items-center gap-2 w-full sm:w-auto justify-end flex-wrap">
                {isAdmin && (photoModalTask.images || []).length > 0 && (
                  <button
                    type="button"
                    onClick={() => handleClearAllPhotos(true)}
                    className="px-4 py-2 text-xs font-semibold rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white shadow-lg shadow-emerald-900/30 transition-all flex items-center gap-1.5"
                    title="Ödevi tamamlandı yapar ve fotoğrafları silerek alanı boşaltır"
                  >
                    <CheckCheck size={16} />
                    <span>✓ Kontrol Edildi & Temizle</span>
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setPhotoModalTask(null)}
                  className={`px-4 py-2 text-xs rounded-lg ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300'} ${colors.text} transition-colors`}
                >
                  Kapat
                </button>
              </div>
            </div>
          }
        >
          <div className="space-y-5">
            {/* Ödev Özet Kartı */}
            <div className={`p-4 rounded-xl border ${colors.border} ${colors.isDark ? 'bg-slate-900/60' : 'bg-slate-50'} flex flex-col sm:flex-row justify-between sm:items-center gap-3`}>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-orange-400">{photoModalTask.subject}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${photoModalTask.status === 'completed' ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' : 'bg-amber-500/20 text-amber-400 border border-amber-500/30'}`}>
                    {photoModalTask.status === 'completed' ? 'Tamamlandı' : 'Bekliyor'}
                  </span>
                </div>
                <p className={`text-sm ${colors.text} font-medium mt-0.5`}>{photoModalTask.topic}</p>
                {photoModalTask.source && (
                  <p className="text-xs text-blue-400 mt-1 flex items-center gap-1">
                    <Book size={12} /> {photoModalTask.source}
                  </p>
                )}
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="file"
                  ref={cameraInputRef}
                  accept="image/*"
                  capture="environment"
                  className="hidden"
                  onChange={(e) => handleUploadPhotos(e.target.files)}
                />
                <input
                  type="file"
                  ref={photoFileInputRef}
                  accept="image/*"
                  multiple
                  className="hidden"
                  onChange={(e) => handleUploadPhotos(e.target.files)}
                />
                <button
                  type="button"
                  disabled={isUploadingPhoto}
                  onClick={() => cameraInputRef.current?.click()}
                  className="flex-1 sm:flex-initial px-3.5 py-2.5 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold text-xs shadow-md shadow-orange-900/20 flex items-center justify-center gap-2 transition-all disabled:opacity-50"
                  title="Telefonda doğrudan kamerayı açar"
                >
                  <Camera size={16} />
                  <span>Kamerayı Aç</span>
                </button>
                <button
                  type="button"
                  disabled={isUploadingPhoto}
                  onClick={() => photoFileInputRef.current?.click()}
                  className={`flex-1 sm:flex-initial px-3.5 py-2.5 rounded-xl border ${colors.border} ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-white hover:bg-slate-100'} ${colors.text} font-semibold text-xs flex items-center justify-center gap-2 transition-all disabled:opacity-50`}
                  title="Galeriden veya bilgisayardan görsel seç"
                >
                  <Upload size={16} />
                  <span>Galeriden Yükle</span>
                </button>
              </div>
            </div>

            {/* Yükleme İlerlemesi */}
            {isUploadingPhoto && (
              <div className="p-4 rounded-xl border border-orange-500/40 bg-orange-500/10 flex items-center justify-center gap-3 animate-pulse">
                <RefreshCw size={18} className="animate-spin text-orange-400" />
                <span className="text-xs font-semibold text-orange-300">Fotoğraflar optimize ediliyor ve yükleniyor, lütfen bekleyin...</span>
              </div>
            )}

            {uploadError && (
              <div className="p-3 rounded-lg border border-red-500/40 bg-red-500/10 text-xs text-red-400 flex items-center justify-between">
                <span>{uploadError}</span>
                <button type="button" onClick={() => setUploadError('')} className="text-red-300 hover:text-white"><X size={14} /></button>
              </div>
            )}

            {/* Fotoğraf Galerisi */}
            {(!photoModalTask.images || photoModalTask.images.length === 0) ? (
              <div className={`p-10 text-center border-2 border-dashed ${colors.border} rounded-2xl flex flex-col items-center justify-center`}>
                <div className={`w-14 h-14 rounded-full ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} flex items-center justify-center mb-3 text-slate-400`}>
                  <ImageIcon size={26} />
                </div>
                <div className={`text-sm font-semibold ${colors.text} mb-1`}>Henüz Ödev Fotoğrafı Yüklenmemiş</div>
                <p className={`text-xs ${colors.textSec} max-w-sm mb-4`}>
                  Öğrenci çözüm veya defter fotoğraflarını yukarıdaki butonlardan çekip yükleyebilir.
                </p>
                <button
                  type="button"
                  onClick={() => cameraInputRef.current?.click()}
                  className="px-4 py-2 rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium flex items-center gap-1.5 transition-colors shadow-md shadow-orange-900/20"
                >
                  <Camera size={14} /> Fotoğraf Çek
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3.5">
                {photoModalTask.images.map((img, idx) => (
                  <div
                    key={img.id || idx}
                    className={`group relative rounded-xl overflow-hidden border ${colors.border} ${colors.isDark ? 'bg-slate-900' : 'bg-slate-100'} shadow-sm hover:shadow-md transition-all`}
                  >
                    <div
                      className="aspect-square cursor-pointer overflow-hidden relative"
                      onClick={() => openLightbox(img, idx)}
                    >
                      <img
                        src={img.url}
                        alt={img.name || 'Ödev görseli'}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/35 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                        <span className="p-2 rounded-full bg-black/60 text-white">
                          <Maximize2 size={16} />
                        </span>
                      </div>
                    </div>
                    {/* Alt Bilgi & Silme Butonu */}
                    <div className={`p-2 flex items-center justify-between border-t ${colors.border} text-[10px] ${colors.textSec}`}>
                      <span className="truncate max-w-[80px]" title={img.name}>
                        {img.size ? formatFileSize(img.size) : `#${idx + 1}`}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteSinglePhoto(img);
                        }}
                        className="p-1 rounded text-red-400 hover:bg-red-500/20 hover:text-red-300 transition-colors"
                        title="Bu fotoğrafı sil"
                      >
                        <Trash2 size={13} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Lightbox Modal (Tam Ekran İnceleme / Yakınlaştırma / Döndürme) */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex flex-col select-none animate-fade-in"
          onClick={closeLightbox}
        >
          {/* Lightbox Üst Bar */}
          <div
            className="flex items-center justify-between px-4 sm:px-6 py-3 bg-black/50 border-b border-white/10 shrink-0"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-3 text-white text-xs sm:text-sm">
              <span className="font-bold text-orange-400">
                Fotoğraf {lightboxIndex + 1} / {(photoModalTask?.images || []).length}
              </span>
              <span className="text-white/40 hidden sm:inline">|</span>
              <span className="text-white/70 hidden sm:inline truncate max-w-[200px]">{lightboxImage.name}</span>
              {lightboxImage.size && (
                <span className="text-[11px] px-2 py-0.5 rounded bg-white/10 text-white/80">
                  {formatFileSize(lightboxImage.size)}
                </span>
              )}
            </div>

            <div className="flex items-center gap-1 sm:gap-2">
              <button
                type="button"
                onClick={() => setLightboxZoom(prev => Math.min(prev + 0.25, 3))}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="Yakınlaştır"
              >
                <ZoomIn size={18} />
              </button>
              <button
                type="button"
                onClick={() => setLightboxZoom(prev => Math.max(prev - 0.25, 0.5))}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="Uzaklaştır"
              >
                <ZoomOut size={18} />
              </button>
              <button
                type="button"
                onClick={() => setLightboxRotation(prev => (prev + 90) % 360)}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="90° Döndür"
              >
                <RotateCw size={18} />
              </button>
              <button
                type="button"
                onClick={() => { setLightboxZoom(1); setLightboxRotation(0); }}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="Sıfırla"
              >
                <RotateCcw size={16} />
              </button>
              <a
                href={lightboxImage.url}
                download={lightboxImage.name || 'odev.jpg'}
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="İndir"
              >
                <Download size={18} />
              </a>
              <button
                type="button"
                onClick={() => handleDeleteSinglePhoto(lightboxImage)}
                className="p-2 rounded-lg text-red-400 hover:text-red-300 hover:bg-red-500/20 transition-colors"
                title="Fotoğrafı Sil"
              >
                <Trash2 size={18} />
              </button>
              <button
                type="button"
                onClick={closeLightbox}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/20 transition-colors ml-2"
                title="Kapat (Esc)"
              >
                <X size={20} />
              </button>
            </div>
          </div>

          {/* Lightbox Görsel Görüntüleme Alanı */}
          <div className="flex-1 flex items-center justify-center relative overflow-hidden p-4">
            {(photoModalTask?.images || []).length > 1 && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); prevLightboxImage(); }}
                className="absolute left-4 p-3 rounded-full bg-black/60 hover:bg-black/90 text-white border border-white/20 transition-all z-10"
                title="Önceki Fotoğraf (Sol Ok)"
              >
                <ChevronLeft size={24} />
              </button>
            )}

            <div
              className="flex items-center justify-center max-w-full max-h-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={lightboxImage.url}
                alt={lightboxImage.name || 'Ödev tam görsel'}
                style={{
                  transform: `scale(${lightboxZoom}) rotate(${lightboxRotation}deg)`,
                  transition: 'transform 0.15s ease-out',
                  maxWidth: '90vw',
                  maxHeight: '80vh',
                  objectFit: 'contain'
                }}
                className="rounded shadow-2xl"
              />
            </div>

            {(photoModalTask?.images || []).length > 1 && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); nextLightboxImage(); }}
                className="absolute right-4 p-3 rounded-full bg-black/60 hover:bg-black/90 text-white border border-white/20 transition-all z-10"
                title="Sonraki Fotoğraf (Sağ Ok)"
              >
                <ChevronRight size={24} />
              </button>
            )}
          </div>

          {/* Lightbox Alt Küçük Resimler Şeridi */}
          {(photoModalTask?.images || []).length > 1 && (
            <div
              className="p-3 bg-black/60 border-t border-white/10 flex items-center justify-center gap-2 overflow-x-auto shrink-0"
              onClick={(e) => e.stopPropagation()}
            >
              {photoModalTask.images.map((img, idx) => (
                <button
                  key={img.id || idx}
                  type="button"
                  onClick={() => openLightbox(img, idx)}
                  className={`w-12 h-12 rounded-lg overflow-hidden border-2 transition-all shrink-0 ${idx === lightboxIndex ? 'border-orange-500 scale-105' : 'border-transparent opacity-60 hover:opacity-100'}`}
                >
                  <img src={img.url} alt="" className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />

      {confirmDialog && (
        <ConfirmModal
          isOpen={!!confirmDialog}
          title={confirmDialog.title}
          message={confirmDialog.message}
          confirmText={confirmDialog.confirmText}
          cancelText={confirmDialog.cancelText}
          variant={confirmDialog.variant}
          icon={confirmDialog.icon}
          onClose={() => setConfirmDialog(null)}
          onConfirm={() => {
            const action = confirmDialog.onConfirm;
            setConfirmDialog(null);
            if (action) action();
          }}
        />
      )}
      </div>

      {/* HAFTALIK PROGRAM YAZDIRMA (A4 YATAY) ÖNİZLEME MODALI */}
      {showPrintModal && (
        <Modal
          title="Haftalık Programı Yazdır (A4 Yatay Önizleme)"
          onClose={() => setShowPrintModal(false)}
          maxWidth="max-w-[96vw]"
          footer={
            <div className="flex flex-wrap items-center justify-between gap-3 w-full">
              <div className={`text-xs ${colors.textSec} hidden sm:flex items-center gap-1.5`}>
                <span>💡</span>
                <span>Yazıcı veya PDF penceresinde <b>Yatay (Landscape)</b> yönlendirme seçiniz.</span>
              </div>
              <div className="flex items-center gap-2 ml-auto">
                <Button variant="secondary" onClick={() => setShowPrintModal(false)}>Kapat</Button>
                <Button icon={Printer} onClick={() => window.print()}>Yazdır / PDF Kaydet</Button>
              </div>
            </div>
          }
        >
          <div className="space-y-3">
            <div className="flex items-center justify-between p-2.5 rounded-lg bg-orange-500/10 border border-orange-500/20 text-xs text-orange-400">
              <div className="flex items-center gap-2">
                <Printer size={16} className="shrink-0" />
                <span>
                  Bu çıktı <b>Yatay A4</b> kağıt formatına responsive olarak uyarlanmıştır. Aşağıdaki önizlemeyi inceleyebilir ve <b>"Yazdır / PDF Kaydet"</b> butonuna tıklayarak doğrudan yazıcıdan çıktı alabilir veya PDF olarak kaydedebilirsiniz.
                </span>
              </div>
            </div>

            <div className="overflow-x-auto border rounded-xl border-slate-300 bg-slate-200/50 p-2 sm:p-4 custom-scrollbar">
              <div className="min-w-[850px] shadow-lg rounded-lg overflow-hidden bg-white">
                <WeeklySchedulePrintView
                  student={student}
                  assignments={assignments}
                  DAYS={DAYS}
                  TASK_TYPES={TASK_TYPES}
                  user={user}
                  weeklyTotalQuestions={weeklyTotalQuestions}
                  weeklySolvedQuestions={weeklySolvedQuestions}
                  weeklyTaskCount={weeklyTaskCount}
                  completionRate={completionRate}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

// 3. HEDEFLER
const GoalsModule = ({ student, onUpdateStudent, user }) => {
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ text: '', target: '', days: [] });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  // Fotoğraf ve Lightbox Durumları
  const [photoModalContext, setPhotoModalContext] = useState(null); // { goalId, dayId }
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxZoom, setLightboxZoom] = useState(1);
  const [lightboxRotation, setLightboxRotation] = useState(0);
  const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [confirmDialog, setConfirmDialog] = useState(null);
  const photoFileInputRef = useRef(null);
  const cameraInputRef = useRef(null);
  const toastTimerRef = useRef(null);

  const colors = useThemeColors();
  const goals = student.goals || [];
  const isAdmin = user.role === 'admin' || user.role === 'superadmin';

  useEffect(() => {
    return () => {
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    };
  }, []);

  // Aktif seçili hedef ve o günün fotoğrafları
  const activeGoal = photoModalContext ? goals.find(g => String(g.id) === String(photoModalContext.goalId)) : null;
  const activeDayObj = photoModalContext ? (DAYS.find(d => d.id === photoModalContext.dayId) || { id: photoModalContext.dayId, label: photoModalContext.dayId }) : null;
  const dayPhotos = React.useMemo(() => {
    return (activeGoal && activeGoal.images && Array.isArray(activeGoal.images[photoModalContext?.dayId]))
      ? activeGoal.images[photoModalContext.dayId]
      : [];
  }, [activeGoal, photoModalContext?.dayId]);
  const isGoalCompletedForDay = (activeGoal && photoModalContext)
    ? !!activeGoal.status?.[`${activeGoal.id}-${photoModalContext.dayId}`]
    : false;

  // Lightbox klavye kontrolleri (Esc, Sağ Ok, Sol Ok)
  useEffect(() => {
    if (!lightboxImage || !photoModalContext) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setLightboxImage(null);
        setLightboxZoom(1);
        setLightboxRotation(0);
      } else if (e.key === 'ArrowRight') {
        if (dayPhotos.length > 1) {
          const nextIdx = (lightboxIndex + 1) % dayPhotos.length;
          setLightboxIndex(nextIdx);
          setLightboxImage(dayPhotos[nextIdx]);
          setLightboxZoom(1);
          setLightboxRotation(0);
        }
      } else if (e.key === 'ArrowLeft') {
        if (dayPhotos.length > 1) {
          const prevIdx = (lightboxIndex - 1 + dayPhotos.length) % dayPhotos.length;
          setLightboxIndex(prevIdx);
          setLightboxImage(dayPhotos[prevIdx]);
          setLightboxZoom(1);
          setLightboxRotation(0);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxImage, lightboxIndex, photoModalContext, dayPhotos]);

  const handleDayToggle = (dayId) => {
    setForm(prev => {
      const days = prev.days.includes(dayId) ? prev.days.filter(d => d !== dayId) : [...prev.days, dayId];
      return { ...prev, days };
    });
  };

  const handleSave = async () => {
    if (!form.text || form.days.length === 0) return alert("Hedef adı ve en az bir gün seçiniz.");
    if (editingId) {
      const updated = goals.map(g => g.id === editingId ? { ...g, ...form } : g);
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: updated }));
        } catch (e) {
          console.error("Goals handleSave error:", e);
        }
      }
      onUpdateStudent({ ...student, goals: updated });
      setEditingId(null);
    } else {
      const newGoal = { id: Date.now(), status: {}, images: {}, ...form };
      const updated = [...goals, newGoal];
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: updated }));
        } catch (e) {
          console.error("Goals handleSave new error:", e);
        }
      }
      onUpdateStudent({ ...student, goals: updated });
    }
    setShowModal(false);
    setForm({ text: '', target: '', days: [] });
  };

  const requestDelete = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    setDeleteConfirm(id);
  };

  const confirmDelete = async () => {
    if (deleteConfirm) {
      const filtered = goals.filter(g => g.id !== deleteConfirm);
      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: filtered }));
        } catch (e) {
          console.error("Goals confirmDelete error:", e);
        }
      }
      onUpdateStudent({ ...student, goals: filtered });
      setDeleteConfirm(null);
    }
  };

  const handleEdit = (goal) => {
    setForm({ text: goal.text, target: goal.target, days: goal.days });
    setEditingId(goal.id);
    setShowModal(true);
  };

  const toggleGoalStatus = async (goalId, dayId) => {
    const goal = goals.find(g => g.id === goalId);
    if (!goal) return;
    const key = `${goalId}-${dayId}`;
    const newStatus = { ...(goal.status || {}), [key]: !goal.status?.[key] };
    const updatedGoals = goals.map(g => g.id === goalId ? { ...g, status: newStatus } : g);

    if (isFirebaseActive && student?.id) {
      try {
        await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: updatedGoals }));
      } catch (e) {
        console.error("Goals toggleGoalStatus error:", e);
      }
    }
    onUpdateStudent({ ...student, goals: updatedGoals });
    if (!goal.status?.[key]) logActivity(student.id, 'goal_update', { goal: goal.text, day: dayId });
  };

  // HAFTAYI SIFIRLA VE SİL (Fotoğrafları da temizler)
  const executeResetWeek = async () => {
    const resetGoals = goals.map(g => ({ ...g, status: {}, images: {} }));
    if (isFirebaseActive && student?.id) {
      try {
        await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: resetGoals }));
      } catch (e) {
        console.error("handleResetWeek error:", e);
      }
    }
    onUpdateStudent({ ...student, goals: resetGoals });
    setToastMessage("Haftalık hedefler ve fotoğraflar sıfırlandı.");
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
  };

  const handleResetWeek = () => {
    setConfirmDialog({
      title: "Haftayı Sıfırla",
      message: "Bu haftaki tüm hedeflerin tamamlanma durumu ve fotoğrafları sıfırlanacak.\n\nOnaylıyor musunuz?",
      confirmText: "Evet, Sıfırla",
      cancelText: "Vazgeç",
      variant: "danger",
      icon: RefreshCw,
      onConfirm: executeResetWeek
    });
  };

  const executeDeleteWeek = async () => {
    if (isFirebaseActive && student?.id) {
      try {
        await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: [] }));
      } catch (e) {
        console.error("handleDeleteWeek error:", e);
      }
    }
    onUpdateStudent({ ...student, goals: [] }, { skipFirestore: true });
  };

  const handleDeleteWeek = () => {
    setConfirmDialog({
      title: "Haftayı Sil",
      message: "DİKKAT: Bu haftanın TÜM hedefleri kalıcı olarak silinecek!\n\nOnaylıyor musunuz?",
      confirmText: "Evet, Tümünü Sil",
      cancelText: "Vazgeç",
      variant: "danger",
      icon: Trash2,
      onConfirm: executeDeleteWeek
    });
  };

  // FOTOĞRAF İŞLEMLERİ
  const handleUploadPhotos = async (files) => {
    if (!files || files.length === 0 || !activeGoal || !photoModalContext) return;
    setIsUploadingPhoto(true);
    setUploadError('');

    try {
      const uploadedList = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!file.type || !file.type.startsWith('image/')) continue;

        const uploadedItem = await uploadPhotoFile(file, student?.id, 'goals');
        uploadedList.push(uploadedItem);
      }

      if (uploadedList.length === 0) {
        setIsUploadingPhoto(false);
        return;
      }

      const dayId = photoModalContext.dayId;
      const currentGoalImages = activeGoal.images || {};
      const currentDayImages = Array.isArray(currentGoalImages[dayId]) ? currentGoalImages[dayId] : [];
      const updatedDayImages = [...currentDayImages, ...uploadedList];
      const updatedGoalImages = { ...currentGoalImages, [dayId]: updatedDayImages };

      const updatedGoals = goals.map(g => String(g.id) === String(activeGoal.id) ? { ...g, images: updatedGoalImages } : g);

      if (isFirebaseActive && student?.id) {
        try {
          await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: updatedGoals }));
        } catch (e) {
          console.error("Goals handleUploadPhotos hatası:", e);
          throw new Error("Hedef görseli kaydedilirken veritabanı hatası: " + (e.message || "Bilinmeyen hata"));
        }
      }
      onUpdateStudent({ ...student, goals: updatedGoals }, { skipFirestore: true });

      setToastMessage(`${uploadedList.length} fotoğraf başarıyla yüklendi`);
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
      toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
    } catch (err) {
      console.error("Fotoğraf yükleme hatası:", err);
      setUploadError(err.message || "Fotoğraf yüklenirken bir hata oluştu.");
    } finally {
      setIsUploadingPhoto(false);
      if (photoFileInputRef.current) photoFileInputRef.current.value = '';
      if (cameraInputRef.current) cameraInputRef.current.value = '';
    }
  };

  const executeDeleteSinglePhoto = async (imageToDelete) => {
    if (storage && imageToDelete?.storagePath) {
      try {
        const fRef = storageRef(storage, imageToDelete.storagePath);
        await deleteObject(fRef);
      } catch (err) {
        console.warn("Storage deleteObject error:", err);
      }
    }

    const dayId = photoModalContext.dayId;
    const remainingImages = dayPhotos.filter(img => String(img.id) !== String(imageToDelete.id));
    const currentGoalImages = activeGoal.images || {};
    const updatedGoalImages = { ...currentGoalImages, [dayId]: remainingImages };
    const updatedGoals = goals.map(g => String(g.id) === String(activeGoal.id) ? { ...g, images: updatedGoalImages } : g);

    if (isFirebaseActive && student?.id) {
      try {
        await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: updatedGoals }));
      } catch (e) {
        console.error("Goals handleDeleteSinglePhoto hatası:", e);
      }
    }
    onUpdateStudent({ ...student, goals: updatedGoals }, { skipFirestore: true });

    if (String(lightboxImage?.id) === String(imageToDelete.id)) {
      setLightboxImage(null);
    }
    setToastMessage("Fotoğraf silindi.");
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2200);
  };

  const handleDeleteSinglePhoto = (imageToDelete) => {
    if (!activeGoal || !photoModalContext) return;
    setConfirmDialog({
      title: "Fotoğrafı Sil",
      message: "Bu fotoğrafı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
      confirmText: "Evet, Sil",
      cancelText: "Vazgeç",
      variant: "danger",
      icon: Trash2,
      onConfirm: () => executeDeleteSinglePhoto(imageToDelete)
    });
  };

  const executeClearAllPhotos = async (alsoCompleteGoal = false) => {
    if (storage && Array.isArray(dayPhotos)) {
      for (const img of dayPhotos) {
        if (img?.storagePath) {
          try {
            const fRef = storageRef(storage, img.storagePath);
            await deleteObject(fRef);
          } catch (err) {
            console.warn("Storage clear error:", err);
          }
        }
      }
    }

    const dayId = photoModalContext.dayId;
    const currentGoalImages = activeGoal.images || {};
    const updatedGoalImages = { ...currentGoalImages, [dayId]: [] };
    const key = `${activeGoal.id}-${dayId}`;
    const newStatus = alsoCompleteGoal ? { ...(activeGoal.status || {}), [key]: true } : (activeGoal.status || {});

    const updatedGoals = goals.map(g => String(g.id) === String(activeGoal.id) ? {
      ...g,
      images: updatedGoalImages,
      status: newStatus
    } : g);

    if (isFirebaseActive && student?.id) {
      try {
        await updateDoc(doc(db, "students", String(student.id)), sanitizeForFirestore({ goals: updatedGoals }));
      } catch (e) {
        console.error("Goals handleClearAllPhotos hatası:", e);
      }
    }
    onUpdateStudent({ ...student, goals: updatedGoals }, { skipFirestore: true });
    if (alsoCompleteGoal && !isGoalCompletedForDay) {
      logActivity(student.id, 'goal_update', { goal: activeGoal.text, day: dayId });
    }

    setLightboxImage(null);
    setToastMessage(alsoCompleteGoal ? "Hedef tamamlandı ve fotoğraflar temizlendi!" : "Fotoğraflar temizlendi, alan boşaltıldı.");
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToastMessage(''), 2500);
  };

  const handleClearAllPhotos = (alsoCompleteGoal = false) => {
    if (!activeGoal || !photoModalContext) return;
    const count = dayPhotos.length;
    if (count === 0 && !alsoCompleteGoal) return;

    const dayLabel = activeDayObj?.label || photoModalContext.dayId;
    const confirmMsg = alsoCompleteGoal
      ? `Hedefi kontrol ettiniz mi?\n\nHedef '${dayLabel}' günü için 'Yapıldı' olarak işaretlenecek ve bu güne ait ${count} adet fotoğraf kalıcı olarak silinerek depolama alanı tamamen boşaltılacaktır.\n\nOnaylıyor musunuz?`
      : `Bu hedefin '${dayLabel}' gününe ait ${count} adet fotoğraf kalıcı olarak silinecek ve depolama alanı boşaltılacaktır.\n\nOnaylıyor musunuz?`;

    setConfirmDialog({
      title: "Hedefi Kontrol Et & Temizle",
      message: confirmMsg,
      confirmText: "✓ Kontrol Edildi & Temizle",
      cancelText: "Vazgeç",
      variant: "success",
      icon: CheckCheck,
      onConfirm: () => executeClearAllPhotos(alsoCompleteGoal)
    });
  };

  const openLightbox = (img, index) => {
    setLightboxImage(img);
    setLightboxIndex(index);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const nextLightboxImage = () => {
    if (dayPhotos.length <= 1) return;
    const nextIdx = (lightboxIndex + 1) % dayPhotos.length;
    setLightboxIndex(nextIdx);
    setLightboxImage(dayPhotos[nextIdx]);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  const prevLightboxImage = () => {
    if (dayPhotos.length <= 1) return;
    const prevIdx = (lightboxIndex - 1 + dayPhotos.length) % dayPhotos.length;
    setLightboxIndex(prevIdx);
    setLightboxImage(dayPhotos[prevIdx]);
    setLightboxZoom(1);
    setLightboxRotation(0);
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="flex justify-between items-center">
        <h2 className={`text-2xl font-bold ${colors.text}`}>Haftalık Hedef Takibi</h2>
        <div className="flex gap-2">
          {isAdmin && <Button variant="ghost" onClick={() => setIsEditMode(!isEditMode)} icon={Settings} className={isEditMode ? 'text-orange-500 bg-orange-500/10' : ''} />}
          {isAdmin && <Button icon={Plus} onClick={() => setShowModal(true)}>Yeni Hedef</Button>}
          {isAdmin && isEditMode && (
            <>
              <Button size="small" variant="secondary" onClick={handleResetWeek} icon={RefreshCw}>Haftayı Sıfırla</Button>
              <Button size="small" variant="danger" onClick={handleDeleteWeek} icon={Trash2}>Haftayı Sil</Button>
            </>
          )}
        </div>
      </div>

      <div className="flex overflow-x-auto gap-4 pb-4 md:grid md:grid-cols-7 md:overflow-visible">
        {DAYS.map(day => {
          const dailyGoals = goals.filter(g => g.days.includes(day.id));
          return (
            <div key={day.id} className={`min-w-[200px] md:min-w-0 ${colors.bgCardTransparent} border ${colors.border} rounded-xl flex flex-col h-full snap-center`}>
              <div className={`p-3 border-b ${colors.border} ${colors.bgCard} rounded-t-xl text-center`}>
                <span className={`font-bold ${colors.textSec} text-sm`}>{day.label}</span>
              </div>
              <div className="p-2 space-y-2 flex-1">
                {dailyGoals.map(goal => {
                  const isCompleted = goal.status?.[`${goal.id}-${day.id}`];
                  const currentDayPhotos = (goal.images && Array.isArray(goal.images[day.id])) ? goal.images[day.id] : [];

                  return (
                    <div
                      key={goal.id}
                      className={`p-3 rounded-lg border text-xs relative group ${colors.shadow} ${isCompleted ? 'bg-emerald-900/20 border-emerald-900/50' : `${colors.bgCard} ${colors.border}`}`}
                    >
                      <div className="font-bold text-orange-400 mb-1">{goal.text}</div>
                      {goal.target && (
                        <div className="text-xs text-emerald-500 mb-2 flex items-center gap-1.5 bg-emerald-500/10 py-1 px-2 rounded w-fit mt-1">
                          <Target size={12} /> <span className="font-medium">{goal.target}</span>
                        </div>
                      )}

                      {/* EDIT MODE CONTROL */}
                      {(isAdmin && isEditMode) && (
                        <div className={`absolute top-2 right-2 flex gap-1 ${colors.isDark ? 'bg-slate-900/50' : 'bg-white/50'} rounded px-1`}>
                          <button onClick={() => handleEdit(goal)} className="text-slate-500 hover:text-blue-400 p-2"><Edit2 size={12} /></button>
                          <button onClick={(e) => requestDelete(e, goal.id)} className="text-slate-500 hover:text-red-500 p-2"><Trash2 size={12} /></button>
                        </div>
                      )}

                      <div className="mt-3 flex items-center gap-1.5 w-full">
                        <button
                          type="button"
                          onClick={() => toggleGoalStatus(goal.id, day.id)}
                          className={`flex-1 min-w-0 h-8 px-2 rounded flex items-center justify-center gap-1 text-xs font-medium transition-all ${isCompleted ?
                            'bg-emerald-600 text-white shadow-md shadow-emerald-900/20 hover:bg-emerald-500' :
                            `${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'} ${colors.textSec} hover:text-white border ${colors.border}`}`}
                          title={isCompleted ? 'Hedef Tamamlandı' : 'Hedefi Tamamla'}
                        >
                          {isCompleted ? (
                            <>
                              <Check size={13} className="shrink-0" />
                              <span className="truncate">Yapıldı</span>
                            </>
                          ) : (
                            <span className="truncate">Yapıldı</span>
                          )}
                        </button>
                        {/* Fotoğraf yükleme ikonu şimdilik gizlendi */}
                        {false && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setPhotoModalContext({ goalId: goal.id, dayId: day.id });
                          }}
                          className={`relative w-8 h-8 shrink-0 rounded flex items-center justify-center transition-all ${currentDayPhotos.length > 0 ?
                            'bg-orange-500/20 text-orange-400 border border-orange-500/50 hover:bg-orange-500/30 shadow-sm' :
                            `${colors.isDark ? 'bg-slate-800 hover:bg-slate-700 text-slate-400' : 'bg-slate-100 hover:bg-slate-200 text-slate-600'} hover:text-orange-400 border ${colors.border}`}`}
                          title={currentDayPhotos.length > 0 ? `${currentDayPhotos.length} Hedef Fotoğrafı Yüklendi (İncele / Sil)` : 'Hedef Fotoğrafı Çek / Yükle'}
                        >
                          <Camera size={14} className="shrink-0" />
                          {currentDayPhotos.length > 0 && (
                            <span className="absolute -top-1.5 -right-1.5 bg-orange-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center shadow-md">
                              {currentDayPhotos.length}
                            </span>
                          )}
                        </button>
                        )}
                      </div>
                    </div>
                  );
                })}
                {dailyGoals.length === 0 && <div className={`text-center py-8 ${colors.textSec} text-xs`}>-</div>}
              </div>
            </div>
          );
        })}
      </div>

      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />

      {showModal && (
        <Modal
          title={editingId ? "Hedefi Düzenle" : "Yeni Hedef Ekle"}
          onClose={() => {
            setShowModal(false);
            setEditingId(null);
            setForm({ text: '', target: '', days: [] });
          }}
        >
          <div className="space-y-4">
            <Input label="Hedef Başlığı" placeholder="Örn: Kitap Okuma" value={form.text} onChange={e => setForm({ ...form, text: e.target.value })} />
            <Input label="Hedef / Miktar" placeholder="Örn: 20 Sayfa / 30 Dk" value={form.target} onChange={e => setForm({ ...form, target: e.target.value })} />
            <div>
              <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase`}>Günler</label>
              <div className="flex flex-wrap gap-2">
                {DAYS.map(day => (
                  <button
                    key={day.id}
                    type="button"
                    onClick={() => handleDayToggle(day.id)}
                    className={`px-3 py-2 rounded text-sm transition-colors ${form.days.includes(day.id) ? 'bg-orange-600 text-white' : `${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} ${colors.textSec} hover:opacity-80`}`}
                  >
                    {day.label}
                  </button>
                ))}
              </div>
            </div>
            <Button onClick={handleSave} className="w-full mt-4">Kaydet</Button>
          </div>
        </Modal>
      )}

      {/* Hedef Fotoğraf Yönetim Modalı */}
      {photoModalContext && activeGoal && (
        <Modal
          title={`📸 Hedef Fotoğrafları: ${activeGoal.text} (${activeDayObj?.label || ''})`}
          maxWidth="max-w-4xl"
          onClose={() => setPhotoModalContext(null)}
          footer={
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 w-full">
              <div className={`text-xs ${colors.textSec} flex items-center gap-2`}>
                <span className="font-semibold text-orange-400">{dayPhotos.length} Fotoğraf</span>
                {dayPhotos.length > 0 && (
                  <>
                    <span>•</span>
                    <span>
                      Toplam {formatFileSize(dayPhotos.reduce((acc, img) => acc + (img.size || 0), 0))}
                    </span>
                  </>
                )}
              </div>
              <div className="flex items-center gap-2 w-full sm:w-auto justify-end flex-wrap">
                {isAdmin && dayPhotos.length > 0 && (
                  <button
                    type="button"
                    onClick={() => handleClearAllPhotos(true)}
                    className="px-4 py-2 text-xs font-semibold rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white shadow-lg shadow-emerald-900/30 transition-all flex items-center gap-1.5"
                    title="Hedefi yapıldı işaretler ve fotoğrafları silerek alanı boşaltır"
                  >
                    <CheckCheck size={16} />
                    <span>✓ Kontrol Edildi & Temizle</span>
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setPhotoModalContext(null)}
                  className={`px-4 py-2 text-xs rounded-lg ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300'} ${colors.text} transition-colors`}
                >
                  Kapat
                </button>
              </div>
            </div>
          }
        >
          <div className="space-y-5">
            {/* Hedef Bilgi Kartı */}
            <div className={`p-4 rounded-xl border ${colors.border} ${colors.isDark ? 'bg-slate-900/60' : 'bg-slate-50'} flex flex-col sm:flex-row justify-between sm:items-center gap-3`}>
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-orange-400">{activeGoal.text}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${isGoalCompletedForDay ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' : 'bg-amber-500/20 text-amber-400 border border-amber-500/30'}`}>
                    {isGoalCompletedForDay ? 'Yapıldı' : 'Bekliyor'}
                  </span>
                  <span className={`text-[11px] px-2 py-0.5 rounded font-medium ${colors.isDark ? 'bg-slate-800 text-slate-300' : 'bg-slate-200 text-slate-700'}`}>
                    {activeDayObj?.label}
                  </span>
                </div>
                {activeGoal.target && (
                  <p className={`text-xs text-emerald-500 font-medium mt-1 flex items-center gap-1`}>
                    <Target size={12} /> {activeGoal.target}
                  </p>
                )}
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="file"
                  ref={cameraInputRef}
                  accept="image/*"
                  capture="environment"
                  className="hidden"
                  onChange={(e) => handleUploadPhotos(e.target.files)}
                />
                <input
                  type="file"
                  ref={photoFileInputRef}
                  accept="image/*"
                  multiple
                  className="hidden"
                  onChange={(e) => handleUploadPhotos(e.target.files)}
                />
                <button
                  type="button"
                  disabled={isUploadingPhoto}
                  onClick={() => cameraInputRef.current?.click()}
                  className="flex-1 sm:flex-initial px-3.5 py-2.5 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold text-xs shadow-md shadow-orange-900/20 flex items-center justify-center gap-2 transition-all disabled:opacity-50"
                  title="Telefonda doğrudan kamerayı açar"
                >
                  <Camera size={16} />
                  <span>Kamerayı Aç</span>
                </button>
                <button
                  type="button"
                  disabled={isUploadingPhoto}
                  onClick={() => photoFileInputRef.current?.click()}
                  className={`flex-1 sm:flex-initial px-3.5 py-2.5 rounded-xl border ${colors.border} ${colors.isDark ? 'bg-slate-800 hover:bg-slate-700' : 'bg-white hover:bg-slate-100'} ${colors.text} font-semibold text-xs flex items-center justify-center gap-2 transition-all disabled:opacity-50`}
                  title="Galeriden veya bilgisayardan görsel seç"
                >
                  <Upload size={16} />
                  <span>Galeriden Yükle</span>
                </button>
              </div>
            </div>

            {/* Yükleme İlerlemesi */}
            {isUploadingPhoto && (
              <div className="p-4 rounded-xl border border-orange-500/40 bg-orange-500/10 flex items-center justify-center gap-3 animate-pulse">
                <RefreshCw size={18} className="animate-spin text-orange-400" />
                <span className="text-xs font-semibold text-orange-300">Fotoğraflar optimize ediliyor ve yükleniyor, lütfen bekleyin...</span>
              </div>
            )}

            {uploadError && (
              <div className="p-3 rounded-lg border border-red-500/40 bg-red-500/10 text-xs text-red-400 flex items-center justify-between">
                <span>{uploadError}</span>
                <button type="button" onClick={() => setUploadError('')} className="text-red-300 hover:text-white"><X size={14} /></button>
              </div>
            )}

            {/* Fotoğraf Galerisi */}
            {dayPhotos.length === 0 ? (
              <div className={`p-10 text-center border-2 border-dashed ${colors.border} rounded-2xl flex flex-col items-center justify-center`}>
                <div className={`w-14 h-14 rounded-full ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} flex items-center justify-center mb-3 text-slate-400`}>
                  <ImageIcon size={26} />
                </div>
                <div className={`text-sm font-semibold ${colors.text} mb-1`}>Henüz Hedef Fotoğrafı Yüklenmemiş</div>
                <p className={`text-xs ${colors.textSec} max-w-sm mb-4`}>
                  Öğrenci kitap okurken, çalışırken veya hedefi tamamlarken fotoğraf çekip buraya yükleyebilir.
                </p>
                <button
                  type="button"
                  onClick={() => cameraInputRef.current?.click()}
                  className="px-4 py-2 rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium flex items-center gap-1.5 transition-colors shadow-md shadow-orange-900/20"
                >
                  <Camera size={14} /> Fotoğraf Çek
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3.5">
                {dayPhotos.map((img, idx) => (
                  <div
                    key={img.id || idx}
                    className={`group relative rounded-xl overflow-hidden border ${colors.border} ${colors.isDark ? 'bg-slate-900' : 'bg-slate-100'} shadow-sm hover:shadow-md transition-all`}
                  >
                    <div
                      className="aspect-square cursor-pointer overflow-hidden relative"
                      onClick={() => openLightbox(img, idx)}
                    >
                      <img
                        src={img.url}
                        alt={img.name || 'Hedef görseli'}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/35 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                        <span className="p-2 rounded-full bg-black/60 text-white">
                          <Maximize2 size={16} />
                        </span>
                      </div>
                    </div>
                    {/* Alt Bilgi & Silme Butonu */}
                    <div className={`p-2 flex items-center justify-between border-t ${colors.border} text-[10px] ${colors.textSec}`}>
                      <span className="truncate max-w-[80px]" title={img.name}>
                        {img.size ? formatFileSize(img.size) : `#${idx + 1}`}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteSinglePhoto(img);
                        }}
                        className="p-1 rounded text-red-400 hover:bg-red-500/20 hover:text-red-300 transition-colors"
                        title="Bu fotoğrafı sil"
                      >
                        <Trash2 size={13} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Lightbox Modal (Tam Ekran İnceleme / Yakınlaştırma / Döndürme) */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-md flex flex-col select-none animate-fade-in"
          onClick={closeLightbox}
        >
          {/* Lightbox Üst Bar */}
          <div
            className="flex items-center justify-between px-4 sm:px-6 py-3 bg-black/50 border-b border-white/10 shrink-0"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-3 text-white text-xs sm:text-sm">
              <span className="font-bold text-orange-400">
                Fotoğraf {lightboxIndex + 1} / {dayPhotos.length}
              </span>
              <span className="text-white/40 hidden sm:inline">|</span>
              <span className="text-white/70 hidden sm:inline truncate max-w-[200px]">{lightboxImage.name}</span>
              {lightboxImage.size && (
                <span className="text-[11px] px-2 py-0.5 rounded bg-white/10 text-white/80">
                  {formatFileSize(lightboxImage.size)}
                </span>
              )}
            </div>

            <div className="flex items-center gap-1 sm:gap-2">
              <button
                type="button"
                onClick={() => setLightboxZoom(prev => Math.min(prev + 0.25, 3))}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="Yakınlaştır"
              >
                <ZoomIn size={18} />
              </button>
              <button
                type="button"
                onClick={() => setLightboxZoom(prev => Math.max(prev - 0.25, 0.5))}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="Uzaklaştır"
              >
                <ZoomOut size={18} />
              </button>
              <button
                type="button"
                onClick={() => setLightboxRotation(prev => (prev + 90) % 360)}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="90° Döndür"
              >
                <RotateCw size={18} />
              </button>
              <button
                type="button"
                onClick={() => { setLightboxZoom(1); setLightboxRotation(0); }}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="Sıfırla"
              >
                <RotateCcw size={16} />
              </button>
              <a
                href={lightboxImage.url}
                download={lightboxImage.name || 'hedef.jpg'}
                target="_blank"
                rel="noreferrer"
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
                title="İndir"
              >
                <Download size={18} />
              </a>
              <button
                type="button"
                onClick={() => handleDeleteSinglePhoto(lightboxImage)}
                className="p-2 rounded-lg text-red-400 hover:text-red-300 hover:bg-red-500/20 transition-colors"
                title="Fotoğrafı Sil"
              >
                <Trash2 size={18} />
              </button>
              <button
                type="button"
                onClick={closeLightbox}
                className="p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/20 transition-colors ml-2"
                title="Kapat (Esc)"
              >
                <X size={20} />
              </button>
            </div>
          </div>

          {/* Lightbox Görsel Görüntüleme Alanı */}
          <div className="flex-1 flex items-center justify-center relative overflow-hidden p-4">
            {dayPhotos.length > 1 && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); prevLightboxImage(); }}
                className="absolute left-4 p-3 rounded-full bg-black/60 hover:bg-black/90 text-white border border-white/20 transition-all z-10"
                title="Önceki Fotoğraf (Sol Ok)"
              >
                <ChevronLeft size={24} />
              </button>
            )}

            <div
              className="flex items-center justify-center max-w-full max-h-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={lightboxImage.url}
                alt={lightboxImage.name || 'Hedef tam görsel'}
                style={{
                  transform: `scale(${lightboxZoom}) rotate(${lightboxRotation}deg)`,
                  transition: 'transform 0.15s ease-out',
                  maxWidth: '90vw',
                  maxHeight: '80vh',
                  objectFit: 'contain'
                }}
                className="rounded shadow-2xl"
              />
            </div>

            {dayPhotos.length > 1 && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); nextLightboxImage(); }}
                className="absolute right-4 p-3 rounded-full bg-black/60 hover:bg-black/90 text-white border border-white/20 transition-all z-10"
                title="Sonraki Fotoğraf (Sağ Ok)"
              >
                <ChevronRight size={24} />
              </button>
            )}
          </div>
        </div>
      )}

      {/* Confirm Dialog Modalı */}
      {confirmDialog && (
        <ConfirmModal
          isOpen={!!confirmDialog}
          title={confirmDialog.title}
          message={confirmDialog.message}
          confirmText={confirmDialog.confirmText}
          cancelText={confirmDialog.cancelText}
          variant={confirmDialog.variant}
          icon={confirmDialog.icon}
          onClose={() => setConfirmDialog(null)}
          onConfirm={() => {
            const action = confirmDialog.onConfirm;
            setConfirmDialog(null);
            if (action) action();
          }}
        />
      )}

      {/* Toast Bildirimi */}
      {toastMessage && (
        <div className="fixed bottom-6 right-6 z-[120] bg-emerald-600 text-white px-4 py-2.5 rounded-xl shadow-lg shadow-emerald-900/30 text-xs font-semibold flex items-center gap-2 animate-fade-in">
          <Check size={16} />
          <span>{toastMessage}</span>
        </div>
      )}
    </div>
  );
};

// 4. KAYNAKLAR
const ResourceModule = ({ student, curriculum, onUpdateStudent, user }) => {
  const activeCurriculum = student?.curriculum || curriculum;
  const [selectedCourseId, setSelectedCourseId] = useState(activeCurriculum[0]?.id || null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailModalId, setShowDetailModalId] = useState(null);
  const activeDetailResource = student?.resources?.find(r => r.id === showDetailModalId) || null;
  const [newResource, setNewResource] = useState({ name: '', publisher: '' });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const colors = useThemeColors();

  if (!student) return <div className={`${colors.textSec} text-center mt-20`}>Yükleniyor...</div>;

  const selectedCourse = activeCurriculum.find(c => c.id === selectedCourseId);
  let resources = student.resources ? student.resources.filter(r => r.courseId === selectedCourseId) : [];
  if (user.role === 'student') {
    resources = resources.filter(r => !r.isHidden);
  }
  const activeResources = resources.filter(r => !r.isCompleted);
  const completedResources = resources.filter(r => r.isCompleted);

  const handleAddResource = () => { if (!newResource.name) return; const res = { id: Date.now(), courseId: selectedCourseId, name: newResource.name, publisher: newResource.publisher, progress: 0, notes: '', completedTopics: [], isHidden: false, isCompleted: false }; onUpdateStudent({ ...student, resources: [...(student.resources || []), res] }); logActivity(student.id, 'resource_add', { resourceName: newResource.name, publisher: newResource.publisher }); setShowAddModal(false); setNewResource({ name: '', publisher: '' }); };
  const updateResource = (updatedRes) => { const updatedList = student.resources.map(r => r.id === updatedRes.id ? updatedRes : r); onUpdateStudent({ ...student, resources: updatedList }); logActivity(student.id, 'resource_edit', { resourceName: updatedRes.name }); };

  const toggleHide = (resId) => {
    const updated = student.resources.map(r => r.id === resId ? { ...r, isHidden: !r.isHidden } : r);
    onUpdateStudent({ ...student, resources: updated });
  };

  const toggleComplete = (resId) => {
    const updated = student.resources.map(r => r.id === resId ? { ...r, isCompleted: !r.isCompleted } : r);
    onUpdateStudent({ ...student, resources: updated });
  };

  const requestDelete = (e, id) => { e.stopPropagation(); e.preventDefault(); setDeleteConfirm(id); };
  const confirmDelete = () => { if (deleteConfirm) { const updatedList = student.resources.filter(r => r.id !== deleteConfirm); onUpdateStudent({ ...student, resources: updatedList }); setDeleteConfirm(null); } };
  const toggleTopicCompletion = (resource, uniqueTopicKey, extra = null) => {
    const isCompleted = resource.completedTopics?.includes(uniqueTopicKey);
    let newCompleted = resource.completedTopics || [];
    if (isCompleted) {
      newCompleted = newCompleted.filter(t => t !== uniqueTopicKey);
    } else {
      newCompleted = [...newCompleted, uniqueTopicKey];
    }
    const resCourse = activeCurriculum.find(c => c.id === resource.courseId);
    let totalTopics = 0;
    if (resCourse) {
      resCourse.units.forEach(u => totalTopics += u.topics.length);
    }
    const progress = totalTopics > 0 ? Math.round((newCompleted.length / totalTopics) * 100) : 0;
    updateResource({ ...resource, completedTopics: newCompleted, progress });
    if (!isCompleted) {
      logActivity(student.id, 'topic_completion', {
        resourceName: resource.name,
        subject: extra?.subject || resCourse?.name,
        unit: extra?.unit,
        topic: extra?.topic || uniqueTopicKey,
        topicKey: uniqueTopicKey
      });
    }
  };

  const ResourceCard = ({ res }) => (
    <div key={res.id} className={`${colors.bgCard} border ${colors.border} rounded-xl p-5 hover:border-slate-500 transition-all ${colors.shadow} ${res.isHidden ? 'opacity-40 grayscale-[0.5]' : ''}`}>
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className={`font-bold ${colors.text} text-lg truncate`}>{res.name}</h3>
            {res.isHidden && <EyeOff size={14} className="text-slate-500 shrink-0" />}
            {res.isCompleted && <CheckCircle size={14} className="text-emerald-500 shrink-0" />}
          </div>
          <div className={`text-sm ${colors.textSec}`}>{res.publisher}</div>
        </div>
        {user.role !== 'student' && (
          <div className="flex gap-1">
            <button
              onClick={() => toggleHide(res.id)}
              title={res.isHidden ? "Göster" : "Gizle"}
              className={`p-2 rounded-lg transition-colors ${res.isHidden ? 'text-orange-500 bg-orange-500/10' : 'text-slate-500 hover:bg-slate-500/10'}`}
            >
              {res.isHidden ? <Eye size={16} /> : <EyeOff size={16} />}
            </button>
            <button
              onClick={() => toggleComplete(res.id)}
              title={res.isCompleted ? "Aktife Al" : "Tamamlandı"}
              className={`p-2 rounded-lg transition-colors ${res.isCompleted ? 'text-emerald-500 bg-emerald-500/10' : 'text-slate-500 hover:bg-emerald-500/10'}`}
            >
              <CheckCircle size={16} />
            </button>
            <button onClick={(e) => requestDelete(e, res.id)} className="text-slate-600 hover:text-red-500 p-2"><Trash2 size={16} /></button>
          </div>
        )}
      </div>
      <div className="mt-4">
        <div className={`flex justify-between text-xs ${colors.textSec} mb-1`}><span>İlerleme</span><span>%{res.progress}</span></div>
        <div className={`w-full ${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} h-2 rounded-full overflow-hidden`}>
          <div className="bg-emerald-500 h-full transition-all duration-500" style={{ width: `${res.progress}%` }}></div>
        </div>
      </div>
      <div className={`mt-4 pt-4 border-t ${colors.border} flex justify-between items-center`}>
        <div className={`text-xs ${colors.textSec} flex items-center gap-1`}><Check size={12} className="text-emerald-500" />{res.completedTopics?.length || 0} Konu Bitti</div>
        <Button size="small" variant="secondary" onClick={() => setShowDetailModalId(res.id)}>Detay & Düzenle</Button>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col md:flex-row gap-6 h-auto md:h-[calc(100vh-140px)] animate-fade-in">
      <div className="w-full md:w-1/4 flex flex-col gap-2 max-h-60 md:max-h-full overflow-y-auto pr-2 custom-scrollbar">{activeCurriculum.map(c => (<button key={c.id} onClick={() => setSelectedCourseId(c.id)} className={`p-4 rounded-lg text-left transition-all flex justify-between items-center ${selectedCourseId === c.id ? `bg-slate-800 border-orange-500 text-white border` : `${colors.bgCard} ${colors.border} ${colors.textSec}`}`}><span>{c.name}</span><span className={`text-xs ${colors.isDark ? 'bg-slate-700' : 'bg-slate-200'} px-2 py-1 rounded ${colors.textSec}`}>{student.resources?.filter(r => r.courseId === c.id).length || 0}</span></button>))}</div>
      <div className={`flex-1 ${colors.bgCardTransparent} border ${colors.border} rounded-xl p-6 overflow-y-auto custom-scrollbar`}>
        <div className={`flex justify-between items-center mb-6 pb-4 border-b ${colors.border}`}>
          <h2 className={`text-xl font-bold ${colors.text}`}>{selectedCourse?.name} Kaynakları</h2>
          <Button size="small" icon={Plus} onClick={() => setShowAddModal(true)}>Kaynak Ekle</Button>
        </div>

        <div className="space-y-8">
          {/* AKTİF KAYNAKLAR */}
          <div>
            <div className={`text-xs font-bold ${colors.textSec} uppercase mb-4 tracking-wider flex items-center gap-2`}>
              <div className="w-2 h-2 rounded-full bg-blue-500"></div>
              Aktif Kaynaklar ({activeResources.length})
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {activeResources.map(res => <ResourceCard key={res.id} res={res} />)}
              {activeResources.length === 0 && <div className={`col-span-2 text-center py-6 ${colors.textSec} bg-slate-500/5 rounded-lg border border-dashed ${colors.border} text-xs`}>Aktif kaynak bulunamadı.</div>}
            </div>
          </div>

          {/* TAMAMLANAN KAYNAKLAR */}
          {completedResources.length > 0 && (
            <div className="pt-4 border-t border-slate-700/50">
              <div className={`text-xs font-bold text-emerald-500 uppercase mb-4 tracking-wider flex items-center gap-2`}>
                <CheckCircle size={14} />
                Tamamlanan Kaynaklar ({completedResources.length})
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {completedResources.map(res => <ResourceCard key={res.id} res={res} />)}
              </div>
            </div>
          )}
        </div>
      </div>
      {showAddModal && (<Modal title="Yeni Kaynak Ekle" onClose={() => setShowAddModal(false)}><div className="space-y-4"><Input label="Kaynak Adı" placeholder="Örn: 3D TYT Matematik Soru Bankası" value={newResource.name} onChange={e => setNewResource({ ...newResource, name: e.target.value })} /><Input label="Yayıncı" placeholder="Örn: 3D Yayınları" value={newResource.publisher} onChange={e => setNewResource({ ...newResource, publisher: e.target.value })} /><Button onClick={handleAddResource} className="w-full mt-4">Ekle</Button></div></Modal>)}
      {activeDetailResource && (() => {
        const modalCourse = activeCurriculum.find(c => c.id === activeDetailResource.courseId);
        return (
          <Modal title={activeDetailResource.name} onClose={() => setShowDetailModalId(null)}>
            <div className="space-y-6">
              {user.role !== 'student' && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-orange-500/5 p-4 rounded-xl border border-orange-500/10">
                  <div>
                    <label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase tracking-wider`}>Kaynak Adı</label>
                    <input
                      type="text"
                      className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg px-4 py-2.5 ${colors.text} text-sm focus:outline-none focus:border-orange-500 transition-colors`}
                      value={activeDetailResource.name}
                      onChange={e => updateResource({ ...activeDetailResource, name: e.target.value })}
                    />
                  </div>
                  <div>
                    <label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase tracking-wider`}>Yayıncı</label>
                    <input
                      type="text"
                      className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg px-4 py-2.5 ${colors.text} text-sm focus:outline-none focus:border-orange-500 transition-colors`}
                      value={activeDetailResource.publisher || ''}
                      onChange={e => updateResource({ ...activeDetailResource, publisher: e.target.value })}
                    />
                  </div>
                </div>
              )}
              <div>
                <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase`}>İlerleme Durumu (%)</label>
                <div className="flex gap-4 items-center">
                  <input
                    type="range"
                    min="0"
                    max="100"
                    className="w-full accent-orange-500"
                    value={activeDetailResource.progress}
                    onChange={e => updateResource({ ...activeDetailResource, progress: parseInt(e.target.value) })}
                  />
                  <span className={`font-bold ${colors.text} w-10 text-right`}>%{activeDetailResource.progress}</span>
                </div>
              </div>
              <div>
                <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase`}>Notlar</label>
                <textarea
                  className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-3 ${colors.text} text-sm h-24`}
                  value={activeDetailResource.notes}
                  onChange={e => updateResource({ ...activeDetailResource, notes: e.target.value })}
                  placeholder="Bu kaynakla ilgili notlar..."
                />
              </div>
              <div>
                <label className={`block text-xs font-medium ${colors.textSec} mb-2 uppercase`}>Konu Takibi (Bu Kitap İçin)</label>
                <div className={`${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} rounded-lg p-2 max-h-60 overflow-y-auto custom-scrollbar space-y-4`}>
                  {modalCourse?.units.map(unit => (
                    <div key={unit.id || unit.name}>
                      <div className="text-orange-500 text-xs font-bold px-2 mb-1">{unit.name}</div>
                      {unit.topics.map((topic, idx) => {
                        const key = `${unit.id || unit.name}-${idx}`;
                        const isChecked = activeDetailResource.completedTopics?.includes(key);
                        return (
                          <div
                            key={key}
                            onClick={() => toggleTopicCompletion(activeDetailResource, key, { subject: modalCourse?.name, unit: unit.name, topic: topic })}
                            className={`flex items-center gap-3 p-2 ${colors.hoverBg} rounded cursor-pointer`}
                          >
                            <div className={`w-4 h-4 rounded border flex items-center justify-center ${isChecked ? 'bg-emerald-500 border-emerald-500' : 'border-slate-600'}`}>
                              {isChecked && <Check size={10} className="text-white" />}
                            </div>
                            <span className={`text-sm ${isChecked ? colors.text : colors.textSec}`}>{topic}</span>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Modal>
        );
      })()}
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};

// 5. GELİŞMİŞ DENEME TAKİBİ (DÜZELTİLDİ: Yetki Kontrolü & Yanlış/Boş Ayrımı)
const ExamModule = ({ student, onUpdateStudent, user, curriculum }) => {
  const [view, setView] = useState('list');
  const [filterType, setFilterType] = useState('TYT');
  const [branchFilter, setBranchFilter] = useState('mat');
  const [examType, setExamType] = useState('TYT');
  const [editingId, setEditingId] = useState(null);

  // Konu ve Modal State'leri
  const [showTopicModal, setShowTopicModal] = useState(false);
  const [topicSelection, setTopicSelection] = useState({ course: '', unit: '', topic: '', qNo: '', reason: 'Bilgi Eksiği', type: 'wrong' }); // type: 'wrong' | 'empty'
  const [showRankModal, setShowRankModal] = useState(null);
  const [showWrongTopicsModal, setShowWrongTopicsModal] = useState(null);

  const [formData, setFormData] = useState({ name: "", date: new Date().toISOString().split('T')[0], difficulty: "Orta", stats: { turkey: { rank: '', total: '' }, city: { rank: '', total: '' }, school: { rank: '', total: '' } }, details: {}, branchSubject: 'mat', duration: '', wrongTopics: [] });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const colors = useThemeColors();
  const isAdmin = user.role === 'admin' || user.role === 'superadmin';
  const isStudent = user.role === 'student';
  const activeCurriculum = student.curriculum || curriculum || [];

  const examTabs = React.useMemo(() => {
    const allowed = student.allowedExams || ['LGS', 'YKS', 'KPSS'];
    const tabs = [];
    if (allowed.includes('YKS')) tabs.push('TYT', 'AYT');
    if (allowed.includes('LGS')) tabs.push('LGS');
    if (allowed.includes('KPSS')) tabs.push('KPSS');
    tabs.push('BRANS');
    return tabs;
  }, [student.allowedExams]);

  useEffect(() => {
    if (!examTabs.includes(filterType) && examTabs.length > 0) {
      setFilterType(examTabs[0]);
    }
  }, [examTabs, filterType]);

  const handleAddTopicAnalysis = () => {
    if (!topicSelection.topic) return alert("Konu seçiniz");
    if (!topicSelection.qNo) return alert("Soru numarasını giriniz");
    const analysisType = topicSelection.type || 'wrong';
    const newTopic = {
      id: Date.now(),
      name: topicSelection.topic,
      course: activeCurriculum.find(c => c.id === topicSelection.course)?.name || '',
      qNo: topicSelection.qNo,
      reason: topicSelection.reason,
      type: analysisType
    };
    setFormData({ ...formData, wrongTopics: [...formData.wrongTopics, newTopic] });

    setTopicSelection({ ...topicSelection, qNo: '' });
  };

  const removeTopicAnalysis = (id) => setFormData({ ...formData, wrongTopics: formData.wrongTopics.filter(t => t.id !== id) });

  const handleSave = () => {
    if (!formData.name) return alert("Deneme adı giriniz.");
    let totalNet = 0;
    const processedDetails = {};

    const wrongCoef = examType === 'LGS' ? 3 : 4;

    if (examType === 'BRANS') {
      const key = formData.branchSubject;
      const dVal = formData.details[key]?.d ? parseFloat(formData.details[key].d) : 0;
      const yVal = formData.details[key]?.y ? parseFloat(formData.details[key].y) : 0;
      const net = Math.max(0, dVal - (yVal / wrongCoef));
      processedDetails[key] = { d: dVal, y: yVal, n: net };
      totalNet = net;
    } else {
      if (EXAM_TYPES[examType]) {
        Object.keys(formData.details).forEach(key => {
          const detail = formData.details[key];
          const dVal = detail?.d ? parseFloat(detail.d) : 0;
          const yVal = detail?.y ? parseFloat(detail.y) : 0;
          const net = Math.max(0, dVal - (yVal / wrongCoef));
          processedDetails[key] = { d: dVal, y: yVal, n: net };
          totalNet += net;
        });
      }
    }

    const examData = { type: examType, subject: examType === 'BRANS' ? formData.branchSubject : null, ...formData, totalNet, details: processedDetails };

    if (editingId) onUpdateStudent({ ...student, exams: student.exams.map(e => e.id === editingId ? { ...e, ...examData } : e) });
    else { onUpdateStudent({ ...student, exams: [{ id: Date.now(), ...examData }, ...student.exams] }); logActivity(student.id, 'exam_entry', { examName: formData.name, type: examType, totalNet }); }
    setView('list'); setEditingId(null);
  };

  const handleEdit = (exam) => {
    setEditingId(exam.id);
    setExamType(exam.type);
    if (exam.type === 'BRANS') setBranchFilter(exam.subject);

    setFormData({
      name: exam.name,
      date: exam.date,
      difficulty: exam.difficulty,
      stats: exam.stats || { turkey: { rank: '', total: '' }, city: { rank: '', total: '' }, school: { rank: '', total: '' } },
      details: exam.details || {},
      branchSubject: exam.subject || 'mat',
      duration: exam.duration || '',
      wrongTopics: exam.wrongTopics || []
    });
    setView('add');
  };

  const updateDetail = (key, field, value) => {
    setFormData(prev => ({ ...prev, details: { ...prev.details, [key]: { ...prev.details[key], [field]: value } } }));
  };

  const updateStat = (scope, field, value) => setFormData(prev => ({ ...prev, stats: { ...prev.stats, [scope]: { ...prev.stats[scope], [field]: value } } }));
  const confirmDelete = () => { if (deleteConfirm) { onUpdateStudent({ ...student, exams: student.exams.filter(e => e.id !== deleteConfirm) }); setDeleteConfirm(null); } };

  const handleAddNew = () => {
    setView('add');
    setEditingId(null);
    const typeToUse = filterType === 'ALL' ? 'TYT' : filterType;
    setExamType(typeToUse);
    setFormData({ name: "", date: new Date().toISOString().split('T')[0], difficulty: "Orta", stats: { turkey: { rank: '', total: '' }, city: { rank: '', total: '' }, school: { rank: '', total: '' } }, details: {}, branchSubject: 'mat', duration: '', wrongTopics: [] });
  };

  let visibleExams = student.exams;
  if (filterType !== 'ALL') { visibleExams = visibleExams.filter(e => e.type === filterType); if (filterType === 'BRANS') visibleExams = visibleExams.filter(e => e.subject === branchFilter); }
  visibleExams = visibleExams.sort((a, b) => new Date(a.date) - new Date(b.date));

  const last10Exams = visibleExams.slice(-10);
  const chartData = last10Exams.map(e => ({ ...e, date: formatDate(e.date) }));

  const getSubjectHistory = (subjectKey) => chartData.map(e => ({ date: e.date, net: e.details[subjectKey]?.n || 0 }));

  const getAverageStats = () => {
    if (filterType === 'ALL' || filterType === 'BRANS' || last10Exams.length === 0) return null;
    const subjectKeys = [];
    if (EXAM_TYPES[filterType]) {
      EXAM_TYPES[filterType].groups.forEach(g => g.sections.forEach(s => subjectKeys.push(s)));
    }
    const avgTotal = last10Exams.reduce((a, b) => a + b.totalNet, 0) / last10Exams.length;
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 mb-6">
        <div className={`${colors.bgCard} p-4 rounded-xl border ${colors.border} text-center ${colors.shadow}`}><div className={`text-[10px] ${colors.textSec} uppercase font-bold mb-1`}>Analiz Edilen</div><div className={`text-xl font-bold ${colors.text}`}>{last10Exams.length} <span className="text-xs font-normal text-slate-500">/ {visibleExams.length}</span></div></div>
        <div className={`${colors.bgCard} p-4 rounded-xl border ${colors.border} text-center ${colors.shadow}`}><div className={`text-[10px] ${colors.textSec} uppercase font-bold mb-1`}>Son 10 Ort.</div><div className="text-xl font-bold text-orange-500">{avgTotal.toFixed(2)}</div></div>
        {subjectKeys.map(sub => { const avgSub = last10Exams.reduce((a, b) => a + (b.details[sub.key]?.n || 0), 0) / last10Exams.length; return (<div key={sub.key} className={`${colors.bgCard} p-4 rounded-xl border ${colors.border} text-center ${colors.shadow}`}><div className={`text-[10px] ${colors.textSec} uppercase font-bold mb-1 truncate`}>{sub.label} Ort.</div><div className="text-xl font-bold text-emerald-400">{avgSub.toFixed(2)}</div></div>) })}
      </div>
    );
  }

  const getTableHeaders = () => {
    if (filterType === 'ALL') return ['Tarih', 'Sınav', 'Tür', 'Net', 'Analiz', 'İşlem'];
    if (filterType === 'BRANS') return ['Tarih', 'Sınav', 'Ders', 'Süre', 'Net', 'Analiz', 'İşlem'];

    const subjects = [];
    if (EXAM_TYPES[filterType]) {
      EXAM_TYPES[filterType].groups.forEach(g => g.sections.forEach(s => subjects.push(s.label)));
    }
    return ['Tarih', 'Sınav', ...subjects, 'Toplam', 'Analiz', 'İşlem'];
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className={`flex flex-col lg:flex-row justify-between items-start lg:items-center ${colors.bgCardTransparent} p-4 rounded-xl border ${colors.border} gap-4`}>
        <div className={`flex flex-wrap gap-2 ${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} p-1 rounded-lg`}>{examTabs.map(type => (<button key={type} onClick={() => setFilterType(type)} className={`px-4 py-2 rounded-md text-sm font-bold transition-all ${filterType === type ? 'bg-orange-600 text-white shadow' : `${colors.textSec} hover:${colors.text}`}`}>{type}</button>))}</div>
        {filterType === 'BRANS' && (<select value={branchFilter} onChange={(e) => setBranchFilter(e.target.value)} className={`${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm rounded-lg p-2.5 outline-none`}>{BRANCH_SUBJECTS.map(sub => <option key={sub.id} value={sub.id}>{sub.label}</option>)}</select>)}
        <div className="flex gap-2 ml-auto"><Button size="small" variant={view === 'list' ? 'primary' : 'ghost'} onClick={() => { setView('list'); setEditingId(null); }}>Liste</Button>{(isAdmin || isStudent) && <Button size="small" variant={view === 'add' ? 'primary' : 'ghost'} icon={Plus} onClick={handleAddNew}>Ekle</Button>}</div>
      </div>

      {view === 'list' && (<>
        {getAverageStats()}

        <div className="space-y-6">
          <Card title={`${filterType} Net Gelişimi (Son 10)`}>
            <div className="h-72 w-full"><LineChart data={chartData} dataKey="totalNet" labelKey="date" subLabelKey="name" height={280} /></div>
          </Card>

          {filterType !== 'BRANS' && EXAM_TYPES[filterType] && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {EXAM_TYPES[filterType].groups.flatMap(g => g.sections).map(section => (
                <div key={section.key} className={`${colors.bgCardTransparent} p-4 rounded-lg border ${colors.border}`}>
                  <div className={`text-xs font-bold ${colors.textSec} mb-2`}>{section.label}</div>
                  <div className="h-40"><LineChart data={getSubjectHistory(section.key)} dataKey="net" labelKey="date" height={160} color="#3b82f6" maxValue={section.q} /></div>
                </div>
              ))}
            </div>
          )}
        </div>

        <Card title="Sınav Sonuçları (Tümü)">
          <div className="overflow-x-auto"><table className="w-full text-left text-sm whitespace-nowrap"><thead className={colors.tableHeader}><tr>{getTableHeaders().map((h, i) => <th key={i} className="p-3 font-bold text-xs uppercase">{h}</th>)}</tr></thead><tbody className={colors.divider}>
            {visibleExams.slice().reverse().map(exam => (
              <tr key={exam.id} className={colors.hoverBg}>
                <td className={`p-3 ${colors.textSec}`}>{formatDate(exam.date)}</td>
                <td className={`p-3 font-bold ${colors.text}`}>{exam.name}</td>
                {(filterType === 'ALL' || filterType === 'BRANS') ? (<><td className="p-3"><span className={`text-[10px] px-2 py-1 rounded bg-slate-700 text-slate-300`}>{exam.type === 'BRANS' ? exam.subject : exam.type}</span></td>{filterType === 'BRANS' && <td className="p-3 font-bold text-blue-400">{exam.duration ? `${exam.duration} dk` : '-'}</td>}</>) : (EXAM_TYPES[filterType]?.groups.flatMap(g => g.sections).map(sec => (<td key={sec.key} className="p-3 text-center">{exam.details[sec.key]?.n?.toFixed(2) || '-'}</td>)))}
                <td className="p-3 font-bold text-orange-500 text-lg">{exam.totalNet.toFixed(2)}</td>
                <td className="p-3"><button onClick={() => setShowWrongTopicsModal(exam)} className={`px-2 py-1 rounded text-xs border ${exam.wrongTopics?.length > 0 ? 'border-orange-500/50 text-orange-500 bg-orange-500/10' : `${colors.border} ${colors.textSec}`}`}>{exam.wrongTopics?.length || 0} Konu</button></td>
                <td className="p-3 flex gap-2 items-center">
                  <button onClick={() => setShowRankModal(exam)} className="text-blue-500 hover:bg-blue-500/10 p-2 rounded"><Activity size={16} /></button>
                  {/* YETKİ KONTROLÜ: Sadece admin/superadmin düzenleyebilir/silebilir */}
                  {(isAdmin || isStudent) && (
                    <>
                      <button onClick={() => handleEdit(exam)} className="text-slate-500 hover:text-orange-500 p-2"><Edit2 size={16} /></button>
                      {isAdmin && <button onClick={() => setDeleteConfirm(exam.id)} className="text-slate-500 hover:text-red-500 p-2"><Trash2 size={16} /></button>}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody></table></div>
        </Card>
      </>)}

      {view === 'add' && (
        <div className="max-w-5xl mx-auto animate-fade-in"><Card title={`Sınav Girişi (${examType})`}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Input label="Deneme Adı" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
            <Input label="Tarih" type="date" value={formData.date} onChange={e => setFormData({ ...formData, date: e.target.value })} />
            {examType === 'BRANS' && (
              <>
                <div><label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase`}>Branş</label><select className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg p-3 ${colors.text} text-sm`} value={formData.branchSubject} onChange={e => setFormData({ ...formData, branchSubject: e.target.value })}><option value="">Seçiniz</option>{BRANCH_SUBJECTS.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}</select></div>
                <Input label="Süre (Dk)" type="number" value={formData.duration} onChange={e => setFormData({ ...formData, duration: e.target.value })} />
              </>
            )}
            <div className="pt-6 md:col-span-3"><Button onClick={() => setShowTopicModal(true)} variant="secondary" className="w-full">Konu Analizi (Yanlış / Boş) ({formData.wrongTopics?.length})</Button></div>
          </div>

          <div className="space-y-6 mb-8">
            <h4 className={`text-orange-500 font-bold border-b ${colors.border} pb-2`}>Sonuçlar</h4>
            {examType === 'BRANS' ? (
              <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-5`}>
                <h5 className={`${colors.text} font-bold mb-4`}>{BRANCH_SUBJECTS.find(s => s.id === formData.branchSubject)?.label || 'Branş'} Sonuçları</h5>
                <div className="flex justify-between items-center">
                  <span className="text-sm">Doğru / Yanlış</span>
                  <div className="flex gap-2">
                    <input type="number" placeholder="D" className={`w-20 ${colors.inputBg} border rounded p-2 text-center`} value={formData.details[formData.branchSubject]?.d || ''} onChange={e => updateDetail(formData.branchSubject, 'd', e.target.value)} />
                    <input type="number" placeholder="Y" className={`w-20 ${colors.inputBg} border rounded p-2 text-center`} value={formData.details[formData.branchSubject]?.y || ''} onChange={e => updateDetail(formData.branchSubject, 'y', e.target.value)} />
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {EXAM_TYPES[examType] && EXAM_TYPES[examType].groups.map((group, idx) => (
                  <div key={idx} className={`${colors.bgCard} border ${colors.border} rounded-xl p-5`}>
                    <h5 className={`${colors.text} font-bold mb-4`}>{group.title}</h5>
                    <div className="space-y-3">
                      {group.sections.map(sec => (
                        <div key={sec.key} className="flex justify-between items-center">
                          <span className="text-sm">{sec.label}</span>
                          <div className="flex gap-2">
                            <input type="number" placeholder="D" className={`w-14 ${colors.inputBg} border rounded p-1 text-center`} value={formData.details[sec.key]?.d || ''} onChange={e => updateDetail(sec.key, 'd', e.target.value)} />
                            <input type="number" placeholder="Y" className={`w-14 ${colors.inputBg} border rounded p-1 text-center`} value={formData.details[sec.key]?.y || ''} onChange={e => updateDetail(sec.key, 'y', e.target.value)} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {examType !== 'BRANS' && (<div className={`mb-8 ${colors.bgCardTransparent} rounded-xl border ${colors.border} p-4`}><h4 className={`${colors.textSec} text-sm font-bold mb-4 flex items-center gap-2`}><Activity size={16} /> Sıralama Bilgileri (İsteğe Bağlı)</h4><div className="grid grid-cols-1 md:grid-cols-3 gap-6">{['turkey', 'city', 'school'].map(scope => (<div key={scope} className={`${colors.bgCard} p-4 rounded-lg border ${colors.border} ${colors.shadow}`}><label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase`}>{scope === 'turkey' ? 'Türkiye' : scope === 'city' ? 'İl Geneli' : 'Kurum'}</label><div className="flex gap-2"><input placeholder="Sıralama" type="number" className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 text-sm ${colors.text}`} value={formData.stats[scope].rank} onChange={e => updateStat(scope, 'rank', e.target.value)} /><input placeholder="Katılım" type="number" className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded p-2 text-sm ${colors.text}`} value={formData.stats[scope].total} onChange={e => updateStat(scope, 'total', e.target.value)} /></div></div>))}</div></div>)}
          <div className="flex justify-end gap-4"><Button variant="secondary" onClick={() => { setView('list'); setEditingId(null); }}>İptal</Button><Button onClick={handleSave} size="large">Kaydet</Button></div></Card>
        </div>
      )}

      {showTopicModal && (<Modal title="Analiz: Yanlış & Boş Konular" onClose={() => setShowTopicModal(false)}><div className="space-y-4">
        {/* YANLIŞ / BOŞ SEÇİMİ */}
        <div className="flex bg-slate-800 p-1 rounded-lg">
          <button onClick={() => setTopicSelection(prev => ({ ...prev, type: 'wrong' }))} className={`flex-1 py-2 rounded-md text-sm font-bold transition-all flex items-center justify-center gap-2 ${topicSelection.type === 'wrong' ? 'bg-red-500 text-white' : 'text-slate-400 hover:text-white'}`}>
            <X size={16} /> Yanlış Soru
          </button>
          <button onClick={() => setTopicSelection(prev => ({ ...prev, type: 'empty' }))} className={`flex-1 py-2 rounded-md text-sm font-bold transition-all flex items-center justify-center gap-2 ${topicSelection.type === 'empty' ? 'bg-amber-500 text-white' : 'text-slate-400 hover:text-white'}`}>
            <Activity size={16} /> Boş Bırakılan
          </button>
        </div>

        <div className="grid grid-cols-3 gap-2"><select className={`col-span-3 ${colors.inputBg} border ${colors.inputBorder} p-2 rounded text-sm ${colors.text}`} value={topicSelection.course} onChange={e => setTopicSelection({ ...topicSelection, course: e.target.value, unit: '', topic: '' })}><option value="">Ders Seçiniz</option>{activeCurriculum.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}</select>{topicSelection.course && <select className={`col-span-3 ${colors.inputBg} border ${colors.inputBorder} p-2 rounded text-sm ${colors.text}`} value={topicSelection.unit} onChange={e => setTopicSelection({ ...topicSelection, unit: e.target.value, topic: '' })}><option value="">Ünite Seçiniz</option>{activeCurriculum.find(c => c.id === topicSelection.course)?.units.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}</select>}{topicSelection.unit && <select className={`col-span-3 ${colors.inputBg} border ${colors.inputBorder} p-2 rounded text-sm ${colors.text}`} value={topicSelection.topic} onChange={e => setTopicSelection({ ...topicSelection, topic: e.target.value })}><option value="">Konu Seçiniz</option>{activeCurriculum.find(c => c.id === topicSelection.course)?.units.find(u => u.id === topicSelection.unit)?.topics.map(t => <option key={t} value={t}>{t}</option>)}</select>}
          {topicSelection.topic && (
            <div className="col-span-3 grid grid-cols-3 gap-2">
              <input type="number" placeholder="Soru No" className={`w-full ${colors.inputBg} border ${colors.inputBorder} p-2 rounded text-sm ${colors.text}`} value={topicSelection.qNo} onChange={e => setTopicSelection({ ...topicSelection, qNo: e.target.value })} />
              <select className={`w-full ${colors.inputBg} border ${colors.inputBorder} p-2 rounded text-sm ${colors.text}`} value={topicSelection.reason} onChange={e => setTopicSelection({ ...topicSelection, reason: e.target.value })}>
                {['Bilgi Eksiği', 'Soru Kalıbı Eksiği', 'Zaman Yetersizliği', 'Dikkat Hatası', 'Diğer'].map(r => <option key={r} value={r}>{r}</option>)}
              </select>
              <Button onClick={handleAddTopicAnalysis} className={topicSelection.type === 'empty' ? 'bg-amber-600 hover:bg-amber-700' : 'bg-red-600 hover:bg-red-700'}>Ekle</Button>
            </div>
          )}</div>
        <div className="border-t border-slate-700 pt-4">
          <h4 className="text-xs font-bold text-slate-500 mb-3 uppercase">Eklenen Konular</h4>
          <div className="space-y-3">
            {Object.values(formData.wrongTopics.reduce((acc, curr) => {
              const key = `${curr.course}-${curr.name}`;
              if (!acc[key]) acc[key] = { name: curr.name, course: curr.course, items: [] };
              acc[key].items.push(curr);
              return acc;
            }, {})).map((group, gIdx) => (
              <div key={gIdx} className={`p-3 rounded-xl border ${colors.border} ${colors.bgCard} ${colors.shadow}`}>
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <div className={`text-sm font-bold ${colors.text}`}>{group.name}</div>
                    <div className={`text-[10px] ${colors.textSec}`}>{group.course}</div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2">
                  {['wrong', 'empty'].map(type => {
                    const typeItems = group.items.filter(it => it.type === type).sort((a, b) => a.qNo - b.qNo);
                    if (typeItems.length === 0) return null;
                    return (
                      <div key={type} className={`flex flex-wrap items-center gap-1.5 p-2 rounded-lg ${type === 'wrong' ? 'bg-red-500/10' : 'bg-amber-500/10'} border ${type === 'wrong' ? 'border-red-500/20' : 'border-amber-500/20'}`}>
                        <span className={`text-[10px] font-bold uppercase ${type === 'wrong' ? 'text-red-500' : 'text-amber-500'}`}>{type === 'wrong' ? 'Yanlış' : 'Boş'}:</span>
                        {typeItems.map(it => (
                          <div key={it.id} className="group/badge relative">
                            <div className={`flex items-center gap-1.5 px-2 py-1 rounded-lg ${type === 'wrong' ? 'bg-red-600 text-white' : 'bg-amber-600 text-white'} text-[10px] font-bold shadow-sm`}>
                              <span>{it.qNo}</span>
                              <span className="opacity-50 font-normal">|</span>
                              <span className="max-w-[80px] truncate">{it.reason}</span>
                              <button onClick={() => removeTopicAnalysis(it.id)} className="ml-1 hover:text-black transition-colors"><X size={10} /></button>
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
            {formData.wrongTopics.length === 0 && <div className={`text-center py-6 ${colors.textSec} text-xs`}>Henüz veri eklenmedi.</div>}
          </div>
        </div>
        <Button onClick={() => setShowTopicModal(false)} className="w-full mt-2">Tamamla</Button></div></Modal>)}

      {showWrongTopicsModal && (<Modal title={`${showWrongTopicsModal.name} - Konu Analizi`} onClose={() => setShowWrongTopicsModal(null)}>
        <div className="space-y-3">
          {Object.values((showWrongTopicsModal.wrongTopics || []).reduce((acc, curr) => {
            const key = `${curr.course}-${curr.name}`;
            if (!acc[key]) acc[key] = { name: curr.name, course: curr.course, items: [] };
            acc[key].items.push(curr);
            return acc;
          }, {})).map((group, gIdx) => (
            <div key={gIdx} className={`p-4 rounded-xl border ${colors.border} ${colors.bgCard}`}>
              <div className="mb-3">
                <div className={`text-sm font-bold ${colors.text}`}>{group.name}</div>
                <div className={`text-[10px] ${colors.textSec}`}>{group.course}</div>
              </div>
              <div className="flex flex-wrap gap-2">
                {['wrong', 'empty'].map(type => {
                  const typeItems = group.items.filter(it => it.type === type).sort((a, b) => a.qNo - b.qNo);
                  if (typeItems.length === 0) return null;
                  return (
                    <div key={type} className={`flex flex-wrap items-center gap-2 p-2 rounded-lg ${type === 'wrong' ? 'bg-red-500/10' : 'bg-amber-500/10'} border ${type === 'wrong' ? 'border-red-500/20' : 'border-amber-500/20'}`}>
                      <span className={`text-[10px] font-bold uppercase ${type === 'wrong' ? 'text-red-500' : 'text-amber-500'}`}>{type === 'wrong' ? 'Yanlış' : 'Boş'}:</span>
                      <div className="flex flex-wrap gap-1.5">
                        {typeItems.map((it, i) => (
                          <div key={i} className={`flex items-center gap-1.5 px-2 py-1 rounded ${type === 'wrong' ? 'bg-red-600 text-white' : 'bg-amber-600 text-white'} text-[10px] font-bold`}>
                            <span>{it.qNo}</span>
                            <span className="opacity-50 font-normal">|</span>
                            <span>{it.reason}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          {(!showWrongTopicsModal.wrongTopics || showWrongTopicsModal.wrongTopics.length === 0) && <div className="text-center text-slate-500 py-6">Kayıtlı analiz verisi yok.</div>}
        </div></Modal>)}

      {showRankModal && (<Modal title={`${showRankModal.name} - Sıralama Sonuçları`} onClose={() => setShowRankModal(null)}><div className="space-y-4"><div className="grid grid-cols-1 gap-4">{['turkey', 'city', 'school'].map(scope => (<div key={scope} className={`${colors.bgCardTransparent} p-4 rounded border ${colors.border}`}><div className={`text-sm font-bold mb-1 ${scope === 'turkey' ? 'text-orange-500' : scope === 'city' ? 'text-blue-500' : 'text-emerald-500'}`}>{scope === 'turkey' ? 'Türkiye' : scope === 'city' ? 'İl' : 'Kurum'} Geneli</div><div className={`text-xl font-bold ${colors.text}`}>{showRankModal.stats?.[scope]?.rank || '-'} <span className="text-sm font-normal text-slate-500"> / {showRankModal.stats?.[scope]?.total || '-'}</span></div></div>))}</div></div></Modal>)}
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={() => confirmDelete()} />
    </div>
  );
};

// 5.5 GELİŞMİŞ DENEME ANALİZİ (YENİ MODÜL)
const ExamAnalysisModule = ({ student, user, curriculum }) => {
  const [filterCount, setFilterCount] = useState(10); // Son 10 deneme
  const [filterType, setFilterType] = useState('ALL'); // ALL, TYT, AYT, LGS, KPSS, BRANS
  const [branchFilter, setBranchFilter] = useState('ALL'); // ALL veya BRANCH_SUBJECTS id'si
  const colors = useThemeColors();

  const exams = (student.exams || []).sort((a, b) => new Date(b.date) - new Date(a.date));
  const filteredExams = exams
    .filter(e => {
      if (filterType === 'ALL') return true;
      if (filterType === 'BRANS') {
        if (e.type !== 'BRANS') return false;
        if (branchFilter !== 'ALL' && e.subject !== branchFilter) return false;
        return true;
      }
      return e.type === filterType;
    })
    .slice(0, filterCount);

  // Veri Toplama
  const topicStats = {}; // { topicKey: { name, course, wrong, empty, reasons: {}, qNos: [] } }
  const reasonStats = {}; // { reason: count }
  const qRangeStats = { '1-10': 0, '11-20': 0, '21-30': 0, '31-40': 0, '40+': 0 };

  filteredExams.forEach(exam => {
    if (exam.wrongTopics) {
      exam.wrongTopics.forEach(wt => {
        const key = `${wt.course}-${wt.name}`;
        if (!topicStats[key]) topicStats[key] = { name: wt.name, course: wt.course, wrong: 0, empty: 0, reasons: {}, qNos: [] };

        if (wt.type === 'wrong') topicStats[key].wrong++;
        else topicStats[key].empty++;

        if (wt.reason) {
          topicStats[key].reasons[wt.reason] = (topicStats[key].reasons[wt.reason] || 0) + 1;
          reasonStats[wt.reason] = (reasonStats[wt.reason] || 0) + 1;
        }

        if (wt.qNo) {
          const q = parseInt(wt.qNo);
          if (q <= 10) qRangeStats['1-10']++;
          else if (q <= 20) qRangeStats['11-20']++;
          else if (q <= 30) qRangeStats['21-30']++;
          else if (q <= 40) qRangeStats['31-40']++;
          else qRangeStats['40+']++;
        }
      });
    }
  });

  const sortedWrongTopics = Object.values(topicStats).sort((a, b) => b.wrong - a.wrong).filter(t => t.wrong > 0).slice(0, 10);
  const sortedEmptyTopics = Object.values(topicStats).sort((a, b) => b.empty - a.empty).filter(t => t.empty > 0).slice(0, 10);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className={`flex flex-col md:flex-row justify-between items-center ${colors.bgCardTransparent} p-4 rounded-xl border ${colors.border} gap-4`}>
        <div className="flex items-center gap-2">
          <h2 className={`text-xl font-bold ${colors.text}`}>Deneme Analiz Merkezi</h2>
          <span className={`text-xs px-2 py-1 rounded bg-orange-500/10 text-orange-500 font-bold border border-orange-500/20`}>{filteredExams.length} Deneme Analiz Ediliyor</span>
        </div>
        <div className="flex flex-wrap gap-2 items-center">
          <select
            value={filterType}
            onChange={e => {
              setFilterType(e.target.value);
              if (e.target.value !== 'BRANS') setBranchFilter('ALL');
            }}
            className={`${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm rounded-lg p-2 outline-none font-medium`}
          >
            <option value="ALL">Tüm Türler</option>
            <option value="TYT">TYT</option>
            <option value="AYT">AYT</option>
            <option value="LGS">LGS</option>
            <option value="KPSS">KPSS</option>
            <option value="BRANS">Branş Denemeleri</option>
          </select>

          {filterType === 'BRANS' && (
            <select
              value={branchFilter}
              onChange={e => setBranchFilter(e.target.value)}
              className={`${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm rounded-lg p-2 outline-none font-medium animate-fade-in`}
            >
              <option value="ALL">Tüm Branşlar</option>
              {BRANCH_SUBJECTS.map(s => (
                <option key={s.id} value={s.id}>{s.label}</option>
              ))}
            </select>
          )}

          <select value={filterCount} onChange={e => setFilterCount(parseInt(e.target.value))} className={`${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm rounded-lg p-2 outline-none`}>
            <option value={5}>Son 5 Deneme</option>
            <option value={10}>Son 10 Deneme</option>
            <option value={20}>Son 20 Deneme</option>
            <option value={999}>Tümü</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card title="Hata Nedenleri Dağılımı">
          <div className="space-y-4">
            {Object.entries(reasonStats).length > 0 ? Object.entries(reasonStats).sort((a, b) => b[1] - a[1]).map(([reason, count]) => (
              <div key={reason}>
                <div className="flex justify-between text-xs mb-1">
                  <span className={colors.text}>{reason}</span>
                  <span className="font-bold text-orange-500">{count} Adet</span>
                </div>
                <div className={`w-full ${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} h-2 rounded-full overflow-hidden`}>
                  <div className="bg-orange-500 h-full" style={{ width: `${(count / Object.values(reasonStats).reduce((a, b) => a + b, 0)) * 100}%` }}></div>
                </div>
              </div>
            )) : <div className={`text-center py-10 ${colors.textSec} text-xs italic`}>Veri bulunamadı.</div>}
          </div>
        </Card>

        <Card title="Soru Aralığı Analizi (Yanlış/Boş)">
          <div className="space-y-4">
            {Object.entries(qRangeStats).map(([range, count]) => (
              <div key={range}>
                <div className="flex justify-between text-xs mb-1">
                  <span className={colors.text}>{range}. Sorular</span>
                  <span className="font-bold text-blue-400">{count}</span>
                </div>
                <div className={`w-full ${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} h-2 rounded-full overflow-hidden`}>
                  <div className="bg-blue-400 h-full" style={{ width: `${(count / (Object.values(qRangeStats).reduce((a, b) => a + b, 0) || 1)) * 100}%` }}></div>
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card title="Genel Başarı Özeti">
          <div className="grid grid-cols-2 gap-4">
            <div className={`${colors.isDark ? 'bg-slate-800/50' : 'bg-slate-100'} p-4 rounded-xl text-center border ${colors.border}`}>
              <div className="text-[10px] uppercase font-bold text-red-500 mb-1">Top. Yanlış</div>
              <div className={`text-3xl font-bold ${colors.text}`}>{Object.values(topicStats).reduce((a, b) => a + b.wrong, 0)}</div>
            </div>
            <div className={`${colors.isDark ? 'bg-slate-800/50' : 'bg-slate-100'} p-4 rounded-xl text-center border ${colors.border}`}>
              <div className="text-[10px] uppercase font-bold text-amber-500 mb-1">Top. Boş</div>
              <div className={`text-3xl font-bold ${colors.text}`}>{Object.values(topicStats).reduce((a, b) => a + b.empty, 0)}</div>
            </div>
            <div className={`col-span-2 ${colors.isDark ? 'bg-emerald-500/10' : 'bg-emerald-500/5'} p-4 rounded-xl text-center border border-emerald-500/20`}>
              <div className="text-[10px] uppercase font-bold text-emerald-500 mb-1">Analiz Edilen Konu</div>
              <div className={`text-3xl font-bold ${colors.text}`}>{Object.keys(topicStats).length}</div>
            </div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="En Çok Yanlış Yapılan Konular" icon={TrendingDown}>
          <div className="space-y-3">
            {sortedWrongTopics.map((t, i) => (
              <div key={i} className={`p-3 rounded-lg border ${colors.border} ${colors.bgCardTransparent} flex justify-between items-center`}>
                <div>
                  <div className={`text-sm font-bold ${colors.text}`}>{t.name}</div>
                  <div className={`text-[10px] ${colors.textSec}`}>{t.course}</div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-right">
                    <div className="text-lg font-bold text-red-500">{t.wrong}</div>
                    <div className="text-[10px] text-slate-500">Yanlış</div>
                  </div>
                  <div className="w-10 h-10 rounded-full bg-red-500/10 flex items-center justify-center text-red-500">
                    <X size={18} />
                  </div>
                </div>
              </div>
            ))}
            {sortedWrongTopics.length === 0 && <div className="text-center py-10 text-slate-500">Henüz yanlış verisi yok.</div>}
          </div>
        </Card>

        <Card title="En Çok Boş Bırakılan Konular" icon={Activity}>
          <div className="space-y-3">
            {sortedEmptyTopics.map((t, i) => (
              <div key={i} className={`p-3 rounded-lg border ${colors.border} ${colors.bgCardTransparent} flex justify-between items-center`}>
                <div>
                  <div className={`text-sm font-bold ${colors.text}`}>{t.name}</div>
                  <div className={`text-[10px] ${colors.textSec}`}>{t.course}</div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-right">
                    <div className="text-lg font-bold text-amber-500">{t.empty}</div>
                    <div className="text-[10px] text-slate-500">Boş</div>
                  </div>
                  <div className="w-10 h-10 rounded-full bg-amber-500/10 flex items-center justify-center text-amber-500">
                    <Minus size={18} />
                  </div>
                </div>
              </div>
            ))}
            {sortedEmptyTopics.length === 0 && <div className="text-center py-10 text-slate-500">Henüz boş verisi yok.</div>}
          </div>
        </Card>
      </div>

      {/* Detaylı Ders Analizi */}
      <Card title="Detaylı Ders & Konu Analizi">
        <div className="space-y-8">
          {Object.entries(
            Object.values(topicStats).reduce((acc, curr) => {
              if (!acc[curr.course]) acc[curr.course] = [];
              acc[curr.course].push(curr);
              return acc;
            }, {})
          ).map(([course, topics]) => (
            <div key={course} className={`border ${colors.border} rounded-xl overflow-hidden`}>
              <div className={`p-4 ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} border-b ${colors.border} flex justify-between items-center`}>
                <h3 className={`font-bold ${colors.text}`}>{course}</h3>
                <div className="flex gap-4 text-xs font-bold uppercase">
                  <span className="text-red-500">Yanlış: {topics.reduce((a, b) => a + b.wrong, 0)}</span>
                  <span className="text-amber-500">Boş: {topics.reduce((a, b) => a + b.empty, 0)}</span>
                </div>
              </div>
              <div className="overflow-x-auto custom-scrollbar pb-2">
                <table className="w-full text-left text-sm min-w-[500px]">
                  <thead className={colors.tableHeader}>
                    <tr>
                      <th className="p-3 text-xs uppercase tracking-wider">Konu</th>
                      <th className="p-3 text-center text-xs uppercase tracking-wider w-24">Yanlış</th>
                      <th className="p-3 text-center text-xs uppercase tracking-wider w-24">Boş</th>
                      <th className="p-3 text-xs uppercase tracking-wider w-32">Hata Eğilimi</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${colors.divider}`}>
                    {topics.sort((a, b) => (b.wrong + b.empty) - (a.wrong + a.empty)).map((t, idx) => {
                      const topReason = Object.entries(t.reasons).sort((a, b) => b[1] - a[1])[0];
                      return (
                        <tr key={idx} className={`${colors.hoverBg} transition-colors`}>
                          <td className={`p-3 font-medium ${colors.text}`}>{t.name}</td>
                          <td className="p-3 text-center text-red-500 font-bold">{t.wrong}</td>
                          <td className="p-3 text-center text-amber-500 font-bold">{t.empty}</td>
                          <td className="p-3">
                            {topReason ? (
                              <span className={`text-[10px] px-2 py-1 rounded-lg ${colors.isDark ? 'bg-slate-800 text-slate-400' : 'bg-slate-100 text-slate-600'} inline-block`}>
                                {topReason[0]}
                              </span>
                            ) : <span className="text-slate-500">-</span>}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

// 6. DUYGUDURUM TAKİBİ (GÜNCELLENMİŞ: Son 10 Veri Grafiği)
const MoodModule = ({ student, onUpdateStudent, user }) => {
  const METRICS_CONFIG = [{ key: 'motivation', label: 'Motivasyon', color: '#3b82f6' }, { key: 'happiness', label: 'Mutluluk', color: '#10b981' }, { key: 'social', label: 'Sosyalleşme', color: '#f59e0b' }, { key: 'examAnxiety', label: 'Sınav Kaygısı', color: '#ef4444' }, { key: 'lessonAnxiety', label: 'Ders Kaygısı', color: '#8b5cf6' }, { key: 'performance', label: 'Performans', color: '#ec4899' }, { key: 'homeworkRate', label: 'Ödev Tamamlama', color: '#06b6d4' }];
  const [editingId, setEditingId] = useState(null); const [formData, setFormData] = useState({ date: new Date().toISOString().split('T')[0], metrics: { motivation: 50, happiness: 50, social: 50, examAnxiety: 50, lessonAnxiety: 50, performance: 50, homeworkRate: 50 } });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const colors = useThemeColors();
  if (user.role === 'student') return <div className={`${colors.text} text-center mt-20`}>Bu alana erişim yetkiniz yok.</div>;
  const handleSave = () => { let newMoods = [...student.moods]; if (editingId) { newMoods = newMoods.map(m => m.id === editingId ? { ...m, date: formData.date, metrics: formData.metrics } : m); } else { newMoods.push({ id: Date.now(), date: formData.date, metrics: formData.metrics }); logActivity(student.id, 'mood_entry', { date: formData.date }); } onUpdateStudent({ ...student, moods: newMoods }); setEditingId(null); setFormData({ ...formData, date: new Date().toISOString().split('T')[0] }); };
  const handleEdit = (mood) => { setEditingId(mood.id); setFormData({ date: mood.date, metrics: { ...mood.metrics } }); window.scrollTo(0, 0); };
  const requestDelete = (e, id) => { e.stopPropagation(); e.preventDefault(); setDeleteConfirm(id); };
  const confirmDelete = () => { if (deleteConfirm) { const filtered = student.moods.filter(m => m.id !== deleteConfirm); onUpdateStudent({ ...student, moods: filtered }); setDeleteConfirm(null); } };
  const sortedMoods = [...student.moods].sort((a, b) => new Date(a.date) - new Date(b.date));

  // SADECE SON 10 VERİ GRAFİKTE GÖRÜNÜR
  const flatData = sortedMoods.map(m => {
    const { examAnxiety, lessonAnxiety, ...positiveMetrics } = m.metrics;
    const values = Object.values(positiveMetrics);
    const average = values.reduce((a, b) => a + b, 0) / values.length;
    return { date: m.date.substring(5), ...m.metrics, average: average };
  }).slice(-10);

  return (
    <div className="space-y-8 animate-fade-in"><Card title={editingId ? "Duygudurum Düzenle" : "Yeni Duygudurum Girişi"} action={<div className="flex gap-4 items-center"><input type="date" value={formData.date} onChange={e => setFormData({ ...formData, date: e.target.value })} className={`${colors.inputBg} border ${colors.inputBorder} ${colors.text} p-2 rounded text-sm`} /><Button onClick={handleSave}>{editingId ? 'Güncelle' : 'Kaydet'}</Button></div>}><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">{METRICS_CONFIG.map(m => (<div key={m.key} className={`${colors.bgCardTransparent} p-4 rounded-lg border ${colors.border}`}><label className={`block text-sm ${colors.textSec} mb-2 font-medium`}>{m.label}</label><div className="flex items-center gap-3"><input type="range" min="0" max="100" value={formData.metrics[m.key]} onChange={e => setFormData({ ...formData, metrics: { ...formData.metrics, [m.key]: parseInt(e.target.value) } })} className={`w-full accent-orange-500 h-2 ${colors.isDark ? 'bg-slate-700' : 'bg-slate-200'} rounded-lg appearance-none cursor-pointer`} /><span className={`${colors.text} font-bold w-10 text-right`}>{formData.metrics[m.key]}%</span></div></div>))}</div></Card>
      <Card title="Kompozit Analiz (Son 10 Kayıt)"><div className="h-64"><LineChart data={flatData} dataKey="average" labelKey="date" color="#3b82f6" fixedRange={true} /></div></Card>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">{METRICS_CONFIG.map(metric => (<Card key={metric.key} title={metric.label} className="!p-4"><div className="h-40"><LineChart data={flatData} dataKey={metric.key} labelKey="date" color={metric.color} height={160} fixedRange={true} /></div></Card>))}</div><Card title="Geçmiş Kayıtlar (Tümü)"><div className="overflow-x-auto"><table className={`w-full text-left text-sm ${colors.textSec}`}><thead className={colors.tableHeader}><tr><th className="p-4">Tarih</th>{METRICS_CONFIG.map(m => <th key={m.key} className="p-4">{m.label}</th>)}<th className="p-4">İşlem</th></tr></thead><tbody className={colors.divider}>
        {student.moods.sort((a, b) => new Date(b.date) - new Date(a.date)).map(mood => (<tr key={mood.id} className={`border-b ${colors.border}`}><td className="p-4">{formatDate(mood.date)}</td>{METRICS_CONFIG.map(m => <td key={m.key} className="p-4 text-center">{mood.metrics[m.key]}</td>)}<td className="p-4 flex gap-2"><button onClick={() => handleEdit(mood)}><Edit2 size="14" className="text-blue-400" /></button><button onClick={(e) => requestDelete(e, mood.id)} className="hover:text-red-500"><Trash2 size="14" className="text-red-400" /></button></td></tr>))}</tbody></table></div></Card>
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};

// 7. GÖRÜŞMELER & NOTLAR
const InterviewModule = ({ student, onUpdateStudent, user }) => {
  const [showModal, setShowModal] = useState(false);
  const [newInterview, setNewInterview] = useState({ date: new Date().toISOString().split('T')[0], title: "", note: "" });
  const [editingInterviewId, setEditingInterviewId] = useState(null);

  const [showNoteModal, setShowNoteModal] = useState(false);
  const [newNote, setNewNote] = useState({ note: "" });
  const [editingNoteId, setEditingNoteId] = useState(null);

  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const colors = useThemeColors();

  // --- GÜVENLİ VERİ HAZIRLIĞI (BU KISIM HATAYI ÇÖZER) ---
  // Eğer student.interviews yoksa veya dizi değilse boş dizi [] kullan.
  // [...array] diyerek kopyasını alıyoruz ki orijinal veriyi bozmadan sıralayabilelim.
  const safeInterviews = Array.isArray(student?.interviews) ? [...student.interviews] : [];
  const safeNotes = Array.isArray(student?.teacherNotes) ? [...student.teacherNotes] : [];

  // --- GÖRÜŞME İŞLEMLERİ ---
  const handleAddInterview = () => {
    if (!newInterview.note) return;

    const currentInterviews = Array.isArray(student?.interviews) ? student.interviews : [];

    if (editingInterviewId) {
      // GÜNCELLEME
      const updatedInterviews = currentInterviews.map(i => i.id === editingInterviewId ? { ...i, ...newInterview } : i);
      onUpdateStudent({ ...student, interviews: updatedInterviews });
      setEditingInterviewId(null);
    } else {
      // EKLEME
      const interview = { id: Date.now(), ...newInterview };
      onUpdateStudent({ ...student, interviews: [interview, ...currentInterviews] });
    }
    setShowModal(false);
    setNewInterview({ date: new Date().toISOString().split('T')[0], title: "", note: "" });
  };

  const handleEditInterview = (interview) => {
    setNewInterview({ date: interview.date, title: interview.title, note: interview.note });
    setEditingInterviewId(interview.id);
    setShowModal(true);
  };

  const deleteInterview = (id) => {
    const currentInterviews = Array.isArray(student?.interviews) ? student.interviews : [];
    const filtered = currentInterviews.filter(i => i.id !== id);
    onUpdateStudent({ ...student, interviews: filtered });
  };

  // --- NOT İŞLEMLERİ ---
  const handleAddNote = () => {
    if (!newNote.note) return;

    const currentNotes = Array.isArray(student?.teacherNotes) ? student.teacherNotes : [];

    if (editingNoteId) {
      // GÜNCELLEME
      const updatedNotes = currentNotes.map(n => n.id === editingNoteId ? { ...n, text: newNote.note } : n);
      onUpdateStudent({ ...student, teacherNotes: updatedNotes });
      setEditingNoteId(null);
    } else {
      // EKLEME
      const noteEntry = { id: Date.now(), date: new Date().toLocaleDateString('tr-TR'), text: newNote.note };
      const updatedNotes = [noteEntry, ...currentNotes];
      onUpdateStudent({ ...student, teacherNotes: updatedNotes });
    }
    setShowNoteModal(false);
    setNewNote({ note: "" });
  };

  const handleEditNote = (note) => {
    setNewNote({ note: note.text });
    setEditingNoteId(note.id);
    setShowNoteModal(true);
  };

  const deleteNote = (id) => {
    const currentNotes = Array.isArray(student?.teacherNotes) ? student.teacherNotes : [];
    const filtered = currentNotes.filter(n => n.id !== id);
    onUpdateStudent({ ...student, teacherNotes: filtered });
  };

  const requestDelete = (e, type, id) => { e.stopPropagation(); e.preventDefault(); setDeleteConfirm({ type, id }); };
  const confirmDelete = () => { if (deleteConfirm) { if (deleteConfirm.type === 'interview') deleteInterview(deleteConfirm.id); if (deleteConfirm.type === 'note') deleteNote(deleteConfirm.id); setDeleteConfirm(null); } };

  if (user.role === 'student') return <div className={`${colors.text} text-center mt-20`}>Bu alana erişim yetkiniz yok.</div>;

  return (
    <div className="animate-fade-in space-y-8">
      {/* Görüşmeler Kısmı */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h2 className={`text-2xl font-bold ${colors.text}`}>Görüşme Kayıtları</h2>
          <Button onClick={() => { setEditingInterviewId(null); setNewInterview({ date: new Date().toISOString().split('T')[0], title: "", note: "" }); setShowModal(true); }} icon={Plus}>Yeni Görüşme</Button>
        </div>
        <div className="grid gap-4">
          {/* BURADA ARTIK safeInterviews KULLANIYORUZ, KESİN ÇÖZÜM */}
          {safeInterviews
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map(interview => (
              <div key={interview.id} className={`${colors.bgCard} border ${colors.border} rounded-xl p-6 relative group ${colors.shadow}`}>
                <div className="flex justify-between mb-2">
                  <h3 className={`font-bold ${colors.text}`}>{interview.title}</h3>
                  <div className="flex items-center gap-3">
                    <span className={`text-xs ${colors.textSec}`}>{formatDate(interview.date)}</span>
                    {/* DÜZENLEME BUTONU */}
                    <button onClick={() => handleEditInterview(interview)} className="text-slate-600 hover:text-blue-500 p-2"><Edit2 size={16} /></button>
                    <button onClick={(e) => requestDelete(e, 'interview', interview.id)} className="text-slate-600 hover:text-red-500 p-2"><Trash2 size={16} /></button>
                  </div>
                </div>
                <p className={`${colors.textSec} text-sm whitespace-pre-wrap`}>{interview.note}</p>
              </div>
            ))}
          {safeInterviews.length === 0 && <div className={`text-center ${colors.textSec} py-4 text-sm`}>Henüz görüşme kaydı yok.</div>}
        </div>
      </div>

      <div className={`border-t ${colors.border} my-6`}></div>

      {/* Öğrenci Notları Kısmı */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h2 className={`text-2xl font-bold ${colors.text} flex items-center gap-2`}><MessageSquare className="text-orange-500" /> Öğrenciye Notlar</h2>
          <Button onClick={() => { setEditingNoteId(null); setNewNote({ note: "" }); setShowNoteModal(true); }} variant="secondary" icon={Edit2}>Not Ekle</Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* BURADA ARTIK safeNotes KULLANIYORUZ */}
          {safeNotes
            .sort((a, b) => {
              const dateA = a.date.includes('.') ? new Date(a.date.split('.').reverse().join('-')) : new Date(a.date);
              const dateB = b.date.includes('.') ? new Date(b.date.split('.').reverse().join('-')) : new Date(b.date);
              return dateB - dateA;
            })
            .map(note => (
              <div key={note.id} className={`${colors.bgCardTransparent} border ${colors.border} rounded-lg p-4 relative`}>
                <div className="flex justify-between items-start mb-2">
                  <div className="text-xs text-orange-400 font-bold">{note.date}</div>
                  <div className="flex gap-1">
                    {/* DÜZENLEME BUTONU */}
                    <button onClick={() => handleEditNote(note)} className="text-slate-600 hover:text-blue-500 p-1"><Edit2 size={14} /></button>
                    <button onClick={(e) => requestDelete(e, 'note', note.id)} className="text-slate-600 hover:text-red-500 p-1"><Trash2 size={14} /></button>
                  </div>
                </div>
                <p className={`${colors.textSec} text-sm italic whitespace-pre-wrap`}>"{note.text}"</p>
              </div>
            ))}
          {safeNotes.length === 0 && <div className={`col-span-full text-center ${colors.textSec} py-4 text-sm`}>Öğrenci paneline düşecek bir not eklemediniz.</div>}
        </div>
      </div>

      {showModal && (
        <Modal title={editingInterviewId ? "Görüşme Düzenle" : "Yeni Görüşme"} onClose={() => setShowModal(false)}>
          <div className="space-y-4">
            <Input label="Tarih" type="date" value={newInterview.date} onChange={e => setNewInterview({ ...newInterview, date: e.target.value })} />
            <Input label="Başlık" value={newInterview.title} onChange={e => setNewInterview({ ...newInterview, title: e.target.value })} />
            <textarea className={`w-full ${colors.inputBg} border ${colors.inputBorder} p-3 rounded ${colors.text} h-32 focus:border-orange-500 outline-none`} value={newInterview.note} onChange={e => setNewInterview({ ...newInterview, note: e.target.value })} placeholder="Görüşme notları..." />
            <Button onClick={handleAddInterview}>{editingInterviewId ? "Güncelle" : "Kaydet"}</Button>
          </div>
        </Modal>
      )}

      {showNoteModal && (
        <Modal title={editingNoteId ? "Notu Düzenle" : "Öğrenci Paneline Not Ekle"} onClose={() => setShowNoteModal(false)}>
          <div className="space-y-4">
            <div className="bg-orange-500/10 p-3 rounded border border-orange-500/20 text-orange-400 text-xs">Buraya yazdığınız notlar öğrenci kendi paneline girdiğinde "Öğretmenden Notlar" bölümünde görünecektir.</div>
            <textarea className={`w-full ${colors.inputBg} border ${colors.inputBorder} p-3 rounded ${colors.text} h-32 focus:border-orange-500 outline-none`} value={newNote.note} onChange={e => setNewNote({ ...newNote, note: e.target.value })} placeholder="Öğrenciye iletmek istediğiniz not..." />
            <Button onClick={handleAddNote}>{editingNoteId ? "Güncelle" : "Notu Yayınla"}</Button>
          </div>
        </Modal>
      )}

      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};

// 7.5. KAYNAK ÖNERİ (LGS - YKS - KPSS | 1-5 Zorluk Seviyeleri | Kırtasiye Entegrasyonu)
const DEFAULT_STATIONERIES = [
  { id: 'stat-1', name: 'İşler Kitabevleri', phone: '0555 111 22 33', address: 'Merkez Şube - Üniversite Cad. No:14', note: 'Tüm YKS & LGS yayınları mevcut, koçluk indirimi var' },
  { id: 'stat-2', name: 'Akademi Kitap & Kırtasiye', phone: '0532 222 33 44', address: 'Atatürk Bulvarı No:42', note: 'KPSS & ÖABT modüler setleri tam kadro' },
  { id: 'stat-3', name: 'Merkez Kırtasiye', phone: '0544 333 44 55', address: 'Çarşı Meydanı İş Hanı Kat:1', note: 'LGS yeni nesil ve branş denemeleri bulunur' },
  { id: 'stat-4', name: 'Kültür Kitabevi', phone: '0505 444 55 66', address: 'Lise Caddesi No:8', note: 'Tüm branş soru bankaları ve fasiküller' }
];

const DEFAULT_RECOMMENDATIONS = [
  // --- LGS KAYNAKLARI ---
  {
    id: 'rec-lgs-1',
    category: 'LGS',
    subject: 'Matematik',
    title: 'Çanta Yayınları Alıştıran Defter & Soru Bankası',
    publisher: 'Çanta Yayınları',
    difficulty: 1,
    stationeryId: 'stat-3',
    stationeryName: 'Merkez Kırtasiye',
    type: 'Konu Kavrama',
    targetNet: '0 - 6 Net',
    note: 'Matematik temeli zayıf öğrenciler için adımsal kavrama sağlar. İlk aşamada özgüven kazandırmak için birebirdir.'
  },
  {
    id: 'rec-lgs-2',
    category: 'LGS',
    subject: 'Matematik',
    title: 'Koray Varol (KVA) Başlangıç Soru Bankası',
    publisher: 'KVA Yayınları',
    difficulty: 2,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Pekiştirme',
    targetNet: '6 - 10 Net',
    note: 'Temel düzeyden orta seviye yeni nesil sorulara yumuşak geçiş yaptırır. Konu pekiştirmede etkilidir.'
  },
  {
    id: 'rec-lgs-3',
    category: 'LGS',
    subject: 'Matematik',
    title: 'Hız Yayınları LGS Matematik Soru Bankası',
    publisher: 'Hız Yayınları',
    difficulty: 3,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Soru Bankası',
    targetNet: '10 - 14 Net',
    note: 'Tam MEB örnek soruları ve LGS standardında. Zaman yönetimi ve soru çözme hızını geliştirmek için idealdir.'
  },
  {
    id: 'rec-lgs-4',
    category: 'LGS',
    subject: 'Matematik',
    title: 'Mozaik Yayınları LGS Matematik Soru Bankası',
    publisher: 'Mozaik Yayınları',
    difficulty: 4,
    stationeryId: 'stat-3',
    stationeryName: 'Merkez Kırtasiye',
    type: 'Beceri Temelli',
    targetNet: '14 - 17 Net',
    note: 'Üst düzey mantık-muhakeme soruları içerir. Görsel ve tablo yorumlama becerisini ciddi oranda artırır.'
  },
  {
    id: 'rec-lgs-5',
    category: 'LGS',
    subject: 'Matematik',
    title: 'Fenomen Matematik (A ve B Serisi) / Okyanus Master',
    publisher: 'Fenomen / Okyanus',
    difficulty: 5,
    stationeryId: 'stat-4',
    stationeryName: 'Kültür Kitabevi',
    type: 'Derece / İleri',
    targetNet: '17 - 20 Net',
    note: 'Derece hedefleyen, netleri 15 üzeri olan öğrencilerin mutlaka çözmesi gereken, eleyici yeni nesil sorular.'
  },
  {
    id: 'rec-lgs-6',
    category: 'LGS',
    subject: 'Fen Bilimleri',
    title: 'Ankara Yayıncılık Güçlendiren Fen Bilimleri',
    publisher: 'Ankara Yayıncılık',
    difficulty: 2,
    stationeryId: 'stat-3',
    stationeryName: 'Merkez Kırtasiye',
    type: 'Soru Bankası',
    targetNet: '8 - 13 Net',
    note: 'Deney ve kavrama sorularını temelden alıp geliştirir. Fen kavram yanılgılarını önler.'
  },
  {
    id: 'rec-lgs-7',
    category: 'LGS',
    subject: 'Fen Bilimleri',
    title: 'Mozaik / Fenomen LGS Fen Bilimleri',
    publisher: 'Mozaik / Fenomen',
    difficulty: 4,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Beceri Temelli',
    targetNet: '15 - 20 Net',
    note: 'Uzun deney düzenekleri ve hipotez test etme sorularında LGS’nin en iyi kaynaklarından biridir.'
  },
  {
    id: 'rec-lgs-8',
    category: 'LGS',
    subject: 'Türkçe',
    title: 'Arı Yayınları Paragrafın Ritmi LGS',
    publisher: 'Arı Yayıncılık',
    difficulty: 2,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Paragraf',
    targetNet: 'Her Seviye',
    note: 'Paragraf çözme alışkanlığı kazandırmak ve okuma hızını artırmak için sezona başlarken önerilir.'
  },
  {
    id: 'rec-lgs-9',
    category: 'LGS',
    subject: 'Türkçe',
    title: 'Nitelik Süper LGS Türkçe Soru Bankası',
    publisher: 'Nitelik Yayınları',
    difficulty: 4,
    stationeryId: 'stat-4',
    stationeryName: 'Kültür Kitabevi',
    type: 'Mantık & Muhakeme',
    targetNet: '15 - 20 Net',
    note: 'Sözel mantık ve grafik okuma sorularında öğrencileri sınav zorluğunun bir tık üzerine çıkarır.'
  },

  // --- YKS KAYNAKLARI ---
  {
    id: 'rec-yks-1',
    category: 'YKS',
    subject: 'Matematik',
    title: 'Aktif Matematik / Antrenmanlarla Matematik 1',
    publisher: 'Aktif / Antrenman',
    difficulty: 1,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Temel Atma',
    targetNet: '0 - 5 Net',
    note: 'Dört işlem ve denklem kurma temeli zayıf öğrenciler için ilk reçete kaynağıdır.'
  },
  {
    id: 'rec-yks-2',
    category: 'YKS',
    subject: 'Matematik',
    title: 'Mikro Orijinal TYT Matematik / Birey A',
    publisher: 'Orijinal Yayınları',
    difficulty: 2,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Giriş-Gelişme',
    targetNet: '5 - 12 Net',
    note: 'Konuyu kavratan klasik sorularla başlayıp hafif yeni nesle geçirir. Temel kuvvetlendirme için ideal.'
  },
  {
    id: 'rec-yks-3',
    category: 'YKS',
    subject: 'Matematik',
    title: '345 TYT Matematik / Bilgi Sarmal TYT Matematik',
    publisher: 'ÜçDörtBeş / Bilgi Sarmal',
    difficulty: 3,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'ÖSYM Standart',
    targetNet: '12 - 22 Net',
    note: 'YKS hazırlığının omurgasıdır. Kolay, orta ve ÖSYM tipi sorular basamaklı şekilde yer alır. Her öğrenciye önerilir.'
  },
  {
    id: 'rec-yks-4',
    category: 'YKS',
    subject: 'Matematik',
    title: '3D TYT Matematik Soru Bankası',
    publisher: '3D Yayınları',
    difficulty: 4,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Zorlayıcı / Yeni Nesil',
    targetNet: '22 - 30 Net',
    note: 'Tümden Gelim testleri ve beceri temelli sorularıyla 20 net üzerine çıkmak isteyen öğrencilere birebirdir.'
  },
  {
    id: 'rec-yks-5',
    category: 'YKS',
    subject: 'Matematik',
    title: 'Orijinal TYT/AYT Matematik & Apotemi Fasikülleri',
    publisher: 'Orijinal / Apotemi',
    difficulty: 5,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Derece Seviyesi',
    targetNet: '30+ Net',
    note: 'İlk 10.000 hedefi olan ve marjinal soru tiplerini görmek isteyen öğrenciler için zirve kaynaktır.'
  },
  {
    id: 'rec-yks-6',
    category: 'YKS',
    subject: 'Geometri',
    title: 'Kenan Kara ile Geometri / Bilgi Sarmal Geometri',
    publisher: 'Bilgi Sarmal',
    difficulty: 3,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'Soru Bankası',
    targetNet: '3 - 7 Net',
    note: 'Görme yeteneğini ve temel kuralları oturtur. Video çözümleri ders gibi öğreticidir.'
  },
  {
    id: 'rec-yks-7',
    category: 'YKS',
    subject: 'Geometri',
    title: 'Orijinal Geometri Soru Bankası',
    publisher: 'Orijinal Yayınları',
    difficulty: 5,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'İleri Seviye',
    targetNet: '8 - 10 Net',
    note: 'Geometriden full çekmek isteyen öğrenciler için en zorlayıcı katlama ve döndürme sorularını içerir.'
  },
  {
    id: 'rec-yks-8',
    category: 'YKS',
    subject: 'Türkçe',
    title: 'Hız ve Renk Paragraf Soru Bankası',
    publisher: 'Hız ve Renk',
    difficulty: 2,
    stationeryId: 'stat-4',
    stationeryName: 'Kültür Kitabevi',
    type: 'Süre Taktikli',
    targetNet: 'Giriş / Hız',
    note: 'Süre tutarak çözülen renk testleri öğrenciye paragrafta kronometre disiplini kazandırır.'
  },
  {
    id: 'rec-yks-9',
    category: 'YKS',
    subject: 'Türkçe',
    title: 'Limit Kronometre / Paraf IQ Paragraf',
    publisher: 'Limit / Paraf',
    difficulty: 4,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Zor / Çeldiricili',
    targetNet: '30+ Net Hedefi',
    note: 'Felsefi metinler ve çift çeldiricili şıklarıyla sınavın en zor paragraf sorularına hazırlar.'
  },
  {
    id: 'rec-yks-10',
    category: 'YKS',
    subject: 'Fizik',
    title: '345 TYT-AYT Fizik / VIP Fizik Soru Bankası',
    publisher: 'ÜçDörtBeş',
    difficulty: 3,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'ÖSYM Tarzı',
    targetNet: 'Temel & Orta',
    note: 'Günlük hayat modellemeleri ve şekilli sorularıyla fiziği sevdiren standart kaynak.'
  },
  {
    id: 'rec-yks-11',
    category: 'YKS',
    subject: 'Fizik',
    title: 'Nihat Bilgin / Karaağaç AYT Fizik',
    publisher: 'Nihat Bilgin',
    difficulty: 5,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'İleri / Konsept',
    targetNet: '12 - 14 Net',
    note: 'Kavramsal derinliği en yüksek, mühendislik ve tıp hedefleyenlerin vazgeçilmez fizik kaynağı.'
  },
  {
    id: 'rec-yks-12',
    category: 'YKS',
    subject: 'Kimya',
    title: 'Aydın Yayınları AYT Kimya Soru Bankası',
    publisher: 'Aydın Yayınları',
    difficulty: 4,
    stationeryId: 'stat-1',
    stationeryName: 'İşler Kitabevleri',
    type: 'Efsane Kaynak',
    targetNet: '10 - 13 Net',
    note: 'Kimyada nokta atışı detayları ve tüm tepkime varyasyonlarını içeren en sağlam AYT Kimya kaynağıdır.'
  },

  // --- KPSS KAYNAKLARI ---
  {
    id: 'rec-kpss-1',
    category: 'KPSS',
    subject: 'Matematik',
    title: 'Benim Hocam Sıfırdan Matematik (İlyas Güneş)',
    publisher: 'Benim Hocam',
    difficulty: 1,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'Temel Atma',
    targetNet: '0 - 10 Net',
    note: 'Sözel çıkışlı veya matematikten uzun süre uzak kalmış KPSS adayları için adım adım temel atma.'
  },
  {
    id: 'rec-kpss-2',
    category: 'KPSS',
    subject: 'Matematik',
    title: 'Pegem Akademi Ezberbozan Matematik',
    publisher: 'Pegem Akademi',
    difficulty: 3,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'KPSS Standart',
    targetNet: '15 - 22 Net',
    note: 'Tam KPSS sınav zorluğu ve formatında. Sayısal mantık ve problem çözme stratejilerini tam oturtur.'
  },
  {
    id: 'rec-kpss-3',
    category: 'KPSS',
    subject: 'Tarih',
    title: 'Benim Hocam Video Ders Defteri & Soru Bankası (Ramazan Yetgin)',
    publisher: 'Benim Hocam',
    difficulty: 2,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'Konu & Soru',
    targetNet: 'Geniş Kapsam',
    note: 'Kodlamaları ve akılda kalıcı hikayeleştirmeleriyle KPSS tarihinin en popüler başlangıç ve kavrama seti.'
  },
  {
    id: 'rec-kpss-4',
    category: 'KPSS',
    subject: 'Tarih',
    title: 'Tarihin Pusulası / Pegem Ezberbozan Tarih',
    publisher: 'Doğru Tercih / Pegem',
    difficulty: 4,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'Detay & Öncüllü',
    targetNet: '22 - 27 Net',
    note: 'En ince ÖSYM dipnotlarını ve kronolojik detayları içerir. 25+ net hedefleyenlere önerilir.'
  },
  {
    id: 'rec-kpss-5',
    category: 'KPSS',
    subject: 'Coğrafya',
    title: 'Haritalarla Coğrafya & Soru Bankası (Bayram Meral)',
    publisher: 'Benim Hocam',
    difficulty: 2,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'Görsel / Harita',
    targetNet: '14 - 18 Net',
    note: 'Görsel hafıza destekli haritalar ile coğrafya lokasyonlarını ve ekonomik verileri eksiksiz öğretir.'
  },
  {
    id: 'rec-kpss-6',
    category: 'KPSS',
    subject: 'Vatandaşlık',
    title: 'Emrah Vahap Özkaraca Vatandaşlık Soru Bankası',
    publisher: 'Hocawebde',
    difficulty: 3,
    stationeryId: 'stat-2',
    stationeryName: 'Akademi Kitap & Kırtasiye',
    type: 'Güncel Mevzuat',
    targetNet: '7 - 9 Net',
    note: 'Anayasa ve idare hukuku terimlerini en sade dille anlatan, sınav formatına en yakın kaynak.'
  }
];

const DIFFICULTY_CONFIG = {
  1: { level: 1, label: '1. Seviye', title: 'Temel / Sıfır Temel', badge: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/30', barColor: 'bg-emerald-500' },
  2: { level: 2, label: '2. Seviye', title: 'Kolay - Orta / Pekiştirme', badge: 'bg-blue-500/15 text-blue-500 border-blue-500/30', barColor: 'bg-blue-500' },
  3: { level: 3, label: '3. Seviye', title: 'Orta / Sınav Ayarı', badge: 'bg-amber-500/15 text-amber-500 border-amber-500/30', barColor: 'bg-amber-500' },
  4: { level: 4, label: '4. Seviye', title: 'Orta - Zor / Beceri Temelli', badge: 'bg-orange-500/15 text-orange-500 border-orange-500/30', barColor: 'bg-orange-500' },
  5: { level: 5, label: '5. Seviye', title: 'İleri / Derece Hedefi', badge: 'bg-rose-500/15 text-rose-500 border-rose-500/30', barColor: 'bg-rose-500' }
};

const CATEGORY_DEFAULT_SUBJECTS = {
  LGS: ['Matematik', 'Fen Bilimleri', 'Türkçe', 'Paragraf & Anlam Bilgisi', 'T.C. İnkılap Tarihi', 'Din Kültürü', 'İngilizce'],
  YKS: ['Matematik', 'AYT Matematik', 'Geometri', 'Türkçe', 'Paragraf', 'AYT Edebiyat', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Felsefe'],
  KPSS: ['Matematik', 'Türkçe', 'Tarih', 'Coğrafya', 'Vatandaşlık', 'Eğitim Bilimleri']
};

const ResourceRecommendationModule = ({ student, onUpdateStudent, user, curriculum, students, admins, setAdmins }) => {
  const colors = useThemeColors();
  const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';

  // Gerçek öğretmen ID'si: Admin ise kendisi, Öğrenci ise atanmış öğretmeni
  const teacherId = isAdmin
    ? (user?.id || 'default_teacher')
    : (student?.teacherId || user?.teacherId || (admins && admins.length > 0 ? admins[0].id : 'default_teacher'));

  // İlgili öğretmenin admin dokümanı
  const teacherAdmin = admins?.find(a => String(a.id) === String(teacherId)) || (isAdmin ? admins?.find(a => String(a.id) === String(user?.id)) : null);

  // Eski genel demo verilerini localStorage'dan kalıcı olarak temizle
  useEffect(() => {
    try {
      localStorage.removeItem('kocum_recommendations_v1');
      localStorage.removeItem('kocum_stationeries_v1');
      localStorage.removeItem('kocum_category_subjects_v1');
    } catch (e) {}
  }, []);

  // Her öğretmene özel başlangıç verilerini getiren yardımcı fonksiyonlar
  const getInitialStationeries = (tId) => {
    try {
      const saved = localStorage.getItem(`kocum_stationeries_teacher_${tId}`);
      if (saved !== null) return JSON.parse(saved);
      if (teacherAdmin && Array.isArray(teacherAdmin.stationeries)) return teacherAdmin.stationeries;
      const isInit = localStorage.getItem(`kocum_recs_initialized_${tId}`);
      if (isInit === 'true' || teacherAdmin?.resourcesInitialized) return [];
      return DEFAULT_STATIONERIES;
    } catch (e) {
      return [];
    }
  };

  const getInitialRecommendations = (tId) => {
    try {
      const saved = localStorage.getItem(`kocum_recommendations_teacher_${tId}`);
      if (saved !== null) return JSON.parse(saved);
      if (teacherAdmin && Array.isArray(teacherAdmin.recommendations)) return teacherAdmin.recommendations;
      // Öğretmen daha önce listeyi başlattıysa veya sildiyse boş dizi dön, demo verileri geri getirme!
      const isInit = localStorage.getItem(`kocum_recs_initialized_${tId}`);
      if (isInit === 'true' || teacherAdmin?.resourcesInitialized) return [];
      // Yalnızca tamamen yeni ve hiç işlem yapılmamış bir hesap için demo veriler
      return DEFAULT_RECOMMENDATIONS;
    } catch (e) {
      return [];
    }
  };

  const getInitialSubjects = (tId) => {
    try {
      const saved = localStorage.getItem(`kocum_category_subjects_teacher_${tId}`);
      if (saved !== null) return JSON.parse(saved);
      if (teacherAdmin && teacherAdmin.subjects && typeof teacherAdmin.subjects === 'object') return teacherAdmin.subjects;
      return CATEGORY_DEFAULT_SUBJECTS;
    } catch (e) {
      return CATEGORY_DEFAULT_SUBJECTS;
    }
  };

  // Öğretmene Özel Kırtasiyeler
  const [stationeries, setStationeries] = useState(() => getInitialStationeries(teacherId));

  // Öğretmene Özel Kaynak Havuzu
  const [recommendations, setRecommendations] = useState(() => getInitialRecommendations(teacherId));

  // Öğretmene Özel Ders / Alan Listesi (LGS, YKS, KPSS)
  const [categorySubjects, setCategorySubjects] = useState(() => getInitialSubjects(teacherId));

  // Kullanıcı / Öğretmen değişirse state'leri yeni öğretmene göre güncelle
  useEffect(() => {
    setStationeries(getInitialStationeries(teacherId));
    setRecommendations(getInitialRecommendations(teacherId));
    setCategorySubjects(getInitialSubjects(teacherId));
  }, [teacherId]);

  // Filtreler & Sekmeler
  const [activeCategory, setActiveCategory] = useState('YKS'); // 'LGS' | 'YKS' | 'KPSS'
  const [viewMode, setViewMode] = useState('subject'); // 'subject' (Ders İstifi) | 'difficulty' (Zorluk İstifi) | 'list' (Tüm Liste)
  const [searchTerm, setSearchTerm] = useState('');
  const [filterSubject, setFilterSubject] = useState('');
  const [filterDifficulty, setFilterDifficulty] = useState('');
  const [filterStationery, setFilterStationery] = useState('');
  const [showGuide, setShowGuide] = useState(false);

  // Modallar
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [editingResource, setEditingResource] = useState(null);
  const [resourceForm, setResourceForm] = useState({
    category: 'YKS',
    subject: 'Matematik',
    title: '',
    publisher: '',
    difficulty: 3,
    stationeryId: '',
    type: 'Soru Bankası',
    targetNet: '',
    note: ''
  });

  const [showStationeryModal, setShowStationeryModal] = useState(false);
  const [stationeryForm, setStationeryForm] = useState({ name: '', phone: '', address: '', note: '' });
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  // Ders / Alan Yönetimi Durumları
  const [showSubjectModal, setShowSubjectModal] = useState(false);
  const [newSubjectInput, setNewSubjectInput] = useState('');
  const [editingSubjectName, setEditingSubjectName] = useState(null);
  const [editedSubjectValue, setEditedSubjectValue] = useState('');
  const [editingSubjectFromCard, setEditingSubjectFromCard] = useState(null);

  // Varsayılan hazır demo verileri isteğe bağlı geri yükleme fonksiyonu
  const handleRestoreDemoDefaults = () => {
    if (window.confirm("Tüm öneriler ve kırtasiyeler varsayılan demo verilerle değiştirilecektir. Onaylıyor musunuz?")) {
      saveAllData(DEFAULT_RECOMMENDATIONS, DEFAULT_STATIONERIES, CATEGORY_DEFAULT_SUBJECTS);
    }
  };

  // Yerel depolamaya ve Firestore'a öğretmene özel kaydetme
  const saveAllData = async (newRecs, newStats, newSubjects) => {
    try {
      const recsToSave = (newRecs !== undefined && newRecs !== null) ? newRecs : recommendations;
      const statsToSave = (newStats !== undefined && newStats !== null) ? newStats : stationeries;
      const subjectsToSave = (newSubjects !== undefined && newSubjects !== null) ? newSubjects : categorySubjects;

      if (newRecs !== undefined && newRecs !== null) {
        setRecommendations(newRecs);
        try {
          localStorage.setItem(`kocum_recommendations_teacher_${teacherId}`, JSON.stringify(newRecs));
          localStorage.setItem(`kocum_recs_initialized_${teacherId}`, 'true');
        } catch (e) {}
      }
      if (newStats !== undefined && newStats !== null) {
        setStationeries(newStats);
        try {
          localStorage.setItem(`kocum_stationeries_teacher_${teacherId}`, JSON.stringify(newStats));
          localStorage.setItem(`kocum_recs_initialized_${teacherId}`, 'true');
        } catch (e) {}
      }
      if (newSubjects !== undefined && newSubjects !== null) {
        setCategorySubjects(newSubjects);
        try {
          localStorage.setItem(`kocum_category_subjects_teacher_${teacherId}`, JSON.stringify(newSubjects));
        } catch (e) {}
      }

      // Firestore'da admins koleksiyonuna kaydet (güvenli, izinli ve anında senkronize)
      if (isFirebaseActive && teacherId && isAdmin) {
        const updatePayload = {
          recommendations: recsToSave,
          stationeries: statsToSave,
          subjects: subjectsToSave,
          resourcesInitialized: true,
          updatedAt: new Date().toISOString()
        };

        try {
          await setDoc(doc(db, "admins", String(teacherId)), updatePayload, { merge: true });
        } catch (err) {
          console.error("Admins koleksiyonuna kaynak kaydetme hatası:", err);
        }

        if (setAdmins) {
          setAdmins(prev => prev.map(a => String(a.id) === String(teacherId) ? { ...a, ...updatePayload } : a));
        }
      }
    } catch (e) {
      console.error("Kaynak önerileri kaydetme hatası:", e);
    }
  };

  // Admin / Öğretmen dokümanı güncellendiğinde senkronize et
  useEffect(() => {
    if (!teacherAdmin) return;
    if (Array.isArray(teacherAdmin.recommendations)) {
      setRecommendations(teacherAdmin.recommendations);
      try {
        localStorage.setItem(`kocum_recommendations_teacher_${teacherId}`, JSON.stringify(teacherAdmin.recommendations));
        localStorage.setItem(`kocum_recs_initialized_${teacherId}`, 'true');
      } catch (e) {}
    }
    if (Array.isArray(teacherAdmin.stationeries)) {
      setStationeries(teacherAdmin.stationeries);
      try {
        localStorage.setItem(`kocum_stationeries_teacher_${teacherId}`, JSON.stringify(teacherAdmin.stationeries));
      } catch (e) {}
    }
    if (teacherAdmin.subjects && typeof teacherAdmin.subjects === 'object') {
      setCategorySubjects(teacherAdmin.subjects);
      try {
        localStorage.setItem(`kocum_category_subjects_teacher_${teacherId}`, JSON.stringify(teacherAdmin.subjects));
      } catch (e) {}
    }
  }, [teacherAdmin?.updatedAt, teacherAdmin?.recommendations, teacherAdmin?.stationeries, teacherAdmin?.subjects, teacherId]);

  // Aktif kategoriye göre kaynaklar ve ders listesi
  const categoryRecommendations = recommendations.filter(r => r.category === activeCategory);

  const currentCategorySubjects = categorySubjects[activeCategory] || CATEGORY_DEFAULT_SUBJECTS[activeCategory] || [];
  const availableSubjects = Array.from(new Set([
    ...currentCategorySubjects,
    ...categoryRecommendations.map(r => r.subject).filter(Boolean)
  ]));

  const filteredRecommendations = categoryRecommendations.filter(r => {
    if (filterSubject && r.subject !== filterSubject) return false;
    if (filterDifficulty && String(r.difficulty) !== String(filterDifficulty)) return false;
    if (filterStationery && r.stationeryId !== filterStationery) return false;
    if (searchTerm) {
      const q = searchTerm.toLowerCase();
      const matchTitle = (r.title || '').toLowerCase().includes(q);
      const matchPublisher = (r.publisher || '').toLowerCase().includes(q);
      const matchSubject = (r.subject || '').toLowerCase().includes(q);
      const matchNote = (r.note || '').toLowerCase().includes(q);
      const matchStat = (r.stationeryName || '').toLowerCase().includes(q);
      if (!matchTitle && !matchPublisher && !matchSubject && !matchNote && !matchStat) return false;
    }
    return true;
  });

  // --- DERS / ALAN YÖNETİM FONKSİYONLARI ---
  const handleAddSubject = (customName) => {
    const name = (customName || newSubjectInput || '').trim();
    if (!name) return alert("Lütfen ders / alan adını giriniz.");
    const currentList = categorySubjects[activeCategory] || CATEGORY_DEFAULT_SUBJECTS[activeCategory] || [];
    if (currentList.some(s => s.toLowerCase() === name.toLowerCase())) {
      return alert(`"${name}" dersi ${activeCategory} alanında zaten mevcut.`);
    }
    const updatedList = [...currentList, name];
    const newSubjects = { ...categorySubjects, [activeCategory]: updatedList };
    saveAllData(null, null, newSubjects);
    setNewSubjectInput('');
  };

  const handleRenameSubject = (oldName, newName) => {
    const trimmed = (newName || '').trim();
    if (!trimmed) return alert("Ders adı boş olamaz.");
    if (trimmed === oldName) {
      setEditingSubjectName(null);
      setEditingSubjectFromCard(null);
      return;
    }
    const currentList = categorySubjects[activeCategory] || CATEGORY_DEFAULT_SUBJECTS[activeCategory] || [];
    if (currentList.some(s => s.toLowerCase() === trimmed.toLowerCase() && s.toLowerCase() !== oldName.toLowerCase())) {
      return alert(`"${trimmed}" isimli bir ders zaten mevcut.`);
    }

    const updatedList = currentList.map(s => s === oldName ? trimmed : s);
    const newSubjects = { ...categorySubjects, [activeCategory]: updatedList };

    // Bu kategorideki bu derse ait tüm kaynakların ders adını da otomatik güncelle
    const updatedRecs = recommendations.map(r => {
      if (r.category === activeCategory && r.subject === oldName) {
        return { ...r, subject: trimmed };
      }
      return r;
    });

    if (filterSubject === oldName) setFilterSubject(trimmed);

    saveAllData(updatedRecs, null, newSubjects);
    setEditingSubjectName(null);
    setEditingSubjectFromCard(null);
  };

  const handleDeleteSubject = (subjToDelete) => {
    const currentList = categorySubjects[activeCategory] || CATEGORY_DEFAULT_SUBJECTS[activeCategory] || [];
    const assignedBooks = recommendations.filter(r => r.category === activeCategory && r.subject === subjToDelete);

    if (assignedBooks.length > 0) {
      const confirmed = window.confirm(
        `"${subjToDelete}" dersine ait ${assignedBooks.length} adet kaynak kayıtlı.\n\nDersi sildiğinizde bu kaynaklar "Diğer / Genel" dersine taşınacaktır. Silmek istiyor musunuz?`
      );
      if (!confirmed) return;

      const fallbackName = 'Diğer';
      let updatedList = currentList.filter(s => s !== subjToDelete);
      if (!updatedList.includes(fallbackName)) updatedList.push(fallbackName);

      const updatedRecs = recommendations.map(r => {
        if (r.category === activeCategory && r.subject === subjToDelete) {
          return { ...r, subject: fallbackName };
        }
        return r;
      });

      const newSubjects = { ...categorySubjects, [activeCategory]: updatedList };
      if (filterSubject === subjToDelete) setFilterSubject('');
      saveAllData(updatedRecs, null, newSubjects);
    } else {
      if (!window.confirm(`"${subjToDelete}" dersini ${activeCategory} alanından silmek istediğinize emin misiniz?`)) return;
      const updatedList = currentList.filter(s => s !== subjToDelete);
      const newSubjects = { ...categorySubjects, [activeCategory]: updatedList };
      if (filterSubject === subjToDelete) setFilterSubject('');
      saveAllData(null, null, newSubjects);
    }
  };

  // --- KAYNAK EKLE / DÜZENLE / SİL ---
  const handleOpenAddResource = (presetSubject = '', presetDifficulty = 3) => {
    setEditingResource(null);
    setResourceForm({
      category: activeCategory,
      subject: presetSubject || availableSubjects[0] || 'Matematik',
      title: '',
      publisher: '',
      difficulty: presetDifficulty || 3,
      stationeryId: stationeries[0]?.id || '',
      type: 'Soru Bankası',
      targetNet: '',
      note: ''
    });
    setShowResourceModal(true);
  };

  const handleOpenEditResource = (item) => {
    setEditingResource(item);
    setResourceForm({
      category: item.category,
      subject: item.subject,
      title: item.title,
      publisher: item.publisher || '',
      difficulty: item.difficulty || 3,
      stationeryId: item.stationeryId || '',
      type: item.type || 'Soru Bankası',
      targetNet: item.targetNet || '',
      note: item.note || ''
    });
    setShowResourceModal(true);
  };

  const handleSaveResource = () => {
    if (!resourceForm.title.trim()) return alert("Lütfen kaynak / kitap adını giriniz.");
    if (!resourceForm.subject.trim()) return alert("Lütfen ders / branş adını belirtiniz.");

    const matchedStationery = stationeries.find(s => s.id === resourceForm.stationeryId);
    const stationeryName = matchedStationery ? matchedStationery.name : '';

    // Eğer yeni yazılan ders kategorinin ders listesinde yoksa otomatik ekle
    let updatedSubjects = null;
    const currentList = categorySubjects[resourceForm.category] || CATEGORY_DEFAULT_SUBJECTS[resourceForm.category] || [];
    if (!currentList.some(s => s.toLowerCase() === resourceForm.subject.trim().toLowerCase())) {
      updatedSubjects = {
        ...categorySubjects,
        [resourceForm.category]: [...currentList, resourceForm.subject.trim()]
      };
    }

    if (editingResource) {
      const updated = recommendations.map(r => r.id === editingResource.id ? {
        ...r,
        ...resourceForm,
        subject: resourceForm.subject.trim(),
        stationeryName,
        updatedAt: new Date().toISOString()
      } : r);
      saveAllData(updated, null, updatedSubjects);
    } else {
      const newRec = {
        id: 'rec-' + Date.now(),
        ...resourceForm,
        subject: resourceForm.subject.trim(),
        stationeryName,
        createdAt: new Date().toISOString()
      };
      saveAllData([newRec, ...recommendations], null, updatedSubjects);
    }
    setShowResourceModal(false);
  };

  const handleConfirmDelete = () => {
    if (!deleteConfirm) return;
    if (deleteConfirm.type === 'resource') {
      const updated = recommendations.filter(r => r.id !== deleteConfirm.id);
      saveAllData(updated, null, null);
    } else if (deleteConfirm.type === 'stationery') {
      const updatedStats = stationeries.filter(s => s.id !== deleteConfirm.id);
      const updatedRecs = recommendations.map(r => r.stationeryId === deleteConfirm.id ? { ...r, stationeryId: '', stationeryName: '' } : r);
      saveAllData(updatedRecs, updatedStats, null);
    }
    setDeleteConfirm(null);
  };

  const handleSaveStationery = () => {
    if (!stationeryForm.name.trim()) return alert("Lütfen kırtasiye adını giriniz.");
    const newStat = {
      id: 'stat-' + Date.now(),
      name: stationeryForm.name.trim(),
      phone: stationeryForm.phone.trim(),
      address: stationeryForm.address.trim(),
      note: stationeryForm.note.trim()
    };
    const updatedStats = [...stationeries, newStat];
    saveAllData(null, updatedStats, null);
    setStationeryForm({ name: '', phone: '', address: '', note: '' });
  };

  // Yıldız / Seviye göstergesi
  const renderStars = (level) => {
    return (
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map(i => (
          <Star
            key={i}
            size={13}
            className={`${i <= level ? 'text-amber-400 fill-amber-400' : 'text-slate-600'}`}
          />
        ))}
      </div>
    );
  };

  // Tekil Kaynak Kartı Bileşeni
  const renderResourceCard = (item) => {
    const diffInfo = DIFFICULTY_CONFIG[item.difficulty] || DIFFICULTY_CONFIG[3];
    return (
      <div
        key={item.id}
        className={`p-4 rounded-xl border ${colors.border} ${colors.bgCard} ${colors.shadow} relative group hover:border-orange-500/50 transition-all flex flex-col justify-between`}
      >
        <div>
          {/* Üst Kısım: Zorluk Seviyesi ve Butonlar */}
          <div className="flex justify-between items-start gap-2 mb-2">
            <div className="flex items-center gap-2 flex-wrap">
              <span className={`px-2.5 py-1 rounded-lg text-xs font-bold border ${diffInfo.badge}`}>
                {diffInfo.label} • {diffInfo.title}
              </span>
              {renderStars(item.difficulty)}
            </div>

            {isAdmin && (
              <div className="flex items-center gap-1 opacity-80 group-hover:opacity-100 transition-opacity">
                <button
                  onClick={() => handleOpenEditResource(item)}
                  className="p-1.5 rounded-lg text-slate-400 hover:text-blue-400 hover:bg-blue-500/10 transition-colors"
                  title="Kaynağı Düzenle"
                >
                  <Edit2 size={14} />
                </button>
                <button
                  onClick={() => setDeleteConfirm({ type: 'resource', id: item.id, name: item.title })}
                  className="p-1.5 rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-500/10 transition-colors"
                  title="Kaynağı Sil"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            )}
          </div>

          {/* Başlık ve Yayın Evi */}
          <h4 className={`text-base font-bold ${colors.text} line-clamp-2 mt-1 leading-snug`}>
            {item.title}
          </h4>
          <div className="flex items-center gap-2 mt-1 flex-wrap">
            <span className="text-xs font-semibold text-orange-400 bg-orange-500/10 px-2 py-0.5 rounded">
              {item.subject}
            </span>
            {item.publisher && (
              <span className={`text-xs ${colors.textSec}`}>
                {item.publisher}
              </span>
            )}
            {item.type && (
              <span className={`text-[11px] ${colors.textSec} border ${colors.border} px-1.5 py-0.5 rounded`}>
                {item.type}
              </span>
            )}
          </div>

          {/* Not / Tavsiye */}
          {item.note && (
            <p className={`text-xs ${colors.textSec} mt-3 p-2.5 rounded-lg ${colors.isDark ? 'bg-slate-900/60' : 'bg-slate-50'} border ${colors.border} italic leading-relaxed`}>
              "{item.note}"
            </p>
          )}
        </div>

        {/* Alt Bilgiler: Kırtasiye & Hedef Net */}
        <div className={`mt-4 pt-3 border-t ${colors.border} flex items-center justify-between gap-2 flex-wrap text-xs`}>
          {item.stationeryName ? (
            <div
              className="flex items-center gap-1.5 text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 px-2.5 py-1 rounded-lg font-medium cursor-pointer hover:bg-emerald-500/20 transition-colors"
              onClick={() => setFilterStationery(item.stationeryId || '')}
              title={`Kırtasiye: ${item.stationeryName}`}
            >
              <Store size={13} />
              <span className="truncate max-w-[160px]">{item.stationeryName}</span>
            </div>
          ) : (
            <div className={`flex items-center gap-1 ${colors.textSec}`}>
              <Store size={13} />
              <span className="italic">Kırtasiye Belirtilmedi</span>
            </div>
          )}

          {item.targetNet && (
            <span className="text-[11px] font-bold text-blue-400 bg-blue-500/10 px-2 py-0.5 rounded">
              Hedef: {item.targetNet}
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6 animate-fade-in pb-12">
      {/* 1. ÜST BAŞLIK & ANA BUTONLAR */}
      <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-4 pb-2 border-b border-slate-700/20">
        <div>
          <div className="flex items-center gap-3">
            <div className="p-3 bg-gradient-to-br from-orange-500/20 to-amber-500/10 text-orange-500 rounded-2xl border border-orange-500/20 shadow-sm shrink-0">
              <Lightbulb size={24} />
            </div>
            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <h2 className={`text-2xl font-bold ${colors.text}`}>Kaynak Öneri Havuzu</h2>
                <span className="text-[11px] font-bold px-2.5 py-0.5 rounded-full bg-orange-500/15 text-orange-400 border border-orange-500/20">
                  {activeCategory}
                </span>
                <span className={`text-[11px] font-semibold px-2.5 py-0.5 rounded-full ${colors.isDark ? 'bg-slate-800/90 text-slate-300 border border-slate-700' : 'bg-slate-200 text-slate-700'}`}>
                  {user?.name ? `${user.name.split(' ')[0]} (Özel Havuz)` : 'Öğretmene Özel'}
                </span>
              </div>
              <p className={`text-xs sm:text-sm ${colors.textSec}`}>
                LGS, YKS ve KPSS için size özel 1-5 zorluk seviyeli kaynak istifi ve kırtasiye koordinasyonu
              </p>
            </div>
          </div>
        </div>

        {/* Aksiyon Grubu */}
        <div className="flex items-center gap-2.5 flex-wrap sm:flex-nowrap justify-between xl:justify-end w-full xl:w-auto">
          {/* Yardımcı Araçlar Toolbar */}
          <div className={`flex items-center p-1 rounded-xl ${colors.isDark ? 'bg-slate-900/90' : 'bg-slate-200/70'} border ${colors.border} gap-1 shadow-sm`}>
            <button
              onClick={() => setShowGuide(!showGuide)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all whitespace-nowrap ${
                showGuide
                  ? 'bg-orange-600 text-white shadow-sm'
                  : `${colors.textSec} hover:${colors.text} hover:${colors.hoverBg}`
              }`}
              title="Öğretmen Kılavuzu"
            >
              <Info size={14} />
              <span>{showGuide ? 'Kılavuzu Kapat' : 'Kılavuz'}</span>
            </button>

            {isAdmin && (
              <>
                <button
                  onClick={() => setShowSubjectModal(true)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold ${colors.textSec} hover:${colors.text} hover:${colors.hoverBg} transition-all whitespace-nowrap`}
                  title="Dersleri ve Alanları Yönet"
                >
                  <BookOpen size={14} />
                  <span>Dersler ({availableSubjects.length})</span>
                </button>

                <button
                  onClick={() => setShowStationeryModal(true)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold ${colors.textSec} hover:${colors.text} hover:${colors.hoverBg} transition-all whitespace-nowrap`}
                  title="Anlaşmalı Kırtasiyeleri Yönet"
                >
                  <Store size={14} />
                  <span>Kırtasiyeler ({stationeries.length})</span>
                </button>
              </>
            )}
          </div>

          {/* Ana Buton: Kaynak Ekle */}
          {isAdmin && (
            <button
              onClick={() => handleOpenAddResource()}
              className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs sm:text-sm font-bold bg-gradient-to-r from-orange-600 to-amber-600 hover:from-orange-500 hover:to-amber-500 text-white shadow-lg shadow-orange-500/25 transition-all active:scale-95 whitespace-nowrap shrink-0"
            >
              <Plus size={16} strokeWidth={2.5} />
              <span>Kaynak Ekle</span>
            </button>
          )}
        </div>
      </div>

      {/* 2. ÖĞRETMEN KILAVUZU / REHBER BÖLÜMÜ (AÇILIP KAPANABİLİR) */}
      {showGuide && (
        <Card className={`${colors.bgCard} border-2 border-orange-500/30 p-5 rounded-2xl animate-fade-in`}>
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <BookOpen className="text-orange-500" size={20} />
              <h3 className={`text-base font-bold ${colors.text}`}>Öğretmenler İçin Kaynak Seçim ve Seviyelendirme Kılavuzu</h3>
            </div>
            <button onClick={() => setShowGuide(false)} className={`p-1 ${colors.textSec} hover:${colors.text}`}>
              <X size={18} />
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-3 text-xs">
            <div className="p-3 rounded-xl bg-emerald-500/10 border border-emerald-500/20">
              <div className="font-bold text-emerald-500 text-sm mb-1">1. Seviye (Temel / Sıfır)</div>
              <p className={colors.textSec}>
                Konuyu ilk defa öğrenen, netleri sıfıra yakın veya işlem özgüveni zayıf öğrencilere verilir. Adım adım basamaklı sorularla korkuyu kırar.
              </p>
            </div>

            <div className="p-3 rounded-xl bg-blue-500/10 border border-blue-500/20">
              <div className="font-bold text-blue-500 text-sm mb-1">2. Seviye (Kolay-Orta)</div>
              <p className={colors.textSec}>
                Konu anlatımını dinleyen öğrencinin soru çözme hızını ve temel formül kullanımını pekiştirmesi için ideal ilk soru bankası seviyesidir.
              </p>
            </div>

            <div className="p-3 rounded-xl bg-amber-500/10 border border-amber-500/20">
              <div className="font-bold text-amber-500 text-sm mb-1">3. Seviye (Sınav Ayarı)</div>
              <p className={colors.textSec}>
                MEB ve ÖSYM’nin standart dağılımını yansıtır. Her öğrencinin kesinlikle bitirmesi gereken temel omurga kaynak grubudur.
              </p>
            </div>

            <div className="p-3 rounded-xl bg-orange-500/10 border border-orange-500/20">
              <div className="font-bold text-orange-500 text-sm mb-1">4. Seviye (Orta-Zor)</div>
              <p className={colors.textSec}>
                Çoklu kazanım, uzun paragraf veya grafik/deney yorumu gerektirir. Hedefi yüksek olan öğrencileri eleyici sorulara hazırlar.
              </p>
            </div>

            <div className="p-3 rounded-xl bg-rose-500/10 border border-rose-500/20">
              <div className="font-bold text-rose-500 text-sm mb-1">5. Seviye (İleri / Derece)</div>
              <p className={colors.textSec}>
                Türkiye derecesi veya ilk dilimleri hedefleyen, 4. seviyeyi rahat çözen öğrencilere verilir. Rutin dışı marjinal sorular içerir.
              </p>
            </div>
          </div>

          <div className={`mt-4 pt-3 border-t ${colors.border} flex items-center justify-between text-xs ${colors.textSec} flex-wrap gap-2`}>
            <span className="flex items-center gap-1">
              <Store size={14} className="text-orange-500" />
              <b>Kırtasiye İpucu:</b> Öğrenciye kitap önermeden önce anlaşmalı kırtasiyelerdeki stok ve güncel basım durumunu kontrol edebilirsiniz.
            </span>
            {isAdmin && (
              <button
                type="button"
                onClick={handleRestoreDemoDefaults}
                className="flex items-center gap-1 text-xs text-orange-400 hover:text-orange-300 transition-colors underline cursor-pointer"
                title="İhtiyaç halinde varsayılan demo kaynak paketini tekrar yükler"
              >
                <RotateCcw size={12} />
                <span>Varsayılan Demo Kaynakları Yükle</span>
              </button>
            )}
          </div>
        </Card>
      )}

      {/* 3. KATEGORİ SEÇİM SEKMELERİ (LGS - YKS - KPSS) */}
      <div className={`p-1.5 rounded-2xl ${colors.bgCard} border ${colors.border} flex items-center gap-2 overflow-x-auto custom-scrollbar`}>
        {[
          { id: 'LGS', label: 'LGS (8. Sınıf)', desc: 'Liselere Giriş Sınavı', count: recommendations.filter(r => r.category === 'LGS').length },
          { id: 'YKS', label: 'YKS (TYT - AYT)', desc: 'Yükseköğretim Kurumları', count: recommendations.filter(r => r.category === 'YKS').length },
          { id: 'KPSS', label: 'KPSS (GY-GK & ÖABT)', desc: 'Kamu Personeli Seçme', count: recommendations.filter(r => r.category === 'KPSS').length }
        ].map(cat => (
          <button
            key={cat.id}
            onClick={() => {
              setActiveCategory(cat.id);
              setFilterSubject('');
            }}
            className={`flex-1 min-w-[170px] px-5 py-3 rounded-xl transition-all flex items-center justify-between text-left ${
              activeCategory === cat.id
                ? 'bg-orange-600 text-white shadow-lg shadow-orange-600/30'
                : `${colors.textSec} hover:${colors.text} hover:${colors.bgMain}`
            }`}
          >
            <div>
              <div className="font-bold text-sm">{cat.label}</div>
              <div className={`text-[11px] ${activeCategory === cat.id ? 'text-white/80' : colors.textSec}`}>{cat.desc}</div>
            </div>
            <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${activeCategory === cat.id ? 'bg-white/20 text-white' : `${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} ${colors.text}`}`}>
              {cat.count}
            </span>
          </button>
        ))}
      </div>

      {/* 4. FİLTRE VE ARAMA ÇUBUĞU */}
      <div className={`p-4 rounded-xl ${colors.bgCard} border ${colors.border} space-y-3`}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {/* Arama Input */}
          <div className="relative">
            <Search className={`absolute left-3 top-3 ${colors.textSec}`} size={16} />
            <input
              type="text"
              placeholder="Kitap, ders, yayın veya not ara..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className={`w-full pl-9 pr-3 py-2 text-sm rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} outline-none focus:border-orange-500`}
            />
          </div>

          {/* Ders Filtresi */}
          <div>
            <select
              value={filterSubject}
              onChange={e => setFilterSubject(e.target.value)}
              className={`w-full p-2 text-sm rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} outline-none focus:border-orange-500`}
            >
              <option value="">Tüm Dersler / Alanlar</option>
              {availableSubjects.map(sub => (
                <option key={sub} value={sub}>{sub}</option>
              ))}
            </select>
          </div>

          {/* Zorluk Seviyesi Filtresi */}
          <div>
            <select
              value={filterDifficulty}
              onChange={e => setFilterDifficulty(e.target.value)}
              className={`w-full p-2 text-sm rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} outline-none focus:border-orange-500`}
            >
              <option value="">Tüm Zorluk Seviyeleri</option>
              <option value="1">1. Seviye - Temel / Sıfır</option>
              <option value="2">2. Seviye - Kolay-Orta</option>
              <option value="3">3. Seviye - Orta / Sınav</option>
              <option value="4">4. Seviye - Orta-Zor</option>
              <option value="5">5. Seviye - İleri / Derece</option>
            </select>
          </div>

          {/* Kırtasiye Filtresi */}
          <div>
            <select
              value={filterStationery}
              onChange={e => setFilterStationery(e.target.value)}
              className={`w-full p-2 text-sm rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} outline-none focus:border-orange-500`}
            >
              <option value="">Tüm Kırtasiyeler</option>
              {stationeries.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Görünüm Modu & Filtre Temizleme */}
        <div className="flex justify-between items-center flex-wrap gap-2 pt-2 border-t border-slate-700/30 text-xs">
          <div className="flex items-center gap-2 flex-wrap">
            <span className={`${colors.textSec} font-medium`}>İstif Düzeni:</span>
            <div className={`p-1 rounded-lg ${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} flex items-center gap-1`}>
              <button
                onClick={() => setViewMode('subject')}
                className={`px-3 py-1 rounded font-bold transition-colors ${viewMode === 'subject' ? 'bg-orange-600 text-white' : `${colors.textSec} hover:${colors.text}`}`}
              >
                Derslere Göre İstifle
              </button>
              <button
                onClick={() => setViewMode('difficulty')}
                className={`px-3 py-1 rounded font-bold transition-colors ${viewMode === 'difficulty' ? 'bg-orange-600 text-white' : `${colors.textSec} hover:${colors.text}`}`}
              >
                Zorluk Seviyesine Göre
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`px-3 py-1 rounded font-bold transition-colors ${viewMode === 'list' ? 'bg-orange-600 text-white' : `${colors.textSec} hover:${colors.text}`}`}
              >
                Kart Görünümü
              </button>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className={`font-bold ${colors.textSec}`}>
              {filteredRecommendations.length} Kaynak
            </span>
            {(searchTerm || filterSubject || filterDifficulty || filterStationery) && (
              <button
                onClick={() => {
                  setSearchTerm('');
                  setFilterSubject('');
                  setFilterDifficulty('');
                  setFilterStationery('');
                }}
                className="text-orange-400 hover:underline font-bold"
              >
                Filtreleri Temizle
              </button>
            )}
          </div>
        </div>
      </div>

      {/* 5. KAYNAK LİSTESİ / İSTİFLERİ */}
      {filteredRecommendations.length === 0 ? (
        <Card className={`${colors.bgCard} p-12 text-center border-dashed border-2 ${colors.border}`}>
          <div className="flex flex-col items-center justify-center space-y-3">
            <div className="p-3 bg-orange-500/10 text-orange-500 rounded-xl">
              <BookOpen size={32} />
            </div>
            <h4 className={`text-base font-bold ${colors.text}`}>Bu Kriterlere Uygun Kaynak Bulunamadı</h4>
            <p className={`text-xs ${colors.textSec} max-w-sm`}>
              Arama kriterlerinizi değiştirebilir veya sağ üstteki <b>"Kaynak Ekle"</b> butonundan yeni bir kitap ekleyebilirsiniz.
            </p>
            <Button size="small" icon={Plus} onClick={() => handleOpenAddResource()}>
              Yeni Kaynak Ekle
            </Button>
          </div>
        </Card>
      ) : viewMode === 'subject' ? (
        /* --- GÖRÜNÜM 1: DERSLERE GÖRE İSTİFLEME (KADEMELİ 1'DEN 5'E MERDİVEN) --- */
        <div className="space-y-6">
          {availableSubjects.map(subj => {
            const subjItems = filteredRecommendations
              .filter(r => r.subject === subj)
              .sort((a, b) => (a.difficulty || 0) - (b.difficulty || 0));

            // Eğer arama veya filtre yapılmışsa ve bu derste kaynak yoksa filtre modunda gizle
            if (filterSubject && subj !== filterSubject) return null;
            if (searchTerm && subjItems.length === 0) return null;

            return (
              <div key={subj} className={`p-5 rounded-2xl ${colors.bgCard} border ${colors.border} space-y-4`}>
                <div className="flex justify-between items-center border-b border-slate-700/30 pb-3 flex-wrap gap-2">
                  <div className="flex items-center gap-3">
                    <span className="w-2.5 h-6 bg-orange-500 rounded-full"></span>

                    {editingSubjectFromCard === subj ? (
                      <div className="flex items-center gap-1.5" onClick={e => e.stopPropagation()}>
                        <input
                          type="text"
                          autoFocus
                          value={editedSubjectValue}
                          onChange={e => setEditedSubjectValue(e.target.value)}
                          onKeyDown={e => {
                            if (e.key === 'Enter') handleRenameSubject(subj, editedSubjectValue);
                            if (e.key === 'Escape') setEditingSubjectFromCard(null);
                          }}
                          className={`px-2.5 py-1 text-base font-bold rounded-lg ${colors.inputBg} border-2 border-orange-500 ${colors.text} outline-none`}
                        />
                        <button
                          onClick={() => handleRenameSubject(subj, editedSubjectValue)}
                          className="p-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 transition-colors"
                          title="Kaydet"
                        >
                          <Check size={14} />
                        </button>
                        <button
                          onClick={() => setEditingSubjectFromCard(null)}
                          className="p-1.5 rounded-lg bg-slate-700 text-slate-300 hover:bg-slate-600 transition-colors"
                          title="İptal"
                        >
                          <X size={14} />
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 group/subj">
                        <h3 className={`text-lg font-bold ${colors.text}`}>{subj}</h3>
                        <button
                          onClick={() => {
                            setEditingSubjectFromCard(subj);
                            setEditedSubjectValue(subj);
                          }}
                          className="p-1 text-slate-400 hover:text-blue-400 transition-colors rounded hover:bg-blue-500/10"
                          title="Ders Adını Düzenle (Örn: AYT Matematik yap)"
                        >
                          <Edit2 size={13} />
                        </button>
                        <button
                          onClick={() => handleDeleteSubject(subj)}
                          className="p-1 text-slate-400 hover:text-red-500 transition-colors rounded hover:bg-red-500/10"
                          title="Bu Dersi Sil"
                        >
                          <Trash2 size={13} />
                        </button>
                      </div>
                    )}

                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${colors.isDark ? 'bg-slate-800 text-slate-300' : 'bg-slate-100 text-slate-700'}`}>
                      {subjItems.length} Kitap
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleOpenAddResource(subj)}
                      className="text-xs font-bold text-orange-500 hover:text-orange-400 flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-orange-500/10 hover:bg-orange-500/20 transition-colors"
                    >
                      <Plus size={14} /> Bu Derse Kaynak Ekle
                    </button>
                  </div>
                </div>

                {subjItems.length === 0 ? (
                  <div className={`p-6 text-center rounded-xl border border-dashed ${colors.border} text-xs ${colors.textSec}`}>
                    Bu alana henüz kaynak eklenmedi.
                    <button onClick={() => handleOpenAddResource(subj)} className="ml-2 text-orange-500 font-bold hover:underline">
                      İlk Kaynağı Ekle
                    </button>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {subjItems.map(item => renderResourceCard(item))}
                  </div>
                )}
              </div>
            );
          })}

          {/* Yeni Ders Ekleme Kutusu */}
          <div className={`p-4 rounded-2xl border-2 border-dashed ${colors.border} flex items-center justify-center hover:border-orange-500/50 transition-colors`}>
            <button
              onClick={() => setShowSubjectModal(true)}
              className="flex items-center gap-2 text-sm font-bold text-orange-500 hover:text-orange-400 py-2 transition-colors"
            >
              <Plus size={18} /> {activeCategory} Alanına Yeni Ders / Branş Ekle
            </button>
          </div>
        </div>
      ) : viewMode === 'difficulty' ? (
        /* --- GÖRÜNÜM 2: ZORLUK SEVİYELERİNE GÖRE İSTİFLEME (1'DEN 5'E SÜTUNLAR/BÖLÜMLER) --- */
        <div className="space-y-6">
          {[1, 2, 3, 4, 5].map(lvl => {
            const lvlConfig = DIFFICULTY_CONFIG[lvl];
            const lvlItems = filteredRecommendations.filter(r => Number(r.difficulty) === lvl);
            if (filterDifficulty && String(lvl) !== String(filterDifficulty)) return null;
            if (lvlItems.length === 0 && (searchTerm || filterSubject)) return null;

            return (
              <div key={lvl} className={`p-5 rounded-2xl ${colors.bgCard} border ${colors.border} space-y-4`}>
                <div className="flex justify-between items-center border-b border-slate-700/30 pb-3">
                  <div className="flex items-center gap-3">
                    <span className={`w-3 h-3 rounded-full ${lvlConfig.barColor}`}></span>
                    <h3 className={`text-base font-bold ${colors.text}`}>
                      {lvlConfig.label} — {lvlConfig.title}
                    </h3>
                    {renderStars(lvl)}
                    <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${lvlConfig.badge}`}>
                      {lvlItems.length} Kaynak
                    </span>
                  </div>

                  <button
                    onClick={() => handleOpenAddResource('', lvl)}
                    className="text-xs font-bold text-orange-500 hover:text-orange-400 flex items-center gap-1"
                  >
                    <Plus size={14} /> Bu Seviyeye Ekle
                  </button>
                </div>

                {lvlItems.length === 0 ? (
                  <div className={`p-6 text-center rounded-xl border border-dashed ${colors.border} text-xs ${colors.textSec}`}>
                    Bu seviyede henüz kaynak bulunmuyor.
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {lvlItems.map(item => renderResourceCard(item))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        /* --- GÖRÜNÜM 3: TÜM LİSTE GRID GÖRÜNÜMÜ --- */
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {filteredRecommendations.map(item => renderResourceCard(item))}
        </div>
      )}

      {/* 6. KAYNAK EKLE / DÜZENLE MODALI */}
      {showResourceModal && (
        <Modal
          title={editingResource ? "Kaynağı Düzenle" : `Yeni ${activeCategory} Kaynağı Ekle`}
          maxWidth="max-w-2xl"
          onClose={() => setShowResourceModal(false)}
          footer={
            <div className="flex items-center justify-end gap-3">
              <Button variant="secondary" onClick={() => setShowResourceModal(false)}>
                İptal
              </Button>
              <Button onClick={handleSaveResource} icon={Save}>
                {editingResource ? 'Değişiklikleri Kaydet' : 'Kaynağı Havuza Ekle'}
              </Button>
            </div>
          }
        >
          <div className="space-y-4">
            {/* Sınav Kategorisi & Ders / Branş */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className={`block text-xs font-bold ${colors.textSec} mb-1.5 uppercase`}>Sınav Kategorisi</label>
                <select
                  className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
                  value={resourceForm.category}
                  onChange={e => {
                    const newCat = e.target.value;
                    const defaultSubjs = categorySubjects[newCat] || CATEGORY_DEFAULT_SUBJECTS[newCat] || [];
                    setResourceForm({
                      ...resourceForm,
                      category: newCat,
                      subject: defaultSubjs[0] || 'Matematik'
                    });
                  }}
                >
                  <option value="LGS">LGS (8. Sınıf)</option>
                  <option value="YKS">YKS (TYT - AYT)</option>
                  <option value="KPSS">KPSS (Genel Yetenek / ÖABT)</option>
                </select>
              </div>

              <div>
                <div className="flex justify-between items-center mb-1.5">
                  <label className={`block text-xs font-bold ${colors.textSec} uppercase`}>Ders / Branş *</label>
                  <button
                    type="button"
                    onClick={() => {
                      const custom = prompt(`Yeni ${resourceForm.category} dersi adı giriniz:`);
                      if (custom && custom.trim()) {
                        handleAddSubject(custom.trim());
                        setResourceForm({ ...resourceForm, subject: custom.trim() });
                      }
                    }}
                    className="text-xs font-bold text-orange-500 hover:underline flex items-center gap-1"
                  >
                    <Plus size={12} /> Yeni Ders
                  </button>
                </div>
                <select
                  className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
                  value={resourceForm.subject}
                  onChange={e => setResourceForm({ ...resourceForm, subject: e.target.value })}
                >
                  {availableSubjects.map(s => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Kaynak Adı & Yayın Evi */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className={`block text-xs font-bold ${colors.textSec} mb-1.5 uppercase`}>Kaynak / Kitap Adı *</label>
                <input
                  type="text"
                  placeholder="Örn: 3D TYT Matematik Soru Bankası"
                  value={resourceForm.title}
                  onChange={e => setResourceForm({ ...resourceForm, title: e.target.value })}
                  className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
                />
              </div>

              <div>
                <label className={`block text-xs font-bold ${colors.textSec} mb-1.5 uppercase`}>Yayın Evi</label>
                <input
                  type="text"
                  placeholder="Örn: 3D Yayınları, Bilgi Sarmal..."
                  value={resourceForm.publisher}
                  onChange={e => setResourceForm({ ...resourceForm, publisher: e.target.value })}
                  className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
                />
              </div>
            </div>

            {/* Kaynak Türü & Bulunduğu Kırtasiye */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className={`block text-xs font-bold ${colors.textSec} mb-1.5 uppercase`}>Kaynak Türü</label>
                <select
                  className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
                  value={resourceForm.type}
                  onChange={e => setResourceForm({ ...resourceForm, type: e.target.value })}
                >
                  <option value="Soru Bankası">Soru Bankası</option>
                  <option value="Konu Kavrama">Konu Kavrama / Anlatımlı</option>
                  <option value="Beceri Temelli">Beceri Temelli / Yeni Nesil</option>
                  <option value="Fasikül">Fasikül Seti</option>
                  <option value="Branş Denemesi">Branş Denemesi</option>
                  <option value="Hızlı Tekrar">Hızlı Tekrar / Hap Bilgi</option>
                </select>
              </div>

              <div>
                <div className="flex justify-between items-center mb-1.5">
                  <label className={`block text-xs font-bold ${colors.textSec} uppercase`}>Bulunduğu Kırtasiye</label>
                  <button
                    type="button"
                    onClick={() => setShowStationeryModal(true)}
                    className="text-xs font-bold text-orange-500 hover:underline flex items-center gap-1"
                  >
                    <Plus size={12} /> Yeni Kırtasiye Ekle
                  </button>
                </div>
                <select
                  className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
                  value={resourceForm.stationeryId}
                  onChange={e => setResourceForm({ ...resourceForm, stationeryId: e.target.value })}
                >
                  <option value="">Kırtasiye Seçiniz (İsteğe Bağlı)</option>
                  {stationeries.map(s => (
                    <option key={s.id} value={s.id}>{s.name} {s.address ? `(${s.address})` : ''}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Zorluk Seviyesi Seçici (1 - 5) */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className={`block text-xs font-bold ${colors.textSec} uppercase`}>
                  Zorluk Seviyesi: <span className="text-orange-400 font-bold">{resourceForm.difficulty}. Seviye ({DIFFICULTY_CONFIG[resourceForm.difficulty]?.title})</span>
                </label>
              </div>
              <div className="grid grid-cols-5 gap-2">
                {[1, 2, 3, 4, 5].map(lvl => {
                  const cfg = DIFFICULTY_CONFIG[lvl];
                  const isSelected = Number(resourceForm.difficulty) === lvl;
                  return (
                    <button
                      type="button"
                      key={lvl}
                      onClick={() => setResourceForm({ ...resourceForm, difficulty: lvl })}
                      className={`p-2 sm:p-2.5 rounded-xl border text-center transition-all ${
                        isSelected
                          ? `${cfg.badge} font-bold ring-2 ring-orange-500 shadow-md scale-[1.02]`
                          : `${colors.isDark ? 'bg-slate-800 text-slate-400' : 'bg-slate-100 text-slate-600'} border-transparent hover:border-slate-500`
                      }`}
                    >
                      <div className="text-sm font-bold">{lvl}. Seviye</div>
                      <div className="text-[10px] truncate mt-0.5">{cfg.title.split('/')[0]}</div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Hedef Net / Öğrenci Profili */}
            <div>
              <label className={`block text-xs font-bold ${colors.textSec} mb-1.5 uppercase`}>Hedef Net / Öğrenci Profili (İsteğe Bağlı)</label>
              <input
                type="text"
                placeholder="Örn: 15-20 Net Arası, Temeli Sıfır Öğrenciler..."
                value={resourceForm.targetNet}
                onChange={e => setResourceForm({ ...resourceForm, targetNet: e.target.value })}
                className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm focus:border-orange-500 outline-none`}
              />
            </div>

            {/* Öğretmen Tavsiye Notu */}
            <div>
              <label className={`block text-xs font-bold ${colors.textSec} mb-1.5 uppercase`}>Öğretmen Tavsiye Notu</label>
              <textarea
                rows={3}
                placeholder="Örn: Video çözümleri çok kaliteli, ilk 2 test kolay sonra yeni nesle geçiyor..."
                className={`w-full p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm outline-none focus:border-orange-500 custom-scrollbar resize-none`}
                value={resourceForm.note}
                onChange={e => setResourceForm({ ...resourceForm, note: e.target.value })}
              />
            </div>
          </div>
        </Modal>
      )}

      {/* 7. DERSLERİ / ALANLARI YÖNET MODALI */}
      {showSubjectModal && (
        <Modal
          title={`${activeCategory} Ders ve Branşlarını Yönet`}
          maxWidth="max-w-xl"
          onClose={() => {
            setShowSubjectModal(false);
            setEditingSubjectName(null);
            setNewSubjectInput('');
          }}
        >
          <div className="space-y-6">
            {/* Yeni Ders Ekle Formu */}
            <div className={`p-4 rounded-xl ${colors.isDark ? 'bg-slate-900/60' : 'bg-slate-50'} border ${colors.border} space-y-3`}>
              <h4 className={`text-sm font-bold ${colors.text} flex items-center gap-2`}>
                <Plus size={16} className="text-orange-500" /> {activeCategory} Alanına Yeni Ders / Branş Ekle
              </h4>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Örn: AYT Matematik, Paragraf, Geometri..."
                  value={newSubjectInput}
                  onChange={e => setNewSubjectInput(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleAddSubject()}
                  className={`flex-1 p-2.5 rounded-lg ${colors.inputBg} border ${colors.inputBorder} ${colors.text} text-sm outline-none focus:border-orange-500`}
                />
                <Button icon={Plus} onClick={() => handleAddSubject()}>
                  Dersi Ekle
                </Button>
              </div>
              <p className={`text-[11px] ${colors.textSec}`}>
                İpucu: Örneğin genel "Matematik" yerine "TYT Matematik" ve "AYT Matematik" veya Türkçeden ayrı "Paragraf / Anlam Bilgisi" ekleyerek kaynakları ayrı istifleyebilirsiniz.
              </p>
            </div>

            {/* Mevcut Dersler Listesi */}
            <div className="space-y-2">
              <div className="flex justify-between items-center mb-1">
                <h4 className={`text-sm font-bold ${colors.text}`}>Kayıtlı Dersler & Branşlar ({availableSubjects.length})</h4>
                <span className={`text-xs ${colors.textSec}`}>İsmi değiştirmek için kaleme tıklayın</span>
              </div>

              <div className="space-y-2">
                {availableSubjects.map(subj => {
                  const bookCount = recommendations.filter(r => r.category === activeCategory && r.subject === subj).length;
                  const isEditing = editingSubjectName === subj;

                  return (
                    <div
                      key={subj}
                      className={`p-3 rounded-xl border ${colors.border} ${colors.bgCard} flex justify-between items-center gap-3`}
                    >
                      {isEditing ? (
                        <div className="flex items-center gap-2 flex-1">
                          <input
                            type="text"
                            autoFocus
                            value={editedSubjectValue}
                            onChange={e => setEditedSubjectValue(e.target.value)}
                            onKeyDown={e => {
                              if (e.key === 'Enter') handleRenameSubject(subj, editedSubjectValue);
                              if (e.key === 'Escape') setEditingSubjectName(null);
                            }}
                            className={`flex-1 p-2 text-sm rounded-lg ${colors.inputBg} border-2 border-orange-500 ${colors.text} font-bold outline-none`}
                          />
                          <button
                            onClick={() => handleRenameSubject(subj, editedSubjectValue)}
                            className="p-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700"
                            title="Kaydet"
                          >
                            <Check size={14} />
                          </button>
                          <button
                            onClick={() => setEditingSubjectName(null)}
                            className="p-2 rounded-lg bg-slate-700 text-slate-300 hover:bg-slate-600"
                            title="İptal"
                          >
                            <X size={14} />
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex items-center gap-2.5">
                            <span className="w-2 h-2 rounded-full bg-orange-500"></span>
                            <span className={`font-bold text-sm ${colors.text}`}>{subj}</span>
                            <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-orange-500/10 text-orange-400">
                              {bookCount} Kaynak
                            </span>
                          </div>

                          <div className="flex items-center gap-1">
                            <button
                              onClick={() => {
                                setEditingSubjectName(subj);
                                setEditedSubjectValue(subj);
                              }}
                              className="p-1.5 text-slate-400 hover:text-blue-400 hover:bg-blue-500/10 rounded-lg transition-colors"
                              title="Ders Adını Düzenle / Değiştir"
                            >
                              <Edit2 size={14} />
                            </button>
                            <button
                              onClick={() => handleDeleteSubject(subj)}
                              className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-500/10 rounded-lg transition-colors"
                              title="Dersi Sil"
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* 8. KIRTASİYE YÖNETİM MODALI */}
      {showStationeryModal && (
        <Modal
          title="Anlaşmalı Kırtasiyeleri Yönet"
          maxWidth="max-w-xl"
          onClose={() => setShowStationeryModal(false)}
        >
          <div className="space-y-6">
            {/* Yeni Kırtasiye Ekle Formu */}
            <div className={`p-4 rounded-xl ${colors.isDark ? 'bg-slate-900/60' : 'bg-slate-50'} border ${colors.border} space-y-3`}>
              <h4 className={`text-sm font-bold ${colors.text} flex items-center gap-2`}>
                <Store size={16} className="text-orange-500" /> Yeni Kırtasiye Ekle
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <Input
                  label="Kırtasiye / Kitabevi Adı *"
                  placeholder="Örn: İşler Kitabevi"
                  value={stationeryForm.name}
                  onChange={e => setStationeryForm({ ...stationeryForm, name: e.target.value })}
                />
                <Input
                  label="İletişim / Telefon"
                  placeholder="Örn: 0555 123 45 67"
                  value={stationeryForm.phone}
                  onChange={e => setStationeryForm({ ...stationeryForm, phone: e.target.value })}
                />
              </div>
              <Input
                label="Adres / Konum"
                placeholder="Örn: Üniversite Cad. No:14 (Merkez)"
                value={stationeryForm.address}
                onChange={e => setStationeryForm({ ...stationeryForm, address: e.target.value })}
              />
              <Input
                label="Özel Not / Koçluk İndirimi Bilgisi"
                placeholder="Örn: Koçluk öğrencilerine %15 indirim kodu: KOC15"
                value={stationeryForm.note}
                onChange={e => setStationeryForm({ ...stationeryForm, note: e.target.value })}
              />
              <Button size="small" icon={Plus} onClick={handleSaveStationery} className="w-full">
                Kırtasiyeyi Listeye Ekle
              </Button>
            </div>

            {/* Mevcut Kırtasiyeler Listesi */}
            <div className="space-y-3">
              <h4 className={`text-sm font-bold ${colors.text}`}>Kayıtlı Kırtasiyeler ({stationeries.length})</h4>
              {stationeries.length === 0 ? (
                <div className={`text-center py-6 text-xs ${colors.textSec}`}>Henüz kırtasiye eklenmedi.</div>
              ) : (
                stationeries.map(stat => {
                  const bookCount = recommendations.filter(r => r.stationeryId === stat.id).length;
                  return (
                    <div
                      key={stat.id}
                      className={`p-3 rounded-xl border ${colors.border} ${colors.bgCard} flex justify-between items-start gap-3`}
                    >
                      <div className="space-y-1">
                        <div className="flex items-center gap-2">
                          <span className={`font-bold text-sm ${colors.text}`}>{stat.name}</span>
                          <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-orange-500/10 text-orange-400">
                            {bookCount} Kaynakta Mevcut
                          </span>
                        </div>
                        {stat.address && (
                          <div className={`text-xs ${colors.textSec} flex items-center gap-1`}>
                            <MapPin size={12} /> {stat.address}
                          </div>
                        )}
                        {stat.phone && (
                          <div className={`text-xs ${colors.textSec} flex items-center gap-1`}>
                            <Phone size={12} /> {stat.phone}
                          </div>
                        )}
                        {stat.note && (
                          <div className="text-[11px] text-emerald-400 italic">
                            Not: {stat.note}
                          </div>
                        )}
                      </div>

                      <button
                        onClick={() => setDeleteConfirm({ type: 'stationery', id: stat.id, name: stat.name })}
                        className="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-500/10 rounded-lg transition-colors"
                        title="Kırtasiyeyi Sil"
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </Modal>
      )}

      {/* 9. SİLME ONAY MODALI */}
      <DeleteConfirmModal
        isOpen={!!deleteConfirm}
        onClose={() => setDeleteConfirm(null)}
        onConfirm={handleConfirmDelete}
        message={
          deleteConfirm?.type === 'stationery'
            ? `"${deleteConfirm?.name}" kırtasiyesini silmek istediğinize emin misiniz? Bu kırtasiyeye bağlı kitapların kırtasiye bilgisi kaldırılacaktır.`
            : `"${deleteConfirm?.name}" kaynağını havuzdan silmek istediğinize emin misiniz?`
        }
      />
    </div>
  );
};

// 8. ÖDEME TAKİBİ (DÜZELTİLDİ: Özet Kartlar Geri Geldi & Yıllık Tablo Entegre Edildi)
const PaymentModule = ({ student, onUpdateStudent, user }) => {
  const [showModal, setShowModal] = useState(false);
  const [newPayment, setNewPayment] = useState({ date: new Date().toISOString().split('T')[0], amount: "", description: "", method: "Nakit" });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const colors = useThemeColors();

  // Yıllık Kontrol Listesi Mantığı
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const checkedMonths = student.paidMonths?.[selectedYear] || [];

  // Hesaplamalar (GERİ GELDİ)
  const totalAmount = student.payments.reduce((acc, curr) => acc + (parseFloat(curr.amount) || 0), 0);
  const lastPayment = student.payments.length > 0
    ? student.payments.sort((a, b) => new Date(b.date) - new Date(a.date))[0]
    : null;

  const toggleMonth = (monthIndex) => {
    const current = student.paidMonths || {};
    const yearData = current[selectedYear] || [];
    const newData = yearData.includes(monthIndex) ? yearData.filter(m => m !== monthIndex) : [...yearData, monthIndex];
    onUpdateStudent({ ...student, paidMonths: { ...current, [selectedYear]: newData } });
  };

  const handleAdd = () => { if (!newPayment.amount) return; const payment = { id: Date.now(), ...newPayment }; onUpdateStudent({ ...student, payments: [payment, ...student.payments] }); setShowModal(false); setNewPayment({ date: new Date().toISOString().split('T')[0], amount: "", description: "", method: "Nakit" }); };
  const confirmDelete = () => { if (deleteConfirm) { const filtered = student.payments.filter(p => p.id !== deleteConfirm); onUpdateStudent({ ...student, payments: filtered }); setDeleteConfirm(null); } };

  if (user.role === 'student') return <div className={`${colors.text} text-center mt-20`}>Erişim yetkisi yok.</div>;

  const MONTHS = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];

  return (
    <div className="animate-fade-in space-y-6">
      <div className="flex justify-between items-center"><h2 className={`text-2xl font-bold ${colors.text}`}>Ödeme Takibi</h2><Button onClick={() => setShowModal(true)} icon={Plus}>Ödeme Ekle</Button></div>

      {/* ÜST KISIM: ÖZETLER VE YILLIK ÇİZELGE YAN YANA */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* SOL: ÖZET KARTLARI (GERİ GELDİ) */}
        <div className="lg:col-span-1 space-y-4">
          <div className="bg-gradient-to-br from-emerald-900 to-emerald-800 p-6 rounded-xl text-white shadow-lg relative overflow-hidden">
            <div className="relative z-10">
              <div className="text-xs font-bold opacity-70 mb-1">TOPLAM TAHSİLAT</div>
              <div className="text-3xl font-bold">{totalAmount.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</div>
            </div>
            <div className="absolute right-0 top-0 p-4 opacity-10"><CreditCard size={64} /></div>
          </div>
          <div className={`p-6 rounded-xl border ${colors.border} ${colors.bgCard} shadow flex justify-between items-center`}>
            <div>
              <div className={`text-xs font-bold ${colors.textSec} mb-1`}>SON İŞLEM</div>
              <div className={`text-xl font-bold ${colors.text}`}>{lastPayment ? formatDate(lastPayment.date) : '-'}</div>
            </div>
            {lastPayment && <div className="text-right"><div className="text-xs text-emerald-500 font-bold">+{Number(lastPayment.amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</div></div>}
          </div>
        </div>

        {/* SAĞ: YILLIK ÇİZELGE (MİNİMAL) */}
        <div className="lg:col-span-2">
          <Card className="h-full">
            <div className="flex items-center justify-between mb-4 border-b border-gray-700 pb-2">
              <h3 className={`font-bold ${colors.text}`}>Yıllık Takip</h3>
              <div className="flex items-center gap-2">
                <button onClick={() => setSelectedYear(selectedYear - 1)} className={`p-1 rounded hover:bg-slate-700 ${colors.textSec}`}><ChevronDown size={16} className="rotate-90" /></button>
                <span className={`font-bold ${colors.text} text-sm`}>{selectedYear}</span>
                <button onClick={() => setSelectedYear(selectedYear + 1)} className={`p-1 rounded hover:bg-slate-700 ${colors.textSec}`}><ChevronRight size={16} /></button>
              </div>
            </div>
            <div className="grid grid-cols-4 md:grid-cols-6 gap-2">
              {MONTHS.map((m, idx) => {
                const isPaid = checkedMonths.includes(idx);
                return (
                  <div key={idx} onClick={() => toggleMonth(idx)} className={`p-2 rounded border cursor-pointer transition-all flex flex-col items-center justify-center gap-1 ${isPaid ? 'bg-emerald-500/10 border-emerald-500' : `${colors.bgCardTransparent} ${colors.border}`}`}>
                    <span className={`text-xs font-bold ${isPaid ? 'text-emerald-500' : colors.textSec}`}>{m}</span>
                    {isPaid ? <Check size={14} className="text-emerald-500" /> : <div className="w-3.5 h-3.5 rounded-full border border-slate-600"></div>}
                  </div>
                )
              })}
            </div>
          </Card>
        </div>
      </div>

      {/* ALT: DETAYLI TABLO */}
      <Card title="Ödeme Geçmişi"><div className="overflow-x-auto"><table className="w-full text-left text-sm"><thead className={colors.tableHeader}><tr><th className="p-4">Tarih</th><th className="p-4">Açıklama</th><th className="p-4">Yöntem</th><th className="p-4 text-right">Tutar</th><th className="p-4 text-right">İşlem</th></tr></thead><tbody className={`divide-y ${colors.divider} ${colors.textSec}`}>
        {student.payments.sort((a, b) => new Date(b.date) - new Date(a.date)).map(p => (
          <tr key={p.id} className={colors.hoverBg}><td className="p-4">{formatDate(p.date)}</td><td className={`p-4 font-medium ${colors.text}`}>{p.description}</td><td className="p-4"><span className={`${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} px-2 py-1 rounded text-xs`}>{p.method}</span></td><td className="p-4 text-right font-bold text-emerald-400">{Number(p.amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td><td className="p-4 text-right"><button onClick={(e) => setDeleteConfirm(p.id)} className="text-slate-500 hover:text-red-500 p-2"><Trash2 size={16} /></button></td></tr>
        ))}</tbody></table></div></Card>

      {showModal && (<Modal title="Yeni Ödeme" onClose={() => setShowModal(false)}><div className="space-y-4"><Input label="Tarih" type="date" value={newPayment.date} onChange={e => setNewPayment({ ...newPayment, date: e.target.value })} /><Input label="Tutar" type="number" value={newPayment.amount} onChange={e => setNewPayment({ ...newPayment, amount: e.target.value })} /><Input label="Açıklama" value={newPayment.description} onChange={e => setNewPayment({ ...newPayment, description: e.target.value })} /><div className="grid grid-cols-2 gap-4"><button onClick={() => setNewPayment({ ...newPayment, method: 'Nakit' })} className={`p-2 rounded border ${newPayment.method === 'Nakit' ? 'bg-orange-600 text-white border-orange-600' : `${colors.bgCard} ${colors.border}`}`}>Nakit</button><button onClick={() => setNewPayment({ ...newPayment, method: 'Havale/EFT' })} className={`p-2 rounded border ${newPayment.method === 'Havale/EFT' ? 'bg-orange-600 text-white border-orange-600' : `${colors.bgCard} ${colors.border}`}`}>Havale/EFT</button></div><Button onClick={handleAdd} className="w-full mt-4">Kaydet</Button></div></Modal>)}
      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};
// 9. RUTİNLER (HIZ VE ALGI)
const RoutineModule = ({ student, onUpdateStudent, user }) => {
  const [activeTab, setActiveTab] = useState('paragraf'); // paragraf | problem | kitap
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ date: new Date().toISOString().split('T')[0], count: '', time: '' }); // count: adet/sayfa, time: dakika
  const [editingId, setEditingId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const colors = useThemeColors();
  const routines = student.routines || [];
  const isAdmin = user.role === 'admin' || user.role === 'superadmin';

  // TABS YAPILANDIRMASI
  const TABS = [
    { id: 'paragraf', label: 'Paragraf', unit: 'Soru', icon: List },
    { id: 'problem', label: 'Problem', unit: 'Soru', icon: Activity },
    { id: 'kitap', label: 'Kitap Okuma', unit: 'Sayfa', icon: BookOpen },
  ];

  const currentTabInfo = TABS.find(t => t.id === activeTab);

  // --- HESAPLAMALAR ---
  // Seçili kategorideki verileri al ve tarihe göre sırala
  const filteredRoutines = routines
    .filter(r => r.type === activeTab)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  // Grafik için son 10 veri (Hız: 10 birim için harcanan dakika)
  const chartData = filteredRoutines.slice(-10).map(r => {
    const pace = (parseInt(r.time) / parseInt(r.count)) * 10; // 10 tanesi kaç dk sürüyor?
    return {
      date: formatDate(r.date).substring(0, 5),
      pace: parseFloat(pace.toFixed(2)),
      raw: r
    };
  });

  // Özet İstatistikler (Son 10 verinin ortalaması vs bir önceki 10 veri)
  const calculateStats = () => {
    if (chartData.length === 0) return { avgPace: 0, trend: 'neutral' };

    const currentAvg = chartData.reduce((acc, curr) => acc + curr.pace, 0) / chartData.length;

    // Trend hesabı (Basitçe son veri ortalamadan iyi mi?)
    const lastEntry = chartData[chartData.length - 1];
    let trend = 'neutral';
    if (lastEntry.pace < currentAvg) trend = 'positive'; // Süre azaldıysa iyi
    else if (lastEntry.pace > currentAvg) trend = 'negative'; // Süre arttıysa kötü

    return { avgPace: currentAvg.toFixed(2), trend };
  };

  const stats = calculateStats();

  // --- CRUD İŞLEMLERİ ---
  const handleSave = () => {
    if (!formData.count || !formData.time) return alert("Lütfen adet ve süre giriniz.");

    const entryData = {
      id: editingId || Date.now(),
      type: activeTab,
      date: formData.date,
      count: parseInt(formData.count),
      time: parseInt(formData.time)
    };

    let updatedRoutines;
    if (editingId) {
      updatedRoutines = routines.map(r => r.id === editingId ? entryData : r);
      setEditingId(null);
    } else {
      updatedRoutines = [...routines, entryData];
    }

    onUpdateStudent({ ...student, routines: updatedRoutines });
    logActivity(student.id, 'routine_entry', { type: activeTab, count: entryData.count, date: entryData.date });
    setShowModal(false);
    setFormData({ date: new Date().toISOString().split('T')[0], count: '', time: '' });
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setFormData({ date: item.date, count: item.count, time: item.time });
    setShowModal(true);
  };

  const requestDelete = (id) => setDeleteConfirm(id);

  const confirmDelete = () => {
    if (deleteConfirm) {
      const filtered = routines.filter(r => r.id !== deleteConfirm);
      onUpdateStudent({ ...student, routines: filtered });
      setDeleteConfirm(null);
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <h2 className={`text-2xl font-bold ${colors.text} flex items-center gap-2`}>
          <Activity className="text-orange-500" /> Rutinler & Hız Takibi
        </h2>
        <Button onClick={() => { setEditingId(null); setShowModal(true); }} icon={Plus}>Veri Gir</Button>
      </div>

      {/* SEKME SEÇİMİ */}
      <div className={`flex p-1 rounded-xl ${colors.isDark ? 'bg-slate-800' : 'bg-slate-200'} gap-1`}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 py-3 rounded-lg text-sm font-bold flex items-center justify-center gap-2 transition-all ${activeTab === tab.id ? 'bg-orange-600 text-white shadow-lg' : `${colors.textSec} hover:${colors.text}`}`}
          >
            <tab.icon size={16} /> {tab.label}
          </button>
        ))}
      </div>

      {/* İSTATİSTİK KARTLARI */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="bg-gradient-to-br from-indigo-900 to-slate-900 text-white border-indigo-500/30">
          <div className="text-xs font-bold opacity-70 mb-1 uppercase">Ortalama Hız (Son 10)</div>
          <div className="text-3xl font-bold flex items-end gap-2">
            {stats.avgPace} <span className="text-sm font-normal opacity-60">dk / 10 {currentTabInfo.unit}</span>
          </div>
          <div className="mt-2 text-xs opacity-70">
            10 {currentTabInfo.unit} {activeTab === 'kitap' ? 'okuma' : 'çözme'} süresi
          </div>
        </Card>

        <Card className={`${colors.bgCard} border ${colors.border}`}>
          <div className={`text-xs font-bold ${colors.textSec} mb-1 uppercase`}>Performans Trendi</div>
          <div className={`text-2xl font-bold flex items-center gap-2 ${stats.trend === 'positive' ? 'text-emerald-500' : stats.trend === 'negative' ? 'text-red-500' : colors.text}`}>
            {stats.trend === 'positive' ? <ArrowDown size={24} /> : stats.trend === 'negative' ? <ArrowUp size={24} /> : <Activity size={24} />}
            {stats.trend === 'positive' ? 'Hızlanıyorsun!' : stats.trend === 'negative' ? 'Yavaşlama Var' : 'Stabil'}
          </div>
          <div className={`mt-2 text-xs ${colors.textSec}`}>
            Son veri ortalamaya göre kıyaslandı.
          </div>
        </Card>

        <Card className={`${colors.bgCard} border ${colors.border}`}>
          <div className={`text-xs font-bold ${colors.textSec} mb-1 uppercase`}>Toplam Yapılan</div>
          <div className={`text-3xl font-bold ${colors.text}`}>
            {filteredRoutines.reduce((acc, curr) => acc + curr.count, 0)} <span className="text-sm font-normal text-slate-500">{currentTabInfo.unit}</span>
          </div>
          <div className={`mt-2 text-xs ${colors.textSec}`}>
            Bu kategoride toplam kaydedilen miktar.
          </div>
        </Card>
      </div>

      {/* GRAFİK */}
      <Card title={`10 ${currentTabInfo.unit} İçin Harcanan Süre (Dk)`}>
        <div className="h-64 w-full">
          {chartData.length > 1 ? (
            <LineChart
              data={chartData}
              dataKey="pace"
              labelKey="date"
              color="#f97316"
              height={250}
            />
          ) : (
            <div className={`h-full flex items-center justify-center ${colors.textSec}`}>Grafik için en az 2 veri girişi yapın.</div>
          )}
        </div>
        <div className="text-center text-[10px] text-slate-500 mt-2 italic">Grafik aşağı doğru gidiyorsa hızlanıyorsunuz demektir.</div>
      </Card>

      {/* GEÇMİŞ TABLOSU */}
      <Card title="Geçmiş Kayıtlar">
        <div className="overflow-x-auto max-h-80 custom-scrollbar">
          <table className="w-full text-left text-sm">
            <thead className={colors.tableHeader}>
              <tr>
                <th className="p-3">Tarih</th>
                <th className="p-3">Miktar</th>
                <th className="p-3">Süre</th>
                <th className="p-3">Hız (10'luk)</th>
                <th className="p-3 text-right">İşlem</th>
              </tr>
            </thead>
            <tbody className={`divide-y ${colors.divider}`}>
              {filteredRoutines.slice().reverse().map(item => {
                const pace = ((item.time / item.count) * 10).toFixed(2);
                return (
                  <tr key={item.id} className={colors.hoverBg}>
                    <td className={`p-3 ${colors.text}`}>{formatDate(item.date)}</td>
                    <td className={`p-3 font-bold ${colors.text}`}>{item.count} {currentTabInfo.unit}</td>
                    <td className="p-3 text-orange-500 font-bold">{item.time} dk</td>
                    <td className="p-3 text-blue-400 font-bold">{pace} dk</td>
                    <td className="p-3 text-right flex justify-end gap-2">
                      <button onClick={() => handleEdit(item)} className="p-2 hover:bg-blue-500/10 text-slate-500 hover:text-blue-500 rounded transition-colors"><Edit2 size={16} /></button>
                      {isAdmin && (
                        <button onClick={() => requestDelete(item.id)} className="p-2 hover:bg-red-500/10 text-slate-500 hover:text-red-500 rounded transition-colors"><Trash2 size={16} /></button>
                      )}
                    </td>
                  </tr>
                )
              })}
              {filteredRoutines.length === 0 && (
                <tr><td colSpan="5" className={`p-4 text-center ${colors.textSec}`}>Bu kategoride henüz veri yok.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* VERİ GİRİŞ MODALI */}
      {showModal && (
        <Modal title={`${currentTabInfo.label} Verisi Ekle`} onClose={() => setShowModal(false)}>
          <div className="space-y-4">
            <Input label="Tarih" type="date" value={formData.date} onChange={e => setFormData({ ...formData, date: e.target.value })} />

            <div className="grid grid-cols-2 gap-4">
              <Input
                label={`Miktar (${currentTabInfo.unit})`}
                type="number"
                placeholder={`Örn: 20`}
                value={formData.count}
                onChange={e => setFormData({ ...formData, count: e.target.value })}
              />
              <Input
                label="Süre (Dakika)"
                type="number"
                placeholder="Örn: 30"
                value={formData.time}
                onChange={e => setFormData({ ...formData, time: e.target.value })}
              />
            </div>

            <div className={`p-3 rounded text-xs ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} ${colors.textSec}`}>
              <span className="font-bold text-orange-500">İpucu:</span> Verileri doğru girmeniz, hız grafiğinizin doğru oluşmasını sağlar.
            </div>

            <Button onClick={handleSave} className="w-full">Kaydet</Button>
          </div>
        </Modal>
      )}

      <DeleteConfirmModal isOpen={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} onConfirm={confirmDelete} />
    </div>
  );
};

// --- AKTİFLİK DURUMU MODÜLÜ ---
const ACTIVITY_TYPE_LABELS = {
  login: { label: 'Sisteme Giriş', color: 'text-emerald-400', bgColor: 'bg-emerald-500/10', icon: '🔑' },
  resource_add: { label: 'Kaynak Ekleme', color: 'text-blue-400', bgColor: 'bg-blue-500/10', icon: '📚' },
  resource_edit: { label: 'Kaynak Düzenleme', color: 'text-cyan-400', bgColor: 'bg-cyan-500/10', icon: '✏️' },
  assignment_mark: { label: 'Ödev İşaretleme', color: 'text-orange-400', bgColor: 'bg-orange-500/10', icon: '✅' },
  topic_completion: { label: 'Konu Tamamlama', color: 'text-purple-400', bgColor: 'bg-purple-500/10', icon: '📖' },
  data_entry: { label: 'Veri Girişi', color: 'text-yellow-400', bgColor: 'bg-yellow-500/10', icon: '📝' },
  exam_entry: { label: 'Deneme Girişi', color: 'text-red-400', bgColor: 'bg-red-500/10', icon: '📊' },
  mood_entry: { label: 'Duygudurum Girişi', color: 'text-pink-400', bgColor: 'bg-pink-500/10', icon: '😊' },
  goal_update: { label: 'Hedef Güncelleme', color: 'text-indigo-400', bgColor: 'bg-indigo-500/10', icon: '🎯' },
  routine_entry: { label: 'Rutin Girişi', color: 'text-teal-400', bgColor: 'bg-teal-500/10', icon: '📅' },
  note_add: { label: 'Not Ekleme', color: 'text-amber-400', bgColor: 'bg-amber-500/10', icon: '🗒️' },
  note_edit: { label: 'Not Düzenleme', color: 'text-lime-400', bgColor: 'bg-lime-500/10', icon: '📝' },
};

const logActivity = async (studentId, type, details = {}) => {
  if (!isFirebaseActive || !studentId) return;
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type,
    timestamp: new Date().toISOString(),
    details,
  };
  try {
    const studentRef = doc(db, 'students', studentId);
    const studentSnap = await getDoc(studentRef);
    if (!studentSnap.exists()) return;
    const history = Array.isArray(studentSnap.data().activityHistory) ? studentSnap.data().activityHistory : [];
    const cutoff = Date.now() - 15 * 24 * 60 * 60 * 1000;
    const updated = [entry, ...history]
      .filter(h => h?.timestamp && new Date(h.timestamp).getTime() > cutoff)
      .slice(0, 500);
    await setDoc(studentRef, { activityHistory: updated }, { merge: true });
  } catch (e) {
    console.error('Activity log error:', e);
  }
};

// --- AKTİFLİK DURUMU DETAY ÇÖZÜMLEME YARDIMCISI ---
const formatActivityDetails = (log, student, pool = STATIC_POOL) => {
  if (!log || !log.details) return '';
  const d = log.details;

  // 1. Sisteme Giriş
  if (log.type === 'login') {
    return d.role === 'student' ? 'Öğrenci Paneline Giriş Yapıldı' : (d.role === 'superadmin' ? 'Yönetici Girişi' : 'Giriş Yapıldı');
  }

  // 2. Deneme Girişi
  if (log.type === 'exam_entry') {
    return d.examName || d.title || 'Deneme sınavı kaydedildi';
  }

  // 3. Duygudurum Girişi
  if (log.type === 'mood_entry') {
    return d.title || 'Duygudurum değerlendirmesi yapıldı';
  }

  // 4. Hedef Güncelleme
  if (log.type === 'goal_update') {
    return d.title || d.text || 'Haftalık hedef güncellendi';
  }

  // 5. Rutin Girişi
  if (log.type === 'routine_entry') {
    return d.title || (d.category ? `${d.category} rutini kaydedildi` : 'Rutin çalışması kaydedildi');
  }

  // 6. Not Ekleme / Düzenleme
  if (log.type === 'note_add' || log.type === 'note_edit') {
    return d.title ? `Not: "${d.title}"` : 'Özel not kaydedildi';
  }

  // 7. Kaynak Ekleme / Düzenleme
  if (log.type === 'resource_add' || log.type === 'resource_edit') {
    let text = d.resourceName || d.title || '';
    if (d.publisher) text += ` (${d.publisher})`;
    return text || 'Kaynak işlemi yapıldı';
  }

  // 8. Ödev İşaretleme
  if (log.type === 'assignment_mark') {
    let text = '';
    if (d.subject) text += d.subject;
    if (d.topic) text += (text ? ' → ' : '') + d.topic;
    if (d.status === 'completed') text += ' (Tamamlandı)';
    return text || d.title || 'Ödev tamamlandı olarak işaretlendi';
  }

  // 9. Konu Tamamlama (topic_completion)
  if (log.type === 'topic_completion') {
    const isRaw = (str) => typeof str === 'string' && (str.startsWith('tpl-') || str.includes('tpl-u-') || /^[a-z0-9_-]+-[0-9]+$/i.test(str));

    const fMap = { konu: 'Konu', soru: 'Soru', t1: '1. Tekrar', t2: '2. Tekrar', t3: '3. Tekrar' };
    const fieldName = d.fieldLabel || fMap[d.field] || (d.field ? d.field : '');

    // Eğer zaten insan tarafından okunabilir konu ve ders bilgisi varsa
    if (d.topic && !isRaw(d.topic)) {
      let out = '';
      if (d.subject) out += `${d.subject} → `;
      if (d.unit) out += `${d.unit} → `;
      out += d.topic;
      if (fieldName) out += ` (${fieldName})`;
      if (d.resourceName) out = `${d.resourceName} • ${out}`;
      return out;
    }

    const rawStr = d.topicId || d.topicKey || d.topic || '';
    const studentCurriculum = Array.isArray(student?.curriculum) ? student.curriculum : [];

    // Kaynak 1: Öğrencinin aktif müfredatı içinde doğrudan eşleşme ara
    for (const course of studentCurriculum) {
      if (!course.units) continue;
      for (const unit of course.units) {
        if (!unit.topics) continue;
        for (let tIdx = 0; tIdx < unit.topics.length; tIdx++) {
          const k1 = `${course.id}-${unit.id}-${tIdx}`;
          const k2 = `${unit.id || unit.name}-${tIdx}`;
          if (rawStr === k1 || rawStr === k2) {
            let out = `${course.name} → ${unit.name} → ${unit.topics[tIdx]}`;
            if (fieldName) out += ` (${fieldName})`;
            if (d.resourceName) out = `${d.resourceName} • ${out}`;
            return out;
          }
        }
      }
    }

    // Kaynak 2: Template ID regex çözümleme:
    // Format: tpl-[TYPE]-[TIMESTAMP]-[COURSE_IDX]-tpl-u-[TIMESTAMP]-[COURSE_IDX]-[UNIT_IDX]-[TOPIC_IDX]
    // Örnek: tpl-LGS-1783952831204-5-tpl-u-1783952831204-5-1-3
    const tplMatch = typeof rawStr === 'string' && rawStr.match(/tpl-([A-Za-z0-9_]+)-\d+-(\d+)-tpl-u-\d+-\d+-(\d+)-(\d+)/);
    if (tplMatch) {
      const [, tmplType, courseIdxStr, unitIdxStr, topicIdxStr] = tplMatch;
      const cIdx = parseInt(courseIdxStr, 10);
      const uIdx = parseInt(unitIdxStr, 10);
      const tIdx = parseInt(topicIdxStr, 10);

      // Öğrencinin ders listesinde cIdx dersi varsa
      if (studentCurriculum[cIdx]?.units?.[uIdx]?.topics?.[tIdx]) {
        const c = studentCurriculum[cIdx];
        const u = c.units[uIdx];
        const t = u.topics[tIdx];
        let out = `${c.name} → ${u.name} → ${t}`;
        if (fieldName) out += ` (${fieldName})`;
        if (d.resourceName) out = `${d.resourceName} • ${out}`;
        return out;
      }

      // Şablon havuzundaki sıra ile eşleştir
      const tmplCourseKeys = {
        LGS: ['LGS_TURKCE', 'LGS_MAT', 'LGS_FEN', 'LGS_INK', 'LGS_ING', 'LGS_DIN'],
        KPSS: ['KPSS_TURKCE', 'KPSS_MATEMATIK', 'KPSS_TARIH', 'KPSS_COGRAFYA', 'KPSS_VATANDASLIK', 'KPSS_GUNCEL'],
        YKS_SAY: ['TYT_TURKCE', 'TYT_MAT', 'TYT_FIZIK', 'TYT_KIMYA', 'TYT_BIYOLOJI', 'GEOMETRI', 'PROBLEMLER', 'PARAGRAF', 'AYT_MAT', 'AYT_FIZIK', 'AYT_KIMYA', 'AYT_BIYOLOJI'],
        YKS_EA: ['TYT_TURKCE', 'TYT_MAT', 'TYT_FIZIK', 'TYT_KIMYA', 'TYT_BIYOLOJI', 'GEOMETRI', 'PROBLEMLER', 'PARAGRAF', 'AYT_MAT', 'AYT_ED', 'AYT_TAR1', 'AYT_COG1'],
        YKS_SOZ: ['TYT_TURKCE', 'TYT_MAT', 'TYT_FIZIK', 'TYT_KIMYA', 'TYT_BIYOLOJI', 'GEOMETRI', 'PROBLEMLER', 'PARAGRAF', 'AYT_ED', 'AYT_TAR1', 'AYT_COG1', 'AYT_TAR2', 'AYT_COG2', 'AYT_FEL', 'AYT_DIN'],
      };

      const keysForType = tmplCourseKeys[tmplType] || tmplCourseKeys[Object.keys(tmplCourseKeys).find(k => tmplType.startsWith(k))];
      if (keysForType && keysForType[cIdx]) {
        const poolKey = keysForType[cIdx];
        const courseData = pool?.[poolKey] || STATIC_POOL?.[poolKey];
        if (courseData && courseData.units?.[uIdx]?.topics?.[tIdx]) {
          const u = courseData.units[uIdx];
          const t = u.topics[tIdx];
          let out = `${courseData.name} → ${u.name} → ${t}`;
          if (fieldName) out += ` (${fieldName})`;
          if (d.resourceName) out = `${d.resourceName} • ${out}`;
          return out;
        }
      }
    }

    // Kaynak 3: STATIC_POOL ve pool içindeki tüm ders ve üniteleri tara
    const allCourses = [...studentCurriculum, ...Object.values(pool || STATIC_POOL || {})];
    for (const course of allCourses) {
      if (!course?.units) continue;
      for (const unit of course.units) {
        if (!unit?.topics) continue;
        for (let idx = 0; idx < unit.topics.length; idx++) {
          const k1 = `${course.id || ''}-${unit.id || ''}-${idx}`;
          const k2 = `${unit.id || unit.name || ''}-${idx}`;
          if (rawStr === k1 || rawStr === k2) {
            let out = `${course.name} → ${unit.name} → ${unit.topics[idx]}`;
            if (fieldName) out += ` (${fieldName})`;
            if (d.resourceName) out = `${d.resourceName} • ${out}`;
            return out;
          }
        }
      }
    }

    // Kaynak 4: Son çare olarak indeks numarasından ve isimlerden konu bul
    if (typeof rawStr === 'string' && rawStr.includes('-')) {
      const parts = rawStr.split('-');
      const lastNum = parseInt(parts[parts.length - 1], 10);
      if (!isNaN(lastNum)) {
        for (const course of allCourses) {
          if (!course?.units) continue;
          for (const unit of course.units) {
            if (unit.topics && unit.topics[lastNum]) {
              if (rawStr.includes(unit.id) || (unit.name && rawStr.includes(unit.name))) {
                let out = `${course.name} → ${unit.name} → ${unit.topics[lastNum]}`;
                if (fieldName) out += ` (${fieldName})`;
                return out;
              }
            }
          }
        }
      }
    }

    // Son çare okunabilir metin
    if (d.resourceName) return `${d.resourceName} (${fieldName || 'Konu Çalışması'})`;
    if (d.topic && !isRaw(d.topic)) return `${d.topic} (${fieldName || 'Konu'})`;
    return fieldName ? `Konu Çalışması (${fieldName})` : 'Konu Tamamlandı';
  }

  // Genel detay fallback
  let res = '';
  if (d.title) res = d.title;
  if (d.resourceName) res = d.resourceName;
  if (d.subject) res += (res ? ' - ' : '') + d.subject;
  if (d.topic && typeof d.topic === 'string' && !d.topic.startsWith('tpl-')) res += (res ? ' → ' : '') + d.topic;
  if (d.examName) res = d.examName;
  if (d.assignmentNote) res = d.assignmentNote;
  if (d.status) res += (res ? ' | ' : '') + d.status;
  return res || '-';
};

const ActivityModule = ({ user, students, selectedStudentId, curriculum, templatesPool }) => {
  const colors = useThemeColors();
  const [filterType, setFilterType] = useState('all');
  const [dateRange, setDateRange] = useState(() => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 15);
    return {
      start: start.toISOString().split('T')[0],
      end: end.toISOString().split('T')[0]
    };
  });

  const activeStudentId = selectedStudentId || students?.[0]?.id || '';
  const selectedStudent = students.find(s => s.id === activeStudentId);

  const logs = React.useMemo(() => {
    const history = selectedStudent?.activityHistory || [];
    const startDate = new Date(dateRange.start);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(dateRange.end);
    endDate.setHours(23, 59, 59, 999);
    return history
      .map(h => ({
        ...h,
        timestamp: h.timestamp?.toDate?.() || new Date(h.timestamp)
      }))
      .filter(h => !isNaN(h.timestamp?.getTime?.()) && h.timestamp >= startDate && h.timestamp <= endDate)
      .sort((a, b) => b.timestamp - a.timestamp);
  }, [selectedStudent, dateRange]);

  const filteredLogs = filterType === 'all' ? logs : logs.filter(l => l.type === filterType);

  // İstatistik hesapla
  const stats = React.useMemo(() => {
    if (logs.length === 0) return { totalActions: 0, loginCount: 0, lastLogin: null, mostActiveHour: '-', avgDaily: 0 };
    const loginLogs = logs.filter(l => l.type === 'login');
    const lastLogin = loginLogs.length > 0 ? loginLogs[0].timestamp : null;

    // Saat bazında dağılım
    const hourCounts = {};
    logs.forEach(l => {
      const hour = l.timestamp.getHours();
      hourCounts[hour] = (hourCounts[hour] || 0) + 1;
    });
    const mostActiveHour = Object.entries(hourCounts).sort((a, b) => b[1] - a[1])[0];

    // Günlük ortalama
    const daySet = new Set(logs.map(l => l.timestamp.toDateString()));
    const avgDaily = daySet.size > 0 ? (logs.length / daySet.size).toFixed(1) : 0;

    // Gün bazlı login dağılımı
    const loginDays = new Set(loginLogs.map(l => l.timestamp.toDateString()));

    return {
      totalActions: logs.length,
      loginCount: loginLogs.length,
      loginDays: loginDays.size,
      lastLogin,
      mostActiveHour: mostActiveHour ? `${mostActiveHour[0].toString().padStart(2, '0')}:00` : '-',
      avgDaily
    };
  }, [logs]);

  // Saat bazında dağılım grafiği verisi
  const hourlyData = React.useMemo(() => {
    const hours = Array(24).fill(0);
    logs.forEach(l => {
      const h = l.timestamp.getHours();
      hours[h]++;
    });
    return hours;
  }, [logs]);

  const maxHourly = Math.max(...hourlyData, 1);

  // Gün bazında dağılım
  const dailyData = React.useMemo(() => {
    const dayMap = {};
    logs.forEach(l => {
      const key = l.timestamp.toLocaleDateString('tr-TR');
      dayMap[key] = (dayMap[key] || 0) + 1;
    });
    return Object.entries(dayMap).sort((a, b) => {
      const da = a[0].split('.').reverse().join('-');
      const db2 = b[0].split('.').reverse().join('-');
      return new Date(db2) - new Date(da);
    }).slice(0, 15);
  }, [logs]);

  const timeAgo = (date) => {
    if (!date) return '-';
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);
    if (diff < 60) return `${diff} sn önce`;
    if (diff < 3600) return `${Math.floor(diff / 60)} dk önce`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} saat önce`;
    return `${Math.floor(diff / 86400)} gün önce`;
  };

  const uniqueTypes = [...new Set(logs.map(l => l.type))];

  return (
    <div className="space-y-6 animate-fade-in">
      {/* BAŞLIK */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <h2 className={`text-2xl font-bold ${colors.text} flex items-center gap-3`}>
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center shadow-lg shadow-purple-500/30">
            <Eye size={20} className="text-white" />
          </div>
          Aktiflik Durumu
        </h2>
      </div>

      {/* FİLTRELER */}
      <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 md:p-6 ${colors.shadow}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Seçili Öğrenci Gösterimi */}
          <div>
            <label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase tracking-wider`}>Öğrenci</label>
            <div className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg px-4 py-3 ${colors.text} text-sm font-semibold flex items-center gap-2`}>
              <span className="w-2 h-2 rounded-full bg-purple-500 animate-pulse"></span>
              {selectedStudent ? selectedStudent.name : 'Seçili Öğrenci Yok'}
            </div>
          </div>
          {/* Başlangıç Tarihi */}
          <div>
            <label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase tracking-wider`}>Başlangıç</label>
            <input
              type="date"
              className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg px-4 py-3 ${colors.text} text-sm focus:outline-none focus:border-purple-500 transition-colors`}
              value={dateRange.start}
              onChange={e => setDateRange({ ...dateRange, start: e.target.value })}
            />
          </div>
          {/* Bitiş Tarihi */}
          <div>
            <label className={`block text-xs font-bold ${colors.textSec} mb-2 uppercase tracking-wider`}>Bitiş</label>
            <input
              type="date"
              className={`w-full ${colors.inputBg} border ${colors.inputBorder} rounded-lg px-4 py-3 ${colors.text} text-sm focus:outline-none focus:border-purple-500 transition-colors`}
              value={dateRange.end}
              onChange={e => setDateRange({ ...dateRange, end: e.target.value })}
            />
          </div>
        </div>
      </div>

      {/* İSTATİSTİK KARTLARI */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 text-center ${colors.shadow} transition-transform hover:scale-105`}>
          <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-2 text-emerald-500"><Activity size={20} /></div>
          <div className={`text-2xl font-bold ${colors.text}`}>{stats.totalActions}</div>
          <div className={`text-[10px] font-bold ${colors.textSec} uppercase`}>Toplam İşlem</div>
        </div>
        <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 text-center ${colors.shadow} transition-transform hover:scale-105`}>
          <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center mx-auto mb-2 text-blue-500"><Users size={20} /></div>
          <div className={`text-2xl font-bold ${colors.text}`}>{stats.loginDays || 0}</div>
          <div className={`text-[10px] font-bold ${colors.textSec} uppercase`}>Giriş Yapılan Gün</div>
        </div>
        <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 text-center ${colors.shadow} transition-transform hover:scale-105`}>
          <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center mx-auto mb-2 text-orange-500"><Clock size={20} /></div>
          <div className={`text-2xl font-bold ${colors.text}`}>{stats.mostActiveHour}</div>
          <div className={`text-[10px] font-bold ${colors.textSec} uppercase`}>En Aktif Saat</div>
        </div>
        <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 text-center ${colors.shadow} transition-transform hover:scale-105`}>
          <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center mx-auto mb-2 text-purple-500"><BarChart2 size={20} /></div>
          <div className={`text-2xl font-bold ${colors.text}`}>{stats.avgDaily}</div>
          <div className={`text-[10px] font-bold ${colors.textSec} uppercase`}>Günlük Ortalama</div>
        </div>
        <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 text-center ${colors.shadow} transition-transform hover:scale-105`}>
          <div className="w-10 h-10 rounded-full bg-cyan-500/20 flex items-center justify-center mx-auto mb-2 text-cyan-500"><Calendar size={20} /></div>
          <div className={`text-sm font-bold ${colors.text}`}>{stats.lastLogin ? timeAgo(stats.lastLogin) : '-'}</div>
          <div className={`text-[10px] font-bold ${colors.textSec} uppercase mt-1`}>Son Giriş</div>
        </div>
      </div>

      {/* SAAT BAZLI DAĞILIM */}
      <div className={`${colors.bgCard} border ${colors.border} rounded-xl p-4 md:p-6 ${colors.shadow}`}>
        <h3 className={`text-sm font-bold ${colors.text} mb-4 flex items-center gap-2`}><Clock size={16} className="text-purple-500" /> Saatlik Aktivite Dağılımı</h3>
        <div className="flex items-end gap-[3px] h-24">
          {hourlyData.map((count, i) => (
            <div key={i} className="flex-1 flex flex-col items-center group relative">
              <div
                className="w-full rounded-t transition-all duration-300 group-hover:opacity-100 opacity-80"
                style={{
                  height: `${Math.max((count / maxHourly) * 100, 2)}%`,
                  background: count > 0 ? `linear-gradient(to top, #8b5cf6, #a78bfa)` : (colors.isDark ? '#1e293b' : '#e2e8f0'),
                  minHeight: '2px'
                }}
              />
              <div className={`text-[8px] ${colors.textSec} mt-1 ${i % 3 === 0 ? '' : 'hidden md:block'}`}>{i.toString().padStart(2, '0')}</div>
              {count > 0 && (
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10">
                  {i.toString().padStart(2, '0')}:00 → {count} işlem
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* TİP FİLTRE BUTONLARI */}
      {uniqueTypes.length > 0 && (
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => setFilterType('all')}
            className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${filterType === 'all' ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/30' : `${colors.bgCard} border ${colors.border} ${colors.textSec} hover:border-purple-500`}`}
          >Tümü ({logs.length})</button>
          {uniqueTypes.map(type => {
            const info = ACTIVITY_TYPE_LABELS[type] || { label: type, color: 'text-slate-400', bgColor: 'bg-slate-500/10', icon: '📌' };
            const count = logs.filter(l => l.type === type).length;
            return (
              <button
                key={type}
                onClick={() => setFilterType(type)}
                className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all flex items-center gap-1.5 ${filterType === type ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/30' : `${colors.bgCard} border ${colors.border} ${colors.textSec} hover:border-purple-500`}`}
              >
                <span>{info.icon}</span> {info.label} ({count})
              </button>
            );
          })}
        </div>
      )}

      {/* İŞLEM TABLOSU */}
      <div className={`${colors.bgCard} border ${colors.border} rounded-xl overflow-hidden ${colors.shadow}`}>
        <div className={`${colors.tableHeader} px-4 md:px-6 py-3 grid grid-cols-12 gap-4 text-xs font-bold uppercase tracking-wider`}>
          <div className="col-span-3">Tarih / Saat</div>
          <div className="col-span-3">İşlem Türü</div>
          <div className="col-span-6">Detaylar</div>
        </div>

        {filteredLogs.length === 0 ? (
          <div className={`text-center py-12 ${colors.textSec}`}>
            <div className="text-4xl mb-3">📭</div>
            <div className="text-sm font-medium">Bu tarih aralığında aktivite kaydı bulunamadı.</div>
            <div className="text-xs mt-1">Öğrenci sistemi kullandıkça işlemler burada listelenecektir.</div>
          </div>
        ) : (
          <div className={`divide-y ${colors.divider} max-h-[500px] overflow-y-auto custom-scrollbar`}>
            {filteredLogs.map((log, idx) => {
              const info = ACTIVITY_TYPE_LABELS[log.type] || { label: log.type, color: 'text-slate-400', bgColor: 'bg-slate-500/10', icon: '📌' };
              const ts = log.timestamp;
              const dateStr = ts.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
              const timeStr = ts.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
              const isWeekend = ts.getDay() === 0 || ts.getDay() === 6;
              const hour = ts.getHours();
              const isNight = hour >= 23 || hour < 6;

              // Detay metnini akıllı çözücü ile oluştur
              const detailText = formatActivityDetails(log, selectedStudent, templatesPool || STATIC_POOL);

              return (
                <div
                  key={log.id}
                  className={`px-4 md:px-6 py-3 grid grid-cols-12 gap-4 items-center text-sm transition-colors ${colors.isDark ? 'hover:bg-slate-800/50' : 'hover:bg-slate-50'} ${idx === 0 ? 'border-l-2 border-l-purple-500' : ''}`}
                >
                  <div className="col-span-3">
                    <div className={`font-medium ${colors.text} text-xs`}>{dateStr}</div>
                    <div className={`text-[11px] ${colors.textSec} flex items-center gap-1`}>
                      <Clock size={10} /> {timeStr}
                      {isNight && <span className="text-yellow-500 ml-1" title="Gece saati">🌙</span>}
                      {isWeekend && <span className="text-blue-400 ml-1" title="Hafta sonu">📅</span>}
                    </div>
                    <div className={`text-[10px] ${colors.textSec} mt-0.5`}>{timeAgo(ts)}</div>
                  </div>
                  <div className="col-span-3">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold ${info.bgColor} ${info.color}`}>
                      <span>{info.icon}</span>
                      {info.label}
                    </span>
                  </div>
                  <div className={`col-span-6 text-xs ${colors.text} font-medium truncate`} title={detailText}>
                    {detailText || <span className="italic opacity-50 text-slate-500">-</span>}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Alt bilgi */}
        {filteredLogs.length > 0 && (
          <div className={`px-4 md:px-6 py-3 border-t ${colors.border} flex justify-between items-center`}>
            <span className={`text-xs ${colors.textSec}`}>
              Toplam {filteredLogs.length} kayıt gösteriliyor
            </span>
            <span className={`text-[10px] ${colors.textSec}`}>
              Veriler son 15 gün tutulur, sonra otomatik silinir.
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

// --- GÜNLÜĞÜM / ÖĞRENCİ GÜNLÜĞÜ MODÜLÜ ---
const DIARY_MOODS = [
  { id: 'productive', label: 'Verimli', icon: '⚡', color: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
  { id: 'great', label: 'Harika', icon: '✨', color: 'bg-amber-500/15 text-amber-400 border-amber-500/30' },
  { id: 'focused', label: 'Odaklanmış', icon: '🎯', color: 'bg-blue-500/15 text-blue-400 border-blue-500/30' },
  { id: 'normal', label: 'Normal', icon: '☕', color: 'bg-slate-500/15 text-slate-400 border-slate-500/30' },
  { id: 'tired', label: 'Yorgun', icon: '😴', color: 'bg-purple-500/15 text-purple-400 border-purple-500/30' },
  { id: 'stressed', label: 'Stresli', icon: '🌧️', color: 'bg-rose-500/15 text-rose-400 border-rose-500/30' },
];

const DiaryModule = ({ user, student, onUpdateStudent, students = [] }) => {
  const colors = useThemeColors();
  const isStudent = user.role === 'student';

  const [showModal, setShowModal] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState('');

  const [form, setForm] = useState({
    title: '',
    content: '',
    mood: 'productive',
    date: new Date().toISOString().split('T')[0],
    time: new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
  });

  const diaryEntries = React.useMemo(() => Array.isArray(student?.diary) ? student.diary : [], [student?.diary]);

  // Sıralama: En son yazılan en üstte
  const sortedEntries = React.useMemo(() => {
    return [...diaryEntries].sort((a, b) => {
      const timeA = new Date(a.createdAt || a.date || 0).getTime();
      const timeB = new Date(b.createdAt || b.date || 0).getTime();
      return timeB - timeA;
    });
  }, [diaryEntries]);

  // Filtreleme
  const filteredEntries = sortedEntries.filter(entry => {
    const matchesSearch = !searchTerm ||
      (entry.title && entry.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (entry.content && entry.content.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesDate = !dateFilter || entry.date === dateFilter;
    return matchesSearch && matchesDate;
  });

  const openNewEntry = () => {
    setEditingEntry(null);
    setForm({
      title: '',
      content: '',
      mood: 'productive',
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
    });
    setShowModal(true);
  };

  const openEditEntry = (entry) => {
    setEditingEntry(entry);
    setForm({
      title: entry.title || '',
      content: entry.content || '',
      mood: entry.mood || 'productive',
      date: entry.date || new Date().toISOString().split('T')[0],
      time: entry.time || new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
    });
    setShowModal(true);
  };

  const handleSaveEntry = () => {
    if (!form.content.trim()) {
      return alert("Lütfen günlük içeriğini boş bırakmayınız.");
    }

    const now = new Date();
    const currentDate = form.date || now.toISOString().split('T')[0];
    const currentTime = form.time || now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

    let updatedList;
    if (editingEntry) {
      updatedList = diaryEntries.map(entry => {
        if (entry.id === editingEntry.id) {
          return {
            ...entry,
            title: form.title.trim(),
            content: form.content.trim(),
            mood: form.mood,
            date: currentDate,
            time: currentTime,
            updatedAt: now.toISOString()
          };
        }
        return entry;
      });
    } else {
      const newEntry = {
        id: 'diary_' + Date.now() + '_' + Math.random().toString(36).substring(2, 6),
        title: form.title.trim(),
        content: form.content.trim(),
        mood: form.mood,
        date: currentDate,
        time: currentTime,
        createdAt: now.toISOString(),
        updatedAt: null
      };
      updatedList = [newEntry, ...diaryEntries];
    }

    onUpdateStudent({ ...student, diary: updatedList });
    setShowModal(false);
    setEditingEntry(null);
  };

  const handleConfirmDelete = () => {
    if (!deleteConfirmId) return;
    const updatedList = diaryEntries.filter(entry => entry.id !== deleteConfirmId);
    onUpdateStudent({ ...student, diary: updatedList });
    setDeleteConfirmId(null);
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' });
      }
      const d = new Date(dateStr);
      return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' });
    } catch (e) {
      return dateStr;
    }
  };

  if (!student) {
    return (
      <div className={`text-center py-20 ${colors.textSec}`}>
        Lütfen işlem yapmak için bir öğrenci seçiniz.
      </div>
    );
  }

  return (
    <div className="space-y-6 animate-fade-in">
      {/* ÜST BAŞLIK BARI */}
      <div className={`p-6 rounded-2xl border ${colors.border} ${colors.bgCard} shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4`}>
        <div className="flex items-center gap-3.5">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-tr from-amber-500 to-orange-500 flex items-center justify-center text-white shadow-lg shadow-orange-500/20 shrink-0">
            <Book size={24} />
          </div>
          <div>
            <h2 className={`text-xl font-bold ${colors.text} flex items-center gap-2`}>
              {isStudent ? 'Günlüğüm' : `Öğrenci Günlüğü (${student.name})`}
            </h2>
            <p className={`text-xs ${colors.textSec} mt-0.5`}>
              {isStudent
                ? 'Günün nasıl geçti? Neler çalıştın, nasıl hissettin? Buraya dilediğince günlük yazabilirsin.'
                : 'Öğrencinin gün içinde yazdığı günlükleri, çalışma hislerini ve kaydedilme saatlerini buradan takip edebilirsiniz.'}
            </p>
          </div>
        </div>

        {/* Öğrenci için Yeni Günlük Butonu */}
        {isStudent && (
          <button
            onClick={openNewEntry}
            className="px-4 py-2.5 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold text-xs shadow-md shadow-orange-900/20 flex items-center justify-center gap-2 transition-all shrink-0"
          >
            <Plus size={16} />
            <span>Yeni Günlük Yaz</span>
          </button>
        )}
      </div>

      {/* İSTATİSTİK / ÖZET KARTLARI */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        <div className={`p-4 rounded-xl border ${colors.border} ${colors.bgCard} shadow-sm`}>
          <div className="flex items-center justify-between">
            <span className={`text-xs font-semibold ${colors.textSec}`}>Toplam Giriş</span>
            <BookOpen size={16} className="text-orange-400" />
          </div>
          <div className={`text-2xl font-bold ${colors.text} mt-2`}>{diaryEntries.length}</div>
          <span className={`text-[11px] ${colors.textSec}`}>kayıtlı günlük</span>
        </div>

        <div className={`p-4 rounded-xl border ${colors.border} ${colors.bgCard} shadow-sm`}>
          <div className="flex items-center justify-between">
            <span className={`text-xs font-semibold ${colors.textSec}`}>Son Günlük</span>
            <Clock size={16} className="text-amber-400" />
          </div>
          <div className={`text-sm font-bold ${colors.text} mt-2 truncate`}>
            {sortedEntries.length > 0 ? (sortedEntries[0].time ? `${sortedEntries[0].time}` : 'Bugün') : '-'}
          </div>
          <span className={`text-[11px] ${colors.textSec} truncate block`}>
            {sortedEntries.length > 0 ? formatDisplayDate(sortedEntries[0].date).split(',')[0] : 'Henüz yazılmadı'}
          </span>
        </div>

        <div className={`col-span-2 sm:col-span-1 p-4 rounded-xl border ${colors.border} ${colors.bgCard} shadow-sm`}>
          <div className="flex items-center justify-between">
            <span className={`text-xs font-semibold ${colors.textSec}`}>Öğrenci</span>
            <User size={16} className="text-blue-400" />
          </div>
          <div className={`text-sm font-bold ${colors.text} mt-2 truncate`}>{student.name}</div>
          <span className={`text-[11px] ${colors.textSec}`}>{student.grade || 'Öğrenci'}</span>
        </div>
      </div>

      {/* ARAMA VE FİLTRELEME ÇUBUĞU */}
      <div className={`p-3 rounded-xl border ${colors.border} ${colors.bgCard} shadow-sm flex flex-col sm:flex-row items-center gap-3`}>
        <div className="relative flex-1 w-full">
          <Search size={16} className={`absolute left-3.5 top-1/2 -translate-y-1/2 ${colors.textSec}`} />
          <input
            type="text"
            placeholder="Günlüklerde ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={`w-full pl-9 pr-4 py-2 rounded-lg text-xs ${colors.inputBg} border ${colors.inputBorder} ${colors.text} focus:border-orange-500 outline-none`}
          />
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto">
          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            className={`px-3 py-2 rounded-lg text-xs ${colors.inputBg} border ${colors.inputBorder} ${colors.text} focus:border-orange-500 outline-none`}
          />
          {(searchTerm || dateFilter) && (
            <button
              onClick={() => { setSearchTerm(''); setDateFilter(''); }}
              className={`px-3 py-2 rounded-lg text-xs border ${colors.border} ${colors.textSec} hover:${colors.text} transition-colors whitespace-nowrap`}
            >
              Filtreyi Temizle
            </button>
          )}
        </div>
      </div>

      {/* GÜNLÜK KARTLARI LİSTESİ */}
      {filteredEntries.length === 0 ? (
        <div className={`p-12 text-center rounded-2xl border-2 border-dashed ${colors.border} ${colors.bgCard}`}>
          <div className={`w-16 h-16 rounded-full ${colors.isDark ? 'bg-slate-800' : 'bg-slate-100'} flex items-center justify-center mx-auto mb-3 text-slate-400`}>
            <BookOpen size={28} />
          </div>
          <h3 className={`text-base font-bold ${colors.text} mb-1`}>
            {searchTerm || dateFilter ? 'Aranan Kriterde Günlük Bulunamadı' : 'Henüz Günlük Yazılmamış'}
          </h3>
          <p className={`text-xs ${colors.textSec} max-w-sm mx-auto mb-5`}>
            {isStudent
              ? 'Bugün yaptığın çalışmaları, hedeflerini veya aklına gelenleri yazarak günlüğünü tutmaya başla!'
              : 'Öğrenci henüz bir günlük girişi yapmamış. Öğrenci yazdığında burada anlık olarak görünecektir.'}
          </p>
          {isStudent && (
            <button
              onClick={openNewEntry}
              className="px-4 py-2 rounded-xl bg-orange-500 hover:bg-orange-600 text-white text-xs font-semibold inline-flex items-center gap-2 shadow-md transition-colors"
            >
              <Plus size={15} />
              <span>İlk Günlüğünü Yaz</span>
            </button>
          )}
        </div>
      ) : (
        <div className="space-y-4">
          {filteredEntries.map((entry) => {
            const moodObj = DIARY_MOODS.find(m => m.id === entry.mood) || DIARY_MOODS[0];
            return (
              <div
                key={entry.id}
                className={`p-5 rounded-2xl border ${colors.border} ${colors.bgCard} shadow-sm hover:shadow-md transition-all group relative overflow-hidden`}
              >
                {/* SOL RENK ŞERİDİ */}
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-orange-500 to-amber-500"></div>

                {/* ÜST BİLGİ SATIRI */}
                <div className={`flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 pb-3 border-b border-dashed ${colors.border}`}>
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="flex items-center gap-1.5 text-xs font-bold text-orange-500">
                      <Calendar size={14} />
                      <span>{formatDisplayDate(entry.date)}</span>
                    </div>

                    {/* KAYDEDİLME SAATİ ROZETİ */}
                    {entry.time && (
                      <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold border ${colors.isDark ? 'bg-amber-500/15 text-amber-300 border-amber-500/30' : 'bg-amber-50 text-amber-700 border-amber-300'}`}>
                        <Clock size={11} />
                        <span>Saat: {entry.time}</span>
                      </span>
                    )}

                    {/* DUYGU ROZETİ */}
                    {moodObj && (
                      <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold border ${moodObj.color}`}>
                        <span>{moodObj.icon}</span>
                        <span>{moodObj.label}</span>
                      </span>
                    )}

                    {/* DÜZENLENME BİLGİSİ */}
                    {entry.updatedAt && (
                      <span className={`text-[10px] ${colors.textSec} italic`}>
                        (Düzenlendi)
                      </span>
                    )}
                  </div>

                  {/* İŞLEM BUTONLARI (SADECE ÖĞRENCİ) */}
                  {isStudent && (
                    <div className="flex items-center gap-1.5 self-end sm:self-auto">
                      <button
                        onClick={() => openEditEntry(entry)}
                        className={`p-1.5 rounded-lg text-blue-400 hover:text-blue-300 hover:bg-blue-500/10 transition-colors`}
                        title="Günlüğü Düzenle"
                      >
                        <Edit2 size={15} />
                      </button>
                      <button
                        onClick={() => setDeleteConfirmId(entry.id)}
                        className={`p-1.5 rounded-lg text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors`}
                        title="Günlüğü Sil"
                      >
                        <Trash2 size={15} />
                      </button>
                    </div>
                  )}
                </div>

                {/* GÜNLÜK BAŞLIK & İÇERİK */}
                <div className="pt-3.5 space-y-2">
                  {entry.title && (
                    <h4 className={`text-base font-bold ${colors.text}`}>
                      {entry.title}
                    </h4>
                  )}
                  <p className={`text-sm ${colors.text} whitespace-pre-wrap leading-relaxed`}>
                    {entry.content}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* YENİ GÜNLÜK YAZMA / DÜZENLEME MODALI */}
      {showModal && (
        <Modal
          title={editingEntry ? 'Günlüğü Düzenle' : 'Yeni Günlük Yaz'}
          onClose={() => { setShowModal(false); setEditingEntry(null); }}
          maxWidth="max-w-xl"
        >
          <div className="space-y-4">
            {/* Tarih & Saat Satırı */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className={`block text-xs font-semibold ${colors.textSec} mb-1.5`}>Tarih</label>
                <input
                  type="date"
                  value={form.date}
                  onChange={(e) => setForm({ ...form, date: e.target.value })}
                  className={`w-full px-3.5 py-2.5 rounded-xl text-xs ${colors.inputBg} border ${colors.inputBorder} ${colors.text} focus:border-orange-500 outline-none`}
                />
              </div>
              <div>
                <label className={`block text-xs font-semibold ${colors.textSec} mb-1.5`}>Kayıt Saati</label>
                <input
                  type="time"
                  value={form.time}
                  onChange={(e) => setForm({ ...form, time: e.target.value })}
                  className={`w-full px-3.5 py-2.5 rounded-xl text-xs ${colors.inputBg} border ${colors.inputBorder} ${colors.text} focus:border-orange-500 outline-none`}
                />
              </div>
            </div>

            {/* Başlık */}
            <div>
              <label className={`block text-xs font-semibold ${colors.textSec} mb-1.5`}>
                Başlık <span className="opacity-60 font-normal">(İsteğe bağlı)</span>
              </label>
              <input
                type="text"
                placeholder="Örn: Bugünkü matematik kampı, deneme sonrası hisler..."
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                className={`w-full px-3.5 py-2.5 rounded-xl text-xs ${colors.inputBg} border ${colors.inputBorder} ${colors.text} focus:border-orange-500 outline-none`}
              />
            </div>

            {/* Ruh Hali Seçimi */}
            <div>
              <label className={`block text-xs font-semibold ${colors.textSec} mb-1.5`}>Günün Hali / Modu</label>
              <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
                {DIARY_MOODS.map((m) => (
                  <button
                    key={m.id}
                    type="button"
                    onClick={() => setForm({ ...form, mood: m.id })}
                    className={`p-2 rounded-xl border text-center transition-all flex flex-col items-center gap-1 ${form.mood === m.id
                      ? 'border-orange-500 bg-orange-500/15 shadow-sm scale-105'
                      : `${colors.border} ${colors.hoverBg} opacity-70 hover:opacity-100`}`}
                  >
                    <span className="text-base">{m.icon}</span>
                    <span className={`text-[10px] font-bold ${colors.text}`}>{m.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Günlük İçeriği */}
            <div>
              <label className={`block text-xs font-semibold ${colors.textSec} mb-1.5`}>
                Sevgili Günlük... <span className="text-orange-500">*</span>
              </label>
              <textarea
                rows={7}
                placeholder="Bugün neler yaptın? Hangi hedeflere ulaştın? Seni zorlayan veya mutlu eden anlar nelerdi? Buraya özgürce dökebilirsin..."
                value={form.content}
                onChange={(e) => setForm({ ...form, content: e.target.value })}
                className={`w-full p-3.5 rounded-xl text-xs ${colors.inputBg} border ${colors.inputBorder} ${colors.text} focus:border-orange-500 outline-none leading-relaxed`}
              />
            </div>

            {/* Alt Butonlar */}
            <div className="flex items-center justify-end gap-2.5 pt-2">
              <button
                type="button"
                onClick={() => { setShowModal(false); setEditingEntry(null); }}
                className={`px-4 py-2.5 rounded-xl text-xs font-semibold border ${colors.border} ${colors.textSec} hover:${colors.text} transition-colors`}
              >
                İptal
              </button>
              <button
                type="button"
                onClick={handleSaveEntry}
                className="px-5 py-2.5 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-semibold text-xs flex items-center gap-1.5 shadow-md shadow-orange-900/20 transition-all"
              >
                <Save size={15} />
                <span>{editingEntry ? 'Güncelle' : 'Günlüğe Kaydet'}</span>
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* SİLME ONAY MODALI */}
      <DeleteConfirmModal
        isOpen={!!deleteConfirmId}
        onClose={() => setDeleteConfirmId(null)}
        onConfirm={handleConfirmDelete}
        message="Bu günlük kaydını silmek istediğinize emin misiniz? Bu işlem geri alınamaz."
      />
    </div>
  );
};

// --- LANDING PAGE (GÜNCELLENDİ: WhatsApp Logolu) ---
const LandingPage = ({ onGoToLogin }) => {
  // WhatsApp SVG İkonu (Orijinal Görünüm İçin)
  const WhatsAppIcon = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" className="inline-block">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.008-.57-.008-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );

  return (
    <div className="min-h-screen bg-slate-950 text-white font-sans selection:bg-orange-500 selection:text-white">
      {/* Header */}
      <nav className="container mx-auto px-6 py-6 flex justify-between items-center">
        <div className="flex items-center gap-2 font-bold text-2xl tracking-tighter text-orange-500">
          <Target size={28} /> Koçum Online
        </div>
        <button
          onClick={onGoToLogin}
          className="bg-white text-slate-900 px-6 py-2.5 rounded-full font-bold text-sm hover:bg-orange-500 hover:text-white transition-all transform hover:scale-105 shadow-lg shadow-white/10"
        >
          Panele Giriş
        </button>
      </nav>

      {/* Hero Section */}
      <div className="container mx-auto px-6 py-12 md:py-20 flex flex-col md:flex-row items-center gap-12">
        <div className="flex-1 space-y-6 animate-fade-in">
          <div className="inline-block px-4 py-1.5 rounded-full bg-orange-500/10 border border-orange-500/20 text-orange-400 text-xs font-bold uppercase tracking-wider mb-2">
            Profesyonel Öğrenci Koçluğu
          </div>
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            Başarıya Giden Yolda <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-500">Dijital Yol Arkadaşın</span>
          </h1>
          <p className="text-slate-400 text-lg md:text-xl leading-relaxed max-w-xl">
            Öğrenci takibi, analizler, yapay zeka destekli raporlamalar ve çok daha fazlası. Koçum Online ile potansiyelini keşfet.
          </p>
          <div className="flex gap-4 pt-4">
            <button onClick={onGoToLogin} className="px-8 py-4 bg-orange-600 hover:bg-orange-700 rounded-xl font-bold text-white shadow-lg shadow-orange-500/25 transition-all flex items-center gap-2">
              Hemen Başla <ChevronRight size={20} />
            </button>
            {/* GÜNCELLEME: WhatsApp Butonu */}
            <a href="https://wa.me/905419706821" target="_blank" rel="noreferrer" className="px-8 py-4 bg-emerald-600 hover:bg-emerald-700 border border-emerald-600 rounded-xl font-bold text-white transition-all flex items-center gap-2 shadow-lg shadow-emerald-500/20">
              <WhatsAppIcon /> WhatsApp
            </a>
          </div>
        </div>

        {/* Görsel / Grafik Alanı */}
        <div className="flex-1 relative">
          <div className="absolute -inset-4 bg-gradient-to-r from-orange-500 to-purple-600 rounded-full blur-3xl opacity-20 animate-pulse"></div>
          <div className="relative bg-slate-900 border border-slate-800 p-6 rounded-2xl shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500">
            <div className="flex items-center gap-4 mb-6 border-b border-slate-800 pb-4">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
            <div className="space-y-4">
              <div className="h-32 bg-slate-800/50 rounded-lg flex items-end justify-between p-4 px-8">
                <div className="w-8 h-12 bg-orange-500/20 rounded-t"></div>
                <div className="w-8 h-20 bg-orange-500/40 rounded-t"></div>
                <div className="w-8 h-16 bg-orange-500/30 rounded-t"></div>
                <div className="w-8 h-24 bg-orange-500/60 rounded-t"></div>
                <div className="w-8 h-28 bg-orange-500 rounded-t shadow-lg shadow-orange-500/20"></div>
              </div>
              <div className="flex gap-4">
                <div className="flex-1 h-20 bg-slate-800/50 rounded-lg p-3">
                  <div className="w-8 h-8 rounded bg-blue-500/20 text-blue-500 flex items-center justify-center mb-2"><Activity size={16} /></div>
                  <div className="h-2 w-16 bg-slate-700 rounded"></div>
                </div>
                <div className="flex-1 h-20 bg-slate-800/50 rounded-lg p-3">
                  <div className="w-8 h-8 rounded bg-green-500/20 text-green-500 flex items-center justify-center mb-2"><CheckCircle size={16} /></div>
                  <div className="h-2 w-16 bg-slate-700 rounded"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="container mx-auto px-6 py-20 border-t border-slate-900">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="p-6 bg-slate-900/50 border border-slate-800 rounded-2xl hover:border-orange-500/30 transition-colors">
            <div className="w-12 h-12 rounded-xl bg-orange-500/10 text-orange-500 flex items-center justify-center mb-4"><BarChart2 size={24} /></div>
            <h3 className="text-xl font-bold mb-2">Detaylı Analiz</h3>
            <p className="text-slate-400 text-sm">Deneme sonuçlarınızı, konu eksiklerinizi ve gelişim grafiğinizi anlık olarak takip edin.</p>
          </div>
          <div className="p-6 bg-slate-900/50 border border-slate-800 rounded-2xl hover:border-blue-500/30 transition-colors">
            <div className="w-12 h-12 rounded-xl bg-blue-500/10 text-blue-500 flex items-center justify-center mb-4"><Calendar size={24} /></div>
            <h3 className="text-xl font-bold mb-2">Akıllı Planlama</h3>
            <p className="text-slate-400 text-sm">Haftalık ders programınızı oluşturun, hedeflerinizi belirleyin ve zamanı yönetin.</p>
          </div>
          <div className="p-6 bg-slate-900/50 border border-slate-800 rounded-2xl hover:border-green-500/30 transition-colors">
            <div className="w-12 h-12 rounded-xl bg-green-500/10 text-green-500 flex items-center justify-center mb-4"><Users size={24} /></div>
            <h3 className="text-xl font-bold mb-2">Koç Desteği</h3>
            <p className="text-slate-400 text-sm">Öğretmeninizle sürekli iletişimde kalın, notlar alın ve rehberlik desteğiyle ilerleyin.</p>
          </div>
        </div>
      </div>

      {/* Footer / Contact */}
      <footer className="bg-slate-900 border-t border-slate-800 py-12">
        <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <h4 className="font-bold text-lg mb-1">Koçum Online</h4>
            <p className="text-slate-500 text-xs italic">Uzm. Psk. Dan. Hamza Metehan Kılıç tarafından geliştirilmiştir.</p>
            <p className="text-slate-600 text-[10px] mt-1">Tüm Hakları Saklıdır © 2025</p>
          </div>
          <div className="flex flex-col md:flex-row gap-6">
            <a href="https://instagram.com/kocum.onlinee" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-slate-400 hover:text-pink-500 transition-colors">
              <div className="p-2 bg-slate-800 rounded-lg"><User size={18} /></div>
              <span>@kocum.onlinee</span>
            </a>
            <a href="https://wa.me/905419706821" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-slate-400 hover:text-emerald-500 transition-colors">
              <div className="p-2 bg-slate-800 rounded-lg"><WhatsAppIcon /></div>
              <span>0541 970 68 21</span>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

// --- LOGIN SCREEN (GÜNCELLENDİ: Enter Tuşu Desteği) ---
const LoginScreen = ({ onLogin, students, admins, isFirebase, isLoading }) => {
  const [mode, setMode] = useState('login');
  const [activeTab, setActiveTab] = useState('admin');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [regForm, setRegForm] = useState({ name: '', phone: '', username: '', password: '' });

  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleLogin = () => {
    setError('');
    setSuccessMsg('');

    if (activeTab === 'admin') {
      const adminUser = admins.find(a => a.username === username && a.password === password);
      if (adminUser) {
        const role = adminUser.role === 'superadmin' ? 'superadmin' : 'admin';
        onLogin({ role: role, id: adminUser.id, name: adminUser.name, username: adminUser.username, password: adminUser.password });
        return;
      }
      setError('Hatalı yönetici bilgisi.');
    } else {
      const student = students.find(s => s.username === username && s.password === password);
      if (student) onLogin({ role: 'student', id: student.id, name: student.name, username: student.username, password: student.password });
      else setError('Hatalı kullanıcı adı veya şifre.');
    }
  };

  const handleRegister = async () => {
    setError('');
    setSuccessMsg('');
    if (!regForm.name || !regForm.phone || !regForm.username || !regForm.password) { return setError("Lütfen tüm alanları doldurunuz."); }

    const adminExists = admins.some(a => a.username === regForm.username);
    const studentExists = students.some(s => s.username === regForm.username);

    if (adminExists || studentExists) { return setError("Bu kullanıcı adı başkası tarafından alınmış."); }

    const today = new Date();
    const trialEndDate = new Date(today);
    trialEndDate.setDate(today.getDate() + 15);
    const startDateStr = today.toISOString().split('T')[0];
    const endDateStr = trialEndDate.toISOString().split('T')[0];

    const newAdminUser = { name: regForm.name, username: regForm.username, password: regForm.password, phone: regForm.phone, role: 'admin', studentLimit: 5, startDate: startDateStr, endDate: endDateStr };

    if (isFirebase) {
      try {
        await addDoc(collection(db, "admins"), newAdminUser);
        setSuccessMsg("Kayıt başarılı! Şimdi giriş yapabilirsiniz.");
        setRegForm({ name: '', phone: '', username: '', password: '' });
        setTimeout(() => { setMode('login'); setUsername(newAdminUser.username); setPassword(''); }, 1500);
      } catch (e) { console.error(e); setError("Kayıt hatası: " + e.message); }
    } else {
      alert("Demo modunda kayıt işlemi simüle edilmiştir.");
      setMode('login');
    }
  };

  // KLAVYE ENTER KONTROLÜ (YENİ EKLENEN KISIM)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (mode === 'login') handleLogin();
      else handleRegister();
    }
  };

  if (isLoading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center"><div className="text-orange-500 font-bold animate-pulse">Sistem Yükleniyor...</div></div>;

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="bg-slate-900 p-8 rounded-2xl w-full max-w-md border border-slate-800 shadow-2xl relative">

        {!isFirebase && <div className="absolute top-2 right-2 bg-yellow-500/20 text-yellow-500 text-[10px] px-2 py-1 rounded border border-yellow-500/30 flex items-center gap-1"><CloudOff size={12} /> Demo Modu</div>}
        {isFirebase && <div className="absolute top-2 right-2 bg-emerald-500/20 text-emerald-500 text-[10px] px-2 py-1 rounded border border-emerald-500/30 flex items-center gap-1"><Cloud size={12} /> Canlı Bağlantı</div>}

        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-white mb-2">Koçum Online</h1>
          <p className="text-slate-500 text-xs">Profesyonel Öğrenci Takip Sistemi</p>
        </div>

        <div className="flex bg-slate-800 p-1 rounded-lg mb-6">
          <button onClick={() => { setMode('login'); setError(''); setSuccessMsg(''); }} className={`flex-1 py-2 rounded-md text-sm font-bold transition-all ${mode === 'login' ? 'bg-orange-600 text-white' : 'text-slate-400 hover:text-white'}`}>Giriş Yap</button>
          <button onClick={() => { setMode('register'); setError(''); setSuccessMsg(''); }} className={`flex-1 py-2 rounded-md text-sm font-bold transition-all ${mode === 'register' ? 'bg-orange-600 text-white' : 'text-slate-400 hover:text-white'}`}>Kayıt Ol</button>
        </div>

        {mode === 'login' && (
          <div className="space-y-4 animate-fade-in">
            <div className="flex bg-slate-800/50 p-1 rounded-lg mb-2">
              <button onClick={() => { setActiveTab('admin'); setError(''); }} className={`flex-1 py-1.5 rounded text-xs font-bold transition-all ${activeTab === 'admin' ? 'bg-slate-700 text-white shadow' : 'text-slate-500 hover:text-slate-300'}`}>Öğretmen</button>
              <button onClick={() => { setActiveTab('student'); setError(''); }} className={`flex-1 py-1.5 rounded text-xs font-bold transition-all ${activeTab === 'student' ? 'bg-slate-700 text-white shadow' : 'text-slate-500 hover:text-slate-300'}`}>Öğrenci</button>
            </div>

            <Input label="Kullanıcı Adı" value={username} onChange={e => setUsername(e.target.value)} onKeyDown={handleKeyDown} />
            <Input label="Şifre" type="password" placeholder="••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={handleKeyDown} />

            {error && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded text-red-400 text-sm text-center flex items-center justify-center gap-2"><Shield size={14} /> {error}</div>}
            {successMsg && <div className="p-3 bg-emerald-500/10 border border-emerald-500/20 rounded text-emerald-400 text-sm text-center flex items-center justify-center gap-2"><CheckCircle size={14} /> {successMsg}</div>}

            <Button size="large" className="w-full" onClick={handleLogin}>Giriş Yap</Button>
          </div>
        )}

        {mode === 'register' && (
          <div className="space-y-4 animate-fade-in">
            <div className="bg-blue-500/10 border border-blue-500/20 p-3 rounded text-blue-400 text-xs text-center mb-4">
              Kayıt olduğunuzda <b>15 Günlük Deneme Sürümü</b> ve <b>5 Öğrenci Kotası</b> hesabınıza otomatik tanımlanacaktır.
            </div>

            <Input label="Ad Soyad" placeholder="Adınız Soyadınız" value={regForm.name} onChange={e => setRegForm({ ...regForm, name: e.target.value })} />
            <Input label="Telefon" placeholder="05XX XXX XX XX" value={regForm.phone} onChange={e => setRegForm({ ...regForm, phone: e.target.value })} />
            <Input label="Kullanıcı Adı" placeholder="Benzersiz bir kullanıcı adı" value={regForm.username} onChange={e => setRegForm({ ...regForm, username: e.target.value })} />
            <Input label="Şifre" type="password" placeholder="Güçlü bir şifre belirleyin" value={regForm.password} onChange={e => setRegForm({ ...regForm, password: e.target.value })} onKeyDown={handleKeyDown} />

            {error && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded text-red-400 text-sm text-center">{error}</div>}
            {successMsg && <div className="p-3 bg-emerald-500/10 border border-emerald-500/20 rounded text-emerald-400 text-sm text-center">{successMsg}</div>}

            <Button size="large" className="w-full bg-emerald-600 hover:bg-emerald-700" onClick={handleRegister}>Ücretsiz Kayıt Ol</Button>
          </div>
        )}

        {/* GELİŞTİRİCİ BİLGİSİ */}
        <div className="mt-8 pt-6 border-t border-slate-800">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-orange-500/10 flex items-center justify-center text-orange-500 shrink-0">
              <GraduationCap size={20} />
            </div>
            <div className="space-y-1">
              <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">Sistem Geliştiricisi</p>
              <h4 className="text-sm font-bold text-white">Uzm. Psk. Dan. Hamza Metehan Kılıç</h4>
              <p className="text-[11px] text-slate-500 leading-relaxed">
                Lisans eğitimini PDR bölümünde; Yüksek Lisans uzmanlıklarını ise Psikolojik Danışmanlık ve Eğitim Bilimleri anabilim dallarında tamamlamıştır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- ANA UYGULAMA ---
const MainApp = () => {
  const AUTH_STORAGE_KEY = 'kocluk_auth_user';
  const UI_ACTIVE_TAB_KEY = 'kocluk_ui_active_tab';
  const UI_SELECTED_STUDENT_KEY = 'kocluk_ui_selected_student_id';
  const [user, setUser] = useState(() => {
    if (typeof window === 'undefined') return null;
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  });
  const [students, setStudents] = useState(INITIAL_STUDENTS);
  const [admins, setAdmins] = useState(INITIAL_ADMINS);
  const [classes, setClasses] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [viewMode, setViewMode] = useState('landing');
  const [curriculum, setCurriculum] = useState(INITIAL_CURRICULUM);
  const [selectedStudentId, setSelectedStudentId] = useState(() => {
    if (typeof window === 'undefined') return null;
    try {
      return localStorage.getItem(UI_SELECTED_STUDENT_KEY);
    } catch (e) {
      return null;
    }
  });
  const [activeTab, setActiveTab] = useState(() => {
    if (typeof window === 'undefined') return 'dashboard';
    try {
      const hash = (window.location.hash || '').replace('#', '').trim();
      if (hash) return hash;
      return localStorage.getItem(UI_ACTIVE_TAB_KEY) || 'dashboard';
    } catch (e) {
      return 'dashboard';
    }
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Sınav Tarihleri State'i (Local Storage'dan okur)
  const [systemSettings, setSystemSettings] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('exam_dates');
      return saved ? JSON.parse(saved) : { tytDate: '', aytDate: '', lgsDate: '' };
    }
    return { tytDate: '', aytDate: '', lgsDate: '' };
  });

  const [curriculumTemplates, setCurriculumTemplates] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('curriculum_templates');
      return saved ? JSON.parse(saved) : null;
    }
    return null;
  });

  useEffect(() => {
    if (curriculumTemplates) {
      try {
        localStorage.setItem('curriculum_templates', JSON.stringify(curriculumTemplates));
      } catch (e) {}
    }
  }, [curriculumTemplates]);

  const activeTemplatesPool = curriculumTemplates || STATIC_POOL;

  // Menü Daraltma Kontrolü
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const [isLoading, setIsLoading] = useState(isFirebaseActive);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [popups, setPopups] = useState([]);
  const [versionConfig, setVersionConfig] = useState(null);

  useEffect(() => {
    const unsub = subscribeVersionConfig(db, isFirebaseActive, (cfg) => {
      setVersionConfig(cfg);
    });
    return () => {
      if (typeof unsub === 'function') unsub();
    };
  }, []);

  useEffect(() => {
    const unsub = subscribePopups(db, isFirebaseActive, (data) => {
      setPopups(data || []);
    });
    registerServiceWorker();
    return () => {
      if (typeof unsub === 'function') unsub();
    };
  }, []);

  // Arka planda veya açıkken gelen Push bildirimlerini yakala ve üstten düşür
  useEffect(() => {
    if (!user || !popups || popups.length === 0) return;
    popups.forEach(p => {
      handleIncomingPushItem(p, user);
    });
  }, [user, popups]);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (user) localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
      else localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch (e) { }
  }, [user]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      localStorage.setItem(UI_ACTIVE_TAB_KEY, activeTab);
      if ((window.location.hash || '').replace('#', '') !== activeTab) {
        window.history.replaceState(null, '', `#${activeTab}`);
      }
    } catch (e) { }
  }, [activeTab]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (selectedStudentId) localStorage.setItem(UI_SELECTED_STUDENT_KEY, selectedStudentId);
      else localStorage.removeItem(UI_SELECTED_STUDENT_KEY);
    } catch (e) { }
  }, [selectedStudentId]);

  useEffect(() => {
    document.title = "Koçum Online";
  }, []);
  const colors = useThemeColors();

  useEffect(() => {
    if (isFirebaseActive) {
      setIsLoading(true);
      const unsubStudents = onSnapshot(query(collection(db, "students")), (snap) => {
        setStudents(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))); setIsLoading(false);
      });
      const unsubAdmins = onSnapshot(query(collection(db, "admins")), (snap) => {
        const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        if (data.length > 0) {
          setAdmins(data);
          // Sınav tarihlerini admin dokümanlarından anlık senkronize et
          const adminWithDates = data.find(a => a.role === 'superadmin' && a.examDates) || data.find(a => a.examDates);
          if (adminWithDates && adminWithDates.examDates) {
            const d = adminWithDates.examDates;
            setSystemSettings(prev => {
              if (!prev || prev.tytDate !== d.tytDate || prev.aytDate !== d.aytDate || prev.lgsDate !== d.lgsDate) {
                try { localStorage.setItem('exam_dates', JSON.stringify(d)); } catch (e) {}
                return d;
              }
              return prev;
            });
          }
          // Müfredat şablonlarını admin dokümanından senkronize et
          const adminWithTemplates = data.find(a => a.curriculumTemplates);
          if (adminWithTemplates && adminWithTemplates.curriculumTemplates) {
            setCurriculumTemplates(adminWithTemplates.curriculumTemplates);
          }
        }
      }, (err) => {
        console.warn("Admins snapshot dinleme uyarısı:", err.message);
      });
      const unsubClasses = onSnapshot(query(collection(db, "classes")), (snap) => {
        const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setClasses(data.filter(c => !c.deleted));
      });
      const unsubNotif = onSnapshot(query(collection(db, "notifications")), (snap) => {
        setNotifications(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a, b) => new Date(b.date) - new Date(a.date)));
      });
      const unsubSettings = onSnapshot(doc(db, "settings", "exam_dates"), (doc) => {
        if (doc.exists()) {
          const d = doc.data();
          setSystemSettings(d);
          try { localStorage.setItem('exam_dates', JSON.stringify(d)); } catch (e) {}
        }
      }, (err) => {
        console.warn("settings/exam_dates dinleme uyarısı (admin dokümanı kullanılıyor):", err.message);
      });
      const unsubTemplates = onSnapshot(doc(db, "settings", "curriculum_templates"), (doc) => {
        if (doc.exists() && doc.data().pool) setCurriculumTemplates(doc.data().pool);
      }, (err) => {
        console.warn("settings/curriculum_templates dinleme uyarısı:", err.message);
      });
      return () => { unsubStudents(); unsubAdmins(); unsubClasses(); unsubNotif(); unsubSettings(); unsubTemplates(); };
    } else { setIsLoading(false); }
  }, []);

  useEffect(() => {
    if (!user) return;
    if (isLoading) return;

    if (user.role === 'student') {
      const exists = students.some(s => s.id === user.id && s.username === user.username);
      if (!exists) setUser(null);
      return;
    }

    if (user.role === 'admin' || user.role === 'superadmin') {
      const exists = admins.some(a => a.id === user.id && a.username === user.username);
      if (!exists) setUser(null);
    }
  }, [user, isLoading, students, admins]);

  useEffect(() => {
    if (!user) return;
    const allowedTabsByRole = {
      superadmin: ['dashboard', 'schedule', 'lessons', 'goals', 'routines', 'resources', 'mood', 'exams', 'interviews', 'diary', 'resource_recommendations', 'payment', 'admin_panel', 'exam_analysis', 'activity', 'ai_usage', 'popup_notifications', 'version_management'],
      admin: ['dashboard', 'schedule', 'lessons', 'goals', 'routines', 'resources', 'mood', 'exams', 'interviews', 'diary', 'resource_recommendations', 'payment', 'exam_analysis', 'activity'],
      student: ['dashboard', 'schedule', 'goals', 'routines', 'resources', 'mood', 'exams', 'diary', 'study_timer', 'my_notes', 'payment', 'exam_analysis'],
    };
    const allowed = allowedTabsByRole[user.role] || ['dashboard'];
    if (!allowed.includes(activeTab)) setActiveTab('dashboard');
  }, [user, activeTab]);

  const myStudents = React.useMemo(() => {
    if (!user) return [];
    if (user.role === 'student') return students.filter(s => s.id === user.id);
    return students.filter(s => s.teacherId === user.id && !s.isArchived);
  }, [user, students]);

  const myArchivedStudents = React.useMemo(() => {
    if (!user) return [];
    if (user.role === 'student') return [];
    return students.filter(s => s.teacherId === user.id && s.isArchived);
  }, [user, students]);

  const myClasses = React.useMemo(() => {
    if (!user) return [];
    if (user.role === 'superadmin') return classes;
    return classes.filter(c => c.teacherId === user.id);
  }, [user, classes]);

  const licenseInfo = React.useMemo(() => {
    if (!user || user.role === 'student' || user.role === 'superadmin') return { daysLeft: 999, isExpired: false, limit: 9999 };
    const currentAdmin = admins.find(a => a.id === user.id) || user;
    const daysLeft = currentAdmin.endDate ? Math.ceil((new Date(currentAdmin.endDate) - new Date()) / (1000 * 60 * 60 * 24)) : 0;
    return { daysLeft, isExpired: daysLeft < 0, limit: currentAdmin.studentLimit || 20, used: myStudents.length };
  }, [user, admins, myStudents]);

  
  
  useEffect(() => {
    if ((user?.role === 'admin' || user?.role === 'superadmin') && myStudents.length > 0 && (selectedStudentId === null || !myStudents.some(s => s.id === selectedStudentId))) {
      setSelectedStudentId(myStudents[0].id);
    }
  }, [user, myStudents, selectedStudentId]);

  const currentStudent = (user?.role === 'admin' || user?.role === 'superadmin')
    ? students.find(s => String(s.id) === String(selectedStudentId))
    : students.find(s => String(s.id) === String(user?.id));

  const updateStudentData = async (updated, options = {}) => {
    if (!updated || !updated.id) return;
    if (licenseInfo.isExpired && user.role === 'admin') return alert("Üyeliğinizin süresi dolmuştur.");
    const studentId = String(updated.id);
    setStudents(prev => prev.map(s => String(s.id) === studentId ? updated : s));
    if (options?.skipFirestore) return;
    if (isFirebaseActive) {
      try {
        const { id, ...data } = updated;
        const cleanData = sanitizeForFirestore(data);
        await setDoc(doc(db, "students", studentId), cleanData, { merge: true });
      } catch (error) {
        console.error("Öğrenci güncelleme Firestore hatası:", error);
        if (error?.message?.includes("exceeds maximum size") || error?.code === 'resource-exhausted') {
          try {
            // Dokümandaki eski devasa base64 resimlerin boyutunu otomatik küçültmeyi dene
            if (Array.isArray(updated?.assignments)) {
              let hasShrunk = false;
              const shrunkAssignments = updated.assignments.map(a => {
                if (Array.isArray(a.images) && a.images.length > 0) {
                  return {
                    ...a,
                    images: a.images.map(img => {
                      if (img.url && img.url.length > 100000) {
                        hasShrunk = true;
                        return { ...img, url: '' };
                      }
                      return img;
                    })
                  };
                }
                return a;
              });
              if (hasShrunk) {
                const recoveryData = sanitizeForFirestore({ ...updated, assignments: shrunkAssignments });
                delete recoveryData.id;
                await setDoc(doc(db, "students", studentId), recoveryData, { merge: true });
                return;
              }
            }
          } catch (recoveryErr) {
            console.error("Kurtarma hatası:", recoveryErr);
          }
          alert("Uyarı: Öğrenci verisi depolama sınırını (1 MB) aştı. Lütfen eski haftaları veya fotoğrafları temizleyin.");
        } else {
          alert("Bağlantı hatası: Öğrenci verisi veritabanına kaydedilemedi.");
        }
      }
    }
  };

  const handleUpdateProfile = async (updatedUser) => {
    if (!updatedUser || !updatedUser.id) return;
    setUser(updatedUser);
    const userId = String(updatedUser.id);
    if (updatedUser.role === 'student') {
      setStudents(prev => prev.map(s => String(s.id) === userId ? updatedUser : s));
    } else {
      setAdmins(prev => prev.map(a => String(a.id) === userId ? updatedUser : a));
    }
    const collectionName = updatedUser.role === 'student' ? 'students' : 'admins';
    if (isFirebaseActive) {
      const { id, ...data } = updatedUser;
      try {
        await setDoc(doc(db, collectionName, userId), sanitizeForFirestore(data), { merge: true });
      } catch (e) {
        console.error("Profil güncelleme hatası:", e);
      }
    }
  };

  const handleInspectStudent = (studentId) => { setSelectedStudentId(studentId); setActiveTab('dashboard'); };
  const handleLoginSuccess = async (loggedInUser) => {
    setUser(loggedInUser);
    setViewMode('app');
    if (loggedInUser.role === 'student') {
      try {
        await logActivity(loggedInUser.id, 'login', { role: loggedInUser.role });
      } catch (e) {
        console.error('Login log error', e);
      }
    }
  };

  

  if (!user) return viewMode === 'landing' ? <LandingPage onGoToLogin={() => setViewMode('login')} /> : <LoginScreen onLogin={handleLoginSuccess} students={students} admins={admins} isFirebase={isFirebaseActive} isLoading={isLoading} />;

  const MENU_ITEMS = [
    { id: 'dashboard', label: 'Ana Sayfa', icon: Layout, roles: ['superadmin', 'admin', 'student'] },
    { id: 'schedule', label: 'Program & Ödev', icon: Calendar, roles: ['superadmin', 'admin', 'student'] },
    { id: 'lessons', label: 'Ders Yönetimi', icon: BookOpen, roles: ['superadmin', 'admin'] },
    { id: 'goals', label: 'Haftalık Hedefler', icon: Flag, roles: ['superadmin', 'admin', 'student'] },
    { id: 'routines', label: 'Rutinler', icon: Activity, roles: ['superadmin', 'admin', 'student'] }, // YENİ EKLENEN
    { id: 'resources', label: 'Kaynaklar', icon: Library, roles: ['superadmin', 'admin', 'student'] },
    { id: 'mood', label: 'Duygudurum', icon: Smile, roles: ['superadmin', 'admin'] },
    { id: 'exams', label: 'Deneme Takibi', icon: Target, roles: ['superadmin', 'admin', 'student'] },
    { id: 'exam_analysis', label: 'Deneme Analizi', icon: BarChart2, roles: ['superadmin', 'admin', 'student'] },
    { id: 'activity', label: 'Aktiflik Durumu', icon: Eye, roles: ['superadmin', 'admin'] },
    { id: 'diary', label: 'Günlüğüm', icon: Book, roles: ['student'] },
    { id: 'study_timer', label: 'Çalışma Sayacı', icon: Timer, roles: ['student'] },
    { id: 'my_notes', label: 'Notlarım', icon: Edit2, roles: ['student'] },
    { id: 'interviews', label: 'Görüşmeler', icon: MessageSquare, roles: ['superadmin', 'admin'] },
    { id: 'diary', label: 'Öğrenci Günlüğü', icon: Book, roles: ['superadmin', 'admin'] },
    { id: 'resource_recommendations', label: 'Kaynak Öneri', icon: Lightbulb, roles: ['superadmin', 'admin'] },
    { id: 'payment', label: 'Ödeme', icon: CreditCard, roles: ['superadmin', 'admin'] },
    { id: 'ai_usage', label: 'AI Kullanımı', icon: BrainCircuit, roles: ['superadmin'] },
    { id: 'popup_notifications', label: 'Pop-up & Push Bildirim', icon: Megaphone, roles: ['superadmin'] },
    { id: 'version_management', label: 'Sürüm & Güncelleme', icon: DownloadCloud, roles: ['superadmin'] },
    { id: 'admin_panel', label: 'Yönetici Paneli', icon: Shield, roles: ['superadmin'] },
  ];

  return (
    <div className={`flex flex-col md:flex-row h-screen ${colors.bgMain} ${colors.text} overflow-hidden font-sans transition-colors duration-300`}>
      {/* Mobil Header */}
      <div className={`no-print md:hidden ${colors.bgCard} p-4 flex justify-between items-center border-b ${colors.border} z-50`}><div className="flex items-center gap-2 text-orange-500 font-bold text-lg"><Users size={20} /><span>Koçum Online</span></div><button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={colors.text}>{isMobileMenuOpen ? <X /> : <Menu />}</button></div>
      {isMobileMenuOpen && (<div className="no-print fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setIsMobileMenuOpen(false)}></div>)}

      {/* ASIDE (SOL MENÜ) */}
      <aside className={`no-print fixed inset-y-0 left-0 w-64 ${colors.bgCard} border-r ${colors.border} flex flex-col z-50 transform transition-all duration-300 ease-in-out md:relative md:translate-x-0 ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} ${isSidebarCollapsed ? 'md:w-0 md:border-r-0 md:opacity-0 md:overflow-hidden' : 'md:w-64 md:opacity-100'}`}>

        {/* MENÜYÜ İÇERİ İTME (KAPATMA) BUTONU */}
        <button
          onClick={() => setIsSidebarCollapsed(true)}
          className="hidden md:flex absolute right-4 top-7 text-slate-400 hover:text-orange-500 transition-colors z-20"
          title="Menüyü Daralt"
        >
          <ChevronRight size={20} className="rotate-180" />
        </button>

        <div className={`p-6 border-b ${colors.border} flex flex-col gap-1`}>
          <div className="flex items-center gap-2 text-orange-500 font-bold text-lg truncate"><Users /><span>{user.name.split(' ')[0]}</span></div>
          <div className={`text-xs ${colors.textSec} ml-8`}>{user.role === 'superadmin' ? 'Yönetici' : user.role === 'admin' ? 'Öğretmen' : 'Öğrenci'}</div>
          {user.role === 'admin' && (<div className={`mt-2 text-[10px] px-2 py-1 rounded border flex justify-between items-center ${licenseInfo.isExpired ? 'bg-red-500/10 border-red-500/30 text-red-500' : 'bg-emerald-500/10 border-emerald-500/30 text-emerald-500'}`}><span>Kalan: <b>{licenseInfo.daysLeft} Gün</b></span><span>{licenseInfo.used}/{licenseInfo.limit} Öğr.</span></div>)}
        </div>
        {(user.role === 'admin' || user.role === 'superadmin') && (<div className={`p-4 border-b ${colors.border}`}><label className={`block text-[10px] uppercase font-bold ${colors.textSec} mb-2`}>Benim Öğrencilerim</label><select className={`w-full ${colors.inputBg} ${colors.border} border rounded p-2 ${colors.text} text-sm outline-none focus:border-orange-500`} value={selectedStudentId || ''} onChange={e => setSelectedStudentId(e.target.value)}>{myStudents.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}{myStudents.length === 0 && <option value="">Öğrenci Yok</option>}{!myStudents.find(s => s.id === selectedStudentId) && selectedStudentId && <option value={selectedStudentId}>(İncelenen Öğrenci)</option>}</select></div>)}
        <nav className="flex-1 overflow-y-auto px-4 space-y-1 mt-4 custom-scrollbar">{MENU_ITEMS.filter(item => item.roles.includes(user.role)).map(item => (<button key={item.id} onClick={() => { setActiveTab(item.id); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${activeTab === item.id ? 'bg-orange-600 text-white shadow-lg shadow-orange-500/30' : `${colors.textSec} hover:${colors.text} hover:${colors.hoverBg}`}`}><item.icon size={18} /> <span className="text-sm font-medium">{item.label}</span></button>))}</nav>
        <div className={`p-4 border-t ${colors.border} space-y-2`}><button onClick={toggleTheme} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl ${colors.textSec} hover:${colors.text} ${colors.hoverBg} transition-all`}>{theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />} <span className="text-sm font-medium">{theme === 'dark' ? 'Aydınlık Mod' : 'Karanlık Mod'}</span></button><button onClick={() => setShowProfileModal(true)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl ${colors.textSec} hover:${colors.text} ${colors.hoverBg} transition-all`}><User size={18} /><span className="text-sm font-medium">Profilim</span></button><button onClick={() => { setUser(null); setViewMode('landing'); try { localStorage.removeItem(AUTH_STORAGE_KEY); localStorage.removeItem(UI_ACTIVE_TAB_KEY); localStorage.removeItem(UI_SELECTED_STUDENT_KEY); } catch (e) { } }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl ${colors.textSec} hover:text-red-500 ${colors.hoverBg} transition-all`}><LogOut size={18} /> <span className="text-sm font-medium">Güvenli Çıkış</span></button></div>
      </aside>

      <main className={`flex-1 ${colors.bgMain} overflow-y-auto p-4 md:p-8 relative w-full custom-scrollbar`}>

        {/* MENÜYÜ TEKRAR AÇMA BUTONU (GÜNCELLENDİ: Yazı üstüne binmemesi için akışa alındı) */}
        {isSidebarCollapsed && (
          <div className="hidden md:flex mb-6 animate-fade-in"> {/* Buton için yer ayırdık */}
            <button
              onClick={() => setIsSidebarCollapsed(false)}
              className="flex items-center justify-center p-2 bg-slate-800 text-white rounded-lg shadow-lg border border-slate-700 hover:bg-orange-600 transition-colors"
              title="Menüyü Göster"
            >
              <Menu size={20} />
            </button>
          </div>
        )}

        {user.role === 'superadmin' && activeTab === 'admin_panel' ? (
          <AdminManagementModule admins={admins} setAdmins={setAdmins} user={user} allStudents={students} onInspectStudent={handleInspectStudent} notifications={notifications} setNotifications={setNotifications} systemSettings={systemSettings} setSystemSettings={setSystemSettings} />
        ) : user.role === 'superadmin' && activeTab === 'ai_usage' ? (
          <AiUsageSuperadminModule allStudents={students} admins={admins} user={user} onUpdateStudent={updateStudentData} db={db} isFirebaseActive={isFirebaseActive} />
        ) : user.role === 'superadmin' && activeTab === 'popup_notifications' ? (
          <PopupManagementSuperadminModule allStudents={students} admins={admins} user={user} db={db} isFirebaseActive={isFirebaseActive} />
        ) : user.role === 'superadmin' && activeTab === 'version_management' ? (
          <VersionManagementSuperadminModule user={user} db={db} isFirebaseActive={isFirebaseActive} />
        ) : (user.role === 'admin' || user.role === 'superadmin') && activeTab === 'activity' ? (
          <ActivityModule user={user} students={myStudents} selectedStudentId={selectedStudentId} curriculum={curriculum} templatesPool={activeTemplatesPool} />
        ) : (user.role === 'admin' || user.role === 'superadmin') && activeTab === 'dashboard' ? (
          <DashboardModule user={user} students={myStudents} archivedStudents={myArchivedStudents} setStudents={setStudents} setSelectedStudentId={setSelectedStudentId} onUpdateStudent={updateStudentData} classes={myClasses} setClasses={setClasses} licenseInfo={licenseInfo} admins={admins} setIsMobileMenuOpen={setIsMobileMenuOpen} selectedStudentId={selectedStudentId} />
        ) : (user.role === 'admin' || user.role === 'superadmin') && activeTab === 'resource_recommendations' ? (
          <ResourceRecommendationModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} curriculum={curriculum} students={myStudents} admins={admins} setAdmins={setAdmins} />
        ) : !currentStudent ? <div className={`text-center mt-20 ${colors.textSec}`}>Lütfen işlem yapmak için bir öğrenci seçiniz veya öğrenci ekleyiniz.</div> : (
          <>
            {activeTab === 'dashboard' && <DashboardModule user={user} students={myStudents} archivedStudents={myArchivedStudents} setStudents={setStudents} setSelectedStudentId={setSelectedStudentId} onUpdateStudent={updateStudentData} classes={myClasses} setClasses={setClasses} licenseInfo={licenseInfo} admins={admins} setIsMobileMenuOpen={setIsMobileMenuOpen} selectedStudentId={selectedStudentId} systemSettings={systemSettings} />}
            {activeTab === 'routines' && <RoutineModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} />}
            {activeTab === 'schedule' && <ScheduleModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} students={myStudents} classes={myClasses} curriculum={curriculum} />}
            {activeTab === 'goals' && <GoalsModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} students={myStudents} classes={myClasses} />}
            {activeTab === 'resources' && <ResourceModule user={user} student={currentStudent} curriculum={curriculum} onUpdateStudent={updateStudentData} />}
            {activeTab === 'lessons' && <LessonModule user={user} student={currentStudent} curriculum={curriculum} setCurriculum={setCurriculum} onUpdateStudent={updateStudentData} allStudents={myStudents} templatesPool={activeTemplatesPool} setTemplatesPool={setCurriculumTemplates} />}
            {activeTab === 'mood' && <MoodModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} />}
            {activeTab === 'exams' && <ExamModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} curriculum={curriculum} />}
            {activeTab === 'exam_analysis' && <ExamAnalysisModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} curriculum={curriculum} />}
            {activeTab === 'study_timer' && <StudyTimerModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} />}
            {activeTab === 'diary' && <DiaryModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} students={myStudents} />}
            {activeTab === 'my_notes' && <MyNotesModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} />}
            {activeTab === 'interviews' && <InterviewModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} />}
            {activeTab === 'resource_recommendations' && <ResourceRecommendationModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} curriculum={curriculum} students={myStudents} admins={admins} setAdmins={setAdmins} />}
            {activeTab === 'payment' && <PaymentModule user={user} student={currentStudent} onUpdateStudent={updateStudentData} />}
          </>
        )}
      </main>
      {showProfileModal && <ProfileSettingsModal user={user} onClose={() => setShowProfileModal(false)} onUpdate={handleUpdateProfile} />}
      {user?.role === 'student' && <KocumAiChat student={currentStudent || user} curriculum={curriculum} user={user} db={db} isFirebaseActive={isFirebaseActive} />}
      {(user?.role === 'admin' || user?.role === 'superadmin') && <TeacherAiFloatingChat user={user} currentStudent={currentStudent} students={myStudents} curriculum={curriculum} db={db} isFirebaseActive={isFirebaseActive} />}
      <ActivePopupModal user={user} popups={popups} db={db} isFirebaseActive={isFirebaseActive} />
      <ForceUpdateLockModal versionConfig={versionConfig} user={user} />
      
    </div>
  );
};

// MainApp bileşeni bittikten hemen sonra bunu ekle:
// --- TOAST BİLDİRİM BİLEŞENİ ---
const ToastContainer = ({ toasts, removeToast }) => (
  <div className="fixed top-5 right-5 z-[9999] space-y-2 pointer-events-none max-w-sm w-full sm:w-auto">
    {toasts.map(t => {
      const isSuccess = t.type === 'success';
      const isError = t.type === 'error';
      const isWarning = t.type === 'warning';
      const isInfo = t.type === 'info';

      const bgStyle = isSuccess
        ? 'bg-emerald-600/95 border-emerald-500/80 text-white shadow-emerald-950/30'
        : isError
        ? 'bg-rose-600/95 border-rose-500/80 text-white shadow-rose-950/30'
        : isWarning
        ? 'bg-amber-500/95 border-amber-400/80 text-white shadow-amber-950/30'
        : 'bg-sky-600/95 border-sky-500/80 text-white shadow-sky-950/30';

      return (
        <div
          key={t.id}
          className={`pointer-events-auto flex items-center justify-between gap-3 px-4 py-3 rounded-xl border shadow-2xl backdrop-blur-md transform transition-all duration-300 animate-fade-in ${bgStyle}`}
        >
          <div className="flex items-center gap-3">
            {isSuccess && <CheckCircle size={19} className="shrink-0 text-white" />}
            {isError && <AlertCircle size={19} className="shrink-0 text-white" />}
            {isWarning && <AlertTriangle size={19} className="shrink-0 text-white" />}
            {isInfo && <Info size={19} className="shrink-0 text-white" />}
            <span className="text-xs sm:text-sm font-semibold leading-snug">{t.msg}</span>
          </div>
          <button
            onClick={() => removeToast(t.id)}
            className="p-1 rounded-lg hover:bg-white/20 transition-colors text-white/80 hover:text-white shrink-0 ml-2"
          >
            <X size={14} />
          </button>
        </div>
      );
    })}
  </div>
);

// --- APP ANA BİLEŞEN (Tema Hafızası & Toast Sağlayıcı & Global Scrollbar) ---
export default function App() {
  // 1. Tema Hafızası
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') return localStorage.getItem('app-theme') || 'dark';
    return 'dark';
  });

  // 2. Toast State
  const [toasts, setToasts] = useState([]);

  const addToast = (msg, type = 'success') => {
    if (!msg) return;
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev.slice(-3), { id, msg: String(msg), type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3800); // 3.8 Saniye sonra kaybolur
  };

  // Toast fonksiyonunu global yapıyoruz ve sistem alert'lerini modern toasta yönlendiriyoruz
  useEffect(() => {
    window.toast = {
      success: (msg) => addToast(msg, 'success'),
      error: (msg) => addToast(msg, 'error'),
      warning: (msg) => addToast(msg, 'warning'),
      info: (msg) => addToast(msg, 'info')
    };

    const originalAlert = window.alert;
    window.alert = (msg) => {
      if (!msg) return;
      const str = String(msg);
      const lower = str.toLowerCase();
      if (lower.includes('hata') || lower.includes('error') || lower.includes('silinemedi') || lower.includes('başarısız') || lower.includes('yetki')) {
        addToast(str, 'error');
      } else if (lower.includes('doldur') || lower.includes('seç') || lower.includes('boş bırakılamaz') || lower.includes('uyarı') || lower.includes('kayıtlı') || lower.includes('kullanımda') || lower.includes('kota') || lower.includes('kendinizi')) {
        addToast(str, 'warning');
      } else if (lower.includes('başarı') || lower.includes('güncellendi') || lower.includes('kaydedildi') || lower.includes('eklendi') || lower.includes('silindi') || lower.includes('gönderildi') || lower.includes('taşındı') || lower.includes('yüklendi')) {
        addToast(str, 'success');
      } else {
        addToast(str, 'info');
      }
    };

    return () => {
      window.alert = originalAlert;
    };
  }, []);

  const toggleTheme = () => {
    setTheme(prev => {
      const newTheme = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem('app-theme', newTheme);
      return newTheme;
    });
  };

  // --- DİNAMİK SCROLLBAR STİLİ (BURASI YENİ EKLENDİ) ---
  // Temaya göre renkleri otomatik ayarlar
  const scrollbarStyles = `
    /* Tüm tarayıcılar için genel ayarlar */
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    
    /* Arka Plan (Track) */
    ::-webkit-scrollbar-track {
      background: ${theme === 'dark' ? '#0f172a' : '#f1f5f9'}; /* Slate-950 veya Slate-100 */
    }

    /* Kaydırma Çubuğu (Thumb) */
    ::-webkit-scrollbar-thumb {
      background-color: ${theme === 'dark' ? '#334155' : '#cbd5e1'}; /* Slate-700 veya Slate-300 */
      border-radius: 6px;
      border: 2px solid ${theme === 'dark' ? '#0f172a' : '#f1f5f9'}; /* Kenarlarda boşluk hissi için */
    }

    /* Üzerine gelince (Hover) */
    ::-webkit-scrollbar-thumb:hover {
      background-color: ${theme === 'dark' ? '#475569' : '#94a3b8'}; /* Slate-600 veya Slate-400 */
    }

    /* Köşe birleşim yerleri */
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
    
    /* Firefox Desteği */
    * {
      scrollbar-width: thin;
      scrollbar-color: ${theme === 'dark' ? '#334155 #0f172a' : '#cbd5e1 #f1f5f9'};
    }
  `;

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {/* Stilleri sayfaya enjekte ediyoruz */}
      <style>{scrollbarStyles}</style>

      <ToastContainer toasts={toasts} removeToast={(id) => setToasts(prev => prev.filter(t => t.id !== id))} />
      <MainApp />
    </ThemeContext.Provider>
  );
}
